/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 36);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(44);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translate__ = __webpack_require__(72);
/* unused harmony reexport translate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__I18n__ = __webpack_require__(23);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__I18n__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Interpolate__ = __webpack_require__(76);
/* unused harmony reexport Interpolate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Trans__ = __webpack_require__(77);
/* unused harmony reexport Trans */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__I18nextProvider__ = __webpack_require__(83);
/* unused harmony reexport I18nextProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loadNamespaces__ = __webpack_require__(84);
/* unused harmony reexport loadNamespaces */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context__ = __webpack_require__(11);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__context__["c"]; });
/* unused harmony reexport setDefaults */
/* unused harmony reexport getDefaults */
/* unused harmony reexport setI18n */
/* unused harmony reexport getI18n */








/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(73)();
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_EventRegister__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Env=Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ENV":"production","REACT_APP_API_URL":"https://contact-api.triamnetwork.com/api"});var triamBlogs={production:'https://community.triamnetwork.com',staging:'https://stg-community.triamnetwork.com'};var Footer=function(_Component){_inherits(Footer,_Component);function Footer(props){_classCallCheck(this,Footer);var _this=_possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).call(this,props));_this.onChangeLanguage=function(e,lang,i18n){e.preventDefault();i18n.changeLanguage(lang);__WEBPACK_IMPORTED_MODULE_3__helper_EventRegister__["b" /* default */].emit(__WEBPACK_IMPORTED_MODULE_3__helper_EventRegister__["a" /* CHANGE_LANGUAGE */],{lang:lang});};_this.state={triamBlog:triamBlogs[Env.REACT_APP_ENV]};return _this;}_createClass(Footer,[{key:'render',value:function render(){var _this2=this;var isDisplayOnWebview=window.location.href.endsWith('/a/faq');return!isDisplayOnWebview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],{ns:'translations'},function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row custom-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-2 col-sm-2 col-md-2 wow slideInLeft footer-1 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/logo_bottom.png',alt:'TRIAM NETWORK'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:"logo-fb",href:'https://facebook.com/development.triam.3',title:'https://facebook.com/development.triam.3',target:"_blank"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:"img-logo-sn-top",src:'/images/fb-logo.png',alt:'Facebook'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:"logo-tw",href:'https://twitter.com/triamnetwork1',title:'https://twitter.com/triamnetwork1',target:"_blank"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:"img-logo-sn-top",src:'/images/tw-logo.png',alt:'Twitter'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-2 col-sm-2 col-md-2 footer-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'footer-title'},t('Home')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'footer-link',href:'https://triamnetwork.github.io/triam-docs/',target:'_blank',rel:'noopener noreferrer'},t('Developer'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'footer-link',href:'https://triamnetwork.github.io/triam-sdk/',target:'_blank',rel:'noopener noreferrer'},t('API Document'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'footer-link',target:'_blank',rel:'noopener noreferrer',href:'/documents/TRIAM.pdf'},t('White paper'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'footer-link',target:'_blank',rel:'noopener noreferrer',href:'https://dashboard.triamnetwork.com/'},t('blockscan')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-2 col-sm-2 col-md-2 footer-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'footer-title'},'About'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/faq'},t('RIA FAQ'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'footer-link',target:'_blank',rel:'noopener noreferrer',href:_this2.state.triamBlog},' ',t('Community'),' '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-2 col-sm-2 col-md-2 footer-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'footer-title'},t('Privacy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'footer-link',target:'_blank',rel:'noopener noreferrer',href:'/privacy'},t('privacy_')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-2 col-sm-2 col-md-2 footer-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'footer-title'},t('Language')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'footer-link',onClick:function onClick(e){return _this2.onChangeLanguage(e,'en',i18n);}},'English')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'footer-link',onClick:function onClick(e){return _this2.onChangeLanguage(e,'ch',i18n);}},'\u4E2D\u6587(\u7B80\u4F53)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'footer-link',onClick:function onClick(e){return _this2.onChangeLanguage(e,'ja',i18n);}},'\u65E5\u672C\u8A9E')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'footer-link',onClick:function onClick(e){return _this2.onChangeLanguage(e,'ko',i18n);}},'\uD55C\uAD6D\uC5B4')))))));});}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18next__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_EventRegister__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Menu=function(_Component){_inherits(Menu,_Component);function Menu(props){_classCallCheck(this,Menu);var _this=_possibleConstructorReturn(this,(Menu.__proto__||Object.getPrototypeOf(Menu)).call(this,props));_this.changeStateFlag=function(_ref){var lang=_ref.lang;_this.setState({currentFlag:'/images/'+lang+'.png'});};_this.onChangeLanguage=function(e,lang,i18n){_this.props.history.push({search:'lang='+lang});e&&e.preventDefault();i18n.changeLanguage(lang);_this.changeStateFlag({lang:lang});};_this.state={currentFlag:'/images/'+(localStorage.getItem('i18nextLng')||'en')+'.png',lang:localStorage.getItem('i18nextLng')||'en'};return _this;}_createClass(Menu,[{key:'componentDidMount',value:function componentDidMount(){var query=new URLSearchParams(document.location.search);var lang=query.get('lang');if(lang&&['en','ch','ja','ko'].includes(lang)){this.changeStateFlag({lang:lang});this.onChangeLanguage(null,lang,__WEBPACK_IMPORTED_MODULE_1_i18next__["a" /* default */]);}this.changeLanguageEvent=__WEBPACK_IMPORTED_MODULE_4__helper_EventRegister__["b" /* default */].on(__WEBPACK_IMPORTED_MODULE_4__helper_EventRegister__["a" /* CHANGE_LANGUAGE */],this.changeStateFlag);}},{key:'componentWillUnmount',value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_4__helper_EventRegister__["b" /* default */].off(this.changeLanguageEvent);}},{key:'render',value:function render(){var _this2=this;var currentItem=this.props.currentItem;var isDisplayOnWebview=window.location.href.endsWith('/a/faq')||window.location.href.endsWith('/a/faq?lng=en')||window.location.href.endsWith('/a/faq?lng=ja')||window.location.href.endsWith('/a/faq?lng=ko')||window.location.href.endsWith('/a/faq?lng=ch');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["a" /* I18n */],{ns:'translations'},function(t,_ref2){var i18n=_ref2.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'navbar nav-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navbar-header'},!isDisplayOnWebview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'navbar-toggle','data-toggle':'collapse','data-target':'.navbar-ex1-collapse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sr-only'},'Toggle navigation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon-bar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon-bar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon-bar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{className:'navbar-brand logo',to:isDisplayOnWebview?"#":"/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/logo.png',alt:'TRIAM NETWORK',style:{width:250}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collapse navbar-collapse navbar-ex1-collapse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav navbar-nav navbar-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'animated rubberBand '+(currentItem==='home'?"menu-active":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'m_dot'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:'/'},t('Home'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'animated rubberBand '+(currentItem==='service'?"menu-active":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'m_dot'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:'/service'},t('Service'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'animated rubberBand '+(currentItem==='about'?"menu-active":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'m_dot'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,t('About'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'animated rubberBand '+(currentItem==='contact'?"menu-active":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'m_dot'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:'contact'},t('Contact'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'language'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'dropbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:_this2.state.currentFlag,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'caret'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'dropdown-language'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.onChangeLanguage(e,'en',i18n);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/en.png',alt:'EN'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.onChangeLanguage(e,'ja',i18n);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/ja.png',alt:'JP'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.onChangeLanguage(e,'ch',i18n);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/ch.png',alt:'CH'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.onChangeLanguage(e,'ko',i18n);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/ko.png',alt:'KO'})))))))));});}}]);return Menu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* withRouter */])(Menu));

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var consoleLogger = {
  type: 'logger',

  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, _toConsumableArray(args));
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  Logger.prototype.init = function init(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  };

  Logger.prototype.setDebug = function setDebug(bool) {
    this.debug = bool;
  };

  Logger.prototype.log = function log() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return this.forward(args, 'log', '', true);
  };

  Logger.prototype.warn = function warn() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return this.forward(args, 'warn', '', true);
  };

  Logger.prototype.error = function error() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return this.forward(args, 'error', '');
  };

  Logger.prototype.deprecate = function deprecate() {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  };

  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (typeof args[0] === 'string') args[0] = '' + prefix + this.prefix + ' ' + args[0];
    return this.logger[lvl](args);
  };

  Logger.prototype.create = function create(moduleName) {
    return new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
  };

  return Logger;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Logger());

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  EventEmitter.prototype.on = function on(events, listener) {
    var _this = this;

    events.split(' ').forEach(function (event) {
      _this.observers[event] = _this.observers[event] || [];
      _this.observers[event].push(listener);
    });
    return this;
  };

  EventEmitter.prototype.off = function off(event, listener) {
    var _this2 = this;

    if (!this.observers[event]) {
      return;
    }

    this.observers[event].forEach(function () {
      if (!listener) {
        delete _this2.observers[event];
      } else {
        var index = _this2.observers[event].indexOf(listener);
        if (index > -1) {
          _this2.observers[event].splice(index, 1);
        }
      }
    });
  };

  EventEmitter.prototype.emit = function emit(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (this.observers[event]) {
      var cloned = [].concat(this.observers[event]);
      cloned.forEach(function (observer) {
        observer.apply(undefined, args);
      });
    }

    if (this.observers['*']) {
      var _cloned = [].concat(this.observers['*']);
      _cloned.forEach(function (observer) {
        observer.apply(observer, [event].concat(args));
      });
    }
  };

  return EventEmitter;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventEmitter);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = makeString;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["h"] = setPath;
/* harmony export (immutable) */ __webpack_exports__["f"] = pushPath;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPath;
/* harmony export (immutable) */ __webpack_exports__["b"] = deepExtend;
/* harmony export (immutable) */ __webpack_exports__["g"] = regexEscape;
/* harmony export (immutable) */ __webpack_exports__["c"] = escape;
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */
  return '' + object;
}

function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};

    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}

function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}

function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}

function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }
  return target;
}

function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

/* eslint-disable */
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': '&quot;',
  "'": '&#39;',
  "/": '&#x2F;'
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = setDefaults;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDefaults;
/* harmony export (immutable) */ __webpack_exports__["e"] = setI18n;
/* harmony export (immutable) */ __webpack_exports__["b"] = getI18n;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reactI18nextModule; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var defaultOptions = {
  wait: false,
  withRef: false,
  bindI18n: 'languageChanged loaded',
  bindStore: 'added removed',
  translateFuncName: 't',
  nsMode: 'default',
  usePureComponent: false,
  omitBoundRerender: true
};

var i18n = void 0;

function setDefaults(options) {
  defaultOptions = _extends({}, defaultOptions, options);
}

function getDefaults() {
  return defaultOptions;
}

function setI18n(instance) {
  i18n = instance;
}

function getI18n() {
  return i18n;
}

var reactI18nextModule = {
  type: '3rdParty',

  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(90);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(93);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(31);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(95);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(98);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(100);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(102);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(13);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(105);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(107);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(109);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(14);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createBrowserHistory */
/* unused harmony export createHashHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(30);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["default"])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.1",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		}
		if ( nodeType === 1 || nodeType === 11 ) {
			return elem.textContent;
		}
		if ( nodeType === 9 ) {
			return elem.documentElement.textContent;
		}
		if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors
	// (see trac-13936).
	// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
	// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
	if ( documentElement.msMatchesSelector &&

		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented as part of
// Sizzle so let's maintain them for now for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;
find.tokenize = tokenize;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Re-enable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "box-sizing:content-box;border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is `display: block`
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this
			.on( "mouseenter", fnOver )
			.on( "mouseleave", fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return faqDidMount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
var faqDidMount=function faqDidMount(){var hash=window.location.hash;if(hash){var anchor=__WEBPACK_IMPORTED_MODULE_0_jquery___default()('[href="'+hash+'"]');var target=anchor.attr('href');var position=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(target).position();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({scrollTop:position.top-75},1000);var expand=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(target+' div h3 div');expand.click();}__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.list-policy-sidenav li a').on('click',function(e){var anchor=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);var target=anchor.attr('href');var position=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(target).position();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({scrollTop:position.top-75},1000);var expand=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(target+' div h3 div');expand.click();e.preventDefault();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.click-scroll').on('click',function(e){var anchor=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);var target=anchor.attr('href');var position=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(target).position();__WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({scrollTop:position.top-75},1000);var expand=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(target+' div h3 div');expand.click();e.preventDefault();});__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".expand").click(function(){// $(this).next().slideToggle(200);
var expand=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find(">:first-child");if(expand.text()==="+"){expand.text("-");}else{expand.text("+");}});};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(39);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export changeLanguage */
/* unused harmony export cloneInstance */
/* unused harmony export createInstance */
/* unused harmony export dir */
/* unused harmony export exists */
/* unused harmony export getFixedT */
/* unused harmony export init */
/* unused harmony export loadLanguages */
/* unused harmony export loadNamespaces */
/* unused harmony export loadResources */
/* unused harmony export off */
/* unused harmony export on */
/* unused harmony export setDefaultNamespace */
/* unused harmony export t */
/* unused harmony export use */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18next_js__ = __webpack_require__(50);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

var changeLanguage = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].changeLanguage.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var cloneInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].cloneInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var createInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].createInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var dir = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].dir.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var exists = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].exists.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var getFixedT = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].getFixedT.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var init = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].init.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadLanguages = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadLanguages.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadNamespaces = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadNamespaces.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadResources = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadResources.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var off = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].off.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var on = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].on.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var setDefaultNamespace = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].setDefaultNamespace.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var t = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].t.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var use = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].use.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  processors: {},

  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });

    return value;
  }
});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var removedIsInitialSSR = false;

var I18n = function (_Component) {
  _inherits(I18n, _Component);

  function I18n(props, context) {
    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, (I18n.__proto__ || Object.getPrototypeOf(I18n)).call(this, props, context));

    _this.i18n = props.i18n || context.i18n || Object(__WEBPACK_IMPORTED_MODULE_2__context__["b" /* getI18n */])();

    var i18nOptions = _this.i18n && _this.i18n.options && _this.i18n.options.react || {};
    _this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2__context__["a" /* getDefaults */])(), i18nOptions, props);

    // nextjs SSR: getting data from next.js or other ssr stack
    if (props.initialI18nStore) {
      _this.i18n.services.resourceStore.data = props.initialI18nStore;
      _this.options.wait = false; // we got all passed down already
    }
    if (props.initialLanguage) {
      _this.i18n.changeLanguage(props.initialLanguage);
    }

    // provider SSR: data was set in provider and ssr flag was set
    if (_this.i18n.options && _this.i18n.options.isInitialSSR) {
      _this.options.wait = false;
    }

    var language = _this.i18n.languages && _this.i18n.languages[0];
    var ready = !!language && _this.getNamespaces().every(function (ns) {
      return _this.i18n.hasResourceBundle(language, ns);
    });

    _this.state = {
      i18nLoadedAt: null,
      ready: ready
    };

    _this.t = _this.getI18nTranslate();

    _this.onI18nChanged = _this.onI18nChanged.bind(_this);
    _this.getI18nTranslate = _this.getI18nTranslate.bind(_this);
    _this.namespaces = _this.getNamespaces.bind(_this);
    return _this;
  }

  _createClass(I18n, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        t: this.t,
        i18n: this.i18n
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadNamespaces();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Note that dynamically loading additional namespaces after the initial mount will not block rendering – even if the `wait` option is true.
      if (this.props.ns && prevProps.ns !== this.props.ns) this.loadNamespaces();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      this.mounted = false;
      if (this.onI18nChanged) {
        if (this.options.bindI18n) {
          var p = this.options.bindI18n.split(' ');
          p.forEach(function (f) {
            return _this2.i18n.off(f, _this2.onI18nChanged);
          });
        }
        if (this.options.bindStore) {
          var _p = this.options.bindStore.split(' ');
          _p.forEach(function (f) {
            return _this2.i18n.store && _this2.i18n.store.off(f, _this2.onI18nChanged);
          });
        }
      }
    }
  }, {
    key: 'onI18nChanged',
    value: function onI18nChanged() {
      if (!this.mounted) return;
      if (!this.state.ready && this.options.omitBoundRerender) return;

      this.t = this.getI18nTranslate();
      this.setState({ i18nLoadedAt: new Date() }); // rerender
    }
  }, {
    key: 'getI18nTranslate',
    value: function getI18nTranslate() {
      return this.i18n.getFixedT(null, this.options.nsMode === 'fallback' ? this.getNamespaces() : this.getNamespaces()[0]);
    }
  }, {
    key: 'getNamespaces',
    value: function getNamespaces() {
      var ns = this.props.ns || this.i18n.options && this.i18n.options.defaultNS;
      return typeof ns === 'string' ? [ns] : ns;
    }
  }, {
    key: 'loadNamespaces',
    value: function loadNamespaces() {
      var _this3 = this;

      var bind = function bind() {
        if (_this3.options.bindI18n && _this3.i18n) _this3.i18n.on(_this3.options.bindI18n, _this3.onI18nChanged);
        if (_this3.options.bindStore && _this3.i18n.store) _this3.i18n.store.on(_this3.options.bindStore, _this3.onI18nChanged);
      };

      this.mounted = true;
      this.i18n.loadNamespaces(this.getNamespaces(), function () {
        var ready = function ready() {
          if (_this3.mounted && !_this3.state.ready) _this3.setState({ ready: true });
          if (_this3.options.wait && _this3.mounted) bind();
        };

        if (_this3.i18n.isInitialized) {
          ready();
        } else {
          var initialized = function initialized() {
            // due to emitter removing issue in i18next we need to delay remove
            setTimeout(function () {
              _this3.i18n.off('initialized', initialized);
            }, 1000);
            ready();
          };

          _this3.i18n.on('initialized', initialized);
        }
      });

      if (!this.options.wait) bind();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var children = this.props.children;
      var ready = this.state.ready;


      if (!ready && this.options.wait) return null;

      // remove ssr flag set by provider - first render was done from now on wait if set to wait
      if (this.i18n.options && this.i18n.options.isInitialSSR && !removedIsInitialSSR) {
        removedIsInitialSSR = true;
        setTimeout(function () {
          delete _this4.i18n.options.isInitialSSR;
        }, 100);
      }

      return children(this.t, {
        i18n: this.i18n,
        t: this.t,
        lng: this.i18n.language,
        ready: ready
      });
    }
  }]);

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (I18n);


I18n.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

I18n.childContextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var printWarning = function() {};

if (false) {
  printWarning = function(format, subs) {
    var index = 0;
    var message =
      'Warning: ' +
      (subs.length > 0
        ? format.replace(/%s/g, function() {
            return subs[index++];
          })
        : format);

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging history ---
      // This error was thrown as a convenience so that you can use the
      // stack trace to find the callsite that triggered this warning.
      throw new Error(message);
    } catch (e) {}
  };
}

module.exports = function(member) {
  printWarning(
    'Please use `require("history").%s` instead of `require("history/%s")`. ' +
      'Support for the latter will be removed in the next major release.',
    [member, member]
  );
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(92);
} else {
  module.exports = require('./cjs/history.js');
}


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["default"] = (warning);


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}




/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(33);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(99)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = prefix || defaultDelimiter
    var pattern = capture || group
    var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '')

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : restrictBacktrack(delimiter, prevText))
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

function restrictBacktrack(delimiter, prevText) {
  if (!prevText || prevText.indexOf(delimiter) > -1) {
    return '[^' + escapeString(delimiter) + ']+?'
  }

  return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?'
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_LANGUAGE; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var CHANGE_LANGUAGE='CHANGE_LANGUAGE';var EventRegister=function(){function EventRegister(){_classCallCheck(this,EventRegister);}_createClass(EventRegister,null,[{key:'addEventListener',value:function addEventListener(eventName,callback){if(typeof eventName==='string'&&typeof callback==='function'){EventRegister.listeners.count++;var eventId='l'+EventRegister.listeners.count;EventRegister.listeners.refs[eventId]={name:eventName,callback:callback};return eventId;}return false;}},{key:'removeEventListener',value:function removeEventListener(id){if(typeof id==='string'){return delete EventRegister.listeners.refs[id];}return false;}},{key:'removeAllListeners',value:function removeAllListeners(){var removeError=false;Object.keys(EventRegister.listeners.refs).forEach(function(id){var removed=delete EventRegister.listeners.refs[id];removeError=!removeError?!removed:removeError;});return!removeError;}},{key:'emitEvent',value:function emitEvent(eventName,data){Object.keys(EventRegister.listeners.refs).forEach(function(id){if(EventRegister.listeners.refs[id]&&eventName===EventRegister.listeners.refs[id].name){EventRegister.listeners.refs[id].callback(data);}});}},{key:'on',value:function on(eventName,callback){return EventRegister.addEventListener(eventName,callback);}},{key:'subscribe',value:function subscribe(eventName,callback){var id=EventRegister.addEventListener(eventName,callback);if(id)return function(){return EventRegister.removeEventListener(id);};else return function(){};}},{key:'off',value:function off(eventName){return EventRegister.removeEventListener(eventName);}},{key:'offAll',value:function offAll(){return EventRegister.removeAllListeners();}},{key:'emit',value:function emit(eventName,data){EventRegister.emitEvent(eventName,data);}}]);return EventRegister;}();EventRegister.listeners={count:0,refs:{}};/* harmony default export */ __webpack_exports__["b"] = (EventRegister);

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(37);
module.exports = __webpack_require__(43);


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(38).enable();
  window.Promise = __webpack_require__(41);
}

// fetch() polyfill for making API calls.
__webpack_require__(42);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(10);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(19);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)))

/***/ }),
/* 40 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(19);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(86);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),document.getElementById('root'));

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(10),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(46);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(10),r=__webpack_require__(47);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(48);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18next__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18next_xhr_backend__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18next_xhr_backend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_i18next_xhr_backend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18next_browser_languagedetector__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18next_browser_languagedetector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_i18next_browser_languagedetector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
__WEBPACK_IMPORTED_MODULE_0_i18next__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_i18next_xhr_backend___default.a).use(__WEBPACK_IMPORTED_MODULE_2_i18next_browser_languagedetector___default.a).use(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* reactI18nextModule */]).init({fallbackLng:'en',// have a common namespace used around the full app
ns:['translations'],defaultNS:'translations',debug:false,interpolation:{escapeValue:false// not needed for react!!
},react:{wait:true}});/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_i18next__["a" /* default */]);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceStore_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Translator_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LanguageUtils_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PluralResolver_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Interpolator_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BackendConnector_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defaults_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__postProcessor_js__ = __webpack_require__(21);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }












function noop() {}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  function I18n() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.options = Object(__WEBPACK_IMPORTED_MODULE_8__defaults_js__["b" /* transformOptions */])(options);
    _this.services = {};
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */];
    _this.modules = { external: [] };

    if (callback && !_this.isInitialized && !options.isClone) {
      var _ret;

      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) return _ret = _this.init(options, callback), _possibleConstructorReturn(_this, _ret);
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }

  I18n.prototype.init = function init() {
    var _this2 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_8__defaults_js__["a" /* get */])(), this.options, Object(__WEBPACK_IMPORTED_MODULE_8__defaults_js__["b" /* transformOptions */])(options));

    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;

    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    }

    // init services
    if (!this.options.isClone) {
      if (this.modules.logger) {
        __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].init(null, this.options);
      }

      var lu = new __WEBPACK_IMPORTED_MODULE_4__LanguageUtils_js__["a" /* default */](this.options);
      this.store = new __WEBPACK_IMPORTED_MODULE_2__ResourceStore_js__["a" /* default */](this.options.resources, this.options);

      var s = this.services;
      s.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */];
      s.resourceStore = this.store;
      s.languageUtils = lu;
      s.pluralResolver = new __WEBPACK_IMPORTED_MODULE_5__PluralResolver_js__["a" /* default */](lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON, simplifyPluralSuffix: this.options.simplifyPluralSuffix });
      s.interpolator = new __WEBPACK_IMPORTED_MODULE_6__Interpolator_js__["a" /* default */](this.options);

      s.backendConnector = new __WEBPACK_IMPORTED_MODULE_7__BackendConnector_js__["a" /* default */](createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        s.languageDetector.init(s, this.options.detection, this.options);
      }

      if (this.modules.i18nFormat) {
        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
        if (s.i18nFormat.init) s.i18nFormat.init(this);
      }

      this.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator_js__["a" /* default */](this.services, this.options);
      // pipe events from translator
      this.translator.on('*', function (event) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      this.modules.external.forEach(function (m) {
        if (m.init) m.init(_this2);
      });
    }

    // append api
    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
    storeApi.forEach(function (fcName) {
      _this2[fcName] = function () {
        var _store;

        return (_store = _this2.store)[fcName].apply(_store, arguments);
      };
    });

    var load = function load() {
      _this2.changeLanguage(_this2.options.lng, function (err, t) {
        _this2.isInitialized = true;
        _this2.logger.log('initialized', _this2.options);
        _this2.emit('initialized', _this2.options);

        callback(err, t);
      });
    };

    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }

    return this;
  };

  /* eslint consistent-return: 0 */


  I18n.prototype.loadResources = function loadResources() {
    var _this3 = this;

    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    if (!this.options.resources) {
      if (this.language && this.language.toLowerCase() === 'cimode') return callback(); // avoid loading resources for cimode

      var toLoad = [];

      var append = function append(lng) {
        if (!lng) return;
        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };

      if (!this.language) {
        // at least load fallbacks in this case
        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(function (l) {
          return append(l);
        });
      } else {
        append(this.language);
      }

      if (this.options.preload) {
        this.options.preload.forEach(function (l) {
          return append(l);
        });
      }

      this.services.backendConnector.load(toLoad, this.options.ns, callback);
    } else {
      callback(null);
    }
  };

  I18n.prototype.reloadResources = function reloadResources(lngs, ns, callback) {
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    if (!callback) callback = function callback() {};
    this.services.backendConnector.reload(lngs, ns, callback);
  };

  I18n.prototype.use = function use(module) {
    if (module.type === 'backend') {
      this.modules.backend = module;
    }

    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }

    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }

    if (module.type === 'i18nFormat') {
      this.modules.i18nFormat = module;
    }

    if (module.type === 'postProcessor') {
      __WEBPACK_IMPORTED_MODULE_9__postProcessor_js__["a" /* default */].addPostProcessor(module);
    }

    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }

    return this;
  };

  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
    var _this4 = this;

    var done = function done(err, l) {
      _this4.translator.changeLanguage(l);

      if (l) {
        _this4.emit('languageChanged', l);
        _this4.logger.log('languageChanged', l);
      }

      if (callback) callback(err, function () {
        return _this4.t.apply(_this4, arguments);
      });
    };

    var setLng = function setLng(l) {
      if (l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        if (!_this4.translator.language) _this4.translator.changeLanguage(l);

        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
      }

      _this4.loadResources(function (err) {
        done(err, l);
      });
    };

    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      this.services.languageDetector.detect(setLng);
    } else {
      setLng(lng);
    }
  };

  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
    var _this5 = this;

    var fixedT = function fixedT(key, opts) {
      for (var _len3 = arguments.length, rest = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        rest[_key3 - 2] = arguments[_key3];
      }

      var options = _extends({}, opts);
      if ((typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) !== 'object') {
        options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      }

      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      return _this5.t(key, options);
    };
    if (typeof lng === 'string') {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    return fixedT;
  };

  I18n.prototype.t = function t() {
    var _translator;

    return this.translator && (_translator = this.translator).translate.apply(_translator, arguments);
  };

  I18n.prototype.exists = function exists() {
    var _translator2;

    return this.translator && (_translator2 = this.translator).exists.apply(_translator2, arguments);
  };

  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  };

  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
    var _this6 = this;

    if (!this.options.ns) return callback && callback();
    if (typeof ns === 'string') ns = [ns];

    ns.forEach(function (n) {
      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
    });

    this.loadResources(callback);
  };

  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
    if (typeof lngs === 'string') lngs = [lngs];
    var preloaded = this.options.preload || [];

    var newLngs = lngs.filter(function (lng) {
      return preloaded.indexOf(lng) < 0;
    });
    // Exit early if all given languages are already preloaded
    if (!newLngs.length) return callback();

    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(callback);
  };

  I18n.prototype.dir = function dir(lng) {
    if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
    if (!lng) return 'rtl';

    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];

    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
  };

  /* eslint class-methods-use-this: 0 */


  I18n.prototype.createInstance = function createInstance() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    return new I18n(options, callback);
  };

  I18n.prototype.cloneInstance = function cloneInstance() {
    var _this7 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    var mergedOptions = _extends({}, this.options, options, { isClone: true });
    var clone = new I18n(mergedOptions);
    var membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(function (m) {
      clone[m] = _this7[m];
    });
    clone.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator_js__["a" /* default */](clone.services, clone.options);
    clone.translator.on('*', function (event) {
      for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      clone.emit.apply(clone, [event].concat(args));
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = clone.options; // sync options

    return clone;
  };

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new I18n());

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventEmitter_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }




var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };

    _classCallCheck(this, ResourceStore);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.data = data || {};
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    return _this;
  }

  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  };

  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
    var index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  };

  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

    var path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    }

    return __WEBPACK_IMPORTED_MODULE_1__utils_js__["d" /* getPath */](this.data, path);
  };

  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };

    var keySeparator = this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    __WEBPACK_IMPORTED_MODULE_1__utils_js__["h" /* setPath */](this.data, path, value);

    if (!options.silent) this.emit('added', lng, ns, key, value);
  };

  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { silent: false };

    /* eslint no-restricted-syntax: 0 */
    for (var m in resources) {
      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
    }
    if (!options.silent) this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : { silent: false };

    var path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    var pack = __WEBPACK_IMPORTED_MODULE_1__utils_js__["d" /* getPath */](this.data, path) || {};

    if (deep) {
      __WEBPACK_IMPORTED_MODULE_1__utils_js__["b" /* deepExtend */](pack, resources, overwrite);
    } else {
      pack = _extends({}, pack, resources);
    }

    __WEBPACK_IMPORTED_MODULE_1__utils_js__["h" /* setPath */](this.data, path, pack);

    if (!options.silent) this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);

    this.emit('removed', lng, ns);
  };

  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  };

  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;

    // COMPATIBILITY: remove extend in v2.1.0
    if (this.options.compatibilityAPI === 'v1') return _extends({}, this.getResource(lng, ns));

    return this.getResource(lng, ns);
  };

  ResourceStore.prototype.getDataByLanguage = function getDataByLanguage(lng) {
    return this.data[lng];
  };

  ResourceStore.prototype.toJSON = function toJSON() {
    return this.data;
  };

  return ResourceStore;
}(__WEBPACK_IMPORTED_MODULE_0__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ResourceStore);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__postProcessor_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_js__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }






var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  function Translator(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* copy */](['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat'], services, _this);

    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('translator');
    return _this;
  }

  Translator.prototype.changeLanguage = function changeLanguage(lng) {
    if (lng) this.language = lng;
  };

  Translator.prototype.exists = function exists(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };

    var resolved = this.resolve(key, options);
    return resolved && resolved.res !== undefined;
  };

  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';

    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

    var namespaces = options.ns || this.options.defaultNS;
    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
      var parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    if (typeof namespaces === 'string') namespaces = [namespaces];

    return {
      key: key,
      namespaces: namespaces
    };
  };

  Translator.prototype.translate = function translate(keys, options) {
    var _this2 = this;

    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object' && this.options.overloadTranslationOptionHandler) {
      /* eslint prefer-rest-params: 0 */
      options = this.options.overloadTranslationOptionHandler(arguments);
    }
    if (!options) options = {};

    // non valid keys handling
    if (keys === undefined || keys === null || keys === '') return '';
    if (typeof keys === 'number') keys = String(keys);
    if (typeof keys === 'string') keys = [keys];

    // separators
    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

    // get namespace(s)

    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _extractFromKey.key,
        namespaces = _extractFromKey.namespaces;

    var namespace = namespaces[namespaces.length - 1];

    // return key on CIMode
    var lng = options.lng || this.language;
    var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
        return namespace + nsSeparator + key;
      }

      return key;
    }

    // resolve from store
    var resolved = this.resolve(keys, options);
    var res = resolved && resolved.res;
    var resUsedKey = resolved && resolved.usedKey || key;

    var resType = Object.prototype.toString.apply(res);
    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;

    // object
    var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
    var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
    if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
      }

      // if we got a separator we loop over children - else we just return object as is
      // as having it set to false means no hierarchy so no lookup for nested values
      if (keySeparator) {
        var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy

        /* eslint no-restricted-syntax: 0 */
        for (var m in res) {
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            var deepKey = '' + resUsedKey + keySeparator + m;
            copy[m] = this.translate(deepKey, _extends({}, options, { joinArrays: false, ns: namespaces }));
            if (copy[m] === deepKey) copy[m] = res[m]; // if nothing found use orginal value as fallback
          }
        }
        res = copy;
      }
    } else if (handleAsObjectInI18nFormat && joinArrays && resType === '[object Array]') {
      // array special treatment
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, options);
    } else {
      // string, empty or null
      var usedDefault = false;
      var usedKey = false;

      // fallback value
      if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
        usedDefault = true;

        if (options.count !== undefined) {
          var suffix = this.pluralResolver.getSuffix(lng, options.count);
          res = options['defaultValue' + suffix];
        }
        if (!res) res = options.defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }

      // save missing
      var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;
      if (usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);

        var lngs = [];
        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (var i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }

        var send = function send(l, k) {
          if (_this2.options.missingKeyHandler) {
            _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
            _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          }
          _this2.emit('missingKey', l, namespace, k, res);
        };

        if (this.options.saveMissing) {
          var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
          if (this.options.saveMissingPlurals && needsPluralHandling) {
            lngs.forEach(function (l) {
              var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);

              plurals.forEach(function (p) {
                return send([l], p);
              });
            });
          } else {
            send(lngs, key);
          }
        }
      }

      // extend
      res = this.extendTranslation(res, keys, options, resolved);

      // append namespace if still key
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;

      // parseMissingKeyHandler
      if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
    }

    // return
    return res;
  };

  Translator.prototype.extendTranslation = function extendTranslation(res, key, options, resolved) {
    var _this3 = this;

    if (this.i18nFormat && this.i18nFormat.parse) {
      res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, { resolved: resolved });
    } else if (!options.skipInterpolation) {
      // i18next.parsing
      if (options.interpolation) this.interpolator.init(_extends({}, options, { interpolation: _extends({}, this.options.interpolation, options.interpolation) }));

      // interpolate
      var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
      if (this.options.interpolation.defaultVariables) data = _extends({}, this.options.interpolation.defaultVariables, data);
      res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

      // nesting
      if (options.nest !== false) res = this.interpolator.nest(res, function () {
        return _this3.translate.apply(_this3, arguments);
      }, options);

      if (options.interpolation) this.interpolator.reset();
    }

    // post process
    var postProcess = options.postProcess || this.options.postProcess;
    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

    if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = __WEBPACK_IMPORTED_MODULE_2__postProcessor_js__["a" /* default */].handle(postProcessorNames, res, key, options, this);
    }

    return res;
  };

  Translator.prototype.resolve = function resolve(keys) {
    var _this4 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var found = void 0;
    var usedKey = void 0;
    var usedLng = void 0;
    var usedNS = void 0;

    if (typeof keys === 'string') keys = [keys];

    // forEach possible key
    keys.forEach(function (k) {
      if (_this4.isValidLookup(found)) return;
      var extracted = _this4.extractFromKey(k, options);
      var key = extracted.key;
      usedKey = key;
      var namespaces = extracted.namespaces;
      if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);

      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';

      var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);

      namespaces.forEach(function (ns) {
        if (_this4.isValidLookup(found)) return;
        usedNS = ns;

        codes.forEach(function (code) {
          if (_this4.isValidLookup(found)) return;
          usedLng = code;

          var finalKey = key;
          var finalKeys = [finalKey];

          if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
            _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
          } else {
            var pluralSuffix = void 0;
            if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);

            // fallback for plural if context not found
            if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);

            // get key for context if needed
            if (needsContextHandling) finalKeys.push(finalKey += '' + _this4.options.contextSeparator + options.context);

            // get key for plural if needed
            if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
          }

          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
          var possibleKey = void 0;
          /* eslint no-cond-assign: 0 */
          while (possibleKey = finalKeys.pop()) {
            if (!_this4.isValidLookup(found)) {
              found = _this4.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });

    return { res: found, usedKey: usedKey, usedLng: usedLng, usedNS: usedNS };
  };

  Translator.prototype.isValidLookup = function isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  };

  Translator.prototype.getResource = function getResource(code, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
    return this.resourceStore.getResource(code, ns, key, options);
  };

  return Translator;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Translator);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(6);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;

    this.whitelist = this.options.whitelist || false;
    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('languageUtils');
  }

  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return null;

    var p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    return this.formatLanguageCode(p.join('-'));
  };

  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return code;

    var p = code.split('-');
    return this.formatLanguageCode(p[0]);
  };

  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      var p = code.split('-');

      if (this.options.lowerCaseLng) {
        p = p.map(function (part) {
          return part.toLowerCase();
        });
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();

        // if lenght 2 guess it's a country
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }

      return p.join('-');
    }

    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  };

  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
  };

  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;

    if (!code) return fallbacks.default || [];

    // asume we have an object defining fallbacks
    var found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks.default;

    return found || [];
  };

  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
    var _this = this;

    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);

    var codes = [];
    var addCode = function addCode(c) {
      if (!c) return;
      if (_this.isWhitelisted(c)) {
        codes.push(c);
      } else {
        _this.logger.warn('rejecting non-whitelisted language code: ' + c);
      }
    };

    if (typeof code === 'string' && code.indexOf('-') > -1) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }

    fallbackCodes.forEach(function (fc) {
      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
    });

    return codes;
  };

  return LanguageUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (LanguageUtil);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(6);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
/* eslint-disable */
var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];

var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n === 1 ? 0 : n === 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;

    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('pluralResolver');

    this.rules = createRules();
  }

  PluralResolver.prototype.addRule = function addRule(lng, obj) {
    this.rules[lng] = obj;
  };

  PluralResolver.prototype.getRule = function getRule(code) {
    return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  };

  PluralResolver.prototype.needsPlural = function needsPlural(code) {
    var rule = this.getRule(code);

    return rule && rule.numbers.length > 1;
  };

  PluralResolver.prototype.getPluralFormsOfKey = function getPluralFormsOfKey(code, key) {
    var _this = this;

    var ret = [];

    var rule = this.getRule(code);

    if (!rule) return ret;

    rule.numbers.forEach(function (n) {
      var suffix = _this.getSuffix(code, n);
      ret.push('' + key + suffix);
    });

    return ret;
  };

  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
    var _this2 = this;

    var rule = this.getRule(code);

    if (rule) {
      // if (rule.numbers.length === 1) return ''; // only singular

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      // special treatment for lngs only having singular and plural
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      // COMPATIBILITY JSON
      // v1
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return '_plural_' + suffix.toString();
        return returnSuffix();
      } else if ( /* v2 */this.options.compatibilityJSON === 'v2' && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      } else if ( /* v3 - gettext index */this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }

    this.logger.warn('no plural rule found for: ' + code);
    return '';
  };

  return PluralResolver;
}();

/* harmony default export */ __webpack_exports__["a"] = (PluralResolver);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = __WEBPACK_IMPORTED_MODULE_1__logger_js__["a" /* default */].create('interpolator');

    this.init(options, true);
  }

  /* eslint no-param-reassign: 0 */


  Interpolator.prototype.init = function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reset = arguments[1];

    if (reset) {
      this.options = options;
      this.format = options.interpolation && options.interpolation.format || function (value) {
        return value;
      };
    }
    if (!options.interpolation) options.interpolation = { escapeValue: true };

    var iOpts = options.interpolation;

    this.escape = iOpts.escape !== undefined ? iOpts.escape : __WEBPACK_IMPORTED_MODULE_0__utils_js__["c" /* escape */];
    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
    this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;

    this.prefix = iOpts.prefix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.prefix) : iOpts.prefixEscaped || '{{';
    this.suffix = iOpts.suffix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.suffix) : iOpts.suffixEscaped || '}}';

    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';

    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';

    this.nestingPrefix = iOpts.nestingPrefix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */]('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](')');

    this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;

    // the regexp
    this.resetRegExp();
  };

  Interpolator.prototype.reset = function reset() {
    if (this.options) this.init(this.options);
  };

  Interpolator.prototype.resetRegExp = function resetRegExp() {
    // the regexp
    var regexpStr = this.prefix + '(.+?)' + this.suffix;
    this.regexp = new RegExp(regexpStr, 'g');

    var regexpUnescapeStr = '' + this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');

    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  };

  Interpolator.prototype.interpolate = function interpolate(str, data, lng, options) {
    var _this = this;

    var match = void 0;
    var value = void 0;
    var replaces = void 0;

    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }

    var handleFormat = function handleFormat(key) {
      if (key.indexOf(_this.formatSeparator) < 0) return __WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, key);

      var p = key.split(_this.formatSeparator);
      var k = p.shift().trim();
      var f = p.join(_this.formatSeparator).trim();

      return _this.format(__WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, k), f, lng);
    };

    this.resetRegExp();

    var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;

    replaces = 0;
    // unescape if has unescapePrefix/Suffix
    /* eslint no-cond-assign: 0 */
    while (match = this.regexpUnescape.exec(str)) {
      value = handleFormat(match[1].trim());
      str = str.replace(match[0], value);
      this.regexpUnescape.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }

    replaces = 0;
    // regular escape on demand
    while (match = this.regexp.exec(str)) {
      value = handleFormat(match[1].trim());
      if (value === undefined) {
        if (typeof missingInterpolationHandler === 'function') {
          var temp = missingInterpolationHandler(str, match);
          value = typeof temp === 'string' ? temp : '';
        } else {
          this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
          value = '';
        }
      } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
        value = __WEBPACK_IMPORTED_MODULE_0__utils_js__["e" /* makeString */](value);
      }
      value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }
    return str;
  };

  Interpolator.prototype.nest = function nest(str, fc) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var match = void 0;
    var value = void 0;

    var clonedOptions = _extends({}, options);
    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
    function handleHasOptions(key, inheritedOptions) {
      if (key.indexOf(',') < 0) return key;

      var p = key.split(',');
      key = p.shift();
      var optionsString = p.join(',');
      optionsString = this.interpolate(optionsString, clonedOptions);
      optionsString = optionsString.replace(/'/g, '"');

      try {
        clonedOptions = JSON.parse(optionsString);

        if (inheritedOptions) clonedOptions = _extends({}, inheritedOptions, clonedOptions);
      } catch (e) {
        this.logger.error('failed parsing options string in nesting for key ' + key, e);
      }

      return key;
    }

    // regular escape on demand
    while (match = this.nestingRegexp.exec(str)) {
      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);

      // is only the nesting key (key1 = '$(key2)') return the value without stringify
      if (value && match[0] === str && typeof value !== 'string') return value;

      // no string to include or empty
      if (typeof value !== 'string') value = __WEBPACK_IMPORTED_MODULE_0__utils_js__["e" /* makeString */](value);
      if (!value) {
        this.logger.warn('missed to resolve ' + match[1] + ' for nesting ' + str);
        value = '';
      }
      // Nested keys should not be escaped by default #854
      // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  return Interpolator;
}();

/* harmony default export */ __webpack_exports__["a"] = (Interpolator);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventEmitter_js__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }





function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.backend = backend;
    _this.store = store;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_1__logger_js__["a" /* default */].create('backendConnector');

    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }

  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, options, callback) {
    var _this2 = this;

    // find what needs to be loaded
    var toLoad = [];
    var pending = [];
    var toLoadLanguages = [];
    var toLoadNamespaces = [];

    languages.forEach(function (lng) {
      var hasAllNamespaces = true;

      namespaces.forEach(function (ns) {
        var name = lng + '|' + ns;

        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
          _this2.state[name] = 2; // loaded
        } else if (_this2.state[name] < 0) {
          // nothing to do for err
        } else if (_this2.state[name] === 1) {
          if (pending.indexOf(name) < 0) pending.push(name);
        } else {
          _this2.state[name] = 1; // pending

          hasAllNamespaces = false;

          if (pending.indexOf(name) < 0) pending.push(name);
          if (toLoad.indexOf(name) < 0) toLoad.push(name);
          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
        }
      });

      if (!hasAllNamespaces) toLoadLanguages.push(lng);
    });

    if (toLoad.length || pending.length) {
      this.queue.push({
        pending: pending,
        loaded: {},
        errors: [],
        callback: callback
      });
    }

    return {
      toLoad: toLoad,
      pending: pending,
      toLoadLanguages: toLoadLanguages,
      toLoadNamespaces: toLoadNamespaces
    };
  };

  Connector.prototype.loaded = function loaded(name, err, data) {
    var _name$split = name.split('|'),
        _name$split2 = _slicedToArray(_name$split, 2),
        lng = _name$split2[0],
        ns = _name$split2[1];

    if (err) this.emit('failedLoading', lng, ns, err);

    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    }

    // set loaded
    this.state[name] = err ? -1 : 2;

    // consolidated loading done in this run - only emit once for a loaded namespace
    var loaded = {};

    // callback if ready
    this.queue.forEach(function (q) {
      __WEBPACK_IMPORTED_MODULE_0__utils_js__["f" /* pushPath */](q.loaded, [lng], ns);
      remove(q.pending, name);

      if (err) q.errors.push(err);

      if (q.pending.length === 0 && !q.done) {
        // only do once per loaded -> this.emit('loaded', q.loaded);
        Object.keys(q.loaded).forEach(function (l) {
          if (!loaded[l]) loaded[l] = [];
          if (q.loaded[l].length) {
            q.loaded[l].forEach(function (ns) {
              if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
            });
          }
        });

        /* eslint no-param-reassign: 0 */
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });

    // emit consolidated loaded event
    this.emit('loaded', loaded);

    // remove done load requests
    this.queue = this.queue.filter(function (q) {
      return !q.done;
    });
  };

  Connector.prototype.read = function read(lng, ns, fcName) {
    var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    var _this3 = this;

    var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
    var callback = arguments[5];

    if (!lng.length) return callback(null, {}); // noting to load

    return this.backend[fcName](lng, ns, function (err, data) {
      if (err && data /* = retryFlag */ && tried < 5) {
        setTimeout(function () {
          _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    });
  };

  /* eslint consistent-return: 0 */


  Connector.prototype.prepareLoading = function prepareLoading(languages, namespaces) {
    var _this4 = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var callback = arguments[3];

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }

    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    var toLoad = this.queueLoad(languages, namespaces, options, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
      return null; // pendings will trigger callback
    }

    toLoad.toLoad.forEach(function (name) {
      _this4.loadOne(name);
    });
  };

  Connector.prototype.load = function load(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {}, callback);
  };

  Connector.prototype.reload = function reload(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, { reload: true }, callback);
  };

  Connector.prototype.loadOne = function loadOne(name) {
    var _this5 = this;

    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var _name$split3 = name.split('|'),
        _name$split4 = _slicedToArray(_name$split3, 2),
        lng = _name$split4[0],
        ns = _name$split4[1];

    this.read(lng, ns, 'read', null, null, function (err, data) {
      if (err) _this5.logger.warn(prefix + 'loading namespace ' + ns + ' for language ' + lng + ' failed', err);
      if (!err && data) _this5.logger.log(prefix + 'loaded namespace ' + ns + ' for language ' + lng, data);

      _this5.loaded(name, err, data);
    });
  };

  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    if (this.backend && this.backend.create) {
      this.backend.create(languages, namespace, key, fallbackValue, null /* unused callback */, _extends({}, options, { isUpdate: isUpdate }));
    }

    // write to store to avoid resending
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  };

  return Connector;
}(__WEBPACK_IMPORTED_MODULE_2__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Connector);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* harmony export (immutable) */ __webpack_exports__["b"] = transformOptions;

function get() {
  return {
    debug: false,
    initImmediate: true,

    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false, // string or array of namespaces

    whitelist: false, // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all', // | currentOnly | languageOnly
    preload: false, // array with preload languages

    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',

    saveMissing: false, // enable to send missing values
    updateMissing: false, // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
    saveMissingTo: 'fallback', // 'current' || 'all'
    saveMissingPlurals: true, // will save all forms not only singular key
    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling
    missingInterpolationHandler: false, // function(str, match)

    postProcess: false, // string or array of postProcessor names
    returnNull: true, // allows null value as valid translation
    returnEmptyString: true, // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false, // or string to join array
    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (args[1]) ret.defaultValue = args[1];
      if (args[2]) ret.tDescription = args[2];
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',

      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
      maxReplaces: 1000 // max replaces to prevent endless loop
    }
  };
}

/* eslint no-param-reassign: 0 */
function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  // extend whitelist with cimode
  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
    options.whitelist = options.whitelist.concat(['cimode']);
  }

  return options;
}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(59).default;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(60);

var utils = _interopRequireWildcard(_utils);

var _ajax = __webpack_require__(61);

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getDefaults() {
  return {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: '/locales/add/{{lng}}/{{ns}}',
    allowMultiLoading: false,
    parse: JSON.parse,
    crossDomain: false,
    ajax: _ajax2.default
  };
}

var Backend = function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Backend);

    this.init(services, options);

    this.type = 'backend';
  }

  _createClass(Backend, [{
    key: 'init',
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.services = services;
      this.options = utils.defaults(options, this.options || {}, getDefaults());
    }
  }, {
    key: 'readMulti',
    value: function readMulti(languages, namespaces, callback) {
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath(languages, namespaces);
      }

      var url = this.services.interpolator.interpolate(loadPath, { lng: languages.join('+'), ns: namespaces.join('+') });

      this.loadUrl(url, callback);
    }
  }, {
    key: 'read',
    value: function read(language, namespace, callback) {
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath([language], [namespace]);
      }

      var url = this.services.interpolator.interpolate(loadPath, { lng: language, ns: namespace });

      this.loadUrl(url, callback);
    }
  }, {
    key: 'loadUrl',
    value: function loadUrl(url, callback) {
      var _this = this;

      this.options.ajax(url, this.options, function (data, xhr) {
        if (xhr.status >= 500 && xhr.status < 600) return callback('failed loading ' + url, true /* retry */);
        if (xhr.status >= 400 && xhr.status < 500) return callback('failed loading ' + url, false /* no retry */);

        var ret = void 0,
            err = void 0;
        try {
          ret = _this.options.parse(data, url);
        } catch (e) {
          err = 'failed parsing ' + url + ' to json';
        }
        if (err) return callback(err, false);
        callback(null, ret);
      });
    }
  }, {
    key: 'create',
    value: function create(languages, namespace, key, fallbackValue) {
      var _this2 = this;

      if (typeof languages === 'string') languages = [languages];

      var payload = {};
      payload[key] = fallbackValue || '';

      languages.forEach(function (lng) {
        var url = _this2.services.interpolator.interpolate(_this2.options.addPath, { lng: lng, ns: namespace });

        _this2.options.ajax(url, _this2.options, function (data, xhr) {
          //const statusCode = xhr.status.toString();
          // TODO: if statusCode === 4xx do log
        }, payload);
      });
    }
  }]);

  return Backend;
}();

Backend.type = 'backend';

exports.default = Backend;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaults = defaults;
exports.extend = extend;
var arr = [];
var each = arr.forEach;
var slice = arr.slice;

function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

function extend(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function addQueryString(url, params) {
  if (params && (typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
    var queryString = '',
        e = encodeURIComponent;

    // Must encode data
    for (var paramName in params) {
      queryString += '&' + e(paramName) + '=' + e(params[paramName]);
    }

    if (!queryString) {
      return url;
    }

    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
  }

  return url;
}

// https://gist.github.com/Xeoncross/7663273
function ajax(url, options, callback, data, cache) {

  if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
    if (!cache) {
      data['_t'] = new Date();
    }
    // URL encoded form data must be in querystring format
    data = addQueryString('', data).slice(1);
  }

  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }

  try {
    var x;
    if (XMLHttpRequest) {
      x = new XMLHttpRequest();
    } else {
      x = new ActiveXObject('MSXML2.XMLHTTP.3.0');
    }
    x.open(data ? 'POST' : 'GET', url, 1);
    if (!options.crossDomain) {
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }
    x.withCredentials = !!options.withCredentials;
    if (data) {
      x.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    }
    if (x.overrideMimeType) {
      x.overrideMimeType("application/json");
    }
    var h = options.customHeaders;
    if (h) {
      for (var i in h) {
        x.setRequestHeader(i, h[i]);
      }
    }
    x.onreadystatechange = function () {
      x.readyState > 3 && callback && callback(x.responseText, x);
    };
    x.send(data);
  } catch (e) {
    console && console.log(e);
  }
}

exports.default = ajax;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(63).default;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(64);

var utils = _interopRequireWildcard(_utils);

var _cookie = __webpack_require__(65);

var _cookie2 = _interopRequireDefault(_cookie);

var _querystring = __webpack_require__(66);

var _querystring2 = _interopRequireDefault(_querystring);

var _localStorage = __webpack_require__(67);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _navigator = __webpack_require__(68);

var _navigator2 = _interopRequireDefault(_navigator);

var _htmlTag = __webpack_require__(69);

var _htmlTag2 = _interopRequireDefault(_htmlTag);

var _path = __webpack_require__(70);

var _path2 = _interopRequireDefault(_path);

var _subdomain = __webpack_require__(71);

var _subdomain2 = _interopRequireDefault(_subdomain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getDefaults() {
  return {
    order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',

    // cache user language
    caches: ['localStorage'],
    excludeCacheFor: ['cimode']
    //cookieMinutes: 10,
    //cookieDomain: 'myDomain'
  };
}

var Browser = function () {
  function Browser(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Browser);

    this.type = 'languageDetector';
    this.detectors = {};

    this.init(services, options);
  }

  _createClass(Browser, [{
    key: 'init',
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.services = services;
      this.options = utils.defaults(options, this.options || {}, getDefaults());

      // backwards compatibility
      if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;

      this.i18nOptions = i18nOptions;

      this.addDetector(_cookie2.default);
      this.addDetector(_querystring2.default);
      this.addDetector(_localStorage2.default);
      this.addDetector(_navigator2.default);
      this.addDetector(_htmlTag2.default);
      this.addDetector(_path2.default);
      this.addDetector(_subdomain2.default);
    }
  }, {
    key: 'addDetector',
    value: function addDetector(detector) {
      this.detectors[detector.name] = detector;
    }
  }, {
    key: 'detect',
    value: function detect(detectionOrder) {
      var _this = this;

      if (!detectionOrder) detectionOrder = this.options.order;

      var detected = [];
      detectionOrder.forEach(function (detectorName) {
        if (_this.detectors[detectorName]) {
          var lookup = _this.detectors[detectorName].lookup(_this.options);
          if (lookup && typeof lookup === 'string') lookup = [lookup];
          if (lookup) detected = detected.concat(lookup);
        }
      });

      var found = void 0;
      detected.forEach(function (lng) {
        if (found) return;
        var cleanedLng = _this.services.languageUtils.formatLanguageCode(lng);
        if (_this.services.languageUtils.isWhitelisted(cleanedLng)) found = cleanedLng;
      });

      if (!found) {
        var fallbacks = this.i18nOptions.fallbackLng;
        if (typeof fallbacks === 'string') fallbacks = [fallbacks];
        if (!fallbacks) fallbacks = [];

        if (Object.prototype.toString.apply(fallbacks) === '[object Array]') {
          found = fallbacks[0];
        } else {
          found = fallbacks[0] || fallbacks.default && fallbacks.default[0];
        }
      };

      return found;
    }
  }, {
    key: 'cacheUserLanguage',
    value: function cacheUserLanguage(lng, caches) {
      var _this2 = this;

      if (!caches) caches = this.options.caches;
      if (!caches) return;
      if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
      caches.forEach(function (cacheName) {
        if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
      });
    }
  }]);

  return Browser;
}();

Browser.type = 'languageDetector';

exports.default = Browser;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaults = defaults;
exports.extend = extend;
var arr = [];
var each = arr.forEach;
var slice = arr.slice;

function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

function extend(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var cookie = {
  create: function create(name, value, minutes, domain) {
    var expires = void 0;
    if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = '; expires=' + date.toGMTString();
    } else expires = '';
    domain = domain ? 'domain=' + domain + ';' : '';
    document.cookie = name + '=' + value + expires + ';' + domain + 'path=/';
  },

  read: function read(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  remove: function remove(name) {
    this.create(name, '', -1);
  }
};

exports.default = {
  name: 'cookie',

  lookup: function lookup(options) {
    var found = void 0;

    if (options.lookupCookie && typeof document !== 'undefined') {
      var c = cookie.read(options.lookupCookie);
      if (c) found = c;
    }

    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupCookie && typeof document !== 'undefined') {
      cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain);
    }
  }
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'querystring',

  lookup: function lookup(options) {
    var found = void 0;

    if (typeof window !== 'undefined') {
      var query = window.location.search.substring(1);
      var params = query.split('&');
      for (var i = 0; i < params.length; i++) {
        var pos = params[i].indexOf('=');
        if (pos > 0) {
          var key = params[i].substring(0, pos);
          if (key === options.lookupQuerystring) {
            found = params[i].substring(pos + 1);
          }
        }
      }
    }

    return found;
  }
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasLocalStorageSupport = void 0;
try {
  hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
  var testKey = 'i18next.translate.boo';
  window.localStorage.setItem(testKey, 'foo');
  window.localStorage.removeItem(testKey);
} catch (e) {
  hasLocalStorageSupport = false;
}

exports.default = {
  name: 'localStorage',

  lookup: function lookup(options) {
    var found = void 0;

    if (options.lookupLocalStorage && hasLocalStorageSupport) {
      var lng = window.localStorage.getItem(options.lookupLocalStorage);
      if (lng) found = lng;
    }

    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupLocalStorage && hasLocalStorageSupport) {
      window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
  }
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'navigator',

  lookup: function lookup(options) {
    var found = [];

    if (typeof navigator !== 'undefined') {
      if (navigator.languages) {
        // chrome only; not an array, so can't use .push.apply instead of iterating
        for (var i = 0; i < navigator.languages.length; i++) {
          found.push(navigator.languages[i]);
        }
      }
      if (navigator.userLanguage) {
        found.push(navigator.userLanguage);
      }
      if (navigator.language) {
        found.push(navigator.language);
      }
    }

    return found.length > 0 ? found : undefined;
  }
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'htmlTag',

  lookup: function lookup(options) {
    var found = void 0;
    var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);

    if (htmlTag && typeof htmlTag.getAttribute === 'function') {
      found = htmlTag.getAttribute('lang');
    }

    return found;
  }
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'path',

  lookup: function lookup(options) {
    var found = void 0;
    if (typeof window !== 'undefined') {
      var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (language instanceof Array) {
        if (typeof options.lookupFromPathIndex === 'number') {
          if (typeof language[options.lookupFromPathIndex] !== 'string') {
            return undefined;
          }
          found = language[options.lookupFromPathIndex].replace('/', '');
        } else {
          found = language[0].replace('/', '');
        }
      }
    }
    return found;
  }
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'subdomain',

  lookup: function lookup(options) {
    var found = void 0;
    if (typeof window !== 'undefined') {
      var language = window.location.href.match(/(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/gi);
      if (language instanceof Array) {
        if (typeof options.lookupFromSubdomainIndex === 'number') {
          found = language[options.lookupFromSubdomainIndex].replace('http://', '').replace('https://', '').replace('.', '');
        } else {
          found = language[0].replace('http://', '').replace('https://', '').replace('.', '');
        }
      }
    }
    return found;
  }
};

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shallowEqual__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__I18n__ = __webpack_require__(23);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








function getDisplayName(component) {
  return component.displayName || component.name || 'Component';
}

function translate(namespaceArg) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


  return function Wrapper(WrappedComponent) {
    var Translate = function (_Component) {
      _inherits(Translate, _Component);

      function Translate(props, context) {
        _classCallCheck(this, Translate);

        var _this = _possibleConstructorReturn(this, (Translate.__proto__ || Object.getPrototypeOf(Translate)).call(this, props, context));

        _this.i18n = props.i18n || options.i18n || context.i18n || Object(__WEBPACK_IMPORTED_MODULE_4__context__["b" /* getI18n */])();
        _this.namespaces = typeof namespaceArg === 'function' ? namespaceArg(props) : namespaceArg || context.defaultNS || _this.i18n.options && _this.i18n.options.defaultNS;
        if (typeof _this.namespaces === 'string') _this.namespaces = [_this.namespaces];

        var i18nOptions = _this.i18n && _this.i18n.options && _this.i18n.options.react || {};
        _this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__context__["a" /* getDefaults */])(), i18nOptions, options);

        if (context.reportNS) {
          var namespaces = _this.namespaces || [undefined];
          namespaces.forEach(context.reportNS);
        }

        _this.getWrappedInstance = _this.getWrappedInstance.bind(_this);
        return _this;
      }

      _createClass(Translate, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
          if (!this.options.usePureComponent) {
            return true;
          }

          return !Object(__WEBPACK_IMPORTED_MODULE_3__shallowEqual__["a" /* default */])(this.props, nextProps);
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          if (!this.options.withRef) {
            // eslint-disable-next-line no-console
            console.error('To access the wrapped instance, you need to specify ' + '{ withRef: true } as the second argument of the translate() call.');
          }

          /* eslint react/no-string-refs: 1 */
          return this.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var extraProps = {};

          if (this.options.withRef) {
            extraProps.ref = function (c) {
              _this2.wrappedInstance = c;
            };
          }

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__I18n__["a" /* default */], _extends({ ns: this.namespaces }, this.options, this.props, { i18n: this.i18n }), function (t, _ref) {
            var ready = _ref.ready,
                context = _objectWithoutProperties(_ref, ['ready']);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
              tReady: ready
            }, _this2.props, extraProps, context));
          });
        }
      }]);

      return Translate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Translate.WrappedComponent = WrappedComponent;

    Translate.contextTypes = {
      i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
      defaultNS: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      reportNS: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
    };

    Translate.displayName = 'Translate(' + getDisplayName(WrappedComponent) + ')';

    Translate.namespaces = namespaceArg;

    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Translate, WrappedComponent);
  };
}

translate.setDefaults = __WEBPACK_IMPORTED_MODULE_4__context__["d" /* setDefaults */];

translate.setI18n = __WEBPACK_IMPORTED_MODULE_4__context__["e" /* setI18n */];

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(74);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowEqual
 * @typechecks
 * 
 */

/* eslint-disable no-self-compare */

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  }
  // Step 6.a: NaN == NaN
  return x !== x && y !== y;
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Interpolate = function (_Component) {
  _inherits(Interpolate, _Component);

  function Interpolate(props, context) {
    _classCallCheck(this, Interpolate);

    var _this = _possibleConstructorReturn(this, (Interpolate.__proto__ || Object.getPrototypeOf(Interpolate)).call(this, props, context));

    _this.i18n = props.i18n || context.i18n;
    _this.t = props.t || context.t;
    return _this;
  }

  _createClass(Interpolate, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var parent = this.props.parent || 'span';
      var REGEXP = this.props.regexp || this.i18n.services.interpolator.regexp;
      var _props = this.props,
          className = _props.className,
          style = _props.style;

      // Set to true if you want to use raw HTML in translation values
      // See https://github.com/i18next/react-i18next/issues/189

      var useDangerouslySetInnerHTML = this.props.useDangerouslySetInnerHTML || false;
      var dangerouslySetInnerHTMLPartElement = this.props.dangerouslySetInnerHTMLPartElement || 'span';

      var tOpts = _extends({}, this.props.options, { interpolation: { prefix: '#$?', suffix: '?$#' } });
      var format = this.t(this.props.i18nKey, tOpts);

      if (!format || typeof format !== 'string') return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('noscript', null);

      var children = [];

      var handleFormat = function handleFormat(key, props) {
        if (key.indexOf(_this2.i18n.options.interpolation.formatSeparator) < 0) {
          if (props[key] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + key + ' for interpolating ' + format);
          return props[key];
        }

        var p = key.split(_this2.i18n.options.interpolation.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this2.i18n.options.interpolation.formatSeparator).trim();

        if (props[k] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + k + ' for interpolating ' + format);
        return _this2.i18n.options.interpolation.format(props[k], f, _this2.i18n.language);
      };

      format.split(REGEXP).reduce(function (memo, match, index) {
        var child = void 0;

        if (index % 2 === 0) {
          if (match.length === 0) return memo;
          if (useDangerouslySetInnerHTML) {
            child = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(dangerouslySetInnerHTMLPartElement, { dangerouslySetInnerHTML: { __html: match } });
          } else {
            child = match;
          }
        } else {
          child = handleFormat(match, _this2.props);
        }

        memo.push(child);
        return memo;
      }, children);

      var additionalProps = {};
      if (this.i18n.options.react && this.i18n.options.react.exposeNamespace) {
        var ns = typeof this.t.ns === 'string' ? this.t.ns : this.t.ns[0];
        if (this.props.i18nKey && this.i18n.options.nsSeparator && this.props.i18nKey.indexOf(this.i18n.options.nsSeparator) > -1) {
          var parts = this.props.i18nKey.split(this.i18n.options.nsSeparator);
          ns = parts[0];
        }
        if (this.t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
      }

      if (className) additionalProps.className = className;
      if (style) additionalProps.style = style;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement.apply(this, [parent, additionalProps].concat(children));
    }
  }]);

  return Interpolate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Interpolate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Interpolate.defaultProps = {
  className: ''
};

Interpolate.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (Interpolate);

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





function hasChildren(node) {
  return node && (node.children || node.props && node.props.children);
}

function getChildren(node) {
  return node && node.children ? node.children : node.props && node.props.children;
}

function nodesToString(mem, children, index) {
  if (!children) return '';
  if (Object.prototype.toString.call(children) !== '[object Array]') children = [children];

  children.forEach(function (child, i) {
    // const isElement = React.isValidElement(child);
    // const elementKey = `${index !== 0 ? index + '-' : ''}${i}:${typeof child.type === 'function' ? child.type.name : child.type || 'var'}`;
    var elementKey = '' + i;

    if (typeof child === 'string') {
      mem = '' + mem + child;
    } else if (hasChildren(child)) {
      mem = mem + '<' + elementKey + '>' + nodesToString('', getChildren(child), i + 1) + '</' + elementKey + '>';
    } else if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      mem = mem + '<' + elementKey + '></' + elementKey + '>';
    } else if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object') {
      var clone = _extends({}, child);
      var format = clone.format;
      delete clone.format;

      var keys = Object.keys(clone);
      if (format && keys.length === 1) {
        mem = mem + '<' + elementKey + '>{{' + keys[0] + ', ' + format + '}}</' + elementKey + '>';
      } else if (keys.length === 1) {
        mem = mem + '<' + elementKey + '>{{' + keys[0] + '}}</' + elementKey + '>';
      } else if (console && console.warn) {
        // not a valid interpolation object (can only contain one value plus format)
        console.warn('react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.', child);
      }
    } else if (console && console.warn) {
      console.warn('react-i18next: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.', child);
    }
  });

  return mem;
}

function renderNodes(children, targetString, i18n) {
  if (targetString === "") return [];
  if (!children) return [targetString];

  // parse ast from string with additional wrapper tag
  // -> avoids issues in parser removing prepending text nodes
  var ast = __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2___default.a.parse('<0>' + targetString + '</0>');

  function mapAST(reactNodes, astNodes) {
    if (Object.prototype.toString.call(reactNodes) !== '[object Array]') reactNodes = [reactNodes];
    if (Object.prototype.toString.call(astNodes) !== '[object Array]') astNodes = [astNodes];

    return astNodes.reduce(function (mem, node, i) {
      if (node.type === 'tag') {
        var child = reactNodes[parseInt(node.name, 10)] || {};
        var isElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child);

        if (typeof child === 'string') {
          mem.push(child);
        } else if (hasChildren(child)) {
          var inner = mapAST(getChildren(child), node.children);
          if (child.dummy) child.children = inner; // needed on preact!
          mem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _extends({}, child.props, { key: i }), inner));
        } else if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object' && !isElement) {
          var content = node.children[0] ? node.children[0].content : null;
          if (content) {
            var interpolated = i18n.services.interpolator.interpolate(node.children[0].content, child, i18n.language);
            mem.push(interpolated);
          }
        } else {
          mem.push(child);
        }
      } else if (node.type === 'text') {
        mem.push(node.content);
      }
      return mem;
    }, []);
  }

  // call mapAST with having react nodes nested into additional node like
  // we did for the string ast from translation
  // return the children of that extra node to get expected result
  var result = mapAST([{ dummy: true, children: children }], ast);
  return getChildren(result[0]);
}

var Trans = function (_React$Component) {
  _inherits(Trans, _React$Component);

  function Trans() {
    _classCallCheck(this, Trans);

    return _possibleConstructorReturn(this, (Trans.__proto__ || Object.getPrototypeOf(Trans)).apply(this, arguments));
  }

  _createClass(Trans, [{
    key: 'render',
    value: function render() {
      var contextAndProps = _extends({ i18n: this.context.i18n, t: this.context.t }, this.props);

      var children = contextAndProps.children,
          count = contextAndProps.count,
          parent = contextAndProps.parent,
          i18nKey = contextAndProps.i18nKey,
          tOptions = contextAndProps.tOptions,
          values = contextAndProps.values,
          defaults = contextAndProps.defaults,
          components = contextAndProps.components,
          namespace = contextAndProps.ns,
          i18n = contextAndProps.i18n,
          tFromContextAndProps = contextAndProps.t,
          additionalProps = _objectWithoutProperties(contextAndProps, ['children', 'count', 'parent', 'i18nKey', 'tOptions', 'values', 'defaults', 'components', 'ns', 'i18n', 't']);

      var t = tFromContextAndProps || i18n.t.bind(i18n);

      var reactI18nextOptions = i18n.options && i18n.options.react || {};
      var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;

      var defaultValue = defaults || nodesToString('', children, 0);
      var hashTransKey = reactI18nextOptions.hashTransKey;
      var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
      var interpolationOverride = values ? {} : { interpolation: { prefix: '#$?', suffix: '?$#' } };
      var translation = key ? t(key, _extends({}, tOptions, values, interpolationOverride, { defaultValue: defaultValue, count: count, ns: namespace })) : defaultValue;

      if (reactI18nextOptions.exposeNamespace) {
        var ns = typeof t.ns === 'string' ? t.ns : t.ns[0];
        if (i18nKey && i18n.options && i18n.options.nsSeparator && i18nKey.indexOf(i18n.options.nsSeparator) > -1) {
          var parts = i18nKey.split(i18n.options.nsSeparator);
          ns = parts[0];
        }
        if (t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
      }

      if (!useAsParent) return renderNodes(components || children, translation, i18n);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(useAsParent, additionalProps, renderNodes(components || children, translation, i18n));
    }
  }]);

  return Trans;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Trans);


Trans.propTypes = {
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  parent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  i18nKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

// Trans.defaultProps = {
//   parent: 'div'
// };

Trans.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
    parse: __webpack_require__(79),
    stringify: __webpack_require__(82)
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

/*jshint -W030 */
var tagRE = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>)/g;
var parseTag = __webpack_require__(80);
// re-used obj for quick lookups of components
var empty = Object.create ? Object.create(null) : {};
// common logic for pushing a child node onto a list
function pushTextNode(list, html, level, start, ignoreWhitespace) {
    // calculate correct end of the content slice in case there's
    // no tag after the text node.
    var end = html.indexOf('<', start);
    var content = html.slice(start, end === -1 ? undefined : end);
    // if a node is nothing but whitespace, collapse it as the spec states:
    // https://www.w3.org/TR/html4/struct/text.html#h-9.1
    if (/^\s*$/.test(content)) {
        content = ' ';
    }
    // don't add whitespace-only text nodes if they would be trailing text nodes
    // or if they would be leading whitespace-only text nodes:
    //  * end > -1 indicates this is not a trailing text node
    //  * leading node is when level is -1 and list has length 0
    if ((!ignoreWhitespace && end > -1 && level + list.length >= 0) || content !== ' ') {
        list.push({
            type: 'text',
            content: content
        });
    }
}

module.exports = function parse(html, options) {
    options || (options = {});
    options.components || (options.components = empty);
    var result = [];
    var current;
    var level = -1;
    var arr = [];
    var byTag = {};
    var inComponent = false;

    html.replace(tagRE, function (tag, index) {
        if (inComponent) {
            if (tag !== ('</' + current.name + '>')) {
                return;
            } else {
                inComponent = false;
            }
        }

        var isOpen = tag.charAt(1) !== '/';
        var isComment = tag.indexOf('<!--') === 0;
        var start = index + tag.length;
        var nextChar = html.charAt(start);
        var parent;

        if (isOpen && !isComment) {
            level++;

            current = parseTag(tag);
            if (current.type === 'tag' && options.components[current.name]) {
                current.type = 'component';
                inComponent = true;
            }

            if (!current.voidElement && !inComponent && nextChar && nextChar !== '<') {
                pushTextNode(current.children, html, level, start, options.ignoreWhitespace);
            }

            byTag[current.tagName] = current;

            // if we're at root, push new base node
            if (level === 0) {
                result.push(current);
            }

            parent = arr[level - 1];

            if (parent) {
                parent.children.push(current);
            }

            arr[level] = current;
        }

        if (isComment || !isOpen || current.voidElement) {
            if (!isComment) {
                level--;
            }
            if (!inComponent && nextChar !== '<' && nextChar) {
                // trailing text node
                // if we're at the root, push a base text node. otherwise add as
                // a child to the current node.
                parent = level === -1 ? result : arr[level].children;
                pushTextNode(parent, html, level, start, options.ignoreWhitespace);
            }
        }
    });

    // If the "html" passed isn't actually html, add it as a text node.
    if (!result.length && html.length) {
        pushTextNode(result, html, 0, 0, options.ignoreWhitespace);
    }

    return result;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var attrRE = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g;
var voidElements = __webpack_require__(81);

module.exports = function (tag) {
    var i = 0;
    var key;
    var expectingValueAfterEquals = true;
    var res = {
        type: 'tag',
        name: '',
        voidElement: false,
        attrs: {},
        children: []
    };

    tag.replace(attrRE, function (match) {
        if (match === '=') {
            expectingValueAfterEquals = true;
            i++;
            return;
        }

        if (!expectingValueAfterEquals) {
            if (key) {
                res.attrs[key] = key; // boolean attribute
            }
            key=match;
        } else {
            if (i === 0) {
                if (voidElements[match] || tag.charAt(tag.length - 2) === '/') {
                    res.voidElement = true;
                }
                res.name = match;
            } else {
                res.attrs[key] = match.replace(/^['"]|['"]$/g, '');
                key=undefined;
            }
        }
        i++;
        expectingValueAfterEquals = false;
    });

    return res;
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "keygen": true,
  "link": true,
  "menuitem": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

function attrString(attrs) {
    var buff = [];
    for (var key in attrs) {
        buff.push(key + '="' + attrs[key] + '"');
    }
    if (!buff.length) {
        return '';
    }
    return ' ' + buff.join(' ');
}

function stringify(buff, doc) {
    switch (doc.type) {
    case 'text':
        return buff + doc.content;
    case 'tag':
        buff += '<' + doc.name + (doc.attrs ? attrString(doc.attrs) : '') + (doc.voidElement ? '/>' : '>');
        if (doc.voidElement) {
            return buff;
        }
        return buff + doc.children.reduce(stringify, '') + '</' + doc.name + '>';
    }
}

module.exports = function (doc) {
    return doc.reduce(function (token, rootEl) {
        return token + stringify('', rootEl);
    }, '');
};


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var I18nextProvider = function (_Component) {
  _inherits(I18nextProvider, _Component);

  function I18nextProvider(props, context) {
    _classCallCheck(this, I18nextProvider);

    var _this = _possibleConstructorReturn(this, (I18nextProvider.__proto__ || Object.getPrototypeOf(I18nextProvider)).call(this, props, context));

    _this.i18n = props.i18n;
    _this.defaultNS = props.defaultNS;
    if (props.initialI18nStore) {
      _this.i18n.services.resourceStore.data = props.initialI18nStore;
      _this.i18n.options.isInitialSSR = true; // if set will be deleted on first render in translate hoc
    }
    if (props.initialLanguage) {
      _this.i18n.changeLanguage(props.initialLanguage);
    }
    _this.reportNS = props.reportNS;
    return _this;
  }

  _createClass(I18nextProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        i18n: this.i18n,
        defaultNS: this.defaultNS,
        reportNS: this.reportNS
      };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.i18n !== nextProps.i18n) {
        throw new Error('[react-i18next][I18nextProvider]does not support changing the i18n object.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children);
    }
  }]);

  return I18nextProvider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

I18nextProvider.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,
  defaultNS: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  reportNS: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

I18nextProvider.childContextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  defaultNS: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  reportNS: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

I18nextProvider.defaultProps = {
  defaultNS: undefined,
  reportNS: undefined
};

/* unused harmony default export */ var _unused_webpack_default_export = (I18nextProvider);

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var objectEntries = Object.entries || function (obj) {
  var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array
  while (i--) {
    resArray[i] = [ownProps[i], obj[ownProps[i]]];
  }return resArray;
};

// Borrowed from https://github.com/Rezonans/redux-async-connect/blob/master/modules/ReduxAsyncConnect.js#L16
function eachComponents(components, iterator) {
  for (var i = 0, l = components.length; i < l; i++) {
    // eslint-disable-line id-length
    if (_typeof(components[i]) === 'object') {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = objectEntries(components[i])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          iterator(value, i, key);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else {
      iterator(components[i], i);
    }
  }
}

function filterAndFlattenComponents(components) {
  var flattened = [];
  eachComponents(components, function (Component) {
    if (Component && Component.namespaces) {

      Component.namespaces.forEach(function (namespace) {
        if (flattened.indexOf(namespace) === -1) {
          flattened.push(namespace);
        }
      });
    }
  });
  return flattened;
}

function loadNamespaces(_ref) {
  var components = _ref.components,
      i18n = _ref.i18n;

  var allNamespaces = filterAndFlattenComponents(components);

  return new Promise(function (resolve) {
    i18n.loadNamespaces(allNamespaces, resolve);
  });
}

/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_index__ = __webpack_require__(88);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_index__["a" /* default */],null);}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes_Main__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["a" /* I18n */],{ns:'translations'},function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__routes_Main__["a" /* default */],null);});}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_home__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_contact__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_service__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_faq__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_pageNotFound__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_privacyPolicy__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_guide_auto_transfer__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_guide_auto_transfer_app__ = __webpack_require__(141);
var Main=function Main(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:'/',component:__WEBPACK_IMPORTED_MODULE_2__containers_home__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/contact',component:__WEBPACK_IMPORTED_MODULE_3__containers_contact__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/service',component:__WEBPACK_IMPORTED_MODULE_4__containers_service__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/faq',component:__WEBPACK_IMPORTED_MODULE_5__containers_faq__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/a/faq',component:__WEBPACK_IMPORTED_MODULE_5__containers_faq__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/privacy',component:__WEBPACK_IMPORTED_MODULE_7__containers_privacyPolicy__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/guide/auto-transfer',component:__WEBPACK_IMPORTED_MODULE_8__containers_guide_auto_transfer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/guide/auto-transfer-app',component:__WEBPACK_IMPORTED_MODULE_9__containers_guide_auto_transfer_app__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_6__containers_pageNotFound__["a" /* default */]})));};/* harmony default export */ __webpack_exports__["a"] = (Main);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(13);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(25)('createBrowserHistory');
module.exports = __webpack_require__(26).createBrowserHistory;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(27)),valueEqual=_interopDefault(__webpack_require__(28));__webpack_require__(29);var invariant=_interopDefault(__webpack_require__(30));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(13);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(25)('createHashHistory');
module.exports = __webpack_require__(26).createHashHistory;


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(96);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(14);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _extends; });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(31);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(101);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(103);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(104);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["d" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(106);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(14);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(108);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(16);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(16);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(111);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(33);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__introduce_multisign__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__introduce_coin__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__section1__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__section2__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__section3__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__section5__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__section6__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__section7__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__section8__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__section10__ = __webpack_require__(123);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Home=function(_Component){_inherits(Home,_Component);function Home(props){_classCallCheck(this,Home);var _this=_possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).call(this,props));_this.state={home:'home_57'};return _this;}_createClass(Home,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var query=new URLSearchParams(document.location.search);var lang=query.get('lang');if(lang&&['en','ch','ja','ko'].includes(lang)){localStorage.setItem('i18nextLng',lang);}setTimeout(function(){return _this2.node.scrollIntoView();},0);if(localStorage.getItem('i18nextLng')==='vi-VN'){localStorage.setItem('i18nextLng','en');}__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#quickly-event').click(function(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('html, body').animate({'scrollTop':__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#quickly').offset().top-70},1800);});__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#secure-event').click(function(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('html, body').animate({'scrollTop':__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#secure').offset().top-30},1800);});__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#low-fee-event').click(function(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('html, body').animate({'scrollTop':__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#low-fee').offset().top-100},2000);});}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],{ns:'translations'},function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'wrapper',ref:function ref(node){return _this3.node=node;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__section1__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__section2__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__section3__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__introduce_multisign__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__section5__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__section6__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__section7__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__section8__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__section10__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__introduce_coin__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__footer__["a" /* default */],null));});}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slideshow_image__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slideshow_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_slideshow_image__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var properties={duration:5000,transitionDuration:500,infinite:true,arrows:true};var multisigData=[{tag:'#role-l1',title:'home_92',content:['home_93','home_94','home_95','home_96']},{tag:'#role-l2',title:'home_97',content:['home_98','home_99']},{tag:'#role-l3',title:'home_100',content:['home_101']},{tag:'#role-l4',title:'home_102',content:['home_103','home_104','home_105']}];var sharedData=[{tag:'#role-m1',title:'home_106',content:['home_107']},{tag:'#role-m2',title:'home_108',content:['home_109','home_110']},{tag:'#role-m3',title:'home_111',content:['home_112','home_113','home_114','home_115','home_116','home_117']}];var IntroduceMultiSign=function(_Component){_inherits(IntroduceMultiSign,_Component);function IntroduceMultiSign(props){_classCallCheck(this,IntroduceMultiSign);var _this=_possibleConstructorReturn(this,(IntroduceMultiSign.__proto__||Object.getPrototypeOf(IntroduceMultiSign)).call(this,props));_this.state={active:'multisig',data:multisigData};return _this;}_createClass(IntroduceMultiSign,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],null,function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',id:'section8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:30,paddingBottom:100}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-12 col-md-12 cs8-top nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn cs8t-consnumer wow bounceInDown '+(_this2.state.active==='multisig'?'active':''),onClick:function onClick(){return _this2.changeActive('multisig');},'data-toggle':'tab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'slant-left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'cs8t-title'},t('home_95')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'slant-right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn cs8t-issuert wow bounceInDown '+(_this2.state.active==='shared'?'active':''),'data-wow-delay':'1s',onClick:function onClick(){return _this2.changeActive('shared');},'data-toggle':'tab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'slant-left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'cs8t-title'},t('home_96')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'slant-right'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-pane fade in active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-6 col-md-6 cs8-left wow animated slideInLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-multi-shared',src:'/images/shared-wallet.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-6 col-md-6 cs8-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_slideshow_image__["Slide"],Object.assign({},properties,{id:'slide'}),_this2.renderData(t)))))))));});}},{key:'renderContent',value:function renderContent(t,item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,item.content.map(function(content,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:index.toString()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'multi-shared-content'},t(content)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}));}},{key:'renderData',value:function renderData(t){var _this3=this;return this.state.data.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingLeft:50,paddingRight:50},key:index.toString()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'wow fadeInRightBig text-uppercase'},t(item.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),_this3.renderContent(t,item));});}},{key:'changeActive',value:function changeActive(active){this.setState({active:active,data:active==='multisig'?multisigData:sharedData});}}]);return IntroduceMultiSign;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IntroduceMultiSign);

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],e):"object"==typeof exports?exports["react-slideshow-image"]=e(require("react")):t["react-slideshow-image"]=e(t.React)}(window,(function(t){return function(t){var e={};function n(i){if(e[i])return e[i].exports;var r=e[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=t,n.c=e,n.d=function(t,e,i){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)n.d(i,r,function(e){return t[e]}.bind(null,r));return i},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=16)}([function(t,e,n){t.exports=n(8)()},function(e,n){e.exports=t},function(t,e,n){"use strict";(function(t){var n=function(){this._tweens={},this._tweensAddedDuringUpdate={}};n.prototype={getAll:function(){return Object.keys(this._tweens).map(function(t){return this._tweens[t]}.bind(this))},removeAll:function(){this._tweens={}},add:function(t){this._tweens[t.getId()]=t,this._tweensAddedDuringUpdate[t.getId()]=t},remove:function(t){delete this._tweens[t.getId()],delete this._tweensAddedDuringUpdate[t.getId()]},update:function(t,e){var n=Object.keys(this._tweens);if(0===n.length)return!1;for(t=void 0!==t?t:r.now();n.length>0;){this._tweensAddedDuringUpdate={};for(var i=0;i<n.length;i++){var o=this._tweens[n[i]];o&&!1===o.update(t)&&(o._isPlaying=!1,e||delete this._tweens[n[i]])}n=Object.keys(this._tweensAddedDuringUpdate)}return!0}};var i,r=new n;r.Group=n,r._nextId=0,r.nextId=function(){return r._nextId++},"undefined"==typeof self&&void 0!==t&&t.hrtime?r.now=function(){var e=t.hrtime();return 1e3*e[0]+e[1]/1e6}:"undefined"!=typeof self&&void 0!==self.performance&&void 0!==self.performance.now?r.now=self.performance.now.bind(self.performance):void 0!==Date.now?r.now=Date.now:r.now=function(){return(new Date).getTime()},r.Tween=function(t,e){this._object=t,this._valuesStart={},this._valuesEnd={},this._valuesStartRepeat={},this._duration=1e3,this._repeat=0,this._repeatDelayTime=void 0,this._yoyo=!1,this._isPlaying=!1,this._reversed=!1,this._delayTime=0,this._startTime=null,this._easingFunction=r.Easing.Linear.None,this._interpolationFunction=r.Interpolation.Linear,this._chainedTweens=[],this._onStartCallback=null,this._onStartCallbackFired=!1,this._onUpdateCallback=null,this._onRepeatCallback=null,this._onCompleteCallback=null,this._onStopCallback=null,this._group=e||r,this._id=r.nextId()},r.Tween.prototype={getId:function(){return this._id},isPlaying:function(){return this._isPlaying},to:function(t,e){return this._valuesEnd=Object.create(t),void 0!==e&&(this._duration=e),this},duration:function(t){return this._duration=t,this},start:function(t){for(var e in this._group.add(this),this._isPlaying=!0,this._onStartCallbackFired=!1,this._startTime=void 0!==t?"string"==typeof t?r.now()+parseFloat(t):t:r.now(),this._startTime+=this._delayTime,this._valuesEnd){if(this._valuesEnd[e]instanceof Array){if(0===this._valuesEnd[e].length)continue;this._valuesEnd[e]=[this._object[e]].concat(this._valuesEnd[e])}void 0!==this._object[e]&&(this._valuesStart[e]=this._object[e],this._valuesStart[e]instanceof Array==!1&&(this._valuesStart[e]*=1),this._valuesStartRepeat[e]=this._valuesStart[e]||0)}return this},stop:function(){return this._isPlaying?(this._group.remove(this),this._isPlaying=!1,null!==this._onStopCallback&&this._onStopCallback(this._object),this.stopChainedTweens(),this):this},end:function(){return this.update(1/0),this},stopChainedTweens:function(){for(var t=0,e=this._chainedTweens.length;t<e;t++)this._chainedTweens[t].stop()},group:function(t){return this._group=t,this},delay:function(t){return this._delayTime=t,this},repeat:function(t){return this._repeat=t,this},repeatDelay:function(t){return this._repeatDelayTime=t,this},yoyo:function(t){return this._yoyo=t,this},easing:function(t){return this._easingFunction=t,this},interpolation:function(t){return this._interpolationFunction=t,this},chain:function(){return this._chainedTweens=arguments,this},onStart:function(t){return this._onStartCallback=t,this},onUpdate:function(t){return this._onUpdateCallback=t,this},onRepeat:function(t){return this._onRepeatCallback=t,this},onComplete:function(t){return this._onCompleteCallback=t,this},onStop:function(t){return this._onStopCallback=t,this},update:function(t){var e,n,i;if(t<this._startTime)return!0;for(e in!1===this._onStartCallbackFired&&(null!==this._onStartCallback&&this._onStartCallback(this._object),this._onStartCallbackFired=!0),n=(t-this._startTime)/this._duration,n=0===this._duration||n>1?1:n,i=this._easingFunction(n),this._valuesEnd)if(void 0!==this._valuesStart[e]){var r=this._valuesStart[e]||0,o=this._valuesEnd[e];o instanceof Array?this._object[e]=this._interpolationFunction(o,i):("string"==typeof o&&(o="+"===o.charAt(0)||"-"===o.charAt(0)?r+parseFloat(o):parseFloat(o)),"number"==typeof o&&(this._object[e]=r+(o-r)*i))}if(null!==this._onUpdateCallback&&this._onUpdateCallback(this._object,n),1===n){if(this._repeat>0){for(e in isFinite(this._repeat)&&this._repeat--,this._valuesStartRepeat){if("string"==typeof this._valuesEnd[e]&&(this._valuesStartRepeat[e]=this._valuesStartRepeat[e]+parseFloat(this._valuesEnd[e])),this._yoyo){var a=this._valuesStartRepeat[e];this._valuesStartRepeat[e]=this._valuesEnd[e],this._valuesEnd[e]=a}this._valuesStart[e]=this._valuesStartRepeat[e]}return this._yoyo&&(this._reversed=!this._reversed),void 0!==this._repeatDelayTime?this._startTime=t+this._repeatDelayTime:this._startTime=t+this._delayTime,null!==this._onRepeatCallback&&this._onRepeatCallback(this._object),!0}null!==this._onCompleteCallback&&this._onCompleteCallback(this._object);for(var s=0,u=this._chainedTweens.length;s<u;s++)this._chainedTweens[s].start(this._startTime+this._duration);return!1}return!0}},r.Easing={Linear:{None:function(t){return t}},Quadratic:{In:function(t){return t*t},Out:function(t){return t*(2-t)},InOut:function(t){return(t*=2)<1?.5*t*t:-.5*(--t*(t-2)-1)}},Cubic:{In:function(t){return t*t*t},Out:function(t){return--t*t*t+1},InOut:function(t){return(t*=2)<1?.5*t*t*t:.5*((t-=2)*t*t+2)}},Quartic:{In:function(t){return t*t*t*t},Out:function(t){return 1- --t*t*t*t},InOut:function(t){return(t*=2)<1?.5*t*t*t*t:-.5*((t-=2)*t*t*t-2)}},Quintic:{In:function(t){return t*t*t*t*t},Out:function(t){return--t*t*t*t*t+1},InOut:function(t){return(t*=2)<1?.5*t*t*t*t*t:.5*((t-=2)*t*t*t*t+2)}},Sinusoidal:{In:function(t){return 1-Math.cos(t*Math.PI/2)},Out:function(t){return Math.sin(t*Math.PI/2)},InOut:function(t){return.5*(1-Math.cos(Math.PI*t))}},Exponential:{In:function(t){return 0===t?0:Math.pow(1024,t-1)},Out:function(t){return 1===t?1:1-Math.pow(2,-10*t)},InOut:function(t){return 0===t?0:1===t?1:(t*=2)<1?.5*Math.pow(1024,t-1):.5*(2-Math.pow(2,-10*(t-1)))}},Circular:{In:function(t){return 1-Math.sqrt(1-t*t)},Out:function(t){return Math.sqrt(1- --t*t)},InOut:function(t){return(t*=2)<1?-.5*(Math.sqrt(1-t*t)-1):.5*(Math.sqrt(1-(t-=2)*t)+1)}},Elastic:{In:function(t){return 0===t?0:1===t?1:-Math.pow(2,10*(t-1))*Math.sin(5*(t-1.1)*Math.PI)},Out:function(t){return 0===t?0:1===t?1:Math.pow(2,-10*t)*Math.sin(5*(t-.1)*Math.PI)+1},InOut:function(t){return 0===t?0:1===t?1:(t*=2)<1?-.5*Math.pow(2,10*(t-1))*Math.sin(5*(t-1.1)*Math.PI):.5*Math.pow(2,-10*(t-1))*Math.sin(5*(t-1.1)*Math.PI)+1}},Back:{In:function(t){var e=1.70158;return t*t*((e+1)*t-e)},Out:function(t){var e=1.70158;return--t*t*((e+1)*t+e)+1},InOut:function(t){var e=2.5949095;return(t*=2)<1?t*t*((e+1)*t-e)*.5:.5*((t-=2)*t*((e+1)*t+e)+2)}},Bounce:{In:function(t){return 1-r.Easing.Bounce.Out(1-t)},Out:function(t){return t<1/2.75?7.5625*t*t:t<2/2.75?7.5625*(t-=1.5/2.75)*t+.75:t<2.5/2.75?7.5625*(t-=2.25/2.75)*t+.9375:7.5625*(t-=2.625/2.75)*t+.984375},InOut:function(t){return t<.5?.5*r.Easing.Bounce.In(2*t):.5*r.Easing.Bounce.Out(2*t-1)+.5}}},r.Interpolation={Linear:function(t,e){var n=t.length-1,i=n*e,o=Math.floor(i),a=r.Interpolation.Utils.Linear;return e<0?a(t[0],t[1],i):e>1?a(t[n],t[n-1],n-i):a(t[o],t[o+1>n?n:o+1],i-o)},Bezier:function(t,e){for(var n=0,i=t.length-1,o=Math.pow,a=r.Interpolation.Utils.Bernstein,s=0;s<=i;s++)n+=o(1-e,i-s)*o(e,s)*t[s]*a(i,s);return n},CatmullRom:function(t,e){var n=t.length-1,i=n*e,o=Math.floor(i),a=r.Interpolation.Utils.CatmullRom;return t[0]===t[n]?(e<0&&(o=Math.floor(i=n*(1+e))),a(t[(o-1+n)%n],t[o],t[(o+1)%n],t[(o+2)%n],i-o)):e<0?t[0]-(a(t[0],t[0],t[1],t[1],-i)-t[0]):e>1?t[n]-(a(t[n],t[n],t[n-1],t[n-1],i-n)-t[n]):a(t[o?o-1:0],t[o],t[n<o+1?n:o+1],t[n<o+2?n:o+2],i-o)},Utils:{Linear:function(t,e,n){return(e-t)*n+t},Bernstein:function(t,e){var n=r.Interpolation.Utils.Factorial;return n(t)/n(e)/n(t-e)},Factorial:(i=[1],function(t){var e=1;if(i[t])return i[t];for(var n=t;n>1;n--)e*=n;return i[t]=e,e}),CatmullRom:function(t,e,n,i,r){var o=.5*(n-t),a=.5*(i-e),s=r*r;return(2*e-2*n+o+a)*(r*s)+(-3*e+3*n-2*o-a)*s+o*r+e}}},e.a=r}).call(this,n(7))},function(t,e,n){"use strict";var i,r=function(){return void 0===i&&(i=Boolean(window&&document&&document.all&&!window.atob)),i},o=function(){var t={};return function(e){if(void 0===t[e]){var n=document.querySelector(e);if(window.HTMLIFrameElement&&n instanceof window.HTMLIFrameElement)try{n=n.contentDocument.head}catch(t){n=null}t[e]=n}return t[e]}}(),a=[];function s(t){for(var e=-1,n=0;n<a.length;n++)if(a[n].identifier===t){e=n;break}return e}function u(t,e){for(var n={},i=[],r=0;r<t.length;r++){var o=t[r],u=e.base?o[0]+e.base:o[0],c=n[u]||0,l="".concat(u," ").concat(c);n[u]=c+1;var h=s(l),p={css:o[1],media:o[2],sourceMap:o[3]};-1!==h?(a[h].references++,a[h].updater(p)):a.push({identifier:l,updater:y(p,e),references:1}),i.push(l)}return i}function c(t){var e=document.createElement("style"),i=t.attributes||{};if(void 0===i.nonce){var r=n.nc;r&&(i.nonce=r)}if(Object.keys(i).forEach((function(t){e.setAttribute(t,i[t])})),"function"==typeof t.insert)t.insert(e);else{var a=o(t.insert||"head");if(!a)throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");a.appendChild(e)}return e}var l,h=(l=[],function(t,e){return l[t]=e,l.filter(Boolean).join("\n")});function p(t,e,n,i){var r=n?"":i.media?"@media ".concat(i.media," {").concat(i.css,"}"):i.css;if(t.styleSheet)t.styleSheet.cssText=h(e,r);else{var o=document.createTextNode(r),a=t.childNodes;a[e]&&t.removeChild(a[e]),a.length?t.insertBefore(o,a[e]):t.appendChild(o)}}function d(t,e,n){var i=n.css,r=n.media,o=n.sourceMap;if(r?t.setAttribute("media",r):t.removeAttribute("media"),o&&btoa&&(i+="\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o))))," */")),t.styleSheet)t.styleSheet.cssText=i;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(i))}}var f=null,v=0;function y(t,e){var n,i,r;if(e.singleton){var o=v++;n=f||(f=c(e)),i=p.bind(null,n,o,!1),r=p.bind(null,n,o,!0)}else n=c(e),i=d.bind(null,n,e),r=function(){!function(t){if(null===t.parentNode)return!1;t.parentNode.removeChild(t)}(n)};return i(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;i(t=e)}else r()}}t.exports=function(t,e){(e=e||{}).singleton||"boolean"==typeof e.singleton||(e.singleton=r());var n=u(t=t||[],e);return function(t){if(t=t||[],"[object Array]"===Object.prototype.toString.call(t)){for(var i=0;i<n.length;i++){var r=s(n[i]);a[r].references--}for(var o=u(t,e),c=0;c<n.length;c++){var l=s(n[c]);0===a[l].references&&(a[l].updater(),a.splice(l,1))}n=o}}}},function(t,e,n){"use strict";t.exports=function(t){var e=[];return e.toString=function(){return this.map((function(e){var n=function(t,e){var n=t[1]||"",i=t[3];if(!i)return n;if(e&&"function"==typeof btoa){var r=(a=i,s=btoa(unescape(encodeURIComponent(JSON.stringify(a)))),u="sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(s),"/*# ".concat(u," */")),o=i.sources.map((function(t){return"/*# sourceURL=".concat(i.sourceRoot||"").concat(t," */")}));return[n].concat(o).concat([r]).join("\n")}var a,s,u;return[n].join("\n")}(e,t);return e[2]?"@media ".concat(e[2]," {").concat(n,"}"):n})).join("")},e.i=function(t,n,i){"string"==typeof t&&(t=[[null,t,""]]);var r={};if(i)for(var o=0;o<this.length;o++){var a=this[o][0];null!=a&&(r[a]=!0)}for(var s=0;s<t.length;s++){var u=[].concat(t[s]);i&&r[u[0]]||(n&&(u[2]?u[2]="".concat(n," and ").concat(u[2]):u[2]=n),e.push(u))}},e}},function(t,e,n){var i=n(3),r=n(6);"string"==typeof(r=r.__esModule?r.default:r)&&(r=[[t.i,r,""]]);var o={insert:"head",singleton:!1};i(r,o);t.exports=r.locals||{}},function(t,e,n){(e=n(4)(!1)).push([t.i,".react-slideshow-container {\n  display: flex;\n  align-items: center;\n}\n\n.react-slideshow-container .nav {\n  height: 30px;\n  background: rgba(255, 255, 255, 0.6);\n  width: 30px;\n  z-index: 10;\n  text-align: center;\n  cursor: pointer;\n  color: #fff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.react-slideshow-container .nav span {\n  display: block;\n  width: 10px;\n  height: 10px;\n  border-color: #000;\n  border-style: solid;\n  transform: rotate(45deg);\n}\n\n.react-slideshow-container .nav.disabled span {\n  border-color: #666;\n}\n\n.react-slideshow-container .nav:hover {\n  background: white;\n  color: #666;\n}\n\n.react-slideshow-container .nav.disabled:hover {\n  cursor: not-allowed;\n}\n\n.react-slideshow-container .nav:first-of-type {\n  margin-right: -30px;\n  border-right: none;\n  border-top: none;\n}\n\n.react-slideshow-container .nav:first-of-type span {\n  margin-left: 5px;\n  border-right: none;\n  border-top: none;\n}\n\n.react-slideshow-container .nav:last-of-type {\n  margin-left: -30px;\n}\n\n.react-slideshow-container .nav:last-of-type span {\n  margin-right: 5px;\n  border-left: none;\n  border-bottom: none;\n}\n\n.react-slideshow-container + div.indicators {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.react-slideshow-container + div.indicators > .each-slideshow-indicator {\n  width: 7px;\n  height: 7px;\n  margin: 0 5px 10px;\n  border-radius: 50%;\n  background: #ccc;\n  cursor: pointer;\n}\n\n.react-slideshow-container + div.indicators > .each-slideshow-indicator:hover {\n  background: #666;\n}\n\n.react-slideshow-container + div.indicators > .each-slideshow-indicator.active {\n  background: #000;\n}\n",""]),t.exports=e},function(t,e){var n,i,r=t.exports={};function o(){throw new Error("setTimeout has not been defined")}function a(){throw new Error("clearTimeout has not been defined")}function s(t){if(n===setTimeout)return setTimeout(t,0);if((n===o||!n)&&setTimeout)return n=setTimeout,setTimeout(t,0);try{return n(t,0)}catch(e){try{return n.call(null,t,0)}catch(e){return n.call(this,t,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:o}catch(t){n=o}try{i="function"==typeof clearTimeout?clearTimeout:a}catch(t){i=a}}();var u,c=[],l=!1,h=-1;function p(){l&&u&&(l=!1,u.length?c=u.concat(c):h=-1,c.length&&d())}function d(){if(!l){var t=s(p);l=!0;for(var e=c.length;e;){for(u=c,c=[];++h<e;)u&&u[h].run();h=-1,e=c.length}u=null,l=!1,function(t){if(i===clearTimeout)return clearTimeout(t);if((i===a||!i)&&clearTimeout)return i=clearTimeout,clearTimeout(t);try{i(t)}catch(e){try{return i.call(null,t)}catch(e){return i.call(this,t)}}}(t)}}function f(t,e){this.fun=t,this.array=e}function v(){}r.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];c.push(new f(t,e)),1!==c.length||l||s(d)},f.prototype.run=function(){this.fun.apply(null,this.array)},r.title="browser",r.browser=!0,r.env={},r.argv=[],r.version="",r.versions={},r.on=v,r.addListener=v,r.once=v,r.off=v,r.removeListener=v,r.removeAllListeners=v,r.emit=v,r.prependListener=v,r.prependOnceListener=v,r.listeners=function(t){return[]},r.binding=function(t){throw new Error("process.binding is not supported")},r.cwd=function(){return"/"},r.chdir=function(t){throw new Error("process.chdir is not supported")},r.umask=function(){return 0}},function(t,e,n){"use strict";var i=n(9);function r(){}function o(){}o.resetWarningCache=r,t.exports=function(){function t(t,e,n,r,o,a){if(a!==i){var s=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw s.name="Invariant Violation",s}}function e(){return t}t.isRequired=t;var n={array:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:e,element:t,elementType:t,instanceOf:e,node:t,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e,checkPropTypes:o,resetWarningCache:r};return n.PropTypes=n,n}},function(t,e,n){"use strict";t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,e,n){var i=n(3),r=n(11);"string"==typeof(r=r.__esModule?r.default:r)&&(r=[[t.i,r,""]]);var o={insert:"head",singleton:!1};i(r,o);t.exports=r.locals||{}},function(t,e,n){(e=n(4)(!1)).push([t.i,".react-slideshow-wrapper.slide {\n  width: 100%;\n  overflow: hidden;\n}\n\n.react-slideshow-wrapper .images-wrap {\n  display: flex;\n  flex-wrap: wrap;\n}\n",""]),t.exports=e},function(t,e,n){var i=n(3),r=n(13);"string"==typeof(r=r.__esModule?r.default:r)&&(r=[[t.i,r,""]]);var o={insert:"head",singleton:!1};i(r,o);t.exports=r.locals||{}},function(t,e,n){(e=n(4)(!1)).push([t.i,".react-slideshow-fade-wrapper {\n  width: 100%;\n  overflow: hidden;\n}\n\n.react-slideshow-fade-wrapper .react-slideshow-fade-images-wrap {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.react-slideshow-fade-wrapper .react-slideshow-fade-images-wrap > div {\n  position: relative;\n  opacity: 0;\n}\n",""]),t.exports=e},function(t,e,n){var i=n(3),r=n(15);"string"==typeof(r=r.__esModule?r.default:r)&&(r=[[t.i,r,""]]);var o={insert:"head",singleton:!1};i(r,o);t.exports=r.locals||{}},function(t,e,n){(e=n(4)(!1)).push([t.i,".react-slideshow-zoom-wrapper {\n  width: 100%;\n  overflow: hidden;\n}\n\n.react-slideshow-zoom-wrapper .zoom-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  overflow: hidden;\n}\n\n.react-slideshow-zoom-wrapper .zoom-wrapper > div {\n  position: relative;\n  display: flex;\n}\n",""]),t.exports=e},function(t,e,n){"use strict";n.r(e);n(5);var i=n(1),r=n.n(i),o=n(2),a=n(0),s=n.n(a);function u(t,e){var n=Object.keys(t);return Object.keys(e).reduce((function(t,i){return-1===n.indexOf(i)&&(t[i]=e[i]),t}),{})}n(10);function c(t){return(c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function l(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function h(t){return(h=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function p(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function d(t,e){return(d=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var f=function(t){function e(t){var n;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=function(t,e){return!e||"object"!==c(e)&&"function"!=typeof e?p(t):e}(this,h(e).call(this,t))).state={index:t.defaultIndex&&t.defaultIndex<t.children.length?t.defaultIndex:0},n.width=0,n.imageContainer=null,n.wrapper=null,n.timeout=null,n.moveSlides=n.moveSlides.bind(p(n)),n.pauseSlides=n.pauseSlides.bind(p(n)),n.startSlides=n.startSlides.bind(p(n)),n.resizeListener=n.resizeListener.bind(p(n)),n.goToSlide=n.goToSlide.bind(p(n)),n.tweenGroup=new o.a.Group,n}var n,i,a;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&d(t,e)}(e,t),n=e,(i=[{key:"componentDidMount",value:function(){var t=this;this.setWidth(),window.addEventListener("resize",this.resizeListener);var e=this.props,n=e.autoplay,i=e.duration;n&&(this.timeout=setTimeout((function(){return t.goNext()}),i))}},{key:"componentWillUnmount",value:function(){this.willUnmount=!0,clearTimeout(this.timeout),window.removeEventListener("resize",this.resizeListener)}},{key:"setWidth",value:function(){this.allImages=Array.prototype.slice.call(this.wrapper.querySelectorAll(".images-wrap > div"),0),this.width=this.wrapper.clientWidth;var t=this.width*(this.props.children.length+2);this.imageContainer.style.width="".concat(t,"px"),this.imageContainer.style.transform="translate(-".concat(this.width*(this.state.index+1),"px)"),this.applySlideStyle()}},{key:"componentDidUpdate",value:function(t){var e=this;this.props.autoplay!==t.autoplay&&(this.props.autoplay?this.timeout=setTimeout((function(){return e.goNext()}),this.props.duration):clearTimeout(this.timeout)),this.props.children.length!=t.children.length&&this.setWidth()}},{key:"resizeListener",value:function(){this.setWidth()}},{key:"applySlideStyle",value:function(){var t=this;this.allImages.forEach((function(e,n){e.style.width="".concat(t.width,"px")}))}},{key:"pauseSlides",value:function(){this.props.pauseOnHover&&clearTimeout(this.timeout)}},{key:"startSlides",value:function(){var t=this,e=this.props,n=e.pauseOnHover,i=e.autoplay;n&&i&&(this.timeout=setTimeout((function(){return t.goNext()}),this.props.duration))}},{key:"moveSlides",value:function(t){"next"===t.currentTarget.dataset.type?this.goNext():this.goBack()}},{key:"goToSlide",value:function(t){var e=t.currentTarget;this.goTo(parseInt(e.dataset.key))}},{key:"goTo",value:function(t){this.slideImages(t)}},{key:"goNext",value:function(){var t=this.state.index,e=this.props,n=e.children;(e.infinite||t!==n.length-1)&&this.slideImages(t+1)}},{key:"goBack",value:function(){var t=this.state.index;(this.props.infinite||0!==t)&&this.slideImages(t-1)}},{key:"showIndicators",value:function(){var t=this,e="boolean"!=typeof this.props.indicators,n=!e&&"each-slideshow-indicator";return r.a.createElement("div",{className:"indicators"},this.props.children.map((function(i,o){return r.a.createElement("div",{key:o,"data-key":o,className:"".concat(n," ").concat(t.state.index===o&&"active"),onClick:t.goToSlide},e&&t.props.indicators(o))})))}},{key:"showPreviousArrow",value:function(){var t=this.props,e=t.arrows,n=t.prevArrow,i=t.infinite,o="";return n||(o="nav ".concat(this.state.index<=0&&!i&&"disabled")),e&&r.a.createElement("div",{className:o,"data-type":"prev",onClick:this.moveSlides},n||r.a.createElement("span",null))}},{key:"showNextArrow",value:function(){var t=this.props,e=t.arrows,n=t.nextArrow,i=t.infinite,o=t.children,a="";return n||(a="nav ".concat(this.state.index===o.length-1&&!i&&"disabled")),e&&r.a.createElement("div",{className:a,"data-type":"next",onClick:this.moveSlides},n||r.a.createElement("span",null))}},{key:"render",value:function(){var t=this,n=this.props,i=n.children,o=(n.infinite,n.indicators),a=(n.arrows,u(e.propTypes,this.props)),s=this.state.index,c={transform:"translate(-".concat((s+1)*this.width,"px)")};return r.a.createElement("div",a,r.a.createElement("div",{className:"react-slideshow-container",onMouseEnter:this.pauseSlides,onMouseLeave:this.startSlides},this.showPreviousArrow(),r.a.createElement("div",{className:"react-slideshow-wrapper slide",ref:function(e){return t.wrapper=e}},r.a.createElement("div",{className:"images-wrap",style:c,ref:function(e){return t.imageContainer=e}},r.a.createElement("div",{"data-index":"-1"},i[i.length-1]),i.map((function(t,e){return r.a.createElement("div",{"data-index":e,key:e,className:e===s?"active":""},t)})),r.a.createElement("div",{"data-index":"-1"},i[0]))),this.showNextArrow()),o&&this.showIndicators())}},{key:"slideImages",value:function(t){var e=this,n=this.props,i=n.children,r=n.transitionDuration,a=n.autoplay,s=n.infinite,u=n.duration,c=n.onChange;if(!this.tweenGroup.getAll().length){clearTimeout(this.timeout);var l={margin:-this.width*(this.state.index+1)},h=new o.a.Tween(l,this.tweenGroup).to({margin:-this.width*(t+1)},r).onUpdate((function(t){e.imageContainer.style.transform="translate(".concat(t.margin,"px)")})).start();!function t(){e.willUnmount?e.tweenGroup.removeAll():(requestAnimationFrame(t),e.tweenGroup.update())}(),h.onComplete((function(){var n=t<0?i.length-1:t>=i.length?0:t;e.willUnmount||("function"==typeof c&&c(e.state.index,n),e.setState({index:n},(function(){a&&(s||e.state.index<i.length)&&(e.timeout=setTimeout((function(){return e.goNext()}),u))})))}))}}}])&&l(n.prototype,i),a&&l(n,a),e}(i.Component);f.defaultProps={duration:5e3,transitionDuration:1e3,defaultIndex:0,infinite:!0,autoplay:!0,indicators:!1,arrows:!0,pauseOnHover:!1},f.propTypes={duration:s.a.number,transitionDuration:s.a.number,defaultIndex:s.a.number,infinite:s.a.bool,indicators:s.a.oneOfType([s.a.bool,s.a.func]),autoplay:s.a.bool,arrows:s.a.bool,onChange:s.a.func,pauseOnHover:s.a.bool,prevArrow:s.a.oneOfType([s.a.object,s.a.func]),nextArrow:s.a.oneOfType([s.a.object,s.a.func])};var v=f;n(12);function y(t){return(y="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function m(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function w(t){return(w=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function g(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function b(t,e){return(b=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var _=function(t){function e(t){var n;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=function(t,e){return!e||"object"!==y(e)&&"function"!=typeof e?g(t):e}(this,w(e).call(this,t))).state={index:t.defaultIndex&&t.defaultIndex<t.children.length?t.defaultIndex:0},n.width=0,n.timeout=null,n.divsContainer=null,n.wrapper=null,n.setWidth=n.setWidth.bind(g(n)),n.resizeListener=n.resizeListener.bind(g(n)),n.navigate=n.navigate.bind(g(n)),n.preFade=n.preFade.bind(g(n)),n.pauseSlides=n.pauseSlides.bind(g(n)),n.startSlides=n.startSlides.bind(g(n)),n.tweenGroup=new o.a.Group,n}var n,i,a;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&b(t,e)}(e,t),n=e,(i=[{key:"componentDidMount",value:function(){window.addEventListener("resize",this.resizeListener),this.setWidth(),this.play()}},{key:"play",value:function(){var t=this,e=this.props,n=e.autoplay,i=e.children,r=this.state.index;n&&i.length>1&&(clearTimeout(this.timeout),this.timeout=setTimeout((function(){return t.fadeImages(r+1)}),this.props.duration))}},{key:"componentDidUpdate",value:function(t){this.props.autoplay!==t.autoplay&&(this.props.autoplay?this.play():clearTimeout(this.timeout)),this.props.children.length!=t.children.length&&(this.applyStyle(),this.play())}},{key:"componentWillUnmount",value:function(){this.willUnmount=!0,clearTimeout(this.timeout),window.removeEventListener("resize",this.resizeListener)}},{key:"setWidth",value:function(){this.width=this.wrapper.clientWidth,this.applyStyle()}},{key:"resizeListener",value:function(){this.setWidth()}},{key:"applyStyle",value:function(){var t=this.width*this.props.children.length;this.divsContainer.style.width="".concat(t,"px");for(var e=0;e<this.divsContainer.children.length;e++){var n=this.divsContainer.children[e];n&&(n.style.width="".concat(this.width,"px"),n.style.left="".concat(e*-this.width,"px"))}}},{key:"pauseSlides",value:function(){this.props.pauseOnHover&&clearTimeout(this.timeout)}},{key:"startSlides",value:function(){var t=this,e=this.props,n=e.pauseOnHover,i=e.autoplay;n&&i&&(this.timeout=setTimeout((function(){return t.goNext()}),this.props.duration))}},{key:"goNext",value:function(){var t=this.state.index,e=this.props,n=e.children;(e.infinite||t!==n.length-1)&&this.fadeImages((t+1)%n.length)}},{key:"goBack",value:function(){var t=this.state.index,e=this.props,n=e.children;(e.infinite||0!==t)&&this.fadeImages(0===t?n.length-1:t-1)}},{key:"navigate",value:function(t){var e=t.currentTarget.dataset;e.key!=this.state.index&&this.goTo(parseInt(e.key))}},{key:"goTo",value:function(t){this.fadeImages(t)}},{key:"preFade",value:function(t){"prev"===t.currentTarget.dataset.type?this.goBack():this.goNext()}},{key:"showIndicators",value:function(){var t=this,e="boolean"!=typeof this.props.indicators,n=!e&&"each-slideshow-indicator";return r.a.createElement("div",{className:"indicators"},this.props.children.map((function(i,o){return r.a.createElement("div",{key:o,"data-key":o,className:"".concat(n," ").concat(t.state.index===o&&"active"),onClick:t.navigate},e&&t.props.indicators(o))})))}},{key:"showPreviousArrow",value:function(){var t=this.props,e=t.arrows,n=t.prevArrow,i=t.infinite,o="";return n||(o="nav ".concat(this.state.index<=0&&!i&&"disabled")),e&&r.a.createElement("div",{className:o,"data-type":"prev",onClick:this.preFade},n||r.a.createElement("span",null))}},{key:"showNextArrow",value:function(){var t=this.props,e=t.arrows,n=t.nextArrow,i=t.infinite,o=t.children,a="";return n||(a="nav ".concat(this.state.index===o.length-1&&!i&&"disabled")),e&&r.a.createElement("div",{className:a,"data-type":"next",onClick:this.preFade},n||r.a.createElement("span",null))}},{key:"render",value:function(){var t=this,n=this.props,i=n.indicators,o=n.children,a=this.state.index,s=u(e.propTypes,this.props);return r.a.createElement("div",s,r.a.createElement("div",{className:"react-slideshow-container",onMouseEnter:this.pauseSlides,onMouseLeave:this.startSlides},this.showPreviousArrow(),r.a.createElement("div",{className:"react-slideshow-fade-wrapper",ref:function(e){return t.wrapper=e}},r.a.createElement("div",{className:"react-slideshow-fade-images-wrap",ref:function(e){return t.divsContainer=e}},o.map((function(t,e){return r.a.createElement("div",{style:{opacity:e===a?"1":"0",zIndex:e===a?"1":"0"},"data-index":e,key:e},t)})))),this.showNextArrow()),i&&this.showIndicators())}},{key:"fadeImages",value:function(t){var e=this,n=this.state.index,i=this.props,r=i.autoplay,a=i.children,s=i.infinite,u=i.duration,c=i.transitionDuration,l=i.onChange;this.tweenGroup.getAll().length||(this.divsContainer.children[t]||(t=0),clearTimeout(this.timeout),function t(){e.willUnmount?e.tweenGroup.removeAll():(requestAnimationFrame(t),e.tweenGroup.update())}(),new o.a.Tween({opacity:0},this.tweenGroup).to({opacity:1},c).onUpdate((function(i){e.divsContainer.children[t].style.opacity=i.opacity,e.divsContainer.children[n].style.opacity=1-i.opacity})).start().onComplete((function(){e.willUnmount||(e.setState({index:t}),"function"==typeof l&&l(n,t),r&&(s||t<a.length-1)&&(clearTimeout(e.timeout),e.timeout=setTimeout((function(){e.fadeImages((t+1)%a.length)}),u)))})))}}])&&m(n.prototype,i),a&&m(n,a),e}(i.Component);_.defaultProps={duration:5e3,transitionDuration:1e3,defaultIndex:0,indicators:!1,arrows:!0,autoplay:!0,infinite:!0,pauseOnHover:!1},_.propTypes={duration:s.a.number,transitionDuration:s.a.number,defaultIndex:s.a.number,indicators:s.a.oneOfType([s.a.bool,s.a.func]),arrows:s.a.bool,autoplay:s.a.bool,infinite:s.a.bool,onChange:s.a.func,pauseOnHover:s.a.bool,prevArrow:s.a.oneOfType([s.a.object,s.a.func]),nextArrow:s.a.oneOfType([s.a.object,s.a.func])};var x=_;n(14);function T(t){return(T="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function k(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function S(t){return(S=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function O(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function C(t,e){return(C=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var I=function(t){function e(t){var n;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(n=function(t,e){return!e||"object"!==T(e)&&"function"!=typeof e?O(t):e}(this,S(e).call(this,t))).state={index:t.defaultIndex&&t.defaultIndex<t.children.length?t.defaultIndex:0},n.width=0,n.timeout=null,n.divsContainer=null,n.wrapper=null,n.setWidth=n.setWidth.bind(O(n)),n.resizeListener=n.resizeListener.bind(O(n)),n.navigate=n.navigate.bind(O(n)),n.preZoom=n.preZoom.bind(O(n)),n.pauseSlides=n.pauseSlides.bind(O(n)),n.startSlides=n.startSlides.bind(O(n)),n.tweenGroup=new o.a.Group,n}var n,i,a;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&C(t,e)}(e,t),n=e,(i=[{key:"componentDidMount",value:function(){window.addEventListener("resize",this.resizeListener),this.setWidth(),this.play()}},{key:"play",value:function(){var t=this,e=this.props,n=e.autoplay,i=e.children,r=this.state.index;n&&i.length>1&&(clearTimeout(this.timeout),this.timeout=setTimeout((function(){return t.zoomTo(r+1)}),this.props.duration))}},{key:"componentWillUnmount",value:function(){this.willUnmount=!0,clearTimeout(this.timeout),window.removeEventListener("resize",this.resizeListener)}},{key:"componentDidUpdate",value:function(t){this.props.autoplay!==t.autoplay&&(this.props.autoplay?this.play():clearTimeout(this.timeout)),this.props.children.length!=t.children.length&&(this.applyStyle(),this.play())}},{key:"setWidth",value:function(){this.width=this.wrapper.clientWidth,this.applyStyle()}},{key:"resizeListener",value:function(){this.setWidth()}},{key:"applyStyle",value:function(){var t=this.width*this.props.children.length;this.divsContainer.style.width="".concat(t,"px");for(var e=0;e<this.divsContainer.children.length;e++){var n=this.divsContainer.children[e];n&&(n.style.width="".concat(this.width,"px"),n.style.left="".concat(e*-this.width,"px"))}}},{key:"pauseSlides",value:function(){this.props.pauseOnHover&&clearTimeout(this.timeout)}},{key:"startSlides",value:function(){var t=this,e=this.props,n=e.pauseOnHover,i=e.autoplay;n&&i&&(this.timeout=setTimeout((function(){return t.goNext()}),this.props.duration))}},{key:"goNext",value:function(){var t=this.state.index,e=this.props,n=e.children;(e.infinite||t!==n.length-1)&&this.zoomTo((t+1)%n.length)}},{key:"goBack",value:function(){var t=this.state.index,e=this.props,n=e.children;(e.infinite||0!==t)&&this.zoomTo(0===t?n.length-1:t-1)}},{key:"goTo",value:function(t){this.zoomTo(t)}},{key:"navigate",value:function(t){var e=t.currentTarget.dataset;e.key!=this.state.index&&this.goTo(parseInt(e.key))}},{key:"preZoom",value:function(t){"prev"===t.currentTarget.dataset.type?this.goBack():this.goNext()}},{key:"showIndicators",value:function(){var t=this,e="boolean"!=typeof this.props.indicators,n=!e&&"each-slideshow-indicator";return r.a.createElement("div",{className:"indicators"},this.props.children.map((function(i,o){return r.a.createElement("div",{key:o,"data-key":o,className:"".concat(n," ").concat(t.state.index===o&&"active"),onClick:t.navigate},e&&t.props.indicators(o))})))}},{key:"showPreviousArrow",value:function(){var t=this.props,e=t.arrows,n=t.prevArrow,i=t.infinite,o="";return n||(o="nav ".concat(this.state.index<=0&&!i&&"disabled")),e&&r.a.createElement("div",{className:o,"data-type":"prev",onClick:this.preZoom},n||r.a.createElement("span",null))}},{key:"showNextArrow",value:function(){var t=this.props,e=t.arrows,n=t.nextArrow,i=t.infinite,o=t.children,a="";return n||(a="nav ".concat(this.state.index===o.length-1&&!i&&"disabled")),e&&r.a.createElement("div",{className:a,"data-type":"next",onClick:this.preZoom},n||r.a.createElement("span",null))}},{key:"render",value:function(){var t=this,n=this.props,i=n.indicators,o=(n.arrows,n.infinite,n.children),a=this.state.index,s=u(e.propTypes,this.props);return r.a.createElement("div",s,r.a.createElement("div",{className:"react-slideshow-container",onMouseEnter:this.pauseSlides,onMouseLeave:this.startSlides},this.showPreviousArrow(),r.a.createElement("div",{className:"react-slideshow-zoom-wrapper",ref:function(e){return t.wrapper=e}},r.a.createElement("div",{className:"zoom-wrapper",ref:function(e){return t.divsContainer=e}},o.map((function(t,e){return r.a.createElement("div",{style:{opacity:e===a?"1":"0",zIndex:e===a?"1":"0"},"data-index":e,key:e},t)})))),this.showNextArrow()),i&&this.showIndicators())}},{key:"zoomTo",value:function(t){var e=this,n=this.state.index,i=this.props,r=i.children,a=i.scale,s=i.autoplay,u=i.infinite,c=i.transitionDuration,l=i.duration,h=i.onChange;this.tweenGroup.getAll().length||(this.divsContainer.children[t]||(t=0),clearTimeout(this.timeout),function t(){e.willUnmount?e.tweenGroup.removeAll():(requestAnimationFrame(t),e.tweenGroup.update())}(),new o.a.Tween({opacity:0,scale:1},this.tweenGroup).to({opacity:1,scale:a},c).onUpdate((function(i){e.divsContainer.children[t].style.opacity=i.opacity,e.divsContainer.children[n].style.opacity=1-i.opacity,e.divsContainer.children[n].style.transform="scale(".concat(i.scale,")")})).start().onComplete((function(){e.willUnmount||("function"==typeof h&&h(n,t),e.setState({index:t},(function(){e.divsContainer.children[n].style.transform="scale(1)"})),s&&(u||t<r.length-1)&&(clearTimeout(e.timeout),e.timeout=setTimeout((function(){e.zoomTo((t+1)%r.length)}),l)))})))}}])&&k(n.prototype,i),a&&k(n,a),e}(i.Component);I.defaultProps={duration:5e3,transitionDuration:1e3,defaultIndex:0,indicators:!1,arrows:!0,autoplay:!0,infinite:!0,pauseOnHover:!1},I.propTypes={duration:s.a.number,transitionDuration:s.a.number,defaultIndex:s.a.number,indicators:s.a.oneOfType([s.a.bool,s.a.func]),scale:s.a.number.isRequired,arrows:s.a.bool,autoplay:s.a.bool,infinite:s.a.bool,onChange:s.a.func,pauseOnHover:s.a.bool,prevArrow:s.a.oneOfType([s.a.object,s.a.func]),nextArrow:s.a.oneOfType([s.a.object,s.a.func])};var E=I;n.d(e,"Slide",(function(){return v})),n.d(e,"Fade",(function(){return x})),n.d(e,"Zoom",(function(){return E}))}])}));
//# sourceMappingURL=react-slideshow-image.min.js.map

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IntroduceCoin=function(_Component){_inherits(IntroduceCoin,_Component);function IntroduceCoin(){_classCallCheck(this,IntroduceCoin);return _possibleConstructorReturn(this,(IntroduceCoin.__proto__||Object.getPrototypeOf(IntroduceCoin)).apply(this,arguments));}_createClass(IntroduceCoin,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],null,function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',id:'section11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'s10-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'partner-title'},'Official Partners')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row partner-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 col-xs-6 text-center partner-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://tee-coin.com/',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/tee_coin.png',className:'partner-icon',alt:'tee'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 col-xs-6 text-center partner-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.kex.com',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/kex_coin.png',className:'partner-icon',alt:'kex'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 col-xs-6 text-center partner-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.exxvip.com',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/exx_coin.png',className:'partner-icon',alt:'kex'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 col-xs-6 text-center partner-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.biki.com',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/biki_coin.png',className:'partner-icon',alt:'kex'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 col-xs-6 text-center partner-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://head-2-head.net/',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/head2head.png',className:'partner-icon','altpartner-block':'kex',alt:'head2head'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 col-xs-6 text-center partner-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://exchange-sgp.com/',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/exchange_sgp2.png',className:'partner-icon',alt:'exchange'})))))));});}}]);return IntroduceCoin;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IntroduceCoin);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Section1=function(_Component){_inherits(Section1,_Component);function Section1(){_classCallCheck(this,Section1);return _possibleConstructorReturn(this,(Section1.__proto__||Object.getPrototypeOf(Section1)).apply(this,arguments));}_createClass(Section1,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],null,function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',id:'section1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'s1-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__menu__["a" /* default */],{currentItem:'home'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-section-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-7 col-md-7 cs1-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'wow fadeInUp'},t('home_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cs1l-content wow fadeInUp','data-wow-delay':'0.5s'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('home_2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('home_3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('home_4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('home_5')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('home_6')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('home_7')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('home_8')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('home_9')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cs1-right fadeInRight animated'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/s1_5.png',className:'s1r-spin',alt:'',width:'95%'})))))));});}}]);return Section1;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Section1);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Section2=function(_Component){_inherits(Section2,_Component);function Section2(){_classCallCheck(this,Section2);return _possibleConstructorReturn(this,(Section2.__proto__||Object.getPrototypeOf(Section2)).apply(this,arguments));}_createClass(Section2,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],null,function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',id:'section2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row speed-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Unprecedented speed and secure of network will make TRIAM the one of the flagship of Blockchain. '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-6 col-sm-3 col-md-3 s2-left wow slideInLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3 text-center img-speed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/intro-speed-1.png',alt:'speed'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'speed-sub-title'},'Transaction Speed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'p-speed'},'Time is most important asset. We can provide comfortable transaction. ')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-6 col-sm-3 col-md-3 s2-left wow slideInLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3 text-center img-speed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/intro-speed-2.png',alt:'speed'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'speed-sub-title'},'Security'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'p-speed'},'TRIAM is placing emphasis on the security.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'On the other hand, no more than three seconds to verify one transaction.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-6 col-sm-3 col-md-3 s2-left wow slideInLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3 text-center img-speed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/intro-speed-3.png',alt:'speed'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'speed-sub-title'},'Low Transaction Fee'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'p-speed'},'Each transaction cost is lower than in any regular Blockchain system.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Small savings will become big asset.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-6 col-sm-3 col-md-3 s2-left wow slideInLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3 text-center img-speed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/intro-speed-4.png',alt:'speed'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'speed-sub-title'},'Multiple Functions for Wallet'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'p-speed'},'Multisign wallet, Shared wallet, Issue your Tokens, Auto Transfer, Wallet App, and more!')))))));});}}]);return Section2;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Section2);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Section3=function(_Component){_inherits(Section3,_Component);function Section3(){_classCallCheck(this,Section3);return _possibleConstructorReturn(this,(Section3.__proto__||Object.getPrototypeOf(Section3)).apply(this,arguments));}_createClass(Section3,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],null,function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',id:'section3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'s3-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-6 col-md-6 s3-left wow slideInLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/s3_1.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-6 col-md-6 s3-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'s3r-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'wow fadeInRightBig'},t('home_13')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'wow fadeInRight','data-wow-delay':'1s'},t('home_14')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'wow fadeInRight','data-wow-delay':'1s'},t('home_15')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'wow fadeInRight','data-wow-delay':'1s'},t('home_16')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'wow fadeInRight','data-wow-delay':'1s'},t('home_17'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'s3r-bottom wow fadeInRightBig','data-wow-delay':'1s'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'s3rb-2 wow fadeInUpBig','data-wow-delay':'2s'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,t('home_21')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('home_22'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'s3rb-1 wow fadeInUpBig','data-wow-delay':'1.5s'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,t('home_18')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('home_19'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'s3rb-3 wow fadeInUpBig','data-wow-delay':'2.5s'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,t('home_23')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('home_24')))))))));});}}]);return Section3;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Section3);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Section5=function(_Component){_inherits(Section5,_Component);function Section5(){_classCallCheck(this,Section5);return _possibleConstructorReturn(this,(Section5.__proto__||Object.getPrototypeOf(Section5)).apply(this,arguments));}_createClass(Section5,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],null,function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',id:'section5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'s5-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container',id:'quickly'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-6 col-md-6 cs5-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'wow fadeInLeftBig'},t('home_27')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'wow fadeInUp','data-wow-delay':'1s'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_28')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_29')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_30')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_31'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'wow fadeInUp','data-wow-delay':'1.5s'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_32')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_33')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_34')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_35'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-6 col-md-6 cs5-right wow slideInRight'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/s5_1.png',alt:''}))))));});}}]);return Section5;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Section5);

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Section6=function(_Component){_inherits(Section6,_Component);function Section6(){_classCallCheck(this,Section6);return _possibleConstructorReturn(this,(Section6.__proto__||Object.getPrototypeOf(Section6)).apply(this,arguments));}_createClass(Section6,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],null,function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',id:'section6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container',id:'secure'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-6 col-md-6 cs6-left wow slideInLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/s6_1.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-6 col-md-6 cs6-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'wow fadeInRightBig'},t('home_36')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'wow fadeInUp','data-wow-delay':'1s'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_37')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_38')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_39')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_40'))))))));});}}]);return Section6;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Section6);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Section7=function(_Component){_inherits(Section7,_Component);function Section7(){_classCallCheck(this,Section7);return _possibleConstructorReturn(this,(Section7.__proto__||Object.getPrototypeOf(Section7)).apply(this,arguments));}_createClass(Section7,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],null,function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',id:'section7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'s7-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container',id:'low-fee'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-6 col-md-6 cs7-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'wow fadeInLeftBig'},t('home_44')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'wow fadeInUp','data-wow-delay':'1s'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_45')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_46')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_47')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_48')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_49')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_50')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-6 col-md-6 cs7-right wow slideInRight'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/s7_2.png',alt:''}))))));});}}]);return Section7;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Section7);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Section8=function(_Component){_inherits(Section8,_Component);function Section8(props){_classCallCheck(this,Section8);var _this=_possibleConstructorReturn(this,(Section8.__proto__||Object.getPrototypeOf(Section8)).call(this,props));_this.state={home:'home_57'};return _this;}_createClass(Section8,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#section8 .nav-tabs a").click(function(){__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#section8 .nav-tabs a").removeClass('active');__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).addClass('active');__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".s8-bg .container div div").removeClass('active').removeClass('in');if(this.id==='consnumer'){__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".s8-bg .container div #cs8t-consnumer").addClass('in').addClass('active');}if(this.id==='issuert'){__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".s8-bg .container div #cs8t-issuert").addClass('in').addClass('active');}if(this.id==='merchant'){__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".s8-bg .container div #cs8t-merchant").addClass('in').addClass('active');}});}},{key:'render',value:function render(){var language=localStorage.getItem('i18nextLng');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["a" /* I18n */],null,function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',id:'section8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'s8-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-12 col-md-12 cs8-top nav nav-tabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn cs8t-consnumer wow bounceInDown active',id:'consnumer','data-toggle':'tab',href:'#cs8t-consnumer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'slant-left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'cs8t-title'},t('home_57')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'slant-right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn cs8t-issuert wow bounceInDown',id:'issuert','data-wow-delay':'1s',href:'#cs8t-issuert','data-toggle':'tab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'slant-left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'cs8t-title'},t('home_58')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'slant-right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn cs8t-merchant wow bounceInDown',id:'merchant','data-wow-delay':'2s','data-toggle':'tab',href:'#cs8t-merchant'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'slant-left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'cs8t-title'},t('home_59')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'slant-right'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'cs8t-consnumer',className:'tab-pane fade in active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-6 col-md-6 cs8-left wow animated slideInLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/s7_1.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-6 col-md-6 cs8-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'wow fadeInRightBig'},t('home_51')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'wow fadeInUp','data-wow-delay':'1s'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_52')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_53')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_54'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'wow fadeInUp','data-wow-delay':'1.5s'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_55')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t('home_56'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-center wow fadeInUp go-wrapper','data-wow-delay':'1.7s'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn btn-go',target:'_blank',rel:'noopener noreferrer',href:'https://wallet.triamnetwork.com/'},t('home_91'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'cs8t-issuert',className:'tab-pane fade'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-6 col-md-6 cs8-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,t('home_82')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('home_83')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('home_84'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-6 col-md-6 cs8-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/s8_'+(language==='ja'?'ja':language)+'.png',className:'animated slideInRight',alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'cs8t-merchant',className:'tab-pane fade'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-6 col-md-6 cs8-left animated slideInLeft '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/s8_3.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-6 col-md-6 cs8-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,t('home_88')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('home_90')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('home_89'))))))));});}}]);return Section8;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Section8);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Section10=function(_Component){_inherits(Section10,_Component);function Section10(){_classCallCheck(this,Section10);return _possibleConstructorReturn(this,(Section10.__proto__||Object.getPrototypeOf(Section10)).apply(this,arguments));}_createClass(Section10,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],null,function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',id:'section10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'s10-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Triam network advantages'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'s10-info'},t('home_66')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-center wow shake'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn btn-download',target:'_blank',rel:'noopener noreferrer',href:'/documents/TRIAM.pdf'},t('home_67'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'s10-blockchain'},t('home_68')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t('home_72')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t('home_69')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t('home_70')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t('home_71'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Bitcoin'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t('home_73')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t('home_77')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t('home_80'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Ethereum'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t('home_74')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t('home_78')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t('home_80'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'EOS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t('home_75')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t('home_79')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t('home_81'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'RIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t('home_76')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t('home_79')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t('home_80'))))))))));});}}]);return Section10;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Section10);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menu__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_constants__ = __webpack_require__(128);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VALIDATION_KEYS={EMAIL_REQUIRED:'contact_error.email_required',EMAIL_INVALID:'contact_error.email_invalid',TITLE_REQUIRED:'contact_error.title_required',CONTENT_REQUIRED:'contact_error.content_required',CONTENT_TOO_LONG:'contact_error.content_too_long',FAILED_TO_SUBMIT:'contact_failed'};var Contact=function(_Component){_inherits(Contact,_Component);function Contact(props){var _this2=this;_classCallCheck(this,Contact);var _this=_possibleConstructorReturn(this,(Contact.__proto__||Object.getPrototypeOf(Contact)).call(this,props));_this.handleInputChange=function(e){var _this$setState;var _e$target=e.target,name=_e$target.name,value=_e$target.value;var finalValue=name==='content'?value.slice(0,1000):value;_this.setState((_this$setState={},_defineProperty(_this$setState,name,finalValue),_defineProperty(_this$setState,'errors',Object.assign({},_this.state.errors,_defineProperty({},name,''))),_this$setState));};_this.validateForm=function(){var _this$state=_this.state,email=_this$state.email,title=_this$state.title,content=_this$state.content;var errors={};// Email validation
var emailRegex=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;if(!email.trim()){errors.email=VALIDATION_KEYS.EMAIL_REQUIRED;}else if(!emailRegex.test(email)){errors.email=VALIDATION_KEYS.EMAIL_INVALID;}// Title validation
if(!title.trim()){errors.title=VALIDATION_KEYS.TITLE_REQUIRED;}// Content validation
if(!content.trim()){errors.content=VALIDATION_KEYS.CONTENT_REQUIRED;}else if(content.length>1000){errors.content=VALIDATION_KEYS.CONTENT_TOO_LONG;}_this.setState({errors:errors});return Object.keys(errors).length===0;};_this.handleSubmit=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:e.preventDefault();if(_this.validateForm()){_context.next=3;break;}return _context.abrupt('return');case 3:_this.setState({loading:true});_context.prev=4;_context.next=7;return fetch("https://contact-api.triamnetwork.com/api"+'/'+__WEBPACK_IMPORTED_MODULE_5__helper_constants__["a" /* API_PATH */].CONTACT,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:_this.state.email,title:_this.state.title,content:_this.state.content})});case 7:response=_context.sent;if(response.ok){_context.next=10;break;}throw new Error('Failed to submit form');case 10:_this.setState({email:'',title:'',content:'',submitSuccess:true});// Reset success message after 3 seconds
setTimeout(function(){_this.setState({submitSuccess:false});},3000);_context.next=18;break;case 14:_context.prev=14;_context.t0=_context['catch'](4);console.error('Error submitting form:',_context.t0);_this.setState({errors:{submit:VALIDATION_KEYS.FAILED_TO_SUBMIT}});case 18:_context.prev=18;_this.setState({loading:false});return _context.finish(18);case 21:case'end':return _context.stop();}}},_callee,_this2,[[4,14,18,21]]);}));return function(_x){return _ref.apply(this,arguments);};}();_this.state={email:'',title:'',content:'',loading:false,errors:{},submitSuccess:false};return _this;}_createClass(Contact,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;setTimeout(function(){return _this3.node.scrollIntoView();},0);}},{key:'render',value:function render(){var _this4=this;var _state=this.state,email=_state.email,title=_state.title,content=_state.content,errors=_state.errors,loading=_state.loading,submitSuccess=_state.submitSuccess;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["a" /* I18n */],{ns:'translations'},function(t){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'wraper-other',ref:function ref(node){return _this4.node=node;}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__menu__["a" /* default */],{currentItem:'contact'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'contact'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-xs-12 col-sm-12 col-md-12 service-top'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'text-center wow bounce'},t('contact_1')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-contact wow rotateIn'},submitSuccess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'alert alert-success'},t('contact_success')),errors.submit&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'alert alert-danger'},t(errors.submit)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:_this4.handleSubmit},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'email'},t('contact_2')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'email',className:'form-control '+(errors.email?'is-invalid':''),id:'email',name:'email',value:email,onChange:_this4.handleInputChange}),errors.email&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'invalid-feedback text-danger'},t(errors.email))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'title'},t('contact_3')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',className:'form-control '+(errors.title?'is-invalid':''),id:'title',name:'title',value:title,onChange:_this4.handleInputChange}),errors.title&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'invalid-feedback text-danger'},t(errors.title))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'content'},t('contact_4')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{className:'form-control '+(errors.content?'is-invalid':''),id:'content',name:'content',rows:'5',value:content,onChange:_this4.handleInputChange}),errors.content&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'invalid-feedback text-danger'},t(errors.content)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('small',{className:'text-muted'},t('contact_4_limit',{current:content.length,max:1000}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'text-center wow shake','data-wow-delay':'1s'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'submit',className:'btn',disabled:loading},loading?t('contact_submitting'):t('contact_5'))))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__footer__["a" /* default */],null));});}}]);return Contact;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Contact);

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(126);


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(127);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 127 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_PATH; });
var API_PATH={CONTACT:'contact'};

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Service=function(_Component){_inherits(Service,_Component);function Service(){_classCallCheck(this,Service);return _possibleConstructorReturn(this,(Service.__proto__||Object.getPrototypeOf(Service)).apply(this,arguments));}_createClass(Service,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;setTimeout(function(){return _this2.node.scrollIntoView();},0);}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],{ns:'translations'},function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'wraper-other',ref:function ref(node){return _this3.node=node;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__menu__["a" /* default */],{currentItem:'service'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'service'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-12 col-md-12 service-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'wow bounce'},'ETDS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Easy token distribution system'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'st-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('service_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('service_2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('service_3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('service_4')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-12 col-md-12 service-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'wow flash'},t('service_5')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-6 col-sm-6 col-md-6 sb-left wow slideInLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/3a.png',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-dis-title'},t('service_8'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-6 col-sm-6 col-md-6 sb-right wow slideInRight'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sbr-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/3b.png',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-dis-describe'},' ',t('service_6'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sbr-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/3c.png',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-dis-describe'},t('service_7'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center btn-service wow shake','data-wow-delay':'1s'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn btn-distribution'},t('service_8')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer__["a" /* default */],null));});}}]);return Service;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Service);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__faq_ja__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__faq_en__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__faq_ch__ = __webpack_require__(133);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Faq=function(_Component){_inherits(Faq,_Component);function Faq(){_classCallCheck(this,Faq);return _possibleConstructorReturn(this,(Faq.__proto__||Object.getPrototypeOf(Faq)).apply(this,arguments));}_createClass(Faq,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;setTimeout(function(){return _this2.node.scrollIntoView();},0);}},{key:'render',value:function render(){var _this3=this;var language=localStorage.getItem('i18nextLng');var isDisplayOnWebview=window.location.href.endsWith('/a/faq')||window.location.href.endsWith('/a/faq?lng=en')||window.location.href.endsWith('/a/faq?lng=ja')||window.location.href.endsWith('/a/faq?lng=ko')||window.location.href.endsWith('/a/faq?lng=ch');var faqContent=void 0;switch(language){case'ja':faqContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__faq_ja__["a" /* default */],null);break;case'ch':faqContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__faq_ch__["a" /* default */],null);break;default:faqContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__faq_en__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],{ns:'translations'},function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'wraper-other',ref:function ref(node){return _this3.node=node;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__menu__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'contact'},faqContent),!isDisplayOnWebview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer__["a" /* default */],null));});}}]);return Faq;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Faq);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FaqJa=function(_Component){_inherits(FaqJa,_Component);function FaqJa(){_classCallCheck(this,FaqJa);return _possibleConstructorReturn(this,(FaqJa.__proto__||Object.getPrototypeOf(FaqJa)).apply(this,arguments));}_createClass(FaqJa,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* faqDidMount */])();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mgt-30 faq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'common-title'},'TRIAM \u3088\u304F\u3042\u308B\u8CEA\u554F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faq-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-policy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-policy-item row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list-policy-sidenav col-12 col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A'),' \u65B0\u898F\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-1'),'\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210\u306E\u65B9\u6CD5\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-2'),'\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210\u306B\u8CBB\u7528\u306F\u304B\u304B\u308A\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-3'),'\u30E1\u30FC\u30EB\u8A8D\u8A3C\u30B3\u30FC\u30C9\u306F\u3069\u3053\u306B\u8A18\u8F09\u3055\u308C\u3066\u3044\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-4'),'\u672C\u4EBA\u78BA\u8A8D\u66F8\u985E\u306B\u306F\u3001\u3069\u306E\u3088\u3046\u306A\u3082\u306E\u3092\u7528\u610F\u3059\u308C\u3070\u3044\u3044\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-5'),'\u3069\u306E\u56FD\u3067\u3082\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210\u306F\u53EF\u80FD\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-6'),'\u30E1\u30FC\u30EB\u304C\u53D7\u4FE1\u3067\u304D\u305A\u3001\u30E1\u30FC\u30EB\u8A8D\u8A3C\u30B3\u30FC\u30C9\u304C\u53D7\u3051\u53D6\u308C\u307E\u305B\u3093\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-7'),'\u672A\u6210\u5E74\u3067\u3059\u304C\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u4F5C\u6210\u3067\u304D\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-8'),'\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u8907\u6570\u767B\u9332\u3067\u304D\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-9'),'\u6CD5\u4EBA\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u4F5C\u6210\u3067\u304D\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-10'),'\u7121\u52B9\u306A\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3067\u3059\u3068\u30A8\u30E9\u30FC\u304C\u51FA\u3066\u767B\u9332\u304C\u3067\u304D\u307E\u305B\u3093')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B'),'\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-1'),'\u30ED\u30B0\u30A4\u30F3\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u3066\u3057\u307E\u3044\u307E\u3057\u305F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-2'),'\u9593\u9055\u3063\u305F\u30ED\u30B0\u30A4\u30F3\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u51CD\u7D50\u3055\u308C\u3066\u3057\u307E\u3044\u307E\u3057\u305F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-3'),'\u30ED\u30B0\u30A4\u30F3\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u66F4\u3057\u305F\u3044\u3067\u3059\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-4'),'\u30ED\u30B0\u30A4\u30F3\u304C\u3067\u304D\u307E\u305B\u3093\u3002\u5165\u529B\u3059\u308B\u3068\u3001\u300C\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u300D\u300C\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u9593\u9055\u3063\u3066\u3044\u307E\u3059\u300D\u3068\u8868\u793A\u3055\u308C\u307E\u3059\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-5'),'\u30ED\u30B0\u30A4\u30F3\u30D1\u30B9\u30EF\u30FC\u30C9\u306B\u8A2D\u5B9A\u3067\u304D\u308B\u6587\u5B57\u6570\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-6'),'\uFF12\u6BB5\u968E\u8A8D\u8A3C\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-7'),'\uFF12\u6BB5\u968E\u8A8D\u8A3C\u306E\u30EA\u30BB\u30C3\u30C8\u30B3\u30FC\u30C9\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-8'),'\uFF12\u6BB5\u968E\u8A8D\u8A3C\u306F\u89E3\u9664\u3067\u304D\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-9'),'\uFF12\u6BB5\u968E\u8A8D\u8A3C\u306E\u30EA\u30BB\u30C3\u30C8\u30B3\u30FC\u30C9\u3092\u5FD8\u308C\u3066\u3057\u307E\u3044\u307E\u3057\u305F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-10'),'\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u304C\u306A\u3044\u30682\u6BB5\u968E\u8A8D\u8A3C\u306F\u8A2D\u5B9A\u3067\u304D\u306A\u3044\u306E\u3067\u3057\u3087\u3046\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-11'),'\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-12'),'\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u66F4\u3057\u305F\u3044\u3067\u3059\u3002 ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-13'),'\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u3066\u3057\u307E\u3044\u307E\u3057\u305F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b14'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-14'),'\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u306B\u8A2D\u5B9A\u3067\u304D\u308B\u6587\u5B57\u6570\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-c'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'C'),'\u3054\u767B\u9332\u60C5\u5831\u306E\u5909\u66F4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-c1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'C-1'),'\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5909\u66F4\u3057\u305F\u3044\u3067\u3059\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-c2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'C-2'),'\u767B\u9332\u3057\u305F\u6C0F\u540D\u3092\u5909\u66F4\u3057\u305F\u3044\u3067\u3059\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-c3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'C-3'),'\u767B\u9332\u3057\u305F\u60C5\u5831\u3092\u78BA\u8A8D\u3059\u308B\u306B\u306F\u3069\u3046\u3057\u305F\u3089\u3044\u3044\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-c4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'C-4'),'\u8A00\u8A9E\u306E\u8A2D\u5B9A\u3092\u5909\u3048\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u304B\uFF1F')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u4F5C\u6210'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-1'),'\u65B0\u898F\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u3069\u306E\u3088\u3046\u306B\u3057\u3066\u4F5C\u6210\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-2'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-3'),'\u79D8\u5BC6\u30AD\u30FC\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-4'),'Google\uFF12\u6BB5\u968E\u8A8D\u8A3C\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-5'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u3092\u5909\u66F4\u3057\u305F\u3044\u3067\u3059\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-6'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u540D\u524D\u306F\u5909\u66F4\u3067\u304D\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-7'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u4F5C\u6210\u306B\u306F\u8CBB\u7528\u304C\u304B\u304B\u308A\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-8'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u8907\u6570\u4F5C\u6210\u3067\u304D\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-9'),'\u3072\u3068\u3064\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u306F\u4F55\u7A2E\u985E\u306E\u30B3\u30A4\u30F3\u3092\u4FDD\u6709\u3067\u304D\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D10'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u306B\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u300C\uFF0B\u300D\u306E\u30DE\u30FC\u30AF\u306F\u4F55\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-11'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u3066\u3044\u307E\u3059\u300D\u3068\u8868\u793A\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u3069\u3046\u3059\u308C\u3070\u3088\u3044\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-12'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u3068\u304D\u306B\u300C\u4FDD\u5B58\u300D\u3092\u3057\u307E\u3057\u305F\u3002\u6709\u52B9\u306A\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u3059\u308B\u306B\u306F\u3069\u3046\u3057\u305F\u3089\u3088\u3044\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-13'),'\u65B0\u898F\u30A6\u30A9\u30EC\u30C3\u30C8\u4F5C\u6210\u6642\u306B\u3001\u4F55\u654520RIAcoin\u4EE5\u4E0A\u5FC5\u8981\u306A\u306E\u3067\u3059\u304B\uFF1F')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-f'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'F'),'\u30C8\u30E9\u30B9\u30C8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-f1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'F-1'),'\u30C8\u30E9\u30B9\u30C8\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-f2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'F-2'),'\u4ED6\u306E\u30B3\u30A4\u30F3\u3084\u30C8\u30FC\u30AF\u30F3\u3092\u30C8\u30E9\u30B9\u30C8\u3059\u308B\u306B\u306F\u3069\u3046\u3057\u305F\u3089\u3044\u3044\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-f3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'F-3'),'\u30C8\u30E9\u30B9\u30C8\u3057\u3066\u3044\u308B\u30C8\u30FC\u30AF\u30F3\u306E\u30C8\u30E9\u30B9\u30C8\u3092\u89E3\u9664\u3057\u305F\u3044\u3067\u3059')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-x'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'X'),'\u624B\u6570\u6599'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-x1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'X-1'),'\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u30D5\u30A3\u30FC\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-x2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'X-2'),'\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u624B\u6570\u6599\u306F\u3001\u3044\u304F\u3089\u304B\u304B\u308A\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-x3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'X-3'),'\u9001\u91D1\u30A8\u30E9\u30FC\u304C\u8868\u793A\u3055\u308C\u3001\u30B3\u30A4\u30F3\u306E\u9001\u4FE1\u304C\u304A\u3053\u306A\u308F\u308C\u3066\u3044\u306A\u3044\u306E\u306B\u624B\u6570\u6599\u304C\u5F15\u304B\u308C\u3066\u3044\u307E\u3059\u3002\u306A\u305C\u3067\u3059\u304B\uFF1F'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list-policy-sidenav col-12 col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G'),'\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u306E\u9001\u4FE1\u30FB\u53D7\u4FE1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-1'),'\u53CB\u9054\u306BRIAcoin\u3092\u9001\u4FE1\u3057\u305F\u3044\u3067\u3059\u3002\u3069\u3046\u3059\u308C\u3070\u3044\u3044\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-2'),'\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u306E\u9001\u91D1\u9650\u5EA6\u984D\u306F\u3042\u308A\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-3'),'\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u306E\u9001\u91D1\u304C\u53CD\u6620\u3055\u308C\u308B\u306E\u306B\u3069\u308C\u304F\u3089\u3044\u306E\u6642\u9593\u304C\u304B\u304B\u308A\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-4'),'\u4ED6\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u9001\u91D1\u3057\u3088\u3046\u3068\u3059\u308B\u3068\u3001\u300C\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u300D\u3068\u8868\u793A\u3055\u308C\u3001\u30A8\u30E9\u30FC\u306B\u306A\u308A\u307E\u3059\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-5'),'\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u3092\u9001\u4FE1\u3057\u305F\u306E\u306B\u3001\u9001\u4FE1\u76F8\u624B\u306B\u5C4A\u3044\u3066\u3044\u307E\u305B\u3093\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-6'),'\u9055\u3046\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u306B\u30B3\u30A4\u30F3\u3092\u8AA4\u9001\u4FE1\u3057\u3066\u3057\u307E\u3044\u307E\u3057\u305F\u3002\u3069\u3046\u3059\u308C\u3070\u3044\u3044\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-7'),'\u30B3\u30A4\u30F3\u306E\u9001\u4FE1\u304C\u5B8C\u4E86\u3057\u3066\u3044\u308B\u304B\u3069\u3046\u304B\u78BA\u304B\u3081\u308B\u65B9\u6CD5\u306F\u3042\u308A\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-8'),'\u30C8\u30E9\u30B9\u30C8\u3057\u305F\u30C8\u30FC\u30AF\u30F3\u306E\u53D7\u3051\u53D6\u308A\u304C\u3067\u304D\u307E\u305B\u3093')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H'),'\u767A\u884C\u8005'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-1'),'\u767A\u884C\u8005\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-2'),'\u767A\u884C\u8005\u306B\u306A\u308B\u65B9\u6CD5\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-3'),'\u767A\u884C\u8005\u306E\u7533\u8ACB\u304C\u627F\u8A8D\u3055\u308C\u308B\u307E\u3067\u306B\u3069\u308C\u304F\u3089\u3044\u306E\u65E5\u6570\u304C\u304B\u304B\u308A\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-4'),'\u767A\u884C\u8005\u306E\u7533\u8ACB\u306B\u306F\u8CBB\u7528\u304C\u304B\u304B\u308A\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-5'),'\u767A\u884C\u8005\u306E\u7533\u8ACB\u6642\u306E\u672C\u4EBA\u78BA\u8A8D\u66F8\u985E\u306B\u306F\u3001\u3069\u306E\u3088\u3046\u306A\u3082\u306E\u3092\u7528\u610F\u3059\u308C\u3070\u3044\u3044\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-6'),'\u672C\u4EBA\u78BA\u8A8D\u8CC7\u6599\u306E\u63D0\u51FA\u306F\u3069\u306E\u3088\u3046\u306B\u884C\u3046\u306E\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-7'),'\u5728\u4F4F\u5834\u6240\u3067\u3059\u304C\u3001\u767A\u884C\u8005\u7533\u8ACB\u306F\u3069\u3053\u306E\u56FD\u3067\u3082\u53EF\u80FD\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-8'),'\u767A\u884C\u8005\u306E\u7533\u8ACB\u6642\u306B\u5165\u529B\u3059\u308B\u300C\u56E3\u4F53\u30FB\u4F1A\u793E\u300D\u3068\u306F\u3001\u4F55\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-9'),'\u767A\u884C\u8005\u7533\u8ACB\u6642\u306B\u767B\u9332\u3057\u305F\u60C5\u5831\u3092\u5909\u66F4\u3057\u305F\u3044\u3067\u3059\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-10'),'\u767A\u884C\u8005\u306E\u7533\u8ACB\u53D7\u7406\u306E\u30E1\u30FC\u30EB\u304C\u5C4A\u304D\u307E\u305B\u3093\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J'),'\u30C8\u30FC\u30AF\u30F3\u306E\u4F5C\u6210\u30FB\u767A\u884C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-1'),'\u30C8\u30FC\u30AF\u30F3\u306E\u4F5C\u6210\u30FB\u767A\u884C\u65B9\u6CD5\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-2'),'\u30C8\u30FC\u30AF\u30F3\u4F5C\u6210\u6642\u306E\u30D7\u30ED\u30D1\u30C6\u30A3\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-3'),'\u30C8\u30FC\u30AF\u30F3\u4F5C\u6210\u30FB\u767A\u884C\u306B\u306F\u8CBB\u7528\u304C\u304B\u304B\u308A\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-4'),'RIA\u3068\u306E\u6BD4\u7387\u3092\u5206\u304B\u308A\u3084\u3059\u304F\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-5'),'\u30C8\u30FC\u30AF\u30F3\u767A\u884C\u7533\u8ACB\u5C65\u6B74\u306E\u30B9\u30C6\u30FC\u30BF\u30B9\u304C\u300CPending\u300D\u3068\u8868\u793A\u3055\u308C\u305F\u307E\u307E\u30C8\u30FC\u30AF\u30F3\u306E\u4F5C\u6210\u304C\u3067\u304D\u307E\u305B\u3093\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-6'),'\u4F5C\u6210\u3057\u305F\u30C8\u30FC\u30AF\u30F3\u3092\u524A\u9664\u3067\u304D\u307E\u3059\u304B\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-7'),'\u30C8\u30FC\u30AF\u30F3\u306E\u8FFD\u52A0\u767A\u884C\u3092\u7121\u52B9\u306B\u3057\u307E\u3057\u305F\u3002\u5143\u306B\u623B\u305B\u307E\u3059\u304B\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-8'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u6B8B\u9AD8\u304C\u3042\u308A\u307E\u3059\u304C\u300CNot enough funds in source account\u300D\u3068\u8868\u793A\u3055\u308C\u30C8\u30FC\u30AF\u30F3\u3092\u767A\u884C\u3067\u304D\u307E\u305B\u3093\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-9'),'\u30C8\u30E9\u30B9\u30C8\u7533\u8ACB\u3092\u9001\u3063\u3066\u304D\u305F\u30E6\u30FC\u30B6\u30FC\u306B\u5BFE\u3057\u3066\u7533\u8ACB\u3092\u62D2\u5426\u3057\u305F\u5834\u5408\u306F\u3069\u306E\u3088\u3046\u306A\u30A2\u30A4\u30B3\u30F3\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u304B\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-10'),'\u6307\u5B9A\u3057\u305F\u30C8\u30FC\u30AF\u30F3\u540D\u3067\u4F5C\u6210\u3067\u304D\u307E\u305B\u3093\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K'),'\u305D\u306E\u4ED6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-1'),'\u63A8\u5968\u30D6\u30E9\u30A6\u30B6\u306B\u3064\u3044\u3066')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-2'),'\u30C8\u30FC\u30AF\u30F3\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-3'),'\u5FC5\u8981\u306A\u304F\u306A\u3063\u305F\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u524A\u9664\u3057\u305F\u3044\u3067\u3059\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-4'),'\u983B\u7E41\u306B\u30B3\u30A4\u30F3\u9001\u4FE1\u3092\u3059\u308B\u30A2\u30C9\u30EC\u30B9\u3092\u767B\u9332\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-5'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u7D71\u5408\u3059\u308B\u3068\u306F\u3069\u3046\u3044\u3046\u6A5F\u80FD\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-6'),'\u672C\u4EBA\u78BA\u8A8D\u66F8\u985E\u306E\u753B\u50CF\u304C\uFF12MB\u4EE5\u4E0A\u3042\u308B\u305F\u3081\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3067\u304D\u307E\u305B\u3093\u3002\u3069\u3046\u3057\u305F\u3089\u3044\u3044\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-7'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u53D6\u5F15\u5C65\u6B74\u306E\u8868\u8A18\u5185\u5BB9\u306B\u3064\u3044\u3066')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-8'),'\u8A2D\u5B9A\u30DA\u30FC\u30B8\u306E\u300C \u30ED\u30B0\u30A4\u30F3\u6642\u306B\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u306E\u5165\u529B\u3092\u8981\u6C42\u3059\u308B\u300D\u3068\u306F\u3069\u3046\u3044\u3046\u610F\u5473\u3067\u3059\u304B\uFF1F')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'M'),'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-m1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'M-1'),'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-m2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'M-2'),'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u4F5C\u6210\u306F\u7121\u6599\u3067\u3059\u304B\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-m3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'M-3'),'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u4F5C\u6210\u306E\u624B\u9806\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-m4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'M-4'),'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u3067\u30B3\u30A4\u30F3\u9001\u4FE1\u3059\u308B\u969B\u306E\u624B\u9806\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-m5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'M-5'),'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u4F5C\u6210\u6642\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u305F\u79D8\u5BC6\u30AD\u30FC\u3092\u78BA\u8A8D\u3059\u308B\u3068\u3001\u30AD\u30FC\u304C6\u500B\u8A18\u8F09\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u3069\u308C\u304C\u79D8\u5BC6\u30AD\u30FC\u3067\u3059\u304B\uFF1F'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-role',id:'accordion',role:'main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TRIAM Network\u3092\u3054\u5229\u7528\u9802\u304D\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TRIAM Network\u3092\u3054\u5229\u7528\u6642\u306B\u304A\u56F0\u308A\u306E\u70B9\u304C\u3054\u3056\u3044\u307E\u3057\u305F\u3089\u3001\u4EE5\u4E0B\u306EQ&A\u3092\u53C2\u7167\u3057\u3066\u4E0B\u3055\u3044\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5B89\u5FC3\u3057\u3066\u3054\u5229\u7528\u3044\u305F\u3060\u304F\u305F\u3081\u306B\u3001TRIAM Network\u306F\u69D8\u3005\u306A\u30B5\u30DD\u30FC\u30C8\u3092\u63D0\u4F9B\u3057\u3066\u3044\u307E\u3059\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-group',id:'accordion'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-a'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A'),'\u65B0\u898F\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-1'),'\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210\u306E\u65B9\u6CD5\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TRIAM Network\u306E\u767B\u9332\u306F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u304A\u6301\u3061\u306E\u65B9\u3067\u3042\u308C\u3070\u3001\u3069\u306A\u305F\u3067\u3082\u3054\u81EA\u7531\u306B\u30E6\u30FC\u30B6\u30FC\u767B\u9332\u3092\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u767B\u9332\u306B\u5FC5\u8981\u306A\u3082\u306E\u306F\u3001\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3068\u3042\u306A\u305F\u304C\u6C7A\u3081\u308B\u30D1\u30B9\u30EF\u30FC\u30C9\u3067\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1. \u30ED\u30B0\u30A4\u30F3\u753B\u9762\u304B\u3089\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210\u753B\u9762\u3092\u958B\u304D\u3001\u6C0F\u540D\u3001\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3001\u30ED\u30B0\u30A4\u30F3\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2. \u300C\u6B21\u3078\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u3054\u767B\u9332\u3044\u305F\u3060\u3044\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u5B9B\u306B\u81EA\u52D5\u8FD4\u4FE1\u30E1\u30FC\u30EB\u304C\u9001\u4FE1\u3055\u308C\u307E\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3. \u81EA\u52D5\u8FD4\u4FE1\u30E1\u30FC\u30EB\u306B\u8A18\u8F09\u3055\u308C\u3066\u3044\u308B\u30E1\u30FC\u30EB\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3059\u308B\u3068\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210\u306F\u5B8C\u4E86\u3067\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3. \uFF12\u6BB5\u968E\u8A8D\u8A3C\u3001\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u8A2D\u5B9A\u3044\u305F\u3060\u304D\u307E\u3059\u3068\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3057\u3066\u3044\u305F\u3060\u3051\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-2'),'\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210\u306B\u8CBB\u7528\u306F\u304B\u304B\u308A\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u4F5C\u6210\u306F\u7121\u6599\u3067\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-3'),'\u30E1\u30FC\u30EB\u8A8D\u8A3C\u30B3\u30FC\u30C9\u306F\u3069\u3053\u306B\u8A18\u8F09\u3055\u308C\u3066\u3044\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210\u306E\u969B\u306B\u3001TRIAM Network\u304B\u3089\u3054\u767B\u9332\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3078\u300C\u30E1\u30FC\u30EB\u8A8D\u8A3C\u30B3\u30FC\u30C9\u300D\u3068\u3044\u3046\u4EF6\u540D\u3067\u30E1\u30FC\u30EB\u304C\u9001\u4FE1\u3055\u308C\u307E\u3059\u3002\u305D\u306E\u30E1\u30FC\u30EB\u306E\u4E2D\u306B\u3001\u8A8D\u8A3C\u30B3\u30FC\u30C9\u304C\u8A18\u8F09\u3055\u308C\u3066\u3044\u307E\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30E1\u30FC\u30EB\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u6307\u5B9A\u3055\u308C\u305F\u753B\u9762\u306B\u5165\u529B\u3059\u308B\u3053\u3068\u3067\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210\u3092\u9032\u3081\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-4'),'\u672C\u4EBA\u78BA\u8A8D\u66F8\u985E\u306B\u306F\u3001\u3069\u306E\u3088\u3046\u306A\u3082\u306E\u3092\u7528\u610F\u3059\u308C\u3070\u3044\u3044\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210\u306E\u969B\u306B\u306F\u3001\u672C\u4EBA\u78BA\u8A8D\u66F8\u985E\u306E\u63D0\u51FA\u306F\u5FC5\u8981\u3042\u308A\u307E\u305B\u3093\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h'},'\u767A\u884C\u8005'),'\uFF08Issuer\uFF09\u7533\u8ACB\u3092\u884C\u3046\u5834\u5408\u306F\u3001\u672C\u4EBA\u78BA\u8A8D\u66F8\u985E\u3092\u3054\u63D0\u51FA\u3044\u305F\u3060\u304D\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-5'),'\u3069\u306E\u56FD\u3067\u3082\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210\u306F\u53EF\u80FD\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672A\u6210\u5E74\u8005\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210\u53CA\u3073\u30B3\u30A4\u30F3\u5229\u7528\u306B\u95A2\u3057\u3066\u306F\u3001\u5229\u7528\u8005\u304C\u5C45\u4F4F\u3059\u308B\u56FD\u30FB\u5730\u57DF\u306E\u6CD5\u5F8B\u30FB\u898F\u5236\u306B\u5F93\u3044\u3054\u5229\u7528\u4E0B\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-6'),'\u30E1\u30FC\u30EB\u304C\u53D7\u4FE1\u3067\u304D\u305A\u3001\u30E1\u30FC\u30EB\u8A8D\u8A3C\u30B3\u30FC\u30C9\u304C\u53D7\u3051\u53D6\u308C\u307E\u305B\u3093\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30E1\u30FC\u30EB\u304C\u5C4A\u304B\u306A\u3044\u3068\u3044\u3046\u304A\u5BA2\u69D8\u306F\u4E0B\u8A18\u72B6\u6CC1\u304C\u8003\u3048\u3089\u308C\u307E\u3059\u306E\u3067\u3001\u6050\u308C\u5165\u308A\u307E\u3059\u304C\u5185\u5BB9\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u307E\u3059\u3088\u3046\u304A\u9858\u3044\u81F4\u3057\u307E\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u25A0\u8FF7\u60D1\u30E1\u30FC\u30EB\u30D5\u30A9\u30EB\u30C0\u306B\u5165\u3063\u3066\u3044\u308B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8FF7\u60D1\u30E1\u30FC\u30EB\u9632\u6B62\u6A5F\u80FD\u306B\u3088\u308A\u3001TRIAM Network\u304B\u3089\u306E\u30E1\u30FC\u30EB\u304C\u8FF7\u60D1\u30E1\u30FC\u30EB\u3068\u9593\u9055\u3048\u3089\u308C\u3066\u3044\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8FF7\u60D1\u30E1\u30FC\u30EB\u30D5\u30A9\u30EB\u30C0\u3084\u30B4\u30DF\u7BB1\u306B\u81EA\u52D5\u7684\u306B\u632F\u308A\u5206\u3051\u3089\u308C\u3066\u3044\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u4E00\u5EA6\u3054\u78BA\u8A8D\u3044\u305F\u3060\u304D\u307E\u3059\u3088\u3046\u304A\u9858\u3044\u81F4\u3057\u307E\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u25A0\u643A\u5E2F\u30FB\u30B9\u30DE\u30DB\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u304A\u4F7F\u3044\u306E\u304A\u5BA2\u69D8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30E1\u30FC\u30EB\u9632\u6B62\u30D5\u30A3\u30EB\u30BF\u30FC\u306B\u3088\u3063\u3066\u306F\u3058\u304B\u308C\u3066\u3044\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30E1\u30FC\u30EB\u9632\u6B62\u30D5\u30A3\u30EB\u30BF\u30FC\u3092\u3054\u5229\u7528\u306E\u5834\u5408\u306F\u3001[no-reply@triamnetwork.com]\u3092\u53D7\u4FE1\u3067\u304D\u308B\u3088\u3046\u8A2D\u5B9A\u3092\u304A\u9858\u3044\u81F4\u3057\u307E\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u25A0\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u5165\u529B\u9593\u9055\u3044'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u304A\u5BA2\u69D8\u304C\u767B\u9332\u3055\u308C\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u3054\u5165\u529B\u3044\u305F\u3060\u304F\u969B\u306B\u3001\u5165\u529B\u5185\u5BB9\u304C\u9593\u9055\u3063\u3066\u3044\u305F\u3068\u3044\u3046\u4E8B\u4F8B\u304C\u6570\u591A\u304F\u3054\u3056\u3044\u307E\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u25A0\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30BD\u30D5\u30C8\u3001\u30A6\u30A4\u30EB\u30B9\u5BFE\u7B56\u30BD\u30D5\u30C8\u306E\u8A2D\u5B9A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30BD\u30D5\u30C8\u306E\u8A2D\u5B9A\u306B\u3088\u3063\u3066\u306F\u3001\u30E1\u30FC\u30EB\u3092\u8FF7\u60D1\u30E1\u30FC\u30EB\u3068\u5224\u65AD\u3057\u3001\u53D7\u4FE1\u62D2\u5426\u30FB\u524A\u9664\u3059\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u304A\u4F7F\u3044\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30BD\u30D5\u30C8\u306E\u8A2D\u5B9A\u3092\u3054\u78BA\u8A8D\u3044\u305F\u3060\u304D\u3001\u8FF7\u60D1\u30E1\u30FC\u30EB\u9664\u5916\u8A2D\u5B9A\u3092\u304A\u9858\u3044\u81F4\u3057\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-7'),'\u672A\u6210\u5E74\u3067\u3059\u304C\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u4F5C\u6210\u3067\u304D\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210\u53CA\u3073\u30B3\u30A4\u30F3\u5229\u7528\u306B\u95A2\u3057\u3066\u306F\u3001\u5229\u7528\u8005\u304C\u5C45\u4F4F\u3059\u308B\u56FD\u30FB\u5730\u57DF\u306E\u6CD5\u5F8B\u30FB\u898F\u5236\u306B\u5F93\u3044\u3054\u5229\u7528\u4E0B\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-8'),'\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u8907\u6570\u767B\u9332\u3067\u304D\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30A2\u30AB\u30A6\u30F3\u30C8\u6570\u306B\u5236\u9650\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u304C\u91CD\u8907\u3057\u3066\u3044\u306A\u3051\u308C\u3070\u8907\u6570\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u305F\u3060\u3057\u3001\u4F5C\u6210\u3055\u308C\u305F\u8907\u6570\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u304A\u5BA2\u69D8\u3054\u81EA\u8EAB\u3067\u5145\u5206\u306A\u7BA1\u7406\u3092\u884C\u3063\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3088\u3046\u304A\u9858\u3044\u81F4\u3057\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a9',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-9'),'\u6CD5\u4EBA\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u4F5C\u6210\u3067\u304D\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a9',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u73FE\u5728\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u306F\u500B\u4EBA\u3001\u6CD5\u4EBA\u306E\u533A\u5225\u306F\u3054\u3056\u3044\u307E\u305B\u3093\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a10',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-10'),'\u7121\u52B9\u306A\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3067\u3059\u3068\u30A8\u30E9\u30FC\u304C\u51FA\u3066\u767B\u9332\u304C\u3067\u304D\u307E\u305B\u3093'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a10',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u81EA\u52D5\u8FD4\u4FE1\u30E1\u30FC\u30EB\u306B\u8A18\u8F09\u3055\u308C\u3066\u3044\u308B\u30E1\u30FC\u30EB\u8A8D\u8A3C\u30B3\u30FC\u30C9\u306B\u306F\u6709\u52B9\u671F\u9650\u304C\u3042\u308A\u3001\u30E1\u30FC\u30EB\u53D7\u4FE1\u304B\u308930\u5206\u4EE5\u4E0A\u306E\u6642\u9593\u304C\u7D4C\u904E\u3059\u308B\u3068\u7121\u52B9\u306B\u306A\u308A\u307E\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u518D\u9001\u3059\u308B\u5834\u5408\u306F\u3001\u3059\u3067\u306B\u9001\u4FE1\u3055\u308C\u305F\u30E1\u30FC\u30EB\u8A8D\u8A3C\u30B3\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u305F\u5F8C\u3001\u3059\u306A\u308F\u306130\u5206\u5F8C\u3067\u306A\u3051\u308C\u3070\u518D\u9001\u306F\u51FA\u6765\u307E\u305B\u3093\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7121\u52B9\u306A\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3001\u3068\u30A8\u30E9\u30FC\u304C\u8868\u793A\u3055\u308C\u305F\u5834\u5408\u306F\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210\u30DA\u30FC\u30B8\u3088\u308A\u518D\u5EA6\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u767B\u9332\u3057\u3066\u3001\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u767A\u884C\u3057\u306A\u304A\u3057\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3088\u3046\u304A\u9858\u3044\u3057\u307E\u3059\u3002'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-b'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B'),'\u30ED\u30B0\u30A4\u30F3\u30D1\u30B9\u30EF\u30FC\u30C9')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-1'),'\u30ED\u30B0\u30A4\u30F3\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u3066\u3057\u307E\u3044\u307E\u3057\u305F\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30ED\u30B0\u30A4\u30F3\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u304A\u5FD8\u308C\u306B\u306A\u3063\u305F\u5834\u5408\u3001\u30ED\u30B0\u30A4\u30F3\u753B\u9762\u306B\u3054\u3056\u3044\u307E\u3059\u3010\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u304A\u5FD8\u308C\u306E\u65B9\u3011\u304B\u3089\u518D\u8A2D\u5B9A\u3092\u884C\u3063\u3066\u9802\u3051\u307E\u3059\u3002\u518D\u8A2D\u5B9A\u306E\u969B\u306B\u3001\u767B\u9332\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u3054\u5165\u529B\u304C\u5FC5\u8981\u3067\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2460 \u3000\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u304A\u5FD8\u308C\u306E\u65B9\u3092\u30AF\u30EA\u30C3\u30AF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2461 \u3000\u767B\u9332\u3057\u3066\u3044\u308B\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2462 \u3000\u518D\u8A2D\u5B9A\u7528\u306E\u8A8D\u8A3C\u30B3\u30FC\u30C9\u304C\u30E1\u30FC\u30EB\u306B\u9001\u4FE1\u3055\u308C\u307E\u3059'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2463 \u3000\u30E1\u30FC\u30EB\u306B\u9001\u4FE1\u3055\u308C\u305F\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u307E\u3059'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2464 \u3000 \u65B0\u3057\u3044\u30ED\u30B0\u30A4\u30F3\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u8A2D\u5B9A\u3057\u307E\u3059'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-2'),'\u9593\u9055\u3063\u305F\u30ED\u30B0\u30A4\u30F3\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u51CD\u7D50\u3055\u308C\u3066\u3057\u307E\u3044\u307E\u3057\u305F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4E00\u5B9A\u56DE\u6570\u4EE5\u4E0A\u3001\u9593\u9055\u3063\u305F\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3055\u308C\u307E\u3059\u3068\u3001\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u78BA\u4FDD\u306E\u89B3\u70B9\u304B\u3089\u4E00\u5B9A\u6642\u9593\u30ED\u30B0\u30A4\u30F3\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u51CD\u7D50\u3055\u308C\u305F\u5834\u5408\u306F\u30E1\u30FC\u30EB\u306B\u3066\u30AB\u30B9\u30BF\u30DE\u30FC\u30B5\u30DD\u30FC\u30C8\u307E\u3067\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TRIAM Support Team'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,'support@triamnetwork.com'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-3'),'\u30ED\u30B0\u30A4\u30F3\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u66F4\u3057\u305F\u3044\u3067\u3059\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30ED\u30B0\u30A4\u30F3\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u5909\u66F4\u306F \u8A2D\u5B9A\u30DA\u30FC\u30B8\u306E [\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u66F4] \u307E\u305F\u306F\u3001\u30ED\u30B0\u30A4\u30F3\u753B\u9762\u306B\u3054\u3056\u3044\u307E\u3059\u3010\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u304A\u5FD8\u308C\u306E\u65B9\u3011\u304B\u3089\u518D\u8A2D\u5B9A\u3092\u884C\u3063\u3066\u9802\u3051\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-4'),'\u30ED\u30B0\u30A4\u30F3\u304C\u3067\u304D\u307E\u305B\u3093\u3002\u5165\u529B\u3059\u308B\u3068\u3001\u300C\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u300D\u300C\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u9593\u9055\u3063\u3066\u3044\u307E\u3059\u300D\u3068\u8868\u793A\u3055\u308C\u307E\u3059\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30ED\u30B0\u30A4\u30F3\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u306E\u969B\u306F\u5927\u6587\u5B57\u3068\u5C0F\u6587\u5B57\u3092\u533A\u5225\u3057\u3066\u8A8D\u8B58\u3055\u308C\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30ED\u30B0\u30A4\u30F3\u3067\u304D\u306A\u3044\u5834\u5408\u306F\u3001caps lock\u30AD\u30FC\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u306A\u3044\u304B\u3069\u3046\u304B\u3092\u78BA\u304B\u3081\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u5404\u6587\u5B57\u306B\u6B63\u3057\u3044\u5927\u6587\u5B57\u5C0F\u6587\u5B57\u3092\u4F7F\u7528\u3057\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-5'),'\u30ED\u30B0\u30A4\u30F3\u30D1\u30B9\u30EF\u30FC\u30C9\u306B\u8A2D\u5B9A\u3067\u304D\u308B\u6587\u5B57\u6570\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u304A\u5BA2\u69D8\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306E\u305F\u3081 TRIAM Network\u3067\u306F\u5145\u5206\u306A\u5F37\u5EA6\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u8A2D\u5B9A\u304C\u5FC5\u8981\u3068\u306A\u308A\u307E\u3059\u3002\u30ED\u30B0\u30A4\u30F3\u30D1\u30B9\u30EF\u30FC\u30C9\u306F 6\u6587\u5B57\u4EE5\u4E0A\u3001100 \u6587\u5B57\u4EE5\u4E0B\u3067\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-6'),'\uFF12\u6BB5\u968E\u8A8D\u8A3C\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\uFF12\u6BB5\u968E\u8A8D\u8A3C\u3068\u306F\u3001TRIAM Network\u306E\u30ED\u30B0\u30A4\u30F3\u30D1\u30B9\u30EF\u30FC\u30C9\u306B\u52A0\u3048\u3066\u3001\u3055\u3089\u306B\u78BA\u8A8D\u30B3\u30FC\u30C9\u306B\u3088\u308B\u8A8D\u8A3C\u3092\u884C\u3046\u3053\u3068\u3067\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u3092\u3088\u308A\u5F37\u5316\u3059\u308B\u305F\u3081\u306E\u4ED5\u7D44\u307F\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'TRIAM Network\u3067\u306F\u3001Google\u306E\u8A8D\u8A3C\u30A2\u30D7\u30EA\u3092\u5229\u7528\u3059\u308B\u65B9\u6CD5\u3067\uFF12\u6BB5\u968E\u8A8D\u8A3C\u3092\u8A2D\u5B9A\u3057\u3066\u3044\u305F\u3060\u3051\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-7'),'\uFF12\u6BB5\u968E\u8A8D\u8A3C\u306E\u30EA\u30BB\u30C3\u30C8\u30B3\u30FC\u30C9\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\uFF12\u6BB5\u968E\u8A8D\u8A3C\u306E\u30EA\u30BB\u30C3\u30C8\u30B3\u30FC\u30C9\u3068\u306F\u3001\uFF12\u6BB5\u968E\u8A8D\u8A3C\u3092\u8A2D\u5B9A\u3057\u3066\u3044\u308B\u7AEF\u672B\u3092\u5909\u66F4\u3059\u308B\u5834\u5408\u306A\u3069\u306B\u5FC5\u8981\u3068\u306A\u308B\u30B3\u30FC\u30C9\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\uFF12\u6BB5\u968E\u8A8D\u8A3C\u306E\u30EA\u30BB\u30C3\u30C8\u306F\u3001\u643A\u5E2F\u96FB\u8A71\u306E\u7D1B\u5931\u3001\u6545\u969C\u6642\u3084\u6A5F\u7A2E\u5909\u66F4\u3092\u3059\u308B\u5834\u5408\u306A\u3069\u306B\u5FC5\u8981\u3068\u306A\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'red'},'\uFF01\uFF01\uFF01\u3054\u6CE8\u610F\uFF01\uFF01\uFF01',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\uFF12\u6BB5\u968E\u8A8D\u8A3C\u306E\u30EA\u30BB\u30C3\u30C8\u30B3\u30FC\u30C9\u306F\u518D\u8868\u793A\u3084\u518D\u767A\u884C\u304C\u4E0D\u53EF\u80FD\u3068\u306A\u3063\u3066\u304A\u308A\u307E\u3059\u306E\u3067\u3001\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u306E\u8A2D\u5B9A\u6642\u306B\u4E00\u5EA6\u3060\u3051\u8868\u793A\u3055\u308C\u308B\u30EA\u30BB\u30C3\u30C8\u30B3\u30FC\u30C9\u3092\u7D1B\u5931\u3057\u306A\u3044\u3088\u3046\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-8'),'\uFF12\u6BB5\u968E\u8A8D\u8A3C\u306F\u89E3\u9664\u3067\u304D\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30ED\u30B0\u30A4\u30F3\u5F8C\u3001\u8A2D\u5B9A\u30E1\u30CB\u30E5\u30FC\u3088\u308A\u3054\u81EA\u8EAB\u3067\u30EA\u30BB\u30C3\u30C8\u30FB\u5909\u66F4\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\uFF12\u6BB5\u968E\u8A8D\u8A3C\u306E\u30EA\u30BB\u30C3\u30C8\u306B\u306F\u8A2D\u5B9A\u6642\u306B\u767A\u884C\u3055\u308C\u305F\u30EA\u30BB\u30C3\u30C8\u30B3\u30FC\u30C9\u304C\u5FC5\u8981\u3067\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u306A\u304A\u3001\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306E\u89B3\u70B9\u304B\u3089\u3001TRIAM Network\u3067\u306F\u3001\uFF12\u6BB5\u968E\u8A8D\u8A3C\u306F\u30B5\u30FC\u30D3\u30B9\u3092\u3054\u5229\u7528\u3044\u305F\u3060\u304F\u306B\u3042\u305F\u3063\u3066\u306E\u5FC5\u9808\u4E8B\u9805\u3068\u306A\u3063\u3066\u304A\u308A\u307E\u3059\u3002\u8A2D\u5B9A\u306E\u5909\u66F4\u306F\u53EF\u80FD\u3067\u3059\u304C\u3001\u89E3\u9664\u3057\u305F\u72B6\u614B\u3067\u306FTRIAM Network\u306E\u69D8\u3005\u306A\u6A5F\u80FD\u304C\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b9',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-9'),'\uFF12\u6BB5\u968E\u8A8D\u8A3C\u306E\u30EA\u30BB\u30C3\u30C8\u30B3\u30FC\u30C9\u3092\u5FD8\u308C\u3066\u3057\u307E\u3044\u307E\u3057\u305F\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b9',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\uFF12\u6BB5\u968E\u8A8D\u8A3C\u306E\u30EA\u30BB\u30C3\u30C8\u30B3\u30FC\u30C9\u306F\uFF12\u6BB5\u968E\u8A8D\u8A3C\u3092\u8A2D\u5B9A\u3059\u308B\u969B\u306B\u4E00\u5EA6\u3060\u3051\u8868\u793A\u3055\u308C\u308B\u3082\u306E\u3067\u3059\u3002\u7D1B\u5931\u3055\u308C\u305F\u5834\u5408\u3001\u518D\u8868\u793A\u3084\u518D\u767A\u884C\u306F\u3067\u304D\u307E\u305B\u3093\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b10',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-10'),'\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u304C\u306A\u3044\u30682\u6BB5\u968E\u8A8D\u8A3C\u306F\u8A2D\u5B9A\u3067\u304D\u306A\u3044\u306E\u3067\u3057\u3087\u3046\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b10',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TRIAM Network\u306E\uFF12\u6BB5\u968E\u8A8D\u8A3C\u306FGoogle\u304C\u63D0\u4F9B\u3059\u308B\u30B5\u30FC\u30D3\u30B9\u3092\u4F7F\u7528\u3057\u3066\u304A\u308A\u307E\u3059\u3002WEB\u7248\u3001IOS\u7248\u3001Android\u7248\u304C\u3054\u3056\u3044\u307E\u3059\u3002\u3054\u5229\u7528\u306E\u30C7\u30D0\u30A4\u30B9\u306B\u3088\u3063\u3066\u3054\u9078\u629E\u4E0B\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Google\uFF12\u6BB5\u968E\u8A8D\u8A3C\u306B\u3064\u3044\u3066\u306F\u4EE5\u4E0B\u306EURL\u3092\u3054\u53C2\u7167\u4E0B\u3055\u3044',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://www.google.com/landing/2step/'},'https://www.google.com/landing/2step/'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b11',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-11'),'\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b11',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3068\u306F\u3001\u30B3\u30A4\u30F3\u9001\u4FE1\u306A\u3069\u306E\u5404\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3059\u308B\u969B\u306B\u305D\u306E\u90FD\u5EA6\u3054\u5165\u529B\u3044\u305F\u3060\u304F\u30D1\u30B9\u30EF\u30FC\u30C9\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u306F\u4E0B\u8A18\u306E\u30EB\u30FC\u30EB\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u82F1\u6570\u8A18\u53F7\uFF16\u6841\u4EE5\u4E0A\u3067\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' \u30FB\uFF11\u3064\u4EE5\u4E0A\u306E\u5C0F\u6587\u5B57\u3092\u542B\u3080 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\uFF11\u3064\u4EE5\u4E0A\u306E\u5927\u6587\u5B57\u3092\u542B\u3080 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\uFF11\u3064\u4EE5\u4E0A\u306E\u6570\u5B57\u3092\u542B\u3080 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\uFF11\u3064\u4EE5\u4E0A\u306E\u8A18\u53F7\u3092\u542B\u3080'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'red'},'\uFF01\uFF01\uFF01\u3054\u6CE8\u610F\uFF01\uFF01\uFF01',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u304A\u5FD8\u308C\u306E\u5834\u5408\u3084\u7D1B\u5931\u3055\u308C\u305F\u5834\u5408\u306F\u30EA\u30BB\u30C3\u30C8\u3059\u308B\u3053\u3068\u304C\u53EF\u80FD\u3067\u3059\u304C\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B\u3068\u3001\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306E\u89B3\u70B9\u304B\u3089\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u5185\u306E\u3059\u3079\u3066\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u307E\u3059\u3002 \u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30D6\u30ED\u30C3\u30AF\u3092\u89E3\u9664\u3059\u308B\u306B\u306F\u3001\u5404\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u79D8\u5BC6\u30AD\u30FC\u304C\u5FC5\u8981\u3067\u3059\u3002 \u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B\u524D\u306B\u3001\u5FC5\u305A\u30A2\u30AB\u30A6\u30F3\u30C8\u5185\u306E\u3059\u3079\u3066\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u79D8\u5BC6\u30AD\u30FC\u304C\u304A\u624B\u5143\u306B\u3042\u308B\u304B\u3069\u3046\u304B\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u884C\u3063\u3066\u304F\u3060\u3055\u3044\u3002 \u79D8\u5BC6\u30AD\u30FC\u304C\u306A\u3044\u72B6\u614B\u3067\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u3066\u3057\u307E\u3046\u3068\u3001\u6C38\u4E45\u306B\u305D\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u3054\u4F7F\u7528\u3044\u305F\u3060\u3051\u306A\u304F\u306A\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d12'},'\u30ED\u30C3\u30AF\u89E3\u9664\u65B9\u6CD5\u306F\u3053\u3061\u3089\u2192'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b12',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-12'),'\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u66F4\u3057\u305F\u3044\u3067\u3059\u3002 '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b12',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8A2D\u5B9A\u30DA\u30FC\u30B8\u306E [\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u66F4] \u304B\u3089\u5909\u66F4\u3057\u3066\u3044\u305F\u3060\u3051\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u307E\u305A\u3001\u73FE\u5728\u304A\u4F7F\u3044\u306E\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u3054\u5165\u529B\u3044\u305F\u3060\u304D\u3001\u7D9A\u3044\u3066\u65B0\u3057\u304F\u8A2D\u5B9A\u3057\u305F\u3044\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u3054\u5909\u66F4\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u306F\u4E0B\u8A18\u306E\u30EB\u30FC\u30EB\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u82F1\u6570\u8A18\u53F7\uFF16\u6841\u4EE5\u4E0A\u3067\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' \u30FB\uFF11\u3064\u4EE5\u4E0A\u306E\u5C0F\u6587\u5B57\u3092\u542B\u3080 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\uFF11\u3064\u4EE5\u4E0A\u306E\u5927\u6587\u5B57\u3092\u542B\u3080 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\uFF11\u3064\u4EE5\u4E0A\u306E\u6570\u5B57\u3092\u542B\u3080 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\uFF11\u3064\u4EE5\u4E0A\u306E\u8A18\u53F7\u3092\u542B\u3080 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b13',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-13'),'\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u3066\u3057\u307E\u3044\u307E\u3057\u305F\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b13',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u304A\u5FD8\u308C\u306E\u5834\u5408\u3084\u7D1B\u5931\u3055\u308C\u305F\u5834\u5408\u306F\u30EA\u30BB\u30C3\u30C8\u3059\u308B\u3053\u3068\u304C\u53EF\u80FD\u3067\u3059\u304C\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B\u3068\u3001\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306E\u89B3\u70B9\u304B\u3089\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u5185\u306E\u3059\u3079\u3066\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30D6\u30ED\u30C3\u30AF\u3092\u89E3\u9664\u3059\u308B\u306B\u306F\u3001\u5404\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u79D8\u5BC6\u30AD\u30FC\u304C\u5FC5\u8981\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B\u524D\u306B\u3001\u5FC5\u305A\u30A2\u30AB\u30A6\u30F3\u30C8\u5185\u306E\u3059\u3079\u3066\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u79D8\u5BC6\u30AD\u30FC\u304C\u304A\u624B\u5143\u306B\u3042\u308B\u304B\u3069\u3046\u304B\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u884C\u3063\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u79D8\u5BC6\u30AD\u30FC\u304C\u306A\u3044\u72B6\u614B\u3067\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u3066\u3057\u307E\u3046\u3068\u3001\u6C38\u4E45\u306B\u305D\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u3054\u4F7F\u7528\u3044\u305F\u3060\u3051\u306A\u304F\u306A\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u30EA\u30BB\u30C3\u30C8\u624B\u9806'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2460 \u8A2D\u5B9A\u30DA\u30FC\u30B8\u306E [\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8] \u3092\u30AF\u30EA\u30C3\u30AF ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u2461 \u65B0\u3057\u304F\u8A2D\u5B9A\u3057\u305F\u3044\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3059\u308B ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u203B\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u306F\u4E0B\u8A18\u306E\u30EB\u30FC\u30EB\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u82F1\u6570\u8A18\u53F7\uFF16\u6841\u4EE5\u4E0A\u3067\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30FB\uFF11\u3064\u4EE5\u4E0A\u306E\u5C0F\u6587\u5B57\u3092\u542B\u3080 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\uFF11\u3064\u4EE5\u4E0A\u306E\u5927\u6587\u5B57\u3092\u542B\u3080 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\uFF11\u3064\u4EE5\u4E0A\u306E\u6570\u5B57\u3092\u542B\u3080 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\uFF11\u3064\u4EE5\u4E0A\u306E\u8A18\u53F7\u3092\u542B\u3080 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2462 \u6B21\u306B\u30A2\u30AB\u30A6\u30F3\u30C8\u5185\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u3046\u3061\uFF11\u3064\u3092\u9078\u629E\u3057\u3066\u305D\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u79D8\u5BC6\u30AD\u30FC\u3092\u3054\u5165\u529B\u3044\u305F\u3060\u304D\u3001[\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B] \u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u2463\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B\u3068\u30A2\u30AB\u30A6\u30F3\u30C8\u5185\u306E\u3059\u3079\u3066\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u307E\u3059\u306E\u3067\u3001\u6700\u5F8C\u306E\u30B9\u30C6\u30C3\u30D7\u3067\u5404\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30D6\u30ED\u30C3\u30AF\u3092\u89E3\u9664\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30D6\u30ED\u30C3\u30AF\u3092\u89E3\u9664\u3057\u305F\u3044\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u79D8\u5BC6\u30AD\u30FC\u3092\u5165\u529B\u3057\u3066 [\u30D6\u30ED\u30C3\u30AF\u89E3\u9664] \u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6700\u5F8C\u306B [\u7D42\u4E86\u3059\u308B] \u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u203B\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30D6\u30ED\u30C3\u30AF\u89E3\u9664\u306F\u3042\u3068\u304B\u3089\u3082\u884C\u3046\u3053\u3068\u3082\u53EF\u80FD\u3067\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d12'},'\u30ED\u30C3\u30AF\u89E3\u9664\u65B9\u6CD5\u306F\u3053\u3061\u3089\u2192'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b14'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b14',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-14'),'\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u306B\u8A2D\u5B9A\u3067\u304D\u308B\u6587\u5B57\u6570\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b14',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u203B\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u306F\u4E0B\u8A18\u306E\u30EB\u30FC\u30EB\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u82F1\u6570\u8A18\u53F7\uFF16\u6841\u4EE5\u4E0A\u3067\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' \u30FB\uFF11\u3064\u4EE5\u4E0A\u306E\u5C0F\u6587\u5B57\u3092\u542B\u3080 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\uFF11\u3064\u4EE5\u4E0A\u306E\u5927\u6587\u5B57\u3092\u542B\u3080 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\uFF11\u3064\u4EE5\u4E0A\u306E\u6570\u5B57\u3092\u542B\u3080 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\uFF11\u3064\u4EE5\u4E0A\u306E\u8A18\u53F7\u3092\u542B\u3080'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-c1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'C'),'\u3054\u767B\u9332\u60C5\u5831\u306E\u5909\u66F4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-c1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-c1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'C-1'),'\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5909\u66F4\u3057\u305F\u3044\u3067\u3059\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-c1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u73FE\u5728\u3001\u3054\u767B\u9332\u6642\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306F\u30ED\u30B0\u30A4\u30F3ID\u3068\u306A\u3063\u3066\u304A\u308A\u307E\u3059\u70BA\u3001\u5909\u66F4\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u3054\u767B\u9332\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u304C\u3054\u5229\u7528\u3067\u304D\u306A\u304F\u306A\u3063\u305F\u5834\u5408\u306F\u30AB\u30B9\u30BF\u30DE\u30FC\u30B5\u30DD\u30FC\u30C8\u3078\u3054\u76F8\u8AC7\u4E0B\u3055\u3044\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,'support@triamnetwork.com'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-c2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-c2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'C-2'),'\u767B\u9332\u3057\u305F\u6C0F\u540D\u3092\u5909\u66F4\u3057\u305F\u3044\u3067\u3059\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-c2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u767B\u9332\u60C5\u5831\u306E\u5909\u66F4\u3092\u3054\u5E0C\u671B\u306E\u5834\u5408\u306F\u30E1\u30FC\u30EB\u306B\u3066\u30AB\u30B9\u30BF\u30DE\u30FC\u30B5\u30DD\u30FC\u30C8\u307E\u3067\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-c3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-c3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'C-3'),'\u767B\u9332\u3057\u305F\u60C5\u5831\u3092\u78BA\u8A8D\u3059\u308B\u306B\u306F\u3069\u3046\u3057\u305F\u3089\u3044\u3044\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-c3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u304A\u624B\u6570\u3067\u3059\u304C\u3001\u30E1\u30FC\u30EB\u306B\u3066\u30AB\u30B9\u30BF\u30DE\u30FC\u30B5\u30DD\u30FC\u30C8\u307E\u3067\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-c4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-c4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'C-4'),'\u8A00\u8A9E\u306E\u8A2D\u5B9A\u3092\u5909\u3048\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-c4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u753B\u9762\u306E\u8A00\u8A9E\u8868\u8A18\u306B\u3064\u304D\u307E\u3057\u3066\u306F\u753B\u9762\u53F3\u4E0A\u306E\u8A00\u8A9E\u56FD\u65D7\u306B\u3066\u3054\u5909\u66F4\u3044\u305F\u3060\u3051\u307E\u3059\u3002'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-d'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u4F5C\u6210')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-1'),'\u65B0\u898F\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u3069\u306E\u3088\u3046\u306B\u3057\u3066\u4F5C\u6210\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'My\u30A6\u30A9\u30EC\u30C3\u30C8\u30DA\u30FC\u30B8\u306E\u300C\u65B0\u898F\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u300D\u304B\u3089\u884C\u3063\u3066\u3044\u305F\u3060\u3051\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A6\u30A9\u30EC\u30C3\u30C8\u540D\u306F\u4EFB\u610F\u3067\u304A\u6C7A\u3081\u3044\u305F\u3060\u3044\u305F\u3082\u306E\u3092\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u306E\u6642\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u79D8\u5BC6\u30AD\u30FC\u3092\u5FC5\u305A\u4FDD\u7BA1\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A6\u30A9\u30EC\u30C3\u30C8\u4F5C\u6210\u6642\u306B\u306F\u3001\u4ED6\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u304B\u3089\u306E\u521D\u671F\u8CC7\u91D1\u306E\u63D0\u4F9B\u304C\u5FC5\u8981\u3068\u306A\u308A\u307E\u3059\u3002[RIAcoin\u3092\u9001\u4FE1\u3059\u308B\u30A6\u30A9\u30EC\u30C3\u30C8]\u306B\u30C1\u30A7\u30C3\u30AF\u3092\u5165\u308C\u3066\u3001\u540C\u4E00\u30A2\u30AB\u30A6\u30F3\u30C8\u5185\u306E\u521D\u671F\u8CC7\u91D1\u3092\u63D0\u4F9B\u3057\u3066\u3082\u3089\u3046\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u6307\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u6B21\u306B\u521D\u671F\u8CC7\u91D1\u306E\u6570\u91CF\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u521D\u671F\u8CC7\u91D1\u306F20 RIAcoin\u4EE5\u4E0A\u304C\u5FC5\u8981\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u3059\u3079\u3066\u306E\u9805\u76EE\u3092\u5165\u529B\u3057\u3066\u300C\u4F5C\u6210\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u306E\u30B3\u30FC\u30C9\u306E\u5165\u529B\u3092\u6C42\u3081\u3089\u308C\u307E\u3059\u306E\u3067\u3001Google\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u306E\u30A2\u30D7\u30EA\u3067\u751F\u6210\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u25A0\u521D\u3081\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u5834\u5408\u306E\u624B\u9806',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A2\u30AB\u30A6\u30F3\u30C8\u5185\u306B\u521D\u3081\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u5834\u5408\u306F\u3001\u4ED6\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u304B\u3089\u521D\u671F\u8CC7\u91D1\u3092\u63D0\u4F9B\u3057\u3066\u3082\u3089\u3046\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'1\uFF09My\u30A6\u30A9\u30EC\u30C3\u30C8\u30DA\u30FC\u30B8\u306E\u300C\u65B0\u898F\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u300D\u3092\u30AF\u30EA\u30C3\u30AF',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'2\uFF09\u4EFB\u610F\u3067\u304A\u6C7A\u3081\u3044\u305F\u3060\u3044\u305F\u30A6\u30A9\u30EC\u30C3\u30C8\u540D\u3092\u5165\u529B ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'3\uFF09\u79D8\u5BC6\u30AD\u30FC\u3092\u4FDD\u7BA1 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4\uFF09\u300C\u4FDD\u5B58\u300D\u3092\u30AF\u30EA\u30C3\u30AF ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4FDD\u5B58\u3057\u305F\u5F8C\u3001\u521D\u671F\u8CC7\u91D1\u3092\u63D0\u4F9B\u3057\u3066\u3082\u3089\u3046\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u6240\u6709\u8005\u306B\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30A2\u30AF\u30C6\u30A3\u30D6\u5316\u306E\u4F5C\u696D\u3092\u3057\u3066\u3082\u3089\u3044\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A2\u30AF\u30C6\u30A3\u30D6\u5316\u306E\u4F5C\u696D\u3092\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u81EA\u5206\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306EMy\u30A6\u30A9\u30EC\u30C3\u30C8\u30DA\u30FC\u30B8\u304B\u3089\u3001\u300C\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30A2\u30AF\u30C6\u30A3\u30D6\u306B\u3059\u308B\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A2\u30AF\u30C6\u30A3\u30D6\u306B\u3057\u305F\u3044\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u3053\u306E\u6642\u3001\u300C\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30A2\u30AF\u30C6\u30A3\u30D6\u306B\u3059\u308B\u300D\u306E\u30C1\u30A7\u30C3\u30AF\u30DC\u30C3\u30AF\u30B9\u306B\u306F\u30C1\u30A7\u30C3\u30AF\u3092\u3044\u308C\u305A\u306B\u4F5C\u696D\u3092\u9032\u3081\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u521D\u671F\u8CC7\u91D1\u3092\u63D0\u4F9B\u3059\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u3001Google\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u306E\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3059\u308C\u3070\u5B8C\u4E86\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'red'},'\uFF01\uFF01\uFF01\u3054\u6CE8\u610F\uFF01\uFF01\uFF01',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A6\u30A9\u30EC\u30C3\u30C8\u4F5C\u6210\u306E\u969B\u306B\u8868\u793A\u3055\u308C\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u79D8\u5BC6\u30AD\u30FC\u306F\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u5909\u66F4\u6642\u3084\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u56DE\u5FA9\u6642\u306B\u5FC5\u8981\u3068\u306A\u308B\u5927\u5909\u91CD\u8981\u306A\u3082\u306E\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u79D8\u5BC6\u30AD\u30FC\u306F\u30A6\u30A9\u30EC\u30C3\u30C8\u4F5C\u6210\u6642\u306B\u4E00\u5EA6\u3060\u3051\u8868\u793A\u3055\u308C\u307E\u3059\u306E\u3067\u3001\u7D19\u306B\u66F8\u3044\u305F\u308A\u5370\u5237\u3059\u308B\u306A\u3069\u3057\u3066\u4FDD\u5B58\u3001\u307E\u305F\u306F\u5199\u771F\u3092\u64AE\u308B\u306A\u3069\u3057\u3066\u30AA\u30D5\u30E9\u30A4\u30F3\u4E0A\u3067\u5B89\u5168\u306B\u4FDD\u7BA1\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u79D8\u5BC6\u30AD\u30FC\u306F\u5404\u30A6\u30A9\u30EC\u30C3\u30C8\u3054\u3068\u306B\u7570\u306A\u3063\u305F\u30AD\u30FC\u304C\u767A\u884C\u3055\u308C\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u79D8\u5BC6\u30AD\u30FC\u3092\u7B2C\u4E09\u8005\u306B\u77E5\u3089\u308C\u305F\u5834\u5408\u306F\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4E57\u3063\u53D6\u3089\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u306E\u3067\u53D6\u308A\u6271\u3044\u306B\u306F\u5145\u5206\u306B\u3054\u6CE8\u610F\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-2'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u3068\u306F\u3001TRIAM Network\u3067\u30B3\u30A4\u30F3\u3084\u30C8\u30FC\u30AF\u30F3\u3092\u5229\u7528\u3059\u308B\u306B\u3042\u305F\u3063\u3066\u306E\u300C\u53E3\u5EA7\u756A\u53F7\u300D\u306E\u3088\u3046\u306A\u3082\u306E\u3067\u3059\u3002\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u306F\u300127\uFF5E34\u6587\u5B57\u306E\u82F1\u6570\u5B57\u304B\u3089\u306A\u3063\u3066\u304A\u308A\u3001\u5404\u30A6\u30A9\u30EC\u30C3\u30C8\u3054\u3068\u306B\u767A\u884C\u3055\u308C\u307E\u3059\u3002\u30B3\u30A4\u30F3\u3084\u30C8\u30FC\u30AF\u30F3\u306E\u9001\u53D7\u4FE1\u306E\u969B\u306B\u306F\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u304C\u5FC5\u8981\u3068\u306A\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u306F\u4ED6\u4EBA\u306B\u77E5\u3089\u305B\u3066\u30B3\u30A4\u30F3\u3084\u30C8\u30FC\u30AF\u30F3\u3092\u9001\u3063\u3066\u3082\u3089\u3046\u3082\u306E\u306A\u306E\u3067\u3001\u7B2C\u4E09\u8005\u306B\u77E5\u3089\u308C\u308B\u3053\u3068\u81EA\u4F53\u306F\u554F\u984C\u3042\u308A\u307E\u305B\u3093\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5404\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u306F\u3001\u300CMy\u30A6\u30A9\u30EC\u30C3\u30C8\u300D\u304B\u3089\u3054\u78BA\u8A8D\u3044\u305F\u3060\u3051\u307E\u3059\u3002\u4F5C\u6210\u3055\u308C\u305F\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30A2\u30C9\u30EC\u30B9\u3092\u5909\u66F4\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-3'),'\u79D8\u5BC6\u30AD\u30FC\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u79D8\u5BC6\u30AD\u30FC\u3068\u306F\u3001\u5404\u30A6\u30A9\u30EC\u30C3\u30C8\u6BCE\u306B\u767A\u884C\u3055\u308C\u308B\u30B3\u30FC\u30C9\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u79D8\u5BC6\u30AD\u30FC\u306F\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30D6\u30ED\u30C3\u30AF\u89E3\u9664\u3084\u56DE\u5FA9\u3001\u30A4\u30F3\u30DD\u30FC\u30C8\u306B\u4F7F\u308F\u308C\u308B\u5927\u5909\u91CD\u8981\u306A\u3082\u306E\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u79D8\u5BC6\u30AD\u30FC\u304C\u3042\u308C\u3070\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4E38\u3054\u3068\u518D\u73FE\u3059\u308B\u3053\u3068\u304C\u53EF\u80FD\u3067\u3059\u3001\u79D8\u5BC6\u30AD\u30FC\u304C\u4ED6\u4EBA\u306B\u6F0F\u308C\u308B\u3068\u3044\u3046\u3053\u3068\u306F\u3001\u30AD\u30E3\u30C3\u30B7\u30E5\u30AB\u30FC\u30C9\u3068\u6697\u8A3C\u756A\u53F7\u3092\u4ED6\u4EBA\u306B\u6559\u3048\u308B\u3053\u3068\u3068\u540C\u3058\u3067\u3059\u3002\u307E\u305F\u3001\u3053\u306E\u79D8\u5BC6\u30AD\u30FC\u304C\u3042\u308C\u3070\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u7121\u304F\u3057\u305F\u5834\u5408\u3084\u58CA\u3057\u3066\u3057\u307E\u3063\u3066\u3082\u5FA9\u5143\u3067\u304D\u307E\u3059\u304C\u3001\u79D8\u5BC6\u30AD\u30FC\u3092\u5FD8\u308C\u305F\u30FB\u7D1B\u5931\u3057\u305F\u5834\u5408\u306A\u3069\u306F\u518D\u767A\u884C\u304C\u51FA\u6765\u307E\u305B\u3093\u306E\u3067\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u554F\u984C\u304C\u8D77\u3053\u3063\u305F\u5834\u5408\u3001\u5BFE\u51E6\u3067\u304D\u306A\u304F\u306A\u308B\u5371\u967A\u304C\u3054\u3056\u3044\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u79D8\u5BC6\u30AD\u30FC\u306F\u30A6\u30A9\u30EC\u30C3\u30C8\u4F5C\u6210\u6642\u306B\u4E00\u5EA6\u3060\u3051\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u518D\u8868\u793A\u3084\u518D\u767A\u884C\u306F\u3067\u304D\u307E\u305B\u3093\u306E\u3067\u3001\u5FC5\u305A\u4FDD\u5B58\u3057\u3066\u5927\u5207\u306B\u4FDD\u7BA1\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u53C8\u3001\u4FDD\u7BA1\u306F\u30AA\u30F3\u30E9\u30A4\u30F3\u4E0A\u306E\u30C7\u30D0\u30A4\u30B9\u3067\u306F\u306A\u304F\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u74B0\u5883\u3067\u4FDD\u7BA1\u3059\u308B\u3053\u3068\u3092\u5F37\u304F\u304A\u52E7\u3081\u81F4\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-4'),'Google\uFF12\u6BB5\u968E\u8A8D\u8A3C\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\uFF12\u6BB5\u968E\u8A8D\u8A3C\u3068\u306F\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u306B\u52A0\u3048\u3001Google\u304B\u3089\u643A\u5E2F\u7AEF\u672B\u306B\u9001\u3089\u308C\u305F\u30B3\u30FC\u30C9\u306E\u5165\u529B\u3092\u5FC5\u8981\u3068\u3059\u308B\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30D7\u30ED\u30BB\u30B9\u3067\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u30ED\u30B0\u30A4\u30F3\u3084\u53D6\u5F15\u306E\u5B9F\u884C\u306E\u305F\u3081\u306B\u5FC5\u8981\u306A\u60C5\u5831\u304C\u5897\u3048\u3001\u30D6\u30EB\u30FC\u30C8\u30D5\u30A9\u30FC\u30B9\u653B\u6483\u306E\u3088\u3046\u306A\u5358\u8A9E\u7DCF\u5F53\u305F\u308A\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u53D6\u5F97\u306E\u653B\u6483\u65B9\u6CD5\u3067\u306F\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u53D6\u5F97\u3057\u30ED\u30B0\u30A4\u30F3\u3084\u53D6\u5F15\u3092\u5B9F\u884C\u3059\u308B\u3053\u3068\u304C\u5B9F\u8CEA\u4E0D\u53EF\u80FD\u306B\u306A\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://www.google.co.jp/intl/ja/landing/2step/'},'https://www.google.co.jp/intl/ja/landing/2step/'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-5'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u3092\u5909\u66F4\u3057\u305F\u3044\u3067\u3059\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4F5C\u6210\u3057\u305F\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30A2\u30C9\u30EC\u30B9\u3092\u5909\u66F4\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-6'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u540D\u524D\u306F\u5909\u66F4\u3067\u304D\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'My\u30A6\u30A9\u30EC\u30C3\u30C8\u304B\u3089\u30A6\u30A9\u30EC\u30C3\u30C8\u540D\u3092\u5909\u66F4\u3057\u305F\u3044\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u3066\u3044\u305F\u3060\u304D\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u540D\u306E\u53F3\u6A2A\u306B\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u925B\u7B46\u30DE\u30FC\u30AF\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3053\u3068\u3067\u5909\u66F4\u3057\u3066\u3044\u305F\u3060\u3051\u307E\u3059\u3002\u30A6\u30A9\u30EC\u30C3\u30C8\u540D\u306E\u5909\u66F4\u306B\u56DE\u6570\u5236\u9650\u306F\u3042\u308A\u307E\u305B\u3093\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u53C8\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u540D\u306F\u3042\u306A\u305F\u81EA\u8EAB\u304C\u7BA1\u7406\u3057\u3084\u3059\u304F\u3059\u308B\u70BA\u306E\u6A5F\u80FD\u3067\u3042\u308A\u3001\u9001\u91D1\u3084\u53D7\u91D1\u306E\u969B\u306B\u76F8\u624B\u306B\u77E5\u3089\u305B\u308B\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-7'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u4F5C\u6210\u306B\u306F\u8CBB\u7528\u304C\u304B\u304B\u308A\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u6642\u70B9\u3067\u306F\u8CBB\u7528\u306F\u5FC5\u8981\u3042\u308A\u307E\u305B\u3093\u304C\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30A2\u30AF\u30C6\u30A3\u30D9\u30FC\u30C8\uFF08RIAcoin\u3084\u30C8\u30FC\u30AF\u30F3\u3092\u4FDD\u7BA1\u3057\u305F\u308A\u9001\u53D7\u4FE1\u306A\u3069\u306B\u5229\u7528\u3059\u308B\u5834\u5408\uFF09\u3059\u308B\u969B\u306B\u306F20RIAcoin\u4EE5\u4E0A\u304C\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u306B\u3042\u308B\u3053\u3068\u304C\u6761\u4EF6\u3068\u306A\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4E00\u5EA6\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30A2\u30AF\u30C6\u30A3\u30D9\u30FC\u30C8\u306B\u3057\u305F\u5834\u5408\u3001\u30A2\u30AF\u30C6\u30A3\u30D9\u30FC\u30C8\u6761\u4EF6\u306B\u4F7F\u7528\u3055\u308C\u305F20RIAcoin\u306F\u79FB\u52D5\u3059\u308B\u3053\u3068\u304C\u51FA\u6765\u306A\u304F\u306A\u308A\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-8'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u8907\u6570\u4F5C\u6210\u3067\u304D\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u8907\u6570\u4F5C\u6210\u3057\u3066\u3044\u305F\u3060\u3051\u307E\u3059\u304C\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4FDD\u6301\u3059\u308B\u306B\u306F\u5E38\u306B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'20RIAcoin'),'\u4EE5\u4E0A\u306E\u6B8B\u9AD8\u304C\u5404\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u3042\u308B\u3053\u3068\u304C\u6761\u4EF6\u3068\u306A\u308A\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d9',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-9'),'\u3072\u3068\u3064\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u306F\u4F55\u7A2E\u985E\u306E\u30B3\u30A4\u30F3\u3092\u4FDD\u6709\u3067\u304D\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d9',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u306B\u4FDD\u6709\u3067\u304D\u308B\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u306E\u7A2E\u985E\u306B\u5236\u9650\u306F\u3054\u3056\u3044\u307E\u305B\u3093\u3002 \u53C8\u3001\u6570\u91CF\u306E\u5236\u9650\u3082\u3042\u308A\u307E\u305B\u3093\u3002\u30C8\u30FC\u30AF\u30F3\u3092\u53D6\u308A\u6271\u3044\u3059\u308B\u306B\u306F',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-f'},'\u30C8\u30E9\u30B9\u30C8'),'\u304C\u5FC5\u8981\u3067\u3059')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d10',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-10'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u306B\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u300C\uFF0B\u300D\u306E\u30DE\u30FC\u30AF\u306F\u4F55\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d10',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u300C+\u300D\u306E\u30DE\u30FC\u30AF\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3053\u3068\u3067\u3001\u305D\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u4ED6\u306E\u30C8\u30FC\u30AF\u30F3\u3092\u30C8\u30E9\u30B9\u30C8\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-f'},'\u30C8\u30E9\u30B9\u30C8'),'\u3057\u305F\u3044\u30C8\u30FC\u30AF\u30F3\u3092\u691C\u7D22\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d11',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-11'),'\u300C\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u3066\u3044\u307E\u3059\u300D\u3068\u8868\u793A\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u3069\u3046\u3059\u308C\u3070\u3088\u3044\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d11',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u66F4\u3057\u305F\u969B\u306A\u3069\u306B\u306F\u3001\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306E\u89B3\u70B9\u304B\u3089\u305D\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u5185\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30D6\u30ED\u30C3\u30AF\u3092\u89E3\u9664\u3059\u308B\u306B\u306F\u3001\u5404\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u79D8\u5BC6\u30AD\u30FC\u306E\u5165\u529B\u304C\u5FC5\u8981\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5404\u30A6\u30A9\u30EC\u30C3\u30C8\u30DA\u30FC\u30B8\u304B\u3089\u30A6\u30A9\u30EC\u30C3\u30C8\u540D\u306E\u5DE6\u6A2A\u306B\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u9375\u30DE\u30FC\u30AF\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u79D8\u5BC6\u30AD\u30FC\u3068\u53D6\u5F15\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3059\u308B\u753B\u9762\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u306E\u3067\u3001\u305D\u308C\u3089\u3092\u6B63\u78BA\u306B\u3054\u5165\u529B\u3044\u305F\u3060\u3051\u308C\u3070\u30D6\u30ED\u30C3\u30AF\u304C\u89E3\u9664\u3055\u308C\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u79D8\u5BC6\u30AD\u30FC\u306F\u5404\u30A6\u30A9\u30EC\u30C3\u30C8\u6BCE\u306B\u7570\u306A\u308A\u307E\u3059\u306E\u3067\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30D6\u30ED\u30C3\u30AF\u89E3\u9664\u306F\u5404\u30A6\u30A9\u30EC\u30C3\u30C8\u6BCE\u306B\u884C\u3063\u3066\u3044\u305F\u3060\u304F\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d12',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-12'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u3068\u304D\u306B\u300C\u4FDD\u5B58\u300D\u3092\u3057\u307E\u3057\u305F\u3002\u6709\u52B9\u306A\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u3059\u308B\u306B\u306F\u3069\u3046\u3057\u305F\u3089\u3088\u3044\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d12',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u969B\u306B\u300C\u4FDD\u5B58\u300D\u3092\u3059\u308B\u3068\u3001\u305D\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u30A2\u30AF\u30C6\u30A3\u30D6\u3067\u306F\u306A\u3044\u72B6\u614B\u3067\u4FDD\u5B58\u3055\u308C\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6709\u52B9\u306A\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u3059\u308B\u306B\u306F\u3001\u3059\u3067\u306B\u30A2\u30AF\u30C6\u30A3\u30D6\u306A\u4ED6\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u304B\u308920RIAcoin\u3092\u9001\u4FE1\u3057\u3066\u3082\u3089\u3046\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'My\u30A6\u30A9\u30EC\u30C3\u30C8\u30DA\u30FC\u30B8\u304B\u3089\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u540D\u306E\u5DE6\u6A2A\u306E\u201D\uFF01\u201D\u30DE\u30FC\u30AF\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u521D\u671F\u8CC7\u91D1\u3092\u63D0\u4F9B\u3057\u3066\u3082\u3089\u3046\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u3001\u521D\u671F\u8CC7\u91D1\u984D\u3092\u5165\u529B\u3057\u307E\u3059\u3002\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30A2\u30AF\u30C6\u30A3\u30D6\u5316\u306B\u306F20RIAcoin\u4EE5\u4E0A\u304C\u5FC5\u8981\u3067\u3059\u3002 \u6700\u5F8C\u306BGoogle\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3059\u308C\u3070\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u30A2\u30AF\u30C6\u30A3\u30D6\u3068\u306A\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u25A0\u4ED6\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u304B\u3089\u521D\u671F\u8CC7\u91D1\u3092\u63D0\u4F9B\u3057\u3066\u3082\u3089\u3046\u5834\u5408 \u521D\u671F\u8CC7\u91D1\u3092\u63D0\u4F9B\u3057\u3066\u3082\u3089\u3046\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u6240\u6709\u8005\u306B\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30A2\u30AF\u30C6\u30A3\u30D6\u5316\u306E\u4F5C\u696D\u3092\u3057\u3066\u3082\u3089\u3044\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'My\u30A6\u30A9\u30EC\u30C3\u30C8\u30DA\u30FC\u30B8\u304B\u3089\u3001\u300C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,'\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30A2\u30AF\u30C6\u30A3\u30D6\u306B\u3059\u308B'),'\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A2\u30AF\u30C6\u30A3\u30D6\u306B\u3057\u305F\u3044\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u3053\u306E\u6642\u3001\u300C\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30A2\u30AF\u30C6\u30A3\u30D6\u306B\u3059\u308B\u300D\u306E\u30C1\u30A7\u30C3\u30AF\u30DC\u30C3\u30AF\u30B9\u306B\u306F\u30C1\u30A7\u30C3\u30AF\u3092\u3044\u308C\u305A\u306B\u4F5C\u696D\u3092\u9032\u3081\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u521D\u671F\u8CC7\u91D1\u3092\u63D0\u4F9B\u3059\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u3001Google\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u306E\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3059\u308C\u3070\u5B8C\u4E86\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d13',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-13'),'\u65B0\u898F\u30A6\u30A9\u30EC\u30C3\u30C8\u4F5C\u6210\u6642\u306B\u3001\u4F55\u654520RIAcoin\u4EE5\u4E0A\u5FC5\u8981\u306A\u306E\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d13',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u7A7A\u306E\u72B6\u614B\u3067\u306F\u6709\u52B9\u306A\u30A6\u30A9\u30EC\u30C3\u30C8\u3068\u3057\u3066\u8A8D\u8B58\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u306A\u3044\u305F\u3081\u3001\u65B0\u898F\u30A6\u30A9\u30EC\u30C3\u30C8\u4F5C\u6210\u6642\u306B\u306F\u5FC5\u305ARIAcoin\u3092\u4FDD\u6709\u3055\u305B\u3066\u304A\u304F\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'TRIAM\u30A6\u30A9\u30EC\u30C3\u30C8\u3067\u306F\u30A2\u30AF\u30C6\u30A3\u30D9\u30FC\u30C8\uFF08\u6709\u52B9\u5316\uFF09\u3059\u308B\u305F\u3081\u306E\u6700\u4F4ERIAcoin\u6570\u304C20RIAcoin\u3068\u306A\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u3053\u306E\u5FC5\u8981\u6700\u4F4E\u6B8B\u9AD8\u306F\u3001\u30B9\u30D1\u30E0\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u4F5C\u6210\u304B\u3089\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u3092\u4FDD\u8B77\u3059\u308B\u306E\u306B\u5F79\u7ACB\u3061\u307E\u3059\u3002'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-f'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'F'),'\u30C8\u30E9\u30B9\u30C8')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-f1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-f1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'F-1'),'\u30C8\u30E9\u30B9\u30C8\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-f1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30C8\u30E9\u30B9\u30C8\u3068\u306F\u7C21\u5358\u306B\u8A00\u3046\u3068\u300C\u305D\u306E\u30C8\u30FC\u30AF\u30F3\u3092\u4FE1\u7528\u3059\u308B\u300D\u3068\u3044\u3046\u610F\u5473\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u7121\u6570\u306B\u5B58\u5728\u3059\u308B\u30C8\u30FC\u30AF\u30F3\u306E\u4E2D\u304B\u3089\u3001\u3054\u81EA\u8EAB\u304C\u4FE1\u983C\u3067\u304D\u308B\u3068\u5224\u65AD\u3057\u305F\u30C8\u30FC\u30AF\u30F3\u306E\u307F\u3092\u4F7F\u7528\u53EF\u80FD\u306B\u3059\u308B\u305F\u3081\u306E\u4ED5\u7D44\u307F\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30C8\u30FC\u30AF\u30F3\u3092\u9001\u4FE1\u30FB\u53D7\u4FE1\u3059\u308B\u306A\u3069\u3001\u3054\u5229\u7528\u3044\u305F\u3060\u304F\u306B\u306F\u3001\u4E8B\u524D\u306B\u305D\u306E\u30C8\u30FC\u30AF\u30F3\u3092\u30C8\u30E9\u30B9\u30C8\uFF08\u4FE1\u7528\uFF09\u3057\u3066\u3044\u305F\u3060\u304F\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-f2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-f2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'F-2'),'\u4ED6\u306E\u30C8\u30FC\u30AF\u30F3\u3092\u30C8\u30E9\u30B9\u30C8\u3059\u308B\u306B\u306F\u3069\u3046\u3057\u305F\u3089\u3044\u3044\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-f2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'My\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u300C+\u300D\u306E\u30DE\u30FC\u30AF\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u30C8\u30E9\u30B9\u30C8\u53EF\u80FD\u306A\u30C8\u30FC\u30AF\u30F3\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30C8\u30E9\u30B9\u30C8\u3057\u305F\u3044\u30C8\u30FC\u30AF\u30F3\u304C\u8868\u793A\u3055\u308C\u3066\u3044\u306A\u3044\u5834\u5408\u306F\u691C\u7D22\u3059\u308B\u3053\u3068\u3067\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u30C8\u30E9\u30B9\u30C8\u3057\u305F\u3044\u30C8\u30FC\u30AF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066OK\u30DC\u30BF\u30F3\u3092\u62BC\u3059\u3068\u30A6\u30A9\u30EC\u30C3\u30C8\u4E0A\u306B\u30C8\u30FC\u30AF\u30F3\u304C\u8FFD\u52A0\u3055\u308C\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30C8\u30FC\u30AF\u30F3\u306F\u30C8\u30E9\u30B9\u30C8\u7533\u8ACB\u3092\u3059\u308B\u3060\u3051\u3067\u627F\u8A8D\u3055\u308C\u308B\u3082\u306E\u3068\u3001\u767A\u884C\u8005\u306E\u627F\u8A8D\u4F5C\u696D\u3092\u3082\u3063\u3066\u30C8\u30E9\u30B9\u30C8\u5B8C\u4E86\u3068\u306A\u308B\u3082\u306E\u304C\u3042\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u306B\u8FFD\u52A0\u3055\u308C\u305F\u30C8\u30FC\u30AF\u30F3\u306E\u53F3\u4E0B\u306B\u30C1\u30A7\u30C3\u30AF\u30DE\u30FC\u30AF\u304C\u8868\u793A\u3055\u308C\u3066\u3044\u308C\u3070\u30C8\u30E9\u30B9\u30C8\u306F\u5B8C\u4E86\u3057\u3066\u3044\u307E\u3059\u3002\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u306B\u8FFD\u52A0\u3055\u308C\u305F\u30C8\u30FC\u30AF\u30F3\u306E\u53F3\u4E0B\u306B\u6642\u8A08\u306E\u30DE\u30FC\u30AF\u304C\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u3082\u306E\u306F\u3001\u767A\u884C\u8005\u304B\u3089\u306E\u30C8\u30E9\u30B9\u30C8\u627F\u8A8D\u304C\u672A\u5B8C\u306E\u72B6\u614B\u3068\u306A\u3063\u3066\u3044\u308B\u3082\u306E\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30C8\u30E9\u30B9\u30C8\u627F\u8A8D\u304C\u5B8C\u4E86\u3057\u3066\u3044\u306A\u3044\u72B6\u614B\u3067\u306F\u3001\u305D\u306E\u30C8\u30FC\u30AF\u30F3\u306E\u9001\u53D7\u4FE1\u306F\u3067\u304D\u307E\u305B\u3093\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-f3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-f3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'F-3'),'\u30C8\u30E9\u30B9\u30C8\u3057\u3066\u3044\u308B\u30C8\u30FC\u30AF\u30F3\u306E\u30C8\u30E9\u30B9\u30C8\u3092\u89E3\u9664\u3057\u305F\u3044\u3067\u3059\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-f3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4E00\u5EA6\u3001\u30C8\u30E9\u30B9\u30C8\u3057\u305F\u30C8\u30FC\u30AF\u30F3\u3092\u89E3\u9664\u3059\u308B\u306B\u306F\u3001\u89E3\u9664\u3057\u305F\u3044\u30C8\u30FC\u30AF\u30F3\u306E\u4FDD\u6709\u6570\u91CF\u304C\uFF10\u3067\u306A\u3051\u308C\u3070\u306A\u308A\u307E\u305B\u3093\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u306E\u30C8\u30E9\u30B9\u30C8\u89E3\u9664\u3057\u305F\u3044\u30C8\u30FC\u30AF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u300C\u30C8\u30FC\u30AF\u30F3\u30C8\u30E9\u30B9\u30C8\u3092\u89E3\u9664\u300D\u304B\u3089\u4F5C\u696D\u3092\u9032\u3081\u3066\u304F\u3060\u3055\u3044\u3002'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-x'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'X'),'\u624B\u6570\u6599')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-x1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-x1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'X-1'),'\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u30D5\u30A3\u30FC\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-x1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30D6\u30ED\u30C3\u30AF\u30C1\u30A7\u30FC\u30F3\u4E0A\u306B\u304A\u3044\u3066\u60C5\u5831\u51E6\u7406\uFF08\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\uFF09\u304C\u5FC5\u8981\u3068\u306A\u308B\u64CD\u4F5C\u304C\u884C\u308F\u308C\u305F\u3068\u304D\u306B\u767A\u751F\u3059\u308B\u624B\u6570\u6599\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5C1A\u3001\u53D6\u5F15\u304C\u5931\u6557\u3057\u305F\u969B\u306B\u3082\u3001\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u30D5\u30A3\u30FC\u306F\u767A\u751F\u3044\u305F\u3057\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-x2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-x2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'X-2'),'\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u624B\u6570\u6599\u306F\u3001\u3044\u304F\u3089\u304B\u304B\u308A\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-x2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'RIAcoin\u306E\u5834\u5408\u30011\u56DE\u306E\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u30D5\u30A3\u30FC\u306F0.001RIAcoin\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'TRIAM\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u4E0A\u3067\u4F5C\u6210\u3055\u308C\u305F\u30C8\u30FC\u30AF\u30F3\u3092\u9001\u4FE1\u3059\u308B\u5834\u5408\u3001RIAcoin\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u30D5\u30A3\u30FC\u3068\u30C8\u30FC\u30AF\u30F3\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u30D5\u30A3\u30FC\u306E\uFF12\u3064\u306E\u30D5\u30A3\u30FC\u304C\u5FC5\u8981\u3067\u3059\u3002\u30C8\u30FC\u30AF\u30F3\u306E\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u30D5\u30A3\u30FC\u306F\u5404\u30C8\u30FC\u30AF\u30F3\u306B\u3088\u308A\u7570\u306A\u308A\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-x3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-x3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'X-3'),'\u9001\u91D1\u30A8\u30E9\u30FC\u304C\u8868\u793A\u3055\u308C\u3001\u30B3\u30A4\u30F3\u306E\u9001\u4FE1\u304C\u304A\u3053\u306A\u308F\u308C\u3066\u3044\u306A\u3044\u306E\u306B\u624B\u6570\u6599\u304C\u5F15\u304B\u308C\u3066\u3044\u307E\u3059\u3002\u306A\u305C\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-x3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u9001\u91D1\u30A8\u30E9\u30FC\u306E\u5834\u5408\u306B\u304A\u3044\u3066\u3082\u3001\u30D6\u30ED\u30C3\u30AF\u30C1\u30A7\u30FC\u30F3\u4E0A\u3067\u60C5\u5831\u51E6\u7406\u304C\u884C\u308F\u308C\u3066\u3044\u308B\u305F\u3081\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u30D5\u30A3\u30FC\u304C\u767A\u751F\u3057\u307E\u3059\u3002'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-g'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G'),'\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u306E\u9001\u4FE1\u30FB\u53D7\u4FE1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-1'),'\u53CB\u9054\u306BRIAcoin\u3092\u9001\u4FE1\u3057\u305F\u3044\u3067\u3059\u3002\u3069\u3046\u3059\u308C\u3070\u3044\u3044\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'My\u30A6\u30A9\u30EC\u30C3\u30C8\u30DA\u30FC\u30B8\u304B\u3089\u3001\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u306E\u9001\u4FE1\u3092\u884C\u3044\u305F\u3044\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6B21\u306B\u9001\u4FE1\u3057\u305F\u3044\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u3092\u9078\u629E\u3057\u307E\u3059\u3002\u3053\u306E\u5834\u5408\u306FRIAcoin\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u53D6\u5F15\u306E\u9078\u629E\u753B\u9762\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u306E\u3067\u3001\u300C\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u3092\u9001\u308B\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u9001\u4FE1\u5148\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3001\u9001\u4FE1\u3057\u305F\u3044\u6570\u91CF\u3092\u5165\u529B\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6700\u5F8C\u306BGoogle\uFF12\u6BB5\u968E\u8A8D\u8A3C\u306E\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3059\u308C\u3070\u5B8C\u4E86\u3067\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-2'),'\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u306E\u9001\u4FE1\u9650\u5EA6\u984D\u306F\u3042\u308A\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u9001\u4FE1\u9650\u5EA6\u984D\u306F\u3042\u308A\u307E\u305B\u3093\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u9001\u4FE1\u5F8C\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u6B8B\u9AD8\u306B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'20RIAcoin'),'\u4EE5\u4E0A\u6B8B\u308B\u3088\u3046\u3054\u6CE8\u610F\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u9001\u4FE1\u5F8C\u306E\u6B8B\u9AD8\u304C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'20RIAcoin'),'\u672A\u6E80\u306B\u306A\u308B\u5834\u5408\u3001\u53D6\u5F15\u306F\u30A8\u30E9\u30FC\u3068\u306A\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4F8B\u3048\u3070\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u306B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'50RIAcoin'),'\u304C\u3042\u308B\u5834\u5408',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u9001\u4FE1\u304C\u53EF\u80FD\u306ARIAcoin\u6570\u91CF\u306F\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30AF\u30C6\u30A3\u30D6\u520620RIAcoin\u3068\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u30D5\u30A3\u30FC\u5206\u306E0.001RIAcoin\u3092\u5F15\u3044\u305F\u300029.999RIAcoin\u304C\u9001\u4FE1\u53EF\u80FD\u6570\u91CF\u3068\u306A\u308A\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-3'),'\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u306E\u9001\u91D1\u304C\u53CD\u6620\u3055\u308C\u308B\u306E\u306B\u3069\u308C\u304F\u3089\u3044\u306E\u6642\u9593\u304C\u304B\u304B\u308A\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TRIAM Network\u4E0A\u3067\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u9593\u9001\u91D1\u306F1\u79D2\uFF5E2\u79D2\u3067\u53CD\u6620\u3055\u308C\u307E\u3059\u3002\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u51E6\u7406\u304C\u6DF7\u307F\u3042\u3063\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u82E5\u5E72\u9045\u308C\u308B\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-4'),'\u4ED6\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u9001\u91D1\u3057\u3088\u3046\u3068\u3059\u308B\u3068\u3001\u300C\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u300D\u3068\u8868\u793A\u3055\u308C\u3001\u30A8\u30E9\u30FC\u306B\u306A\u308A\u307E\u3059\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u9001\u4FE1\u5148\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u304C\u9055\u3063\u3066\u3044\u308B\u3001\u307E\u305F\u306F\u524A\u9664\u7B49\u306E\u7406\u7531\u306B\u3088\u308A\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u5B58\u5728\u3092\u78BA\u8A8D\u3067\u304D\u306A\u3044\u72B6\u6CC1\u304C\u8003\u3048\u3089\u308C\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u300C\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u300D\u3068\u8868\u793A\u3055\u308C\u305F\u5834\u5408\u306F\u4EE5\u4E0B\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u9001\u4FE1\u76F8\u624B\u306B\u9001\u4FE1\u5148\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u3092\u518D\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u30A6\u30A9\u30EC\u30C3\u30C8\u53D6\u5F15\u5C65\u6B74\u306B\u3066\u3001\u5165\u529B\u3057\u305F\u9001\u4FE1\u5148\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u306B\u9593\u9055\u3044\u304C\u306A\u3044\u304B\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u9001\u4FE1\u5148\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u305F\u72B6\u614B\u3067\u306A\u3044\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u9001\u4FE1\u5148\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u30A2\u30AF\u30C6\u30A3\u30D6\u3067\u3042\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-5'),'\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u3092\u9001\u4FE1\u3057\u305F\u306E\u306B\u3001\u9001\u4FE1\u76F8\u624B\u306B\u5C4A\u3044\u3066\u3044\u307E\u305B\u3093\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u304C\u9001\u4FE1\u76F8\u624B\u306B\u5C4A\u304B\u306A\u3044\u5834\u5408\u306F\u4EE5\u4E0B\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u9001\u4FE1\u76F8\u624B\u306B\u9001\u4FE1\u5148\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u3092\u518D\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u30A6\u30A9\u30EC\u30C3\u30C8\u53D6\u5F15\u5C65\u6B74\u306B\u3066\u3001\u5165\u529B\u3057\u305F\u9001\u4FE1\u5148\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u306B\u9593\u9055\u3044\u304C\u306A\u3044\u304B\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-6'),'\u9055\u3046\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u306B\u30B3\u30A4\u30F3\u3092\u8AA4\u9001\u4FE1\u3057\u3066\u3057\u307E\u3044\u307E\u3057\u305F\u3002\u3069\u3046\u3059\u308C\u3070\u3044\u3044\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6050\u308C\u5165\u308A\u307E\u3059\u304C\u3001\u4E00\u5EA6\u9001\u4FE1\u51E6\u7406\u304C\u5B8C\u4E86\u3055\u308C\u305F\u30B3\u30A4\u30F3\u9001\u4FE1\u306F\u53D6\u308A\u6D88\u3059\u4E8B\u304C\u3067\u304D\u307E\u305B\u3093\u3002\u30AB\u30B9\u30BF\u30DE\u30FC\u30B5\u30DD\u30FC\u30C8\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u9802\u304D\u307E\u3057\u3066\u3082\u3001\u9001\u4FE1\u306E\u30AD\u30E3\u30F3\u30BB\u30EB\u3084\u7D44\u623B\u3057\u7B49\u306E\u5BFE\u5FDC\u3092\u3059\u308B\u3053\u3068\u306F\u4E00\u5207\u3067\u304D\u307E\u305B\u3093\u3002\u3000\u9001\u4FE1\u51E6\u7406\u3092\u884C\u3046\u524D\u306B\u3001\u5FC5\u305A\u5145\u5206\u306A\u78BA\u8A8D\u3092\u884C\u3063\u3066\u4E0B\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-7'),'\u30B3\u30A4\u30F3\u306E\u9001\u4FE1\u304C\u5B8C\u4E86\u3057\u3066\u3044\u308B\u304B\u3069\u3046\u304B\u78BA\u304B\u3081\u308B\u65B9\u6CD5\u306F\u3042\u308A\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'My\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u53D6\u5F15\u5C65\u6B74\u304B\u3089\u5404\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u3092\u3054\u78BA\u8A8D\u3044\u305F\u3060\u3051\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u53C8\u3001TRIAM Blockscan \u3067\u9001\u91D1\u5148\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u30B3\u30A4\u30F3\u304C\u53CD\u6620\u3055\u308C\u3066\u3044\u308B\u304B\u3092\u78BA\u8A8D\u3059\u308B\u3053\u3068\u304C\u51FA\u6765\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-8'),'\u30C8\u30E9\u30B9\u30C8\u3057\u305F\u30C8\u30FC\u30AF\u30F3\u306E\u53D7\u3051\u53D6\u308A\u304C\u3067\u304D\u307E\u305B\u3093'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30C8\u30FC\u30AF\u30F3\u306F\u30C8\u30E9\u30B9\u30C8\u7533\u8ACB\u3092\u3059\u308B\u3060\u3051\u3067\u627F\u8A8D\u3055\u308C\u308B\u3082\u306E\u3068\u3001',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h'},' \u767A\u884C\u8005'),'\u306E\u627F\u8A8D\u4F5C\u696D\u3092\u3082\u3063\u3066\u30C8\u30E9\u30B9\u30C8\u5B8C\u4E86\u3068\u306A\u308B\u3082\u306E\u304C\u3042\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u306B\u8FFD\u52A0\u3055\u308C\u305F\u30C8\u30FC\u30AF\u30F3\u306E\u53F3\u4E0B\u306B\u30C1\u30A7\u30C3\u30AF\u30DE\u30FC\u30AF\u304C\u8868\u793A\u3055\u308C\u3066\u3044\u308C\u3070\u30C8\u30E9\u30B9\u30C8\u306F\u5B8C\u4E86\u3057\u3066\u3044\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u306B\u8FFD\u52A0\u3055\u308C\u305F\u30C8\u30FC\u30AF\u30F3\u306E\u53F3\u4E0B\u306B\u6642\u8A08\u306E\u30DE\u30FC\u30AF\u304C\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u3082\u306E\u306F\u3001\u767A\u884C\u8005\u304B\u3089\u306E\u30C8\u30E9\u30B9\u30C8\u627F\u8A8D\u304C\u672A\u5B8C\u306E\u72B6\u614B\u3068\u306A\u3063\u3066\u3044\u308B\u3082\u306E\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30C8\u30E9\u30B9\u30C8\u627F\u8A8D\u304C\u5B8C\u4E86\u3057\u3066\u3044\u306A\u3044\u72B6\u614B\u3067\u306F\u3001\u305D\u306E\u30C8\u30FC\u30AF\u30F3\u306E\u9001\u53D7\u4FE1\u306F\u3067\u304D\u307E\u305B\u3093\u3002'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-h'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H'),'\u767A\u884C\u8005')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-1'),'\u767A\u884C\u8005\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u767A\u884C\u8005\u306B\u306A\u308B\u3068\u3001\u3042\u306A\u305F\u72EC\u81EA\u306E\u30C8\u30FC\u30AF\u30F3\u3092\u4F5C\u6210\u30FB\u767A\u884C\u3067\u304D\u308B\u6A29\u9650\u304C\u4E0E\u3048\u3089\u308C\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u72EC\u81EA\u3067\u767A\u884C\u3057\u305F\u30C8\u30FC\u30AF\u30F3\u306F\u69D8\u3005\u306A\u30D3\u30B8\u30CD\u30B9\u7B49\u306B\u5E45\u5E83\u304F\u3054\u5229\u7528\u3044\u305F\u3060\u304F\u3053\u3068\u304C\u53EF\u80FD\u3067\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-2'),'\u767A\u884C\u8005\u306B\u306A\u308B\u65B9\u6CD5\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u767A\u884C\u8005\u306B\u306A\u308B\u306B\u306F\u7533\u8ACB\u304C\u5FC5\u8981\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u7533\u8ACB\u306F\u8A2D\u5B9A\u30DA\u30FC\u30B8\u306E\u300C\u4E00\u822C\u300D\u304B\u3089\u884C\u3048\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5FC5\u8981\u4E8B\u9805\u3092\u5165\u529B\u3057\u3066\u3044\u305F\u3060\u304D\u3001\u8EAB\u5206\u8A3C\u306E\u753B\u50CF\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3092\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6709\u52B9\u306A\u8EAB\u5206\u8A3C\u306F\u5404\u56FD\u306E\u516C\u7684\u6A5F\u95A2\u304C\u767A\u884C\u3057\u305F\u3082\u306E\u306B\u9650\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4F8B\uFF1A\u904B\u8EE2\u514D\u8A31\u8A3C\u3001\u30D1\u30B9\u30DD\u30FC\u30C8',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u904B\u8EE2\u514D\u8A31\u8A3C\u306F\u8868\u3068\u88CF\u306E\u4E21\u9762\u3092\u3001\u30D1\u30B9\u30DD\u30FC\u30C8\u306F\u5199\u771F\u306E\u30DA\u30FC\u30B8\u3068\u4F4F\u6240\u8A18\u8F09\u30DA\u30FC\u30B8\u3092\u3054\u63D0\u51FA\u304A\u9858\u3044\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u753B\u50CF\u304C\u5207\u308C\u3066\u3044\u308B\u3001\u307E\u305F\u306F\u4E0D\u9BAE\u660E\u306A\u753B\u50CF\u306E\u3082\u306E\u306F\u53D7\u4ED8\u304C\u3067\u304D\u307E\u305B\u3093\u306E\u3067\u3054\u6CE8\u610F\u304F\u3060\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-3'),'\u767A\u884C\u8005\u306E\u7533\u8ACB\u304C\u627F\u8A8D\u3055\u308C\u308B\u307E\u3067\u306B\u3069\u308C\u304F\u3089\u3044\u306E\u65E5\u6570\u304C\u304B\u304B\u308A\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u9806\u6B21\u3001\u3054\u63D0\u51FA\u3044\u305F\u3060\u3044\u305F\u672C\u4EBA\u78BA\u8A8D\u66F8\u985E\u306E\u691C\u8A3C\u304A\u3088\u3073\u7533\u8ACB\u8A8D\u8A3C\u3092\u884C\u3063\u3066\u307E\u3044\u308A\u307E\u3059\u306E\u3067\u3001\u3054\u7533\u8ACB\u3044\u305F\u3060\u304D\u307E\u3057\u305F\u5F8C\u306F\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u307E\u3059\u3088\u3046\u304A\u9858\u3044\u7533\u3057\u4E0A\u3052\u307E\u3059\u3002\u767A\u884C\u8005\u7533\u8ACB\u306E\u627F\u8A8D\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3089\u3054\u767B\u9332\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u627F\u8A8D\u5B8C\u4E86\u306E\u901A\u77E5\u304C\u9001\u4FE1\u3055\u308C\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-4'),'\u767A\u884C\u8005\u306E\u7533\u8ACB\u306B\u306F\u8CBB\u7528\u304C\u304B\u304B\u308A\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u767A\u884C\u8005\u306E\u7533\u8ACB\u53CA\u3073\u767A\u884C\u8005\u306B\u306A\u308B\u70BA\u306E\u8CBB\u7528\u306F\u304B\u304B\u308A\u307E\u305B\u3093\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-5'),'\u767A\u884C\u8005\u306E\u7533\u8ACB\u6642\u306E\u672C\u4EBA\u78BA\u8A8D\u66F8\u985E\u306B\u306F\u3001\u3069\u306E\u3088\u3046\u306A\u3082\u306E\u3092\u7528\u610F\u3059\u308C\u3070\u3044\u3044\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u767A\u884C\u8005\u7533\u8ACB\u306E\u969B\u306B\u3054\u63D0\u51FA\u3044\u305F\u3060\u304F\u672C\u4EBA\u78BA\u8A8D\u66F8\u985E\u306F\u3001\u5404\u56FD\u306E\u516C\u7684\u6A5F\u95A2\u304C\u767A\u884C\u3057\u305F\u3082\u306E\u306B\u9650\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u65E5\u672C\u306E\u5B98\u516C\u5E81\u767A\u884C\u306E\u672C\u4EBA\u78BA\u8A8D\u8CC7\u6599\u306E\u4F8B\uFF1A\u904B\u8EE2\u514D\u8A31\u8A3C\u3001\u30D1\u30B9\u30DD\u30FC\u30C8\u3001\u30DE\u30A4\u30CA\u30F3\u30D0\u30FC\u30AB\u30FC\u30C9\u3001\u5728\u7559\u30AB\u30FC\u30C9',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u203B\u30DE\u30A4\u30CA\u30F3\u30D0\u30FC\u901A\u77E5\u30AB\u30FC\u30C9\uFF08\u9854\u5199\u771F\u306E\u5165\u3063\u3066\u3044\u306A\u3044\u30AB\u30FC\u30C9\uFF09\u306F\u672C\u4EBA\u78BA\u8A8D\u8CC7\u6599\u3068\u3057\u3066\u53D7\u3051\u4ED8\u3051\u3066\u304A\u308A\u307E\u305B\u3093\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u25A0\u904B\u8EE2\u514D\u8A31\u8A3C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u88CF\u9762\u3082\u5FC5\u305A\u3054\u63D0\u51FA\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8CC7\u6599\u5168\u9762\u304C\u9BAE\u660E\u306B\u5199\u308B\u3088\u3046\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u4F4F\u6240\u3001\u6C0F\u540D\u3001\u751F\u5E74\u6708\u65E5\u304C\u9BAE\u660E\u306B\u8A18\u8F09\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002\u4F4F\u6240\u3001\u6C0F\u540D\u306F\u3054\u672C\u4EBA\u60C5\u5831\u767B\u9332\u753B\u9762\u3067\u5165\u529B\u3057\u305F\u3082\u306E\u3068\u540C\u3058\u3067\u3042\u308B\u3053\u3068\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u6709\u52B9\u671F\u9650\u5185\u306E\u3082\u306E\u304B\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u756A\u53F7\u304C\u9BAE\u660E\u306B\u8A18\u8F09\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u516C\u5B89\u5370\u304C\u9BAE\u660E\u306B\u5199\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002\u88CF\u9762\u306B\u8A18\u8F09\u304C\u3042\u308B\u5834\u5408\u306F\u3001\u88CF\u9762\u306E\u516C\u5B89\u5370\u3082\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u9854\u5199\u771F\u304C\u9BAE\u660E\u306B\u5199\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u25A0\u30D1\u30B9\u30DD\u30FC\u30C8\uFF08\u65E5\u672C\u56FD\u304C\u767A\u884C\u3059\u308B\u65C5\u5238\uFF09',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u9854\u5199\u771F\u9762\u3068\u6240\u6301\u4EBA\u8A18\u5165\u6B04\uFF08\u4F4F\u6240\u8A18\u8F09\u30DA\u30FC\u30B8\uFF09\u306E 2 \u30DA\u30FC\u30B8\u3092\u3054\u63D0\u51FA\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8CC7\u6599\u5168\u9762\u304C\u9BAE\u660E\u306B\u5199\u308B\u3088\u3046\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u65C5\u5238\u756A\u53F7\u304C\u9BAE\u660E\u306B\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u6709\u52B9\u671F\u9650\u5185\u306E\u3082\u306E\u304B\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u4F4F\u6240\u3001\u6C0F\u540D\u3001\u751F\u5E74\u6708\u65E5\u304C\u9BAE\u660E\u306B\u8A18\u8F09\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002\u4F4F\u6240\u3001\u6C0F\u540D\u306F\u3054\u672C\u4EBA\u60C5\u5831\u767B\u9332\u753B\u9762\u3067\u5165\u529B\u3057\u305F\u3082\u306E\u3068\u540C\u3058\u3067\u3042\u308B\u3053\u3068\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u25A0\u30DE\u30A4\u30CA\u30F3\u30D0\u30FC\u30AB\u30FC\u30C9\u3000\uFF08\u30DE\u30A4\u30CA\u30F3\u30D0\u30FC\u901A\u77E5\u30AB\u30FC\u30C9\uFF08\u9854\u5199\u771F\u306E\u5165\u3063\u3066\u3044\u306A\u3044\u30AB\u30FC\u30C9\uFF09\u306F\u672C\u4EBA\u78BA\u8A8D\u8CC7\u6599\u3068\u3057\u3066\u53D7\u3051\u4ED8\u3051\u3066\u304A\u308A\u307E\u305B\u3093\u3002\uFF09 \u30FB\u8868\u9762\u306E\u307F\u3054\u63D0\u51FA\u304F\u3060\u3055\u3044\u3002\u88CF\u9762\u306F\u4E0D\u8981\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8CC7\u6599\u5168\u9762\u304C\u9BAE\u660E\u306B\u5199\u308B\u3088\u3046\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u6709\u52B9\u671F\u9650\u5185\u306E\u3082\u306E\u304B\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u4F4F\u6240\u3001\u6C0F\u540D\u3001\u751F\u5E74\u6708\u65E5\u304C\u9BAE\u660E\u306B\u8A18\u8F09\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002\u4F4F\u6240\u3001\u6C0F\u540D\u306F\u3054\u672C\u4EBA\u60C5\u5831\u767B\u9332\u753B\u9762\u3067\u5165\u529B\u3057\u305F\u3082\u306E\u3068\u540C\u3058\u3067\u3042\u308B\u3053\u3068\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u25A0\u5728\u7559\u30AB\u30FC\u30C9',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u88CF\u9762\u3082\u5FC5\u305A\u3054\u63D0\u51FA\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8CC7\u6599\u5168\u9762\u304C\u9BAE\u660E\u306B\u5199\u308B\u3088\u3046\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u4F4F\u6240\u3001\u6C0F\u540D\u3001\u751F\u5E74\u6708\u65E5\u304C\u9BAE\u660E\u306B\u8A18\u8F09\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002\u4F4F\u6240\u3001\u6C0F\u540D\u306F\u3054\u672C\u4EBA\u60C5\u5831\u767B\u9332\u753B\u9762\u3067\u5165\u529B\u3057\u305F\u3082\u306E\u3068\u540C\u3058\u3067\u3042\u308B\u3053\u3068\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8A18\u53F7\u756A\u53F7\u304C\u9BAE\u660E\u306B\u8A18\u8F09\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u6709\u52B9\u671F\u9650\u5185\u306E\u3082\u306E\u304B\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u5370\u7AE0\u304C\u9BAE\u660E\u306B\u5199\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002\u88CF\u9762\u306B\u8A18\u8F09\u304C\u3042\u308B\u5834\u5408\u306F\u3001\u88CF\u9762\u306E\u5370\u7AE0\u3082\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-6'),'\u672C\u4EBA\u78BA\u8A8D\u8CC7\u6599\u306E\u63D0\u51FA\u306F\u3069\u306E\u3088\u3046\u306B\u884C\u3046\u306E\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8A2D\u5B9A\u30DA\u30FC\u30B8\u306E\u767A\u884C\u8005\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u767A\u884C\u8005\u306E\u7533\u8ACB\u3068\u3068\u3082\u306B\u672C\u4EBA\u78BA\u8A8D\u8CC7\u6599\u3092\u3054\u63D0\u51FA\u3044\u305F\u3060\u3051\u307E\u3059\u3002\u8EAB\u5206\u8A3C\u660E\u66F8\u306E\u753B\u50CF\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u3044\u305F\u3060\u304F\u3053\u3068\u3067\u3054\u63D0\u51FA\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u753B\u50CF\u306E\u30B5\u30A4\u30BA\u306F\u6700\u59272MB\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u3054\u63D0\u51FA\u3044\u305F\u3060\u304F\u753B\u50CF\u306B\u3064\u3044\u3066\u306E\u6CE8\u610F\u70B9\u306F\u3001H-5\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-7'),'\u5728\u4F4F\u5834\u6240\u3067\u3059\u304C\u3001\u767A\u884C\u8005\u7533\u8ACB\u306F\u3069\u3053\u306E\u56FD\u3067\u3082\u53EF\u80FD\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5728\u4F4F\u56FD\u306F\u95A2\u4FC2\u306A\u304F\u3069\u306A\u305F\u3067\u3082\u767A\u884C\u8005\u306E\u7533\u8ACB\u306F\u53EF\u80FD\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u305F\u3060\u3057\u3001\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u306E\u767A\u884C\u30FB\u3054\u5229\u7528\u306B\u95A2\u3057\u307E\u3057\u3066\u306F\u3001\u5C45\u4F4F\u56FD\u53CA\u3073\u5730\u57DF\u306E\u6CD5\u5F8B\u3001\u898F\u5247\u306B\u5F93\u3063\u3066\u304F\u3060\u3055\u3044\u3002\u4ECA\u5F8C\u3001\u4E16\u754C\u7684\u53C8\u306F\u5C45\u4F4F\u56FD\u306E\u6CD5\u5F8B\u30FB\u898F\u5247\u7B49\u304C\u5909\u66F4\u306B\u306A\u3063\u305F\u5834\u5408\u3001\u4E00\u5EA6\u627F\u8A8D\u3055\u308C\u305F\u767A\u884C\u8005\u6A29\u9650\u304C\u7121\u52B9\u306B\u306A\u308B\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u305D\u306E\u5834\u5408\u3001\u65E2\u306B\u767A\u884C\u3057\u305F\u30C8\u30FC\u30AF\u30F3\u306B\u95A2\u3059\u308B\u640D\u5931\u30FB\u640D\u5BB3\u7B49\u304C\u767A\u751F\u3057\u305F\u5834\u5408\u3067\u3042\u3063\u3066\u3082\u3001\u4E00\u5207\u306E\u8CAC\u4EFB\u30FB\u8CE0\u511F\u30FB\u88DC\u586B\u306F\u884C\u3044\u307E\u305B\u3093\u306E\u3067\u3054\u6CE8\u610F\u4E0B\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-8'),'\u767A\u884C\u8005\u306E\u7533\u8ACB\u6642\u306B\u5165\u529B\u3059\u308B\u300C\u56E3\u4F53\u30FB\u4F1A\u793E\u300D\u3068\u306F\u3001\u4F55\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u767A\u884C\u8005\u3092\u56E3\u4F53\u30FB\u4F1A\u793E\u7B49\u3067\u884C\u3046\u5834\u5408\u306B\u3001\u5165\u529B\u3057\u3066\u4E0B\u3055\u3044\u3002\u767A\u884C\u8005\u60C5\u5831\u306F\u3001\u516C\u958B\u30FB\u975E\u516C\u958B\u306E\u9078\u629E\u304C\u53EF\u80FD\u3067\u3059\u304C\u3001\u767A\u884C\u30C8\u30FC\u30AF\u30F3\u306E\u4FE1\u983C\u3092\u5F97\u308B\u306B\u306F\u516C\u958B\u3092\u304A\u52E7\u3081\u81F4\u3057\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h9',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-9'),'\u767A\u884C\u8005\u7533\u8ACB\u6642\u306B\u767B\u9332\u3057\u305F\u60C5\u5831\u3092\u5909\u66F4\u3057\u305F\u3044\u3067\u3059\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h9',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u300C\u8A2D\u5B9A\u300D\u21D2\u300C\u4E00\u822C\u300D\u30DA\u30FC\u30B8\u304B\u3089\u767A\u884C\u8005\u306E\u60C5\u5831\u3092\u7DE8\u96C6\u3057\u3066\u518D\u7533\u8ACB\u3059\u308B\u3053\u3068\u306B\u3088\u3063\u3066\u5909\u66F4\u304C\u53EF\u80FD\u3067\u3059\u3002 \u518D\u7533\u8ACB\u3057\u305F\u65B0\u3057\u3044\u60C5\u5831\u304C\u627F\u8A8D\u3055\u308C\u308B\u307E\u3067\u306E\u9593\u306F\u65E2\u5B58\u306E\u60C5\u5831\u304C\u6709\u52B9\u3068\u306A\u3063\u3066\u3044\u307E\u3059\u3002 \u65B0\u3057\u3044\u60C5\u5831\u304C\u627F\u8A8D\u3055\u308C\u6B21\u7B2C\u65E2\u5B58\u306E\u60C5\u5831\u306F\u524A\u9664\u3055\u308C\u3001\u518D\u7533\u8ACB\u3057\u305F\u60C5\u5831\u306B\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h10',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-10'),'\u767A\u884C\u8005\u306E\u7533\u8ACB\u53D7\u7406\u306E\u30E1\u30FC\u30EB\u304C\u5C4A\u304D\u307E\u305B\u3093\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h10',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-6')),' \u3092\u3054\u53C2\u7167\u304F\u3060\u3055\u3044'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-j'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J'),'\u30C8\u30FC\u30AF\u30F3\u306E\u4F5C\u6210\u30FB\u767A\u884C')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-1'),'\u30C8\u30FC\u30AF\u30F3\u306E\u4F5C\u6210\u30FB\u767A\u884C\u65B9\u6CD5\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30C8\u30FC\u30AF\u30F3\u3092\u4F5C\u6210\u30FB\u767A\u884C\u3059\u308B\u306B\u306F\u3001\u307E\u305A\u3001\u767A\u884C\u8005\u7533\u8ACB\u3092\u3057\u3066\u627F\u8A8D\u3055\u308C\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u767A\u884C\u8005\u3068\u3057\u3066\u627F\u8A8D\u3055\u308C\u305F\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u300C\u767A\u884C\u8005\u30E2\u30FC\u30C9\u300D\u306E\u753B\u9762\u304B\u3089\u30C8\u30FC\u30AF\u30F3\u306E\u4F5C\u6210\u30FB\u767A\u884C\u3092\u3057\u3066\u3044\u305F\u3060\u3051\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u307E\u305A\u521D\u3081\u306B\u300C\u30C8\u30FC\u30AF\u30F3\u3092\u4F5C\u6210\u300D\u304B\u3089\u30C8\u30FC\u30AF\u30F3\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30C8\u30FC\u30AF\u30F3\u3092\u4F5C\u6210\u3059\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u307E\u3059\u3002\u30C8\u30FC\u30AF\u30F3\u306FRIAcoin\u3092\u4F7F\u3063\u3066\u4F5C\u6210\u3057\u307E\u3059\u306E\u3067\u3001\u5145\u5206\u306ARIAcoin\u3092\u4FDD\u6709\u3057\u3066\u3044\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3059\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6B21\u306B\u30C8\u30FC\u30AF\u30F3\u306E\u30D7\u30ED\u30D1\u30C6\u30A3\u3092\u9078\u629E\u3057\u3001\u30C8\u30FC\u30AF\u30F3\u306E\u30A2\u30A4\u30B3\u30F3\u753B\u50CF\u3092\u8A2D\u5B9A\u3057\u307E\u3059\u3002\u30A2\u30A4\u30B3\u30F3\u306E\u753B\u50CF\u306F\u5F8C\u304B\u3089\u8A2D\u5B9A\u3059\u308B\u3053\u3068\u3082\u53EF\u80FD\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30C8\u30FC\u30AF\u30F3\u540D\u3001\u30C8\u30FC\u30AF\u30F3\u306E\u5C0F\u6570\u70B9\u6841\u6570\u3001\u53D6\u5F15\u624B\u6570\u6599\u3001RIAcoin\u3068\u306E\u6BD4\u7387\u3092\u5165\u529B\u3057\u3001\u6700\u5F8C\u306B\u3053\u306E\u30C8\u30FC\u30AF\u30F3\u304C\u4F7F\u7528\u3055\u308C\u308B\u3053\u3068\u306B\u3088\u3063\u3066\u767A\u751F\u3059\u308B\u624B\u6570\u6599\u3092\u53D7\u3051\u53D6\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4EE5\u4E0A\u3067\u30C8\u30FC\u30AF\u30F3\u306E\u4F5C\u6210\u306F\u5B8C\u4E86\u3067\u3059\u3002\u6B21\u306B\u3001\u3053\u306E\u30C8\u30FC\u30AF\u30F3\u3092\u5B9F\u969B\u306B\u5229\u7528\u30FB\u6D41\u901A\u3055\u305B\u308B\u305F\u3081\u306B\u30C8\u30FC\u30AF\u30F3\u306E\u767A\u884C\u4F5C\u696D\u3078\u9032\u3093\u3067\u304F\u3060\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-2'),'\u30C8\u30FC\u30AF\u30F3\u4F5C\u6210\u6642\u306E\u30D7\u30ED\u30D1\u30C6\u30A3\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4F5C\u6210\u3059\u308B\u30C8\u30FC\u30AF\u30F3\u306E\u30D7\u30ED\u30D1\u30C6\u30A3\u3092\u8A2D\u5B9A\u3059\u308B\u3053\u3068\u306B\u3088\u308A\u3001\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u3042\u306A\u305F\u306E\u30C8\u30FC\u30AF\u30F3\u3092\u5229\u7528\u3059\u308B\u969B\u306B\u4E00\u5B9A\u306E\u5236\u9650\u3092\u8A2D\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30D7\u30ED\u30D1\u30C6\u30A3\u306F\u4E00\u5EA6\u8A2D\u5B9A\u3059\u308B\u3068\u5909\u66F4\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30D7\u30ED\u30D1\u30C6\u30A31\u306F\u3001\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u305D\u306E\u30C8\u30FC\u30AF\u30F3\u3092\u30C8\u30E9\u30B9\u30C8\u3059\u308B\u969B\u3001\u305D\u306E\u30C8\u30FC\u30AF\u30F3\u3092\u767A\u884C\u3057\u305F\u767A\u884C\u8005\u306E\u627F\u8A8D\u304C\u5FC5\u8981\u3068\u306A\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30D7\u30ED\u30D1\u30C6\u30A32\u306F\u3001\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u305D\u306E\u30C8\u30FC\u30AF\u30F3\u3092\u81EA\u7531\u306B\u30C8\u30E9\u30B9\u30C8\u3057\u3001\u5229\u7528\u3067\u304D\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-3'),'\u30C8\u30FC\u30AF\u30F3\u4F5C\u6210\u30FB\u767A\u884C\u306B\u306F\u8CBB\u7528\u304C\u304B\u304B\u308A\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30C8\u30FC\u30AF\u30F3\u4F5C\u6210\u306B\u8CBB\u7528\u306F\u304B\u304B\u308A\u307E\u305B\u3093\u304C\u3001\u4F5C\u6210\u3057\u305F\u30C8\u30FC\u30AF\u30F3\u3092\u767A\u884C\u3059\u308B\u969B\u306B\u306F\u3001\u305D\u306E\u30C8\u30FC\u30AF\u30F3\u306B\u8A2D\u5B9A\u3055\u308C\u305FRIA\u3068\u306E\u6BD4\u7387\u306B\u3088\u3063\u3066\u3001RIAcoin\u304C\u5FC5\u8981\u3068\u306A\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u306A\u304A\u3001\u30C8\u30FC\u30AF\u30F3\u306E\u4F5C\u6210\u30FB\u767A\u884C\u306E\u969B\u306B\u306F\u3001\u6B8B\u9AD8\u304C21RIA\u4EE5\u4E0A\u3042\u308B\u30A2\u30AF\u30C6\u30A3\u30D6\u30A6\u30A9\u30EC\u30C3\u30C8\u304C2\u3064\u4EE5\u4E0A\u5FC5\u8981\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-4'),'RIA\u3068\u306E\u6BD4\u7387\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30C8\u30FC\u30AF\u30F3\u3092\u4F5C\u6210\u3059\u308B\u969B\u306B\u306F\u3001\u305D\u306E\u30C8\u30FC\u30AF\u30F3\u3068RIA \u3068\u306E\u6BD4\u7387\u3092\u8A2D\u5B9A\u3057\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'RIA\u3068\u306E\u6BD4\u7387\u306F\u3001\uFF3B\u6BD4\u7387\u306A\u3057\uFF3D\uFF3B1/1\uFF3D\uFF3B1/10\uFF3D\uFF3B1/100\uFF3D\uFF3B1/1000\uFF3D\u306E 5 \u3064\u3088\u308A\u9078\u629E\u3067\u304D\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4F8B\u3048\u3070\u6BD4\u7387\uFF3B1/1\uFF3D\u3092\u9078\u629E\u3059\u308B\u3068\u300C\uFF11\u30C8\u30FC\u30AF\u30F3\u300D\u3092\u767A\u884C\u3059\u308B\u305F\u3081\u306B\u300C1RIA\u300D\u304C\u5FC5\u8981\u3068\u306A\u308A\u307E\u3059\u3002\uFF3B1/1000\uFF3D\u3092\u9078\u629E\u3059\u308B\u3068\u300C\uFF11\u30C8\u30FC\u30AF\u30F3\u300D\u3092\u767A\u884C\u3059\u308B\u305F\u3081\u306B\u300C0.001RIA\u300D\u304C\u5FC5\u8981\u3068\u306A\u308A\u307E\u3059\u3002 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-5'),'\u30C8\u30FC\u30AF\u30F3\u767A\u884C\u7533\u8ACB\u5C65\u6B74\u306E\u30B9\u30C6\u30FC\u30BF\u30B9\u304C\u300CPending\u300D\u3068\u8868\u793A\u3055\u308C\u305F\u307E\u307E\u306A\u306E\u3067\u3001\u30C8\u30FC\u30AF\u30F3\u306E\u4F5C\u6210\u304C\u3067\u304D\u307E\u305B\u3093\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u767A\u884C\u8005\u7533\u8ACB\u307E\u305F\u306F\u30C8\u30FC\u30AF\u30F3\u767A\u884C\u7533\u8ACB\u306E\u627F\u8A8D\u304C\u4FDD\u7559\u4E2D\u306E\u72B6\u614B\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30C8\u30FC\u30AF\u30F3\u767A\u884C\u306E\u305F\u3081\u306B\u3054\u63D0\u51FA\u3044\u305F\u3060\u304D\u307E\u3057\u305F\u3054\u672C\u4EBA\u78BA\u8A8D\u66F8\u985E\u306E\u691C\u8A3C\u304A\u3088\u3073\u7533\u8ACB\u8A8D\u8A3C\u306F\u9806\u6B21\u884C\u3063\u3066\u304A\u308A\u307E\u3059\u306E\u3067\u3001\u3054\u7533\u8ACB\u3044\u305F\u3060\u304D\u307E\u3057\u305F\u5F8C\u306F\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u307E\u3059\u3088\u3046\u304A\u9858\u3044\u7533\u3057\u4E0A\u3052\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u767A\u884C\u8005\u7533\u8ACB\u306E\u627F\u8A8D\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3089\u3054\u767B\u9332\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u30C8\u30FC\u30AF\u30F3\u767A\u884C\u7533\u8ACB\u306E\u627F\u8A8D\u5B8C\u4E86\u306E\u901A\u77E5\u304C\u9001\u4FE1\u3055\u308C\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-6'),'\u4F5C\u6210\u3057\u305F\u30C8\u30FC\u30AF\u30F3\u3092\u524A\u9664\u3067\u304D\u307E\u3059\u304B\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4F5C\u6210\u3057\u305F\u30C8\u30FC\u30AF\u30F3\u3001\u304A\u3088\u3073\u767A\u884C\u3057\u305F\u30C8\u30FC\u30AF\u30F3\u3092\u524A\u9664\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-7'),'\u30C8\u30FC\u30AF\u30F3\u306E\u8FFD\u52A0\u767A\u884C\u3092\u7121\u52B9\u306B\u3057\u307E\u3057\u305F\u3002\u5143\u306B\u623B\u305B\u307E\u3059\u304B\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30C8\u30FC\u30AF\u30F3\u306E\u8FFD\u52A0\u767A\u884C\u3092\u7121\u52B9\u306B\u3057\u305F\u5834\u5408\u3001\u305D\u306E\u64CD\u4F5C\u3092\u3084\u308A\u76F4\u3057\u305F\u308A\u3001\u8FFD\u52A0\u767A\u884C\u306E\u7121\u52B9\u3092\u89E3\u9664\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30C8\u30FC\u30AF\u30F3\u306E\u8FFD\u52A0\u767A\u884C\u3092\u7121\u52B9\u306B\u3057\u305F\u5834\u5408\u3001\u305D\u306E\u30C8\u30FC\u30AF\u30F3\u3092\u4F5C\u6210\u3057\u305F\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u3059\u3079\u3066\u306E\u6A5F\u80FD\u306F\u51CD\u7D50\u3055\u308C\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A6\u30A9\u30EC\u30C3\u30C8\u8A2D\u5B9A\u306E\u5909\u66F4\u30FBRIA/\u30C8\u30FC\u30AF\u30F3\u306E\u9001\u53D7\u4FE1\u30FB\u30C8\u30FC\u30AF\u30F3\u306E\u8FFD\u52A0\u767A\u884C\u30FB\u30C8\u30E9\u30B9\u30C8\u30FB\u30C8\u30E9\u30B9\u30C8\u89E3\u9664\u306E\u6A5F\u80FD\u306F\u5229\u7528\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u3054\u5229\u7528\u3067\u304D\u308B\u6A5F\u80FD\u306F\u767A\u884C\u3057\u305F\u30C8\u30FC\u30AF\u30F3\u306E\u30C8\u30E9\u30B9\u30C8\u8A31\u53EF\u306E\u307F\u3068\u306A\u308A\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-8'),'\u300CNot enough funds in source account\u300D\u3068\u8868\u793A\u3055\u308C\u30C8\u30FC\u30AF\u30F3\u3092\u767A\u884C\u3067\u304D\u307E\u305B\u3093\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30C8\u30FC\u30AF\u30F3\u3092\u4F5C\u6210\u3057\u305F\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u6B8B\u9AD8\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30C8\u30FC\u30AF\u30F3\u306E\u4F5C\u6210\u6642\u306B\u8A2D\u5B9A\u3057\u305FRIAcoin\u3068\u306E\u6BD4\u7387\u306B\u57FA\u3065\u3044\u3066\u3001\u30C8\u30FC\u30AF\u30F3\u306E\u767A\u884C\u306B\u5FC5\u8981\u306ARIA\u3068\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u624B\u6570\u6599\u306B\u5FC5\u8981\u306ARIA\u3092\u4FDD\u6709\u3057\u3066\u3044\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j9',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-9'),'\u30C8\u30E9\u30B9\u30C8\u7533\u8ACB\u3092\u9001\u3063\u3066\u304D\u305F\u30E6\u30FC\u30B6\u30FC\u306B\u5BFE\u3057\u3066\u7533\u8ACB\u3092\u62D2\u5426\u3057\u305F\u5834\u5408\u3001\u76F8\u624B\u5074\u306B\u306F\u3069\u306E\u3088\u3046\u306A\u30B9\u30C6\u30FC\u30BF\u30B9\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u304B\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j9',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30C8\u30E9\u30B9\u30C8\u7533\u8ACB\u3092\u62D2\u5426\u3057\u305F\u5834\u5408\u3001\u76F8\u624B\u5074\u306E\u30B9\u30C6\u30FC\u30BF\u30B9\u306F\u672A\u627F\u8A8D\u306E\u307E\u307E\u3067\u3042\u308B\u305F\u3081\u3001\u62D2\u5426\u3055\u308C\u305F\u3053\u3068\u304C\u308F\u304B\u3089\u306A\u3044\u4ED5\u7D44\u307F\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j10',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-10'),'\u5E0C\u671B\u306E\u30C8\u30FC\u30AF\u30F3\u540D\u3067\u30C8\u30FC\u30AF\u30F3\u306E\u4F5C\u6210\u304C\u3067\u304D\u307E\u305B\u3093\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j10',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4F5C\u6210\u4E88\u5B9A\u306E\u30C8\u30FC\u30AF\u30F3\u540D\u306F\u3001\u3059\u3067\u306B\u767A\u884C\u3055\u308C\u3066\u3044\u308B\u4ED6\u306E\u30C8\u30FC\u30AF\u30F3\u540D\u3068\u91CD\u8907\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u305B\u3093\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u3054\u5E0C\u671B\u306E\u30C8\u30FC\u30AF\u30F3\u540D\u304C\u3059\u3067\u306B\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u3088\u3063\u3066\u4F7F\u7528\u3055\u308C\u3066\u3044\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u30C8\u30FC\u30AF\u30F3\u306E\u4F5C\u6210\u306E\u969B\u306F\u30C8\u30FC\u30AF\u30F3\u540D\u306E\u5019\u88DC\u3092\u3042\u3089\u304B\u3058\u3081\u3044\u304F\u3064\u304B\u3054\u6E96\u5099\u3044\u305F\u3060\u304F\u3053\u3068\u3092\u304A\u3059\u3059\u3081\u3057\u307E\u3059\u3002'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-k'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K'),'\u305D\u306E\u4ED6')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-1'),'\u63A8\u5968\u30D6\u30E9\u30A6\u30B6\u306B\u3064\u3044\u3066'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TRIAM Network\u3092\u5B89\u5168\u3067\u5FEB\u9069\u306B\u3054\u5229\u7528\u3044\u305F\u3060\u304F\u305F\u3081\u306B\u3001\u4E0B\u8A18\u30D0\u30FC\u30B8\u30E7\u30F3\u306E\u30D6\u30E9\u30A6\u30B6\u306E\u3054\u5229\u7528\u3092\u304A\u3059\u3059\u3081\u3044\u305F\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBGoogle Chrome \u6700\u65B0\u7248',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBMozilla FireFox \u6700\u65B0\u7248',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u203BInternet Explorer\u3067\u306E\u3054\u5229\u7528\u306F\u304A\u52E7\u3081\u3057\u3066\u304A\u308A\u307E\u305B\u3093\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-2'),'\u30C8\u30FC\u30AF\u30F3\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TRIAM\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u4E0A\u3067\u4F5C\u6210\u3055\u308C\u305F\u72EC\u81EA\u306E\u4EEE\u60F3\u901A\u8CA8\u3067\u3059\u3002TRIAM\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u6240\u6301\u3057\u3066\u3044\u308B\u30E6\u30FC\u30B6\u30FC\u306F\u767A\u884C\u8005\u7533\u8ACB\u3092\u884C\u3044\u3001\u627F\u8A8D\u3055\u308C\u308B\u3053\u3068\u3067\u8AB0\u3082\u304C\u30C8\u30FC\u30AF\u30F3\u3092\u767A\u884C\u3059\u308B\u3053\u3068\u304C\u51FA\u6765\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u767A\u884C\u8005\u306B\u306A\u308B\u70BA\u306E\u8CBB\u7528\u306F\u7121\u6599\u3067\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-3'),'\u5FC5\u8981\u306A\u304F\u306A\u3063\u305F\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u524A\u9664\u3057\u305F\u3044\u3067\u3059\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u524A\u9664\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u305F\u3060\u3057\u3001\u4E0D\u8981\u306B\u306A\u3063\u305F\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4ED6\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u7D71\u5408\u3059\u308B\u3053\u3068\u306B\u3088\u3063\u3066\u30A2\u30AB\u30A6\u30F3\u30C8\u5185\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u6574\u7406\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u7D71\u5408\u6A5F\u80FD\u3092\u4F7F\u3046\u3068\u3001\u7D71\u5408\u3055\u308C\u308B\u5074\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u4FDD\u6709\u3057\u3066\u3044\u308BRIAcoin\u3092\u7D71\u5408\u5148\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u5438\u53CE\u3055\u308C\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u81EA\u4F53\u306F\u6D88\u6EC5\u3059\u308B\u306E\u3067\u3001\u4EE5\u4E0B\u306E\u6761\u4EF6\u3092\u6E80\u305F\u3057\u3066\u3044\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002 \u30FB\u30C8\u30FC\u30AF\u30F3\u3092\u767A\u884C\u3057\u3066\u3044\u306A\u3044',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u4EE3\u7406\u5E97\u306E\u6C7A\u6E08\u30A6\u30A9\u30EC\u30C3\u30C8\u3068\u3057\u3066\u4F7F\u7528\u3057\u3066\u3044\u306A\u3044',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u672A\u89E3\u6C7A\u306E\u53D6\u5F15\uFF08\u9001\u91D1\u30FB\u53D7\u91D1\u3092\u542B\u3080\uFF09\u304C\u306A\u3044',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBRIAcoin\u4EE5\u5916\u306E\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u3092\u30C8\u30E9\u30B9\u30C8\u3057\u3066\u3044\u306A\u3044',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBRIAcoin\u306E\u6B8B\u9AD8\u304C20.001\u30B3\u30A4\u30F3\u4EE5\u4E0A\u3042\u308B ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u7D71\u5408\u306F\u3001My\u30A6\u30A9\u30EC\u30C3\u30C8\u30DA\u30FC\u30B8\u306E\u300C\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u7D71\u5408\u3059\u308B\u300D\u304B\u3089\u884C\u3063\u3066\u3044\u305F\u3060\u3051\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-4'),'\u983B\u7E41\u306B\u30B3\u30A4\u30F3\u9001\u4FE1\u3092\u3059\u308B\u30A2\u30C9\u30EC\u30B9\u3092\u767B\u9332\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u306F\u3044\u3001\u3067\u304D\u307E\u3059\u3002My\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u306E\u300C\u9001\u4FE1\u5148\u30A2\u30C9\u30EC\u30B9\u7BA1\u7406\u300D\u306B\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u3092\u3054\u767B\u9332\u3044\u305F\u3060\u3051\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-5'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u7D71\u5408\u3059\u308B\u3068\u306F\u3069\u3046\u3044\u3046\u6A5F\u80FD\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8907\u6570\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4E00\u3064\u306B\u307E\u3068\u3081\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002 \u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u7D71\u5408\u6A5F\u80FD\u3092\u4F7F\u3046\u3068\u3001\u7D71\u5408\u3055\u308C\u308B\u5074\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u4FDD\u6709\u3057\u3066\u3044\u308BRIAcoin\u3092\u7D71\u5408\u5148\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u5438\u53CE\u3055\u308C\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u81EA\u4F53\u306F\u6D88\u6EC5\u3059\u308B\u306E\u3067\u3001\u4EE5\u4E0B\u306E\u6761\u4EF6\u3092\u6E80\u305F\u3057\u3066\u3044\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002 \u30FB\u30C8\u30FC\u30AF\u30F3\u3092\u767A\u884C\u3057\u3066\u3044\u306A\u3044',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u4EE3\u7406\u5E97\u306E\u6C7A\u6E08\u30A6\u30A9\u30EC\u30C3\u30C8\u3068\u3057\u3066\u4F7F\u7528\u3057\u3066\u3044\u306A\u3044',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u672A\u89E3\u6C7A\u306E\u53D6\u5F15\uFF08\u9001\u91D1\u30FB\u53D7\u91D1\u3092\u542B\u3080\uFF09\u304C\u306A\u3044',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBRIAcoin\u4EE5\u5916\u306E\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u3092\u30C8\u30E9\u30B9\u30C8\u3057\u3066\u3044\u306A\u3044',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBRIAcoin\u306E\u6B8B\u9AD8\u304C20.001\u30B3\u30A4\u30F3\u4EE5\u4E0A\u3042\u308B ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-6'),'\u672C\u4EBA\u78BA\u8A8D\u66F8\u985E\u306E\u753B\u50CF\u304C\uFF12MB\u4EE5\u4E0A\u3042\u308B\u305F\u3081\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3067\u304D\u307E\u305B\u3093\u3002\u3069\u3046\u3057\u305F\u3089\u3044\u3044\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6050\u308C\u5165\u308A\u307E\u3059\u304C\u3001\u753B\u50CF\u7DE8\u96C6\u6A5F\u80FD\u306E\u3042\u308B\u30BD\u30D5\u30C8\u3001\u30A2\u30D7\u30EA\u7B49\u3067\u753B\u50CF\u306E\u30EA\u30B5\u30A4\u30BA\u3092\u884C\u3063\u3066\u304B\u3089\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-7'),'\u30A6\u30A9\u30EC\u30C3\u30C8\u53D6\u5F15\u5C65\u6B74\u306E\u8868\u8A18\u5185\u5BB9\u306B\u3064\u3044\u3066'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30A6\u30A9\u30EC\u30C3\u30C8\u53D6\u5F15\u5C65\u6B74\u3067\u306F\u5404\u30A6\u30A9\u30EC\u30C3\u30C8\u3067\u884C\u308F\u308C\u305F\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u3092\u78BA\u8A8D\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30DA\u30FC\u30B8\u4E0A\u90E8\u306E\u30C9\u30ED\u30C3\u30D7\u30C0\u30A6\u30F3\u3067\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3059\u308B\u3068\u3001\u305D\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u5C65\u6B74\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u300C\u8A73\u7D30\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u5185\u5BB9\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-8'),'\u8A2D\u5B9A\u30DA\u30FC\u30B8\u306E\u300C \u30ED\u30B0\u30A4\u30F3\u6642\u306B\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u306E\u5165\u529B\u3092\u8981\u6C42\u3059\u308B\u300D\u3068\u306F\u3069\u3046\u3044\u3046\u610F\u5473\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u3053\u306E\u30C1\u30A7\u30C3\u30AF\u30DC\u30C3\u30AF\u30B9\u306B\u30C1\u30A7\u30C3\u30AF\u3092\u5165\u308C\u308B\u3053\u3068\u3067\u3001\u30ED\u30B0\u30A4\u30F3\u6642\u306B\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u30B3\u30FC\u30C9\u306E\u5165\u529B\u304C\u8981\u6C42\u3055\u308C\u308B\u3088\u3046\u8A2D\u5B9A\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u5411\u4E0A\u306E\u70BA\u3001\u662F\u975E \u3054\u5229\u7528\u3092\u304A\u52E7\u3081\u3044\u305F\u3057\u307E\u3059\u3002'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'M'),'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-m1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-m1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'M-1'),'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-m1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u3068\u306F\u3001\u901A\u5E38\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u3068\u306F\u7570\u306A\u308A\u3001\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u3092\u4F5C\u6210\u3059\u308B\u969B\u306B\u8907\u6570\u306E\u79D8\u5BC6\u30AD\u30FC\u306B\u3088\u308B\u627F\u8A8D\u3092\u5FC5\u8981\u3068\u3057\u307E\u3059\u3002\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u8907\u6570\u306E\u9375\u3092\u304B\u3051\u308B\u3001\u3068\u3044\u3046\u30A4\u30E1\u30FC\u30B8\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u901A\u5E38\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u79D8\u5BC6\u30AD\u30FC\u306F\u3072\u3068\u3064\u3067\u3059\u3002\u4E07\u304C\u4E00\u30D1\u30BD\u30B3\u30F3\u3084\u30B9\u30DE\u30DB\u304C\u30A6\u30A3\u30EB\u30B9\u306B\u304B\u304B\u3063\u305F\u308A\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u3084\u30AA\u30F3\u30E9\u30A4\u30F3\u74B0\u5883\u3067\u4FDD\u7BA1\u3057\u3066\u3044\u308B\u79D8\u5BC6\u30AD\u30FC\u3092\u30CF\u30C3\u30AD\u30F3\u30B0\u3055\u308C\u305F\u308A\u3059\u308B\u3068\u81EA\u5206\u306E\u30B3\u30A4\u30F3\u3092\u5931\u3046\u30EA\u30B9\u30AF\u304C\u3042\u308B\u3053\u3068\u306B\u306A\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'TRIAM\u306E\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u5834\u5408\u306F\u3001\u4E00\u3064\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u5BFE\u3057\u3066\u79D8\u5BC6\u30AD\u30FC\u304C\uFF13\u3064\u3042\u308A\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u4E00\u3064\u6D41\u51FA\u3057\u305F\u308A\u3057\u3066\u3082\u3001\u30B3\u30A4\u30F3\u306E\u76D7\u96E3\u3092\u9632\u3050\u3053\u3068\u304C\u3067\u304D\u308B\u3001\u3068\u3044\u3046\u52B9\u679C\u304C\u3042\u308A\u307E\u3059\u3002\u79D8\u5BC6\u30AD\u30FC\u304C\u8907\u6570\u3042\u308B\u3053\u3068\u306B\u3088\u308A\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u304C\u4F55\u500D\u306B\u3082\u4E0A\u304C\u308B\u3068\u8003\u3048\u3089\u308C\u3066\u3044\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u3067\u30B3\u30A4\u30F3\u3084\u30C8\u30FC\u30AF\u30F3\u3092\u9001\u4FE1\u3059\u308B\u969B\u306B\u306F\u6BCE\u56DE\u3001\u79D8\u5BC6\u30AD\u30FC\u3092\uFF13\u3064\u3059\u3079\u3066\u3054\u5165\u529B\u3044\u305F\u3060\u304F\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\uFF01\uFF01\uFF01\u3054\u6CE8\u610F\uFF01\uFF01\uFF01',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30DE\u30EB\u30C1\u30B7\u30B0\u5316\u3057\u305F\u5834\u5408\u3001\u53D6\u308A\u6D88\u3057\u3084\u901A\u5E38\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u623B\u3059\u3053\u3068\u306F\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30DE\u30EB\u30C1\u30B7\u30B0\u5316\u3057\u305F\u5834\u5408\u3001\u305D\u306E\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u30B7\u30A7\u30A2\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30DE\u30B9\u30BF\u30FC\u30AD\u30FC\u306B\u8A2D\u5B9A\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u540C\u3058\u304F\u3001\u30B7\u30A7\u30A2\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30DE\u30B9\u30BF\u30FC\u30AD\u30FC\u306B\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30DE\u30EB\u30C1\u30B7\u30B0\u5316\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u305B\u3093\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBTRIAM\u306E\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u3001\u30B3\u30A4\u30F3\u9001\u4FE1\u3084\u30C8\u30FC\u30AF\u30F3\u30C8\u30E9\u30B9\u30C8\u306E\u969B\u306B\u6BCE\u56DE\u3001\u79D8\u5BC6\u30AD\u30FC\u3092\uFF13\u3064\u3059\u3079\u3066\u3054\u5165\u529B\u3044\u305F\u3060\u304F\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\uFF13\u3064\u306E\u79D8\u5BC6\u30AD\u30FC\u306E\u3046\u30611\u3064\u306E\u307F\u3092\u7D1B\u5931\u3055\u308C\u305F\u5834\u5408\u3067\u3082\u3001\u305D\u306E\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u6C38\u4E45\u306B\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u306A\u304F\u306A\u308A\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'3\u3064\u306E\u79D8\u5BC6\u30AD\u30FC\u306F\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30DE\u30EB\u30C1\u30B7\u30B0\u5316\u3059\u308B\u969B\u306B\uFF11\u5EA6\u3060\u3051\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u518D\u8868\u793A\u3084\u518D\u767A\u884C\u7B49\u306F\u4E0D\u53EF\u80FD\u3068\u306A\u3063\u3066\u304A\u308A\u307E\u3059\u306E\u3067\u3001\u4FDD\u5B58\u30FB\u4FDD\u7BA1\u3092\u78BA\u5B9F\u306B\u884C\u3063\u3066\u4E0B\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30DE\u30EB\u30C1\u30B7\u30B0\u5316\u3059\u308B\u969B\u306F\u3001\u4E0A\u8A18\u306E\u69D8\u3005\u306A\u8981\u7D20\u3092\u8003\u616E\u3057\u305F\u306E\u3061\u3001\u614E\u91CD\u306B\u884C\u3063\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3088\u3046\u304A\u9858\u3044\u3044\u305F\u3057\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-m2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-m2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'M-2'),'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u4F5C\u6210\u306F\u7121\u6599\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-m2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u4F5C\u6210\u6642\u306B\u306F\u3001\u624B\u6570\u6599\u3068\u3057\u30660.003RIA\u304C\u6D88\u8CBB\u3055\u308C\u307E\u3059\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-m3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-m3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'M-3'),'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u4F5C\u6210\u306E\u624B\u9806\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-m3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u8A2D\u5B9A\u624B\u9806 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'1\uFF09\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30ED\u30B0\u30A4\u30F3\u3057\u3001\u30E1\u30CB\u30E5\u30FC\u306E\u300C\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u300D\u304B\u3089\u8A2D\u5B9A\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'2\uFF09\u300C\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u4F5C\u6210\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u30DE\u30EB\u30C1\u30B7\u30B0\u5316\u3057\u305F\u3044\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'3\uFF09\u6B21\u306E\u753B\u9762\u3067\u3053\u306E\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u7D10\u3065\u3051\u3089\u308C\u308B\uFF13\u3064\u306E\u79D8\u5BC6\u30AD\u30FC\u3092\u751F\u6210\u3057\u307E\u3059\u3002\u300C\u30AD\u30FC\u30DA\u30A2\u3092\u751F\u6210\u3059\u308B\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u81EA\u52D5\u7684\u306B\u751F\u6210\u3055\u308C\u3001\u7AEF\u672B\u306B\u30AD\u30FC\u30DA\u30A2\u304C\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3055\u308C\u307E\u3059\u3002\uFF08\u304A\u4F7F\u3044\u306E\u7AEF\u672B\u306B\u3088\u3063\u3066\u306F\u81EA\u52D5\u7684\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3055\u308C\u306A\u3044\u5834\u5408\u3082\u3042\u308A\u307E\u3059\u3002\u30AD\u30FC\u30DA\u30A2\u304C\u7AEF\u672B\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3055\u308C\u3066\u3044\u308B\u304B\u78BA\u5B9F\u306B\u3054\u78BA\u8A8D\u3044\u305F\u3060\u304D\u307E\u3059\u3088\u3046\u304A\u9858\u3044\u3044\u305F\u3057\u307E\u3059\uFF09 \u3053\u306E\u6642\u751F\u6210\u3055\u308C\u305F\u79D8\u5BC6\u30AD\u30FC\u3092\u542B\u30803\u3064\u306E\u30AD\u30FC\u30DA\u30A2\u306F\u3001\u4ECA\u5F8C\u3053\u306E\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u3067\u30B3\u30A4\u30F3\u3084\u30C8\u30FC\u30AF\u30F3\u306E\u9001\u4FE1\u3092\u3059\u308B\u969B\u306B\u5FC5\u8981\u3068\u306A\u308B\u5927\u5909\u91CD\u8981\u306A\u3082\u306E\u3067\u3059\u3002\u5FC5\u305A\u5185\u5BB9\u3092\u78BA\u8A8D\u3057\u3066\u5B89\u5168\u306A\u5834\u6240\u306B\u4FDD\u7BA1\u3057\u3066\u304F\u3060\u3055\u3044\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4\uFF09\uFF13\u3064\u306E\u30AD\u30FC\u30DA\u30A2\u304C\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u753B\u9762\u4E0B\u90E8\u306E\u300C\u30AD\u30FC\u30DA\u30A2\u306E\u79D8\u5BC6\u30AD\u30FC\u3092\u5931\u3063\u305F\u5834\u5408\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u306E\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u3092\u79FB\u52D5\u3055\u305B\u308B\u4E8B\u304C\u4E0D\u53EF\u80FD\u306B\u306A\u308B\u3053\u3068\u3092\u7406\u89E3\u3057\u307E\u3057\u305F\u300D\u306E\u30C1\u30A7\u30C3\u30AF\u30DC\u30C3\u30AF\u30B9\u306B\u30C1\u30A7\u30C3\u30AF\u3092\u5165\u308C\u3066\u300C\u6B21\u3078\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30DE\u30EB\u30C1\u30B7\u30B0\u5316\u306F\u5B8C\u4E86\u3067\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u203B\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u8A2D\u5B9A\u6642\u306E\u6CE8\u610F\u70B9 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u8A2D\u5B9A\u3067\u304D\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u3001\u901A\u5E38\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u307F\u3067\u3059\u3002\u30B7\u30A7\u30A2\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30DE\u30B9\u30BF\u30FC\u30AD\u30FC\u30A6\u30A9\u30EC\u30C3\u30C8\u3084\u30B5\u30A4\u30F3\u8005\u30A6\u30A9\u30EC\u30C3\u30C8\u3001\u30C8\u30FC\u30AF\u30F3\u3092\u4F5C\u6210\u3057\u305F\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u30DE\u30EB\u30C1\u30B7\u30B0\u5316\u3067\u304D\u307E\u305B\u3093\u306E\u3067\u3054\u6CE8\u610F\u304F\u3060\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-m4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-m4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'M-4'),'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u3067\u30B3\u30A4\u30F3\u9001\u4FE1\u3059\u308B\u969B\u306E\u624B\u9806\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-m4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u3067\u30B3\u30A4\u30F3\u3092\u9001\u4FE1\u3059\u308B\u624B\u9806 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'1\uFF09\u30C8\u30C3\u30D7\u30E1\u30CB\u30E5\u30FC\u306E\u300C\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u300D\u30DA\u30FC\u30B8\u3092\u958B\u304D\u307E\u3059\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'2\uFF09\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u3066\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u306E\u9001\u4FE1\u3057\u305F\u3044\u30B3\u30A4\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'3\uFF09\u300C\u30B3\u30A4\u30F3\u30FB\u30C8\u30FC\u30AF\u30F3\u3092\u9001\u308B\u300D\u3092\u30AF\u30EA\u30C3\u30AF ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4\uFF09\u9001\u4FE1\u5148\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u3001\u9001\u4FE1\u6570\u91CF\u3092\u5165\u529B\u3057\u307E\u3059\u3002 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5\uFF09\u300C\u9001\u4FE1\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u79D8\u5BC6\u30AD\u30FC\u8A8D\u8A3C\u306E\u5165\u529B\u30DC\u30C3\u30AF\u30B9\u304C\u8868\u793A\u3055\u308C\u3001\u30B3\u30A4\u30F3\u9001\u4FE1\u3092\u3059\u308B\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u5C5E\u3059\u308B\uFF13\u3064\u306E\u79D8\u5BC6\u30AD\u30FC\u306E\u5165\u529B\u304C\u8981\u6C42\u3055\u308C\u307E\u3059\u3002\u5404\u5165\u529B\u6B04\u306B\u79D8\u5BC6\u30AD\u30FC\u3092\u3072\u3068\u3064\u305A\u3064\u5165\u529B\u3057\u3066\u300C\u8A8D\u8A3C\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'6\uFF09\u6700\u5F8C\u306B\uFF12\u6BB5\u968E\u8A8D\u8A3C\u306E\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u9001\u4FE1\u5B8C\u4E86\u3067\u3059\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'red'},'\uFF01\uFF01\uFF01\u3054\u6CE8\u610F\uFF01\uFF01\uFF01 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'TRIAM\u306E\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u3001\u30B3\u30A4\u30F3\u9001\u4FE1\u306E\u969B\u306B\u306F\u6BCE\u56DE\u3001\u79D8\u5BC6\u30AD\u30FC\u3092\uFF13\u3064\u3059\u3079\u3066\u3054\u5165\u529B\u3044\u305F\u3060\u304F\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\uFF13\u3064\u306E\u79D8\u5BC6\u30AD\u30FC\u306E\u3046\u30611\u3064\u306E\u307F\u3092\u7D1B\u5931\u3055\u308C\u305F\u5834\u5408\u3067\u3082\u3001\u305D\u306E\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u6C38\u4E45\u306B\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u306A\u304F\u306A\u308A\u307E\u3059\u3002 3\u3064\u306E\u79D8\u5BC6\u30AD\u30FC\u306F\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30DE\u30EB\u30C1\u30B7\u30B0\u5316\u3059\u308B\u969B\u306B\uFF11\u5EA6\u3060\u3051\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u518D\u8868\u793A\u3084\u518D\u767A\u884C\u7B49\u306F\u4E0D\u53EF\u80FD\u3068\u306A\u3063\u3066\u304A\u308A\u307E\u3059\u306E\u3067\u3001\u4FDD\u5B58\u30FB\u4FDD\u7BA1\u3092\u78BA\u5B9F\u306B\u884C\u3063\u3066\u4E0B\u3055\u3044\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-m5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-m5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'M-5'),'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u4F5C\u6210\u6642\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u305F\u79D8\u5BC6\u30AD\u30FC\u3092\u78BA\u8A8D\u3059\u308B\u3068\u3001\u30AD\u30FC\u304C6\u500B\u8A18\u8F09\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u3069\u308C\u304C\u79D8\u5BC6\u30AD\u30FC\u3067\u3059\u304B\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-m5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30DE\u30EB\u30C1\u30B7\u30B0\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\uFF13\u3064\u306E\u79D8\u5BC6\u30AD\u30FC\u306F\u3001\u30AD\u30FC\u30DA\u30A2\u306E\u751F\u6210\u6642\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u305F\u30D5\u30A1\u30A4\u30EB\u306E\u53F3\u5074\u306B\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u3082\u306E\u3067\u3059\u3002\u30B7\u30B9\u30C6\u30E0\u306E\u90FD\u5408\u4E0A\u3001\u5DE6\u5074\u306E\u300CPUBLIC KEY\u300D\u3068\u30DA\u30A2\u306B\u306A\u3063\u3066\u8868\u793A\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u30B3\u30A4\u30F3\u9001\u4FE1\u306A\u3069\u306E\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u306E\u969B\u306B\u300CPUBLIC KEY\u300D\u3092\u5165\u529B\u3057\u3066\u3082\u627F\u8A8D\u3055\u308C\u307E\u305B\u3093\u306E\u3067\u3054\u6CE8\u610F\u304F\u3060\u3055\u3044\u3002')))))))))));}}]);return FaqJa;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FaqJa);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FaqEn=function(_Component){_inherits(FaqEn,_Component);function FaqEn(){_classCallCheck(this,FaqEn);return _possibleConstructorReturn(this,(FaqEn.__proto__||Object.getPrototypeOf(FaqEn)).apply(this,arguments));}_createClass(FaqEn,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* faqDidMount */])();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mgt-30 faq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'common-title'},'FAQ about TRIAM')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faq-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-policy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-policy-item row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list-policy-sidenav col-12 col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A'),' Create new account'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-1'),'How to create an account?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-2'),'Are there any fee when creating the new account?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-3'),'Where is the verification code attached?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-4'),'What documents should you prepare to verify yourself?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-5'),'Can I create an account in any country?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-6'),'If cannot get the email, I will not receive a verification code')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-7'),'Can minors create accounts?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-8'),'Can a person create multiple accounts?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-9'),'Could I create a business account?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-10'),' If the verification code is invalid and an error occurs, I will not be able to register anymore.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B'),'Password'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-1'),'Forgot your password?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-2'),'When entering the incorrect password, your account will be "frozen".')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-3'),'I want to change my password')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-4'),'When you can not log in, the "Email does not exist" or "Incorrect password" error occur.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-5'),'How many characters can I set up with a password?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-6'),'What is Two Factor Authentication (TFA)?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-7'),'What is TFA reset code?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-8'),'How to reset TFA?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-9'),'If I lost my TFA reset code?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-10'),'When there is no smartphone, will I be able to set up TFA?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-c'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'C'),'Changing registered informations.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-c1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'C-1'),' I want to change email address')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-c2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'C-2'),'I want to change my password')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-c3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'C-3'),'I wan to change my registered name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-c4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'C-4'),'How to confirm the registered information?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-c5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'C-5'),'Can I change the language?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D'),'Create a wallet'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-1'),'How to create a new wallet?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-2'),'What is wallet address?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-3'),'What is private key?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-4'),'What is Google Two Factor Authentication(TFA)?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-5'),'I want to change my wallet address.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-6'),'I want to change my wallet name.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-7'),'What does it cost to create a wallet?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-8'),'Can I create multiple wallets?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-9'),'How many kind of coin/token does a wallet can keep?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-10'),'What is the [+] mark displayed in wallet?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-11'),'What should I do when "Wallet is locked" is displayed?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-12'),'When creating wallet after click on the Save button, how can I create a valid wallet?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-13'),'When creating new wallets, why we need 20 RIA coin?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-l'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'L'),'Multisig wallet'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-l1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'L-1'),'What is a Multisig wallet?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-l2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'L-2'),'How does it work?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-l3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'L-3'),'Increasing security?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-l4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'L-4'),'Important'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list-policy-sidenav col-12 col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-f'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'F'),'Trust'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-f1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'F-1'),'What is "Trust"?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-f2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'F-2'),'How to trust a coin/token?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-f3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'F-3'),'I want to untrust a trusted token')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-x'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'X'),'The Fee'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-x1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'X-1'),'What is transaction fee?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-x2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'X-2'),'How much is transaction fee?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-x3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'X-3'),'An error was displayed, and the fee is still charged even though the transaction was not successful? Why?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G'),'Sending, receiving the coin/token'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-1'),'How do I send RIA coin to my friends?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-2'),'Is there any limit to the amount of coin/token sent?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-3'),'How long does it take to send coin/token?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-4'),'When you want to send coin to another wallet then the error occur "Wallet address does not exist"')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-5'),'In spite of sent the coin-token, the receiver has not yet received it.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-6'),'What can I do when I sent coin/token to other wallet address?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-7'),'Are there any methods to confirm that the transaction has been completed?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-8'),'Cannot receive the trusted token')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H'),'Issuer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-1'),'Who is issuer?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-2'),'How to become an issuer?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-3'),'How long does it take to request to become an issuer?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-4'),'How much does it cost to become an issuer?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-5'),'What documents should I prepare when I need to become an issuer?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-6'),'How to submit the identity verification information?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-7'),'Can I request to become an issuer in any country?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-8'),'What is the [Organization] when entry information to becomes an issuer?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-9'),'I want to change the registered information.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-10'),'Cannot received the issuer\'s approval mail')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J'),'Creating - Issuing Token'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-1'),'How to create a new token?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-2'),'What is the property of wallet when creating the token?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K'),'Other'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-1'),'What is RIA coin?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-2'),'What is Token?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-3'),'What browser should we use?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-4'),'I want to delete wallet no longer needed.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-5'),'What is the Import wallet function?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-6'),'Can I register the address to send coins regularly?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-7'),'What is the Merge wallet function?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-8'),'What should I do when I cannot upload an image of an identity that is larger than 2MB?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-9'),'About the content displayed in the wallet transaction history')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-10'),'What is the [TFA required when login] on the setting page?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'M'),'Share wallet'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-m1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'M-1'),'What Is a Shared Wallet?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-m2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'M-2'),'Increasing security?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-m3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'M-3'),'How does it work?'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-role',id:'accordion',role:'main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Thank you for using TRIAM Network'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you have any question, please refer to Q&A below.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TRIAM Network will provide the best support so that you can peace of mind when using our system.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-group',id:'accordion'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-a'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A'),'Create new account')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a1',className:'panel-title expand custom-h3-font-size custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-1'),'How to create an account?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Anyone with an email address can sign up an account in TRIAM Network for free.Upon registration, you will need an email address and password by yourself.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1. Access "Create new account" page from "Login" page, enter Name, Email address and Password.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2. After you click the "Next" button, the email will be replied automatically to your registered email.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3. Enter the verification code attached to the email, you will be able to start using your account immediately.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-2'),'Are there any fee when creating the new account?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Creating the new account is totally free.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-3'),'Where is the verification code attached?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When creating the account, an email will be sent from TRIAM Network and the code will be attached here.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When entering the verification code into the specified screen, you can continue the steps to create your account.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-4'),'What documents should you prepare to verify yourself?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When creating your account, you do not need to submit document papers to verify yourself.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Only if when requesting becomes an ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h'},'issuer'),' you must submit the document papers to verify yourself.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-5'),'Can I create an account in any country?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'With regard to creating the account and use of coin, users must comply with the laws and regulations of the country/territory where the user resides.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-6'),'If cannot get the email, I will not receive a verification code.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In case the user does not receive the email, we have thought about some of the situations below, so please confirm the content.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u25A0The email will be in the Trash folder'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Since our email is based on a spam blocker filter, there may be instances where the email may have been mistaken for a spam email.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Because of the possibility of being placed in spam or trash box automatically, so please confirm it again.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u25A0The users use email in the smartphone'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In some case, the email may be lost by email blocker.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you use email blocking filter, please setting to receive email from [no-reply@triamnetwork.com]'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u25A0Email address is incorrect or invalid.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'It\'s also likely that the registered email address is incorrect.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u25A0Install security and prevent virus'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Depending on the installation of security software, there will be cases where the email is considered as spam and may be rejected or deleted.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Please check security setting or software and accept receiving spam email.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-7'),'Can minors create accounts?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'With regard to creating the account and use of coin, users must comply with the laws and regulations of the country/territory where the user resides.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-8'),'Can a person create multiple accounts?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'No limit on the number of account creation. Just do not use duplicate mail addresses. However, if you have multiple accounts, please manage them carefully.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a9',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-9'),'Could I create a business account?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a9',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'At present, there is no distinction between personal and business account.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a10',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-10'),' If the verification code is invalid and an error occurs, I will not be able to register anymore'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a10',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The verification code is attached to the autoresponder email will have an expire time. After 30 minutes of receiving the email, it will become invalid code.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In case of resending verification code, after 30 minutes from the previous email, the new email can be sent.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If the verification code is invalid and an error occurs, please return to the account creation page and proceed to resend the verification code.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-b'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B'),'Password')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-1'),'Forgot your password?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you forgot your password, please recover your password from [Forgot password] on the login page. When recovering your password, you must provide the email which you registered.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2460 \u3000Click "Forgot your password"'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2461 \u3000Enter email which is registered'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2462 \u3000The verification code to recover your password will be sent to the email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2463 \u3000Enter the verification code which is sent to the email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2464 \u3000Setting new password'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'red'},'!!! Warning !!!',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'In the case of changing the password, because of security reason, all wallets in the account will be locked.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'To unlock your wallets, you need to have the private key of each wallet.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Before changing your password, make sure you have all of your wallet\'s private key in your account. When the wallet is locked and you do not have the private key of this wallet, the wallet will become unusable forever.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d12',className:'click-scroll'},'Click here to unlock\u2192')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-2'),'When entering the incorrect password, your account will be "frozen".'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you enter an incorrect password more than a certain number of times, you will not be able to log in for a period of time because of security reason. In this case, please contact us via Customer support. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TRIAM Support Team'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,'support@triamnetwork.com'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-3'),' I want to change my password'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You can change the password from [Change Password] of setting page.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'red'},'!!! Warning !!!',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'In the case of changing the password, because of security reason, all wallets in the account will be locked.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'To unlock your wallets, you need to have the private key of each wallet.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Before changing your password, make sure you have all of your wallet\'s ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d3',className:'click-scroll'},'private key'),' in your account.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'When the wallet is locked and you do not have the private key of this wallet, the wallet will become unusable forever.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d12',className:'click-scroll'},'Click here to unlock\u2192')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-4'),'When you can not log in, the "email does not exist" or "Incorrect password" error occur.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The password is case-sensitive.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'In the case cannot be logged in account, please confirm that you don\'t enable Caps Lock and use your correct text and form for each password characters.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-5'),'How many characters can I set up with a password?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'For security reason, TRIAM Network requires a strong password. Length of the password is from 6 to 100 characters.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-6'),'What is Two Factor Authentication (TFA)?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TFA is a system to further enhance the security of your account by performing validation with another validation code beside the login password of TRIAM Network.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'In TRIAM Network, you can set ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,'TFA'),' by using Google Authenticator application.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-7'),'What is TFA reset code?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The TFA reset code is needed in the case of set TFA in another device.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'In some case such as loss of cell phone, damaged or changed device, you need to reinstall the TFA. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'red'},'!!! Warning !!! ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'The TFA reset code cannot be redisplayed or sent back to you, please do not miss it, it only displays once at the TFA installation screen.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-8'),'How to reset TFA?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'After logged in, you can reset or change in Setting Menu by yourself.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'To reset TFA, you must have TFA reset code already displayed in TFA installation screen. For security reasons, in TRIAM Network, TFA will become a necessary service. It is possible to change the settings but please do not use TRIAM Network\'s features in the state where TFA is not installed.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b9',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-9'),'If I lost my TFA reset code?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b9',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The TFA reset code only be displayed once when setting TFA. If you lost that code, it cannot be displayed or reissue.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b10',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-10'),'When there is no smartphone, will I be able to set up TFA?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b10',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TFA will use the services provided by Google. There are Web, iOS, Android version. Please select the device that you are using.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Please refer the following URL about Google TFA.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://www.google.com/landing/2step/'},'https://www.google.com/landing/2step/')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-c'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'C'),'Changing registered informations')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-c1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-c1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'C-1'),' I want to change email address'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-c1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The email is considered as a login ID and can not be changed. In case you can not use registered email, please contact our Customer Support'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,'support@triamnetwork.com'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-c2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-c2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'C-2'),'I want to change my password.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-c2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Please change the password from "Change password" screen in the Setting Menu. You also can change it from the "Forgot the password" section of the "Login screen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'red'},'!!! Warning !!!',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'In the case of changing the password, because of security reason, all wallets in the account will be locked.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'To unlock your wallets, you need to have the private key of each wallet.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Before changing your password, make sure you have all of your wallet\'s private key in your account.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'When the wallet is locked and you do not have the private key of this wallet, the wallet will become unusable forever.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d12',className:'click-scroll'},'\u2192How to unlock the wallet'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-c3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-c3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'C-3'),'I want to change my registered name'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-c3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you would like to change your registration information, please contact Customer Support via support email.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-c4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-c4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'C-4'),'How to confirm the registered information?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-c4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Sorry for this inconvenience, please contact Customer Support via support email.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-c5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-c5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'C-5'),'Can I change the language?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-c5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'For displaying the other language on the screen, you can change the language flag in the right corner of the screen.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-d'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D'),'Create a wallet')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-1'),'How to create a new wallet?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You can start from "Create new wallet" of My wallet page. Enter an arbitrary name to the wallet name.Please be sure to keep the wallet\'s private key at this time. To create a wallet, you need to fund the wallet provided by the other wallet. Check [Funding wallet] and specify a wallet to provide initial funds from the same account. Next, please enter the amount of initial funds. Initial funds amount must be 20 RIA coin or more.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'After click [Create], since the TFA code is required, please enter the code that is generated in the Google TFA app.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u25A0Procedure for creating the first wallet ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'To create a wallet for the first time in your account, you need to fund the wallet provided by the wallet of the other account.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'1)Click "Create new wallet" on the My Wallet page.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'2)Enter an arbitrary name to the wallet name. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'3)Please be sure to keep the wallet\'s private key at this time. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4)Click [Save].',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'After saving the wallet, the account holder of providing initial funds works for activating the saved wallet.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Users who work for activating the others account\'s wallet, click "Activate wallet" from the My Wallet page of your account.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Enter the wallet address you want to activate.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Do not check the checkbox "Active my wallet".',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Please select the wallet that will provide the first funds.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Since the TFA code is required, please enter the code that is generated in the Google TFA app.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'red'},'!!! Warning !!!',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'The wallet\'s private key that is displayed when creating a wallet that is extremely important and essential to be able to use when changing passwords as well as restoring wallets.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'The private key is only displayed once when creating wallet so please save it in a safe offline place such as taking pictures, saving to paper... ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'One wallet only has one private key and it is different from the others.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'In case a third party knows the private key of a wallet, it is likely that the wallet will be occupied so pay close attention to the handling that wallet. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-2'),'What is wallet address?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The wallet is the same as the "account number" when using coin and tokens at TRIAM Network. The wallet address consists of 56 alphanumeric characters and is issued for each wallet. You need to use a wallet address when sending a token or issuing a token.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'The wallet address will be used in the sending, getting coin-token to another, so if another else know the wallet address should not problems.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'The wallet address of each wallet can be view at "My wallet" page. You can not change the address of the created wallet.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-3'),'What is private key?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Private key is the code that is issued for each wallet.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'The private key is a very important thing used in unlock, restore and import wallet.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'If you have a private key, you can recreate the entire wallet, and if the private key is leaked to other people, just as you know the ATM card and its password.If you have a private key, in the case of a lost wallet or a crash, you can restore it, but in case you forgot or lost the private key, you will not be able to recreate it again. What happens to the wallet you will not be able to handle and it will be very dangerous.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'The private key is only displayed once when creating a wallet, because it cannot display later so please save it carefully.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'In addition, we strongly recommend that you save in the offline environment, should not be saved online or on any cloud-based service.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-4'),'What is Google Two Factor Authentication(TFA)?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TFA is a security process that requires entering a code generated from Google to a mobile device in addition to requiring a password.This increases the information required when login and executes transactions. In the attack method as taking the same password as the Brute force attack, the password to log in and execute the transaction will be the thing which cannot happen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://www.google.co.jp/intl/ja/landing/2step/'},'https://www.google.co.jp/intl/ja/landing/2step/'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-5'),'I want to change my wallet address.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Changing wallet addresses is impossible. If you want to change the common wallet address, please create a new wallet.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-6'),'I want to change my wallet name.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you want to change the name of the wallet, select the wallet, and click on the pencil mark displayed to the right of the wallet name, you will be able to change the wallet name. The number of changing wallet name is not limited.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'In addition, the name wallet has functions that you can easily manage yourself, when sending coin or receiving coin you do not need to notify the other party.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-7'),'What does it cost to create a wallet?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Creating a wallet is completely free, but when you activate Wallet (when using it for sending and receiving RIA coins or tokens, etc.) you need to have at least 20 RIA coin in the Wallet.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Once you activate Wallet, the 20 RIA coin used for the activate will not be able to move.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-8'),'Can I create multiple wallets?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Although you can create many wallets, the condition for keeping wallets active is that the excess of each wallet must be from ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'20 RIA coin'),' or more.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d9',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-9'),'How many kind of coin/token does a wallet can keep?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d9',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'There is no limit to the number of coin/token in a wallet. Moreover, there is no limit to the amount of coins/tokens. To use the coin/token you need to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-f'},'trust'),' it.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d10',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-10'),'What is the [+] mark displayed in wallet?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d10',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When you click on the [+] mark you can trust other tokens in the wallet. You can also search for the tokens you want to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-f'},'trust'),'.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d11',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-11'),'What should I do when "Wallet is locked" is displayed?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d11',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In cases such as changing passwords, for security reasons, the wallets in the account will be locked. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'To unlock a wallet, you must have its private key. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'From My wallet, click on the key mark displayed on the left of each wallet. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Screen to enter private key and password will be displayed, if you enter the correct wallet will be unlocked. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Since the private key of each wallet is different, you need to enter the private key for each wallet to unlock.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d12',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-12'),'When creating wallet after click on the Save button, how can I create a valid wallet? '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d12',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When you click Save the wallet, the wallet will be saved at the status "Inactive". ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'To active a wallet, you need to send 20 RIA coin from other active wallets.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'From My wallet page, click on [!] mark on the left of wallet name. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Select the wallet to send starting balance and enter the amount. To Active wallet, you need at least 20 RIA coin. Finally, after entering the Google TFA code, the wallet will be activated. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u25A0In case of receiving starting balance from the wallet of another account. Activating wallet for the account is received the balance from another wallet.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'From the My wallet page, click on \u300C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,'Active wallet'),'\u300D',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Enter the wallet address you want to active. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'At this point, you can continue without checking the [Active wallet] checkbox.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Select the wallet to send starting balance, enter the Google TFA code and complete the operation.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d13',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-13'),'When creating new wallets, why we need 20 RIA coin?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d13',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Because it cannot be recognized as an active wallet when the wallet is in a blank state, when creating a new wallet, it is necessary to have the RIA Coin in wallet.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'In TRIAM Wallet, the minimum RIA coin for active a wallet is 20 RIA coin.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'This minimum balance will help protect the network from creating spam accounts.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-f'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'F'),'Trust')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-f1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-f1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'F-1'),'What is "Trust"?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-f1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Trust means simply trusting to use a coin, a token in TRIAM Network. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'It\'s the mechanism to use only coin/token that you trust and has value in the system. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'To be able to send or receive tokens, the first thing is trusting that token.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-f2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-f2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'F-2'),'How to trust a coin/token?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-f2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Click on [+] mark of My wallet, the coin/token you can trust will be displayed. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'If the coin/token you want to trust is not displayed, it will appear in the Search box. Click the coin/token you want to trust, click the OK button, the coin/token will be added to the wallet.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Some tokens are only approved with the requested trust but some tokens will complete the trust operation when having issuer\'s approval. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'If the check mark on the bottom right of the token is added to the wallet displayed, the trust operation has been completed. When the clock mark at the bottom right of the token is added to the wallet displayed, the trust operation will be in an incomplete state. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'When the trust is not completed, you can not send or receive a coin/token.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-f3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-f3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'F-3'),'I want to untrust a trusted token\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-f3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'To untrust trusted token, the amount of coin/token to untrust must be 0(zero). Please click on the token that you want to remove from your wallet and proceed with "Untrust this asset".'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-x'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'X'),'The Fee')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-x1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-x1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'X-1'),'What is transaction fee?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-x1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'This is the fee that is incurred when processing information on Blockchain. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Transaction fees are mainly incurred in cases such as creating new wallets, sending and receiving trusts. Also, when the transaction fails, transaction fees will still be incurred.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-x2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-x2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'X-2'),'How much is transaction fee?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-x2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'For RIA coin, one transaction will take 0.001 RIA coin. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'When sending the token created on the TRIAM platform, you need two types of fees, the transaction fee RIA coin and the transaction token fee. The transaction token fee will vary, depending on the token.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-x3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-x3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'X-3'),'An error was displayed, and the fee is still charged even though the transaction was not successful? Why?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-x3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In the case of an error occurred, because the processing of information is conducted on Blockchain should still incur a charge.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-g'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G'),'Sending, receiving the coin/token')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-1'),'How do I send RIA coin to my friends?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'From the My wallet page, select the wallet you want to send the coin. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Next, select the coin/token you want to send. In this case, you choose RIA coin. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'The transaction selection screen will be displayed and you click on [Send coin/token].',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Enter the receiving wallet address and enter the number you want to send. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Finally, enter the Google TFA code and click [Send].')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-2'),'Is there any limit to the amount of coin/token sent?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'There is no limit. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Make sure that the balance after sending must more than ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'20 RIA coin'),'. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'If the balance after sending less than ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'20 RIA coin'),' it will occur error',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'For example, there are ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'50 RIA coin'),' in your wallet',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'The amount of RIA coin you can send is ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'29.999 RIA coin'),', including ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'20 RIA coin'),' for active wallet and minus ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'0.001 RIA coin'),' transaction fee.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-3'),'How long does it take to send coin/token?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In TRIAM Network, sending token/coin will take 1 to 2 seconds. If there are multiple transaction processing, it may be a bit slow.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-4'),'When you want to send coin to another wallet then the error occur [Wallet address does not exist]'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You can think about situations where it is impossible to confirm the existence of a wallet such as an incorrect receiving address or a deletion. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'If the [Wallet address does not exist] error occur, please confirm as below.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm the wallet address with the receiver. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBIn the wallet transaction history, please confirm that the wallet address entered is not mistaken. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm whether the received wallet is in a blocked state. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm that the receive wallet is activated.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-5'),'In spite of sent the coin-token, the receiver has not yet received it. '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In case the receiver does not receive the coin-token, please confirm the cases below: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm the wallet address received with the receiver. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBIn the wallet transaction history, please confirm that the wallet address entered is not mistaken.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-6'),'What can I do when I sent coin/token to other wallet address? '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'It is very unfortunate but sending the coin when finished processing cannot be canceled. Although it may be checked by Customer Support, you cannot cancel it. Before proceeding to send coin, please confirm wallet address carefully.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-7'),'Are there any methods to confirm that the transaction has been completed?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You can confirm each transaction from the transaction wallet history in My wallet. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Alternatively, it is possible to confirm that the coin has been sent to the receiver wallet using the TRIAM Block Scan.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-8'),'Cannot receive the trusted token'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Some tokens are only approved with the request trust, and some tokens will complete the trust upon receipt of the ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h'},' issuer'),'\'s approval.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'When the check mark on the right side of the token is added to the wallet displayed, the trust operation is completed. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'When the clock mark to the right of the toke is added to the wallet is displayed, the trust confirmation from the issuer is in an incomplete state. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'When the trust confirmation is not complete, you can not send the token.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-h'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H'),'Issuer')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-1'),'Who is issuer?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When you become an issuer you will have the right to create and issue a token by yourself. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Self-issued tokens can be used extensively for many business purposes.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-2'),'How to become an issuer?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You need to send a request to become an issuer. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'You can send the request from the general settings page',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Please enter the required fields and upload the image ID. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Valid papers are limited to the types issued by each government agency. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Example: Driver\'s license, passport...',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Please submit the front and back of the driver\'s license, the photo page and the attached address of the passport. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Please note that images may not be accepted if the image is not properly ordered or the image is blurry.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-3'),'How long does it take to request to become an issuer?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Since we will confirm in the order of censoring and confirming the request, please wait after sent the request. If we confirm the request to become issuer, we will send a message to the registered email address.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-4'),'How much does it cost to become an issuer?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Requesting and becoming an issuer will not cost you anything')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-5'),'What documents should I prepare when I need to become an issuer? '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The documents that need to be prepared when you want to become an issuer are limited to the types of papers issued by the government agencies of each country. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Examples of papers issued by Japanese government agencies such as driver\'s license, passport, etc.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u25A0Drive license',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBPlease submit the front and back image.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm that all information must be clear.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm your name, address and date of birth are clearly marked. Confirm the address and name are the same as entered at the registration information screen. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm that it is still valid.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm the number is clearly attached.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm that facial image is clear. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u25A0Passport',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBPlease submit two pages of pictures with face and column of the owner (attached page).',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm that all information must be clear. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm that the passport number is displayed clearly. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm that it is still valid',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm that address, name, date of birth is clearly attached. Confirm the address and name are as same as entered at the registration screen for identity information. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u25A0Residence card',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBPlease submit the front and back page.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm that all information must be clear.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm that the address, name, date of birth is clearly attached. Confirm the address and name are the same as entered at the registration screen for identity information. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm the attached number is clear',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm that it is still valid ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBConfirm the seal is displayed clearly. If it is attached to the back, it also confirms the seal on the back.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-6'),'How to submit the identity verification information?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'With the issuer\'s request from the setting page, you can submit identity verification information. Please submit by uploading images of identity verification papers. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Maximum image size is 2MB. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Attention about the submitted picture, please confirm the above tutorial.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-7'),'Can I request to become an issuer in any country? '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Regardless of where you live, whoever you are, you can request to become an issuer. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'However, regarding using and distribution of coins, tokens, you must comply with the laws and regulations of the country or territory in which you reside. In the future, if the laws and regulations of the world or country in which you reside change, there will be cases where the issuer-approved authority may become invalid.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'If so, there will be a loss of revenue and damage related to the token, but no have charge and compensation, please be aware.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-8'),'What is the [Organization] when entry information to becomes an issuer?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Please enter the organization, the company to which the issuer is working. Although you may choose not to disclose the issuer\'s public information, but in order to increase the trust of the token that has been issued, we recommend disclosing the information is needed.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h9',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-9'),'I want to change the registered information.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h9',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You can change this by editing and request information from the issuer from [Settings] => [General] again. Until the new request has been approved, the information that was previously available is still valid. Once the new information has been approved, the old information will be deleted and the requested information will be updated.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h10',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-10'),'Cannot received the issuer\'s approval mail.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h10',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Please refer ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-6'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-j'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J'),'Creating - Issuing Token')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-1'),'How to create a new token?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'To create and issue a token, you need to send a request and be approved to become an issuer.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Users accepted as issuers can create, issue token from [Issuer mode] of the My wallet page.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'First, click on [Create asset]',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Select the wallet to create a token. Since you will be using RIA coin to create tokens, you should select the wallet have many RIA coin.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Next, select the property and setting image icon. Image icon you can edit later.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Enter the token name, decimal point, transaction fee and RIA coin rate, and finally, select the receiving wallet when the token is used. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'At this point, the token is created. Next, let the token be used and the actual circulation you need to issue the token.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-2'),'What is the property of wallet when creating the token?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When setting the wallet property you can set a fixed limit when another user uses a token.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Since the property setting is based on the wallet, the properties are automatically applied to the token by the same wallet.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Attribute 1 is when other users trust the token, which requires approval by the issuer who issued the token. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Attribute 2 is another user who can trust and use that tokens freely.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-k'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K'),'Other')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-1'),'What is RIA coin?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'RIA coin is the virtual currency using in the blockchain. The speed of payment is excellent, and it can move coin by the high trust with low cost.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-2'),'What is Token?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'It\'s coin issued on TRIAM Platform. Any user who owns a TRIAM account can issue a token by executing a token-issuing request and is approved. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Charge to become issuer is free. To manually issue tokens, you need to have RIA coin.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-3'),'What browser should we use?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In order to use TRIAM Network safely and comfortably, we recommend using the browsers with the following versions: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBGoogle Chrome: the latest version',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBMozilla Firefox: the latest version',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u203BInternet Explorer: Not recommend')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-4'),'I want to delete wallet no longer needed '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When the wallet is created it cannot be deleted. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'However, you can "remove" the wallet in the account by merge to another wallet. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'When using the merge wallet function, RIA coin in the merge wallet will be included in the merge wallet, since the wallet itself will disappear, so the following conditions must be met: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBDo not issue any coin tokens ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBDo not use merchant wallets',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBNo pending transactions (including sending coin, receiving coin) ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBNo trust coin/token other than RIA coin',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB RIA coin balance has over 20,001 coin ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'The merge wallet can be implemented from the [Merge wallet] of the My wallet page')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-5'),'What is the Import wallet function?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When using the import wallet function, you can move the wallet of another account into your account. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'To import wallets you need to have the private key of the wallet. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'When the wallet is imported, the receiving fee permission and issuing token permission in the wallet will move together.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Users who issue tokens or use them in business should careful when using the import wallet function.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-6'),'Can I register the address to send coins regularly?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Yes, you can. Please register that wallet address at [my contact] in My wallet.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-7'),'What is the merge wallet function?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You can combine multiple wallets to one. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'When using the merge wallet function, RIA coin in the merge wallet will be sent to the destination wallet, since the wallet itself will disappear, so the following conditions must be met: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBDo not issue new coin tokens ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBDo not use merchant wallets ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBNo pending transactions (including sending coin, receiving coin) ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBNo trust coin-token other than RIA coin ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBRIA coin balance has over 20,001 coin')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-8'),'What should I do when I cannot upload an image of an identity that is larger than 2MB? '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Sorry for this inconvenient but please resign the upload image by software and photo editing app.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k9',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-9'),'About the content displayed in the wallet transaction history'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k9',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In the wallet transaction history, you can confirm the transactions executed in each wallet. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'When you selected a wallet, the transaction history of that wallet is displayed. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'When clicking on [Detail], transaction content will be displayed.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k10',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-10'),'What is the [TFA required when login] on the setting page? '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k10',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When you checked this checkbox, you will set up to entering TFA code at login. For security reasons, we recommend you to use it.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-l'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'L'),'Multisig Wallet')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-l1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-l1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'L-1'),'What Is a Multisig Wallet?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-l1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Multisig stands for multi-signature, which is specific type of digital signature that makes it possible increasing security.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TRIAM Network provide the Multisig wallet that has three secret keys in one wallet.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-l2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-l2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'L-2'),'How does it work?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-l2',className:'panel-collapse collapse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Basically, your funds stored on a multisig wallet can only be accessed by using all of three signatures. For example, sending the asset to third party from your multisig wallet you have to provide all of three secret keys to complete the transaction.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Therefore, the use of a multisig wallet enables you to create an additional layer of security to your funds.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-l3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-l3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'L-3'),'Increasing security?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-l3',className:'panel-collapse collapse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'By using a multisig wallet, you are able to prevent the trouble caused by the hacking or stolen of a secret key. Even if one of the keys are compromised, your funds will be safe.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-l4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-l4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'L-4'),'Important'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-l4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'- Multisig wallets are a great feature for wallet security, but it is important to keep in mind that there are some risks involved.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'- Using a multisig wallet requires management strictly three secret keys by your own. If you lost one of the secret key, it means you cannot access the multisig wallet forever.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'- Even if wallet has multiple secret keys, it will be meaningless if you store it bad environment. We strongly recommend that you should store the secret keys in different places in the offline environment, and it is only way that the effect of the multisig wallet can be realized.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'M'),'Share Wallet')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-m1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-m1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'M-1'),'What Is a Shared Wallet?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-m1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Shared wallet is a specific type of wallet that makes it possible for multiple users to sign transactions as a group. Basically, the funds stored on a shared wallet can only be accessed by using 2 or more signatures.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-m2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-m2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'M-2'),'Increasing security?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-m2',className:'panel-collapse collapse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Suppose I am working with a company that wants to accept cryptocurrency for international trades.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'The company, for security reasons, would not want a single one of its employees to have access to the company asset wallet\'s password. Any transaction would have to meet the approval of more than one employee.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-m3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-m3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'M-3'),'How does it work?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-m3',className:'panel-collapse collapse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'To put it simply, for instance,',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'1-of-2: Husband and wife petty cash joint account \u2014 the signature of either spouse is sufficient to spend the funds.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'2-of-2: Husband and wife savings account \u2014 both signatures are required to spend the funds, preventing one spouse from spending the money without the approval of the other',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'2-of-3: Parents\u2019 savings account for child \u2014 the kid can spend the money with the approval of either parent, and money cannot be taken away from the child unless both parents agree',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'3-of-5: Five trusted people from a project each hold a private key. Three people are required to actually spend the money but anybody can donate to the project\'s address. Reduces the risk of embezzlement, hacking/malware or loss due to a single person losing interest in the project. Which private key was used in the final signature is visible on the blockchain which aids accountability.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Share wallet is a share-participation wallet in which transactions are conducted by approval from users who are participating as a group. Because all of the transaction information is recorded and published on the blockchain, the creation of accounting documents is reduced. In addition to reducing unnecessary work time, it leads to the reduction of paper costs, which are essential for the eco-friendly era.')))))))))));}}]);return FaqEn;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FaqEn);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FaqCh=function(_Component){_inherits(FaqCh,_Component);function FaqCh(){_classCallCheck(this,FaqCh);return _possibleConstructorReturn(this,(FaqCh.__proto__||Object.getPrototypeOf(FaqCh)).apply(this,arguments));}_createClass(FaqCh,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* faqDidMount */])();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mgt-30 faq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'common-title'},'TRIAM \u5E38\u89C1\u95EE\u9898')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faq-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-policy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-policy-item row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list-policy-sidenav col-12 col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A'),'\u521B\u5EFA\u8D26\u6237'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-1'),'\u5982\u4F55\u6CE8\u518C\u521B\u5EFA\u8D26\u6237\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-2'),'\u6CE8\u518C\u521B\u5EFA\u8D26\u6237\u6536\u8D39\u5417\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-3'),'\u5728\u54EA\u91CC\u53EF\u4EE5\u67E5\u770B\u7535\u5B50\u90AE\u4EF6\u8BB0\u8F7D\u7684\u9A8C\u8BC1\u7801\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-4'),'\u672C\u4EBA\u8EAB\u4EFD\u786E\u8BA4\u3001\u9700\u8981\u51C6\u5907\u4EC0\u4E48\u76F8\u5173\u8D44\u6599\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-5'),'\u4EFB\u4F55\u56FD\u5BB6\u5747\u4E3A\u5408\u6CD5\u6CE8\u518C\u521B\u5EFA\u5E10\u6237\u5417\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-6'),'\u90AE\u4EF6\u65E0\u6CD5\u6536\u53D6\uFF0C\u4E5F\u63A5\u6536\u4E0D\u5230\u9A8C\u8BC1\u4EE3\u7801\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-7'),'\u672A\u6210\u5E74\u8005\u53EF\u4EE5\u6CE8\u518C\u521B\u5EFA\u8D26\u53F7\u5417?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-8'),'\u4E00\u4EBA\u53EF\u4EE5\u6CE8\u518C\u591A\u4E2A\u8D26\u53F7\u5417\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-9'),'\u53EF\u4EE5\u6CE8\u518C\u521B\u5EFA\u516C\u53F8\u8D26\u53F7\u5417\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A-10'),'\u663E\u793A\u65E0\u6548\u7684\u9A8C\u8BC1\u4EE3\u7801\uFF0C\u65E0\u6CD5\u6CE8\u518C')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B'),'\u5B89\u5168\u6027'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-1'),'\u5FD8\u8BB0\u767B\u5F55\u5BC6\u7801\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-2'),'\u5BC6\u7801\u8F93\u5165\u9519\u8BEF\uFF0C\u8D26\u6237\u88AB\u51BB\u7ED3\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-3'),' \u5982\u4F55\u66F4\u6539\u767B\u5F55\u5BC6\u7801\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-4'),'\u8F93\u5165\u540E\u663E\u793A\u300C\u8BE5\u7528\u6237\u4E0D\u5B58\u5728\u300D\u3001\u300C\u5BC6\u7801\u9519\u8BEF\u300D\u65E0\u6CD5\u767B\u5F55\u8D26\u6237\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-5'),'\u8BBE\u7F6E\u767B\u5F55\u5BC6\u7801\u5B57\u7B26\u4E3A\u51E0\u4F4D\u6570\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-6'),'\u4EC0\u4E48\u662F\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-7'),'\u4EC0\u4E48\u662F\u53CC\u91CD\u8EAB\u4EFD\u91CD\u7F6E\u4EE3\u7801\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-8'),'\u5982\u4F55\u89E3\u9664\u53CC\u91CD\u8EAB\u4EFD\u91CD\u7F6E\u4EE3\u7801\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-9'),'\u5FD8\u8BB0\u53CC\u91CD\u8EAB\u4EFD\u91CD\u7F6E\u4EE3\u7801\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-10'),'\u6CA1\u6709\u667A\u80FD\u624B\u673A\uFF0C\u53EF\u4EE5\u8BBE\u7F6E\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u5417\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-11'),'\u4EC0\u4E48\u662F\u4EA4\u6613\u5BC6\u7801\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-12'),'\u5982\u679C\u66F4\u6539\u4EA4\u6613\u5BC6\u7801\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-13'),'\u5FD8\u8BB0\u4EA4\u6613\u5BC6\u7801\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-b14'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'B-14'),'\u8BBE\u7F6E\u4EA4\u6613\u5BC6\u7801\u5B57\u7B26\u4E3A\u51E0\u4F4D\u6570\u4EE5\u4E0A\uFF1F')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-c'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'C'),'\u66F4\u6539\u6CE8\u518C\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-c1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'C-1'),'\u66F4\u6539\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-c2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'C-2'),'\u66F4\u6539\u5DF2\u6CE8\u518C\u540D\u79F0\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-c3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'C-3'),'\u5982\u4F55\u67E5\u770B\u81EA\u5DF1\u7684\u6CE8\u518C\u4FE1\u606F\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-c4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'C-4'),'\u5982\u4F55\u7F6E\u6362\u56FD\u5BB6\u8BED\u8A00\uFF1F')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D'),'\u521B\u5EFA\u7535\u5B50\u94B1\u5305'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-1'),' \u5982\u4F55\u521B\u5EFA\u65B0\u7684\u7535\u5B50\u94B1\u5305\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-2'),'\u4EC0\u4E48\u662F\u7535\u5B50\u94B1\u5305\u5730\u5740\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-3'),'\u4EC0\u4E48\u662F\u5BC6\u94A5\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-4'),'\u4EC0\u4E48\u662FGoogle\uFF08\u8C37\u6B4C\uFF09\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-5'),'\u5982\u4F55\u66F4\u6539\u7535\u5B50\u94B1\u5305\u5730\u5740\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-6'),'\u5982\u4F55\u66F4\u6539\u7535\u5B50\u94B1\u5305\u540D\u79F0\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-7'),'\u521B\u5EFA\u7535\u5B50\u94B1\u5305\u6536\u8D39\u5417\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-8'),'\u53EF\u4EE5\u521B\u5EFA\u591A\u4E2A\u7535\u5B50\u94B1\u5305\u5417\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-9'),'\u4E00\u4E2A\u7535\u5B50\u94B1\u5305\u53EF\u6301\u6709\u591A\u5C11\u79CD\u4EE3\u5E01\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-10'),'\u7535\u5B50\u94B1\u5305\u7684\u9875\u9762\u663E\u793A\u300C\uFF0B\u300D\u7B26\u53F7\u662F\u4EC0\u4E48\u610F\u601D\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-11'),'\u300C\u7535\u5B50\u94B1\u5305\u663E\u793A\u88AB\u5C01\u9501\u300D\u5982\u4F55\u64CD\u4F5C\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-12'),'\u521B\u5EFA\u7535\u5B50\u94B1\u5305\u65F6\u5DF2\u6309\u300C\u4FDD\u5B58\u300D\uFF0C\u5982\u4F55\u8BA9\u7535\u5B50\u94B1\u5305\u751F\u6548\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-d13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'D-13'),'\u521B\u5EFA\u65B0\u7535\u5B50\u94B1\u5305\u65F6\uFF0C\u4E3A\u4F55\u5FC5\u987B20RIA\u5E01\u4EE5\u4E0A\uFF1F')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-f'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'F'),'TRUST'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-f1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'F-1'),'\u4EC0\u4E48\u662FTRUST?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-f2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'F-2'),'\u5982\u4F55TRUST\u522B\u7684 \u8D27\u5E01\xB7\u4EE3\u5E01\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-f3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'F-3'),'\u5982\u4F55\u89E3\u9664\u5DF2TRUST\u7684 \u8D27\u5E01\xB7\u4EE3\u5E01\uFF1F'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list-policy-sidenav col-12 col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-x'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'X'),'\u624B\u7EED\u8D39'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-x1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'X-1'),'\u4EC0\u4E48\u662F\u4EA4\u6613\u8D39')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-x2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'X-2'),'\u4EA4\u6613\u624B\u7EED\u8D39\u5982\u4F55\u6536\u53D6\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-x3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'X-3'),'\u53D1\u9001\u663E\u793A\u9519\u8BEF\uFF0C\u4EE3\u5E01\u53D1\u9001\u672A\u6210\u529F\uFF0C\u4E3A\u4F55\u6263\u9664\u624B\u7EED\u8D39\uFF1F')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G'),'\u53D1\u9001 \u8D27\u5E01\xB7\u4EE3\u5E01\uFF0C\u63A5\u6536 \u8D27\u5E01\xB7\u4EE3\u5E01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-1'),'\u5982\u4F55\u5411\u597D\u53CB\u53D1\u9001RIA\u5E01\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-2'),'\u53D1\u9001 \u8D27\u5E01\u30FB\u4EE3\u5E01\u7684\u6570\u91CF\u6709\u9650\u5236\u5417\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-3'),'\u8D27\u5E01\u30FB\u4EE3\u5E01\u53D1\u9001\u540E\u591A\u957F\u65F6\u95F4\u53EF\u663E\u793A\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-4'),'\u53D1\u9001 \u8D27\u5E01\u30FB\u4EE3\u5E01\u65F6\uFF0C\u663E\u793A\u300C\u53D1\u751F\u9519\u8BEF\uFF0C\u6B64\u7535\u5B50\u94B1\u5305\u5730\u5740\u4E0D\u5B58\u5728\u300D')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-5'),'\u53D1\u9001\u7684 \u8D27\u5E01\u30FB\u4EE3\u5E01\u5DF2\u663E\u793A\u6210\u529F\uFF0C\u63A5\u6536\u65B9\u6CA1\u6709\u63A5\u6536\u5230\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-6'),'\u8D27\u5E01\u30FB\u4EE3\u5E01 \u8BEF\u53D1\u4E86\u9519\u8BEF\u7684\u7535\u5B50\u94B1\u5305\uFF0C\u8BE5\u5982\u4F55\u64CD\u4F5C\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-7'),'\u5982\u4F55\u67E5\u770B\u8D27\u5E01\u30FB\u4EE3\u5E01\u662F\u5426\u53D1\u9001\u6210\u529F\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-g8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'G-8'),'\u65E0\u6CD5\u63A5\u6536\u5DF2TRUST\u7684\u4EE3\u5E01')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H'),'ISSUER'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-1'),'\u4EC0\u4E48\u662FISSUER?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-2'),'\u5982\u4F55\u6210\u4E3AISSUER?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-3'),'ISSUER\u4ECE\u7533\u8BF7\u5230\u6279\u51C6\u9700\u8981\u51E0\u5929\u7684\u65F6\u95F4\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-4'),'\u7533\u8BF7ISSUER\u6536\u8D39\u5417\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-5'),'ISSUER\u7684\u7533\u8BF7\uFF0C\u4E2A\u4EBA\u8EAB\u4EFD\u786E\u8BA4\u9700\u8981\u51C6\u5907\u4EC0\u4E48\u8D44\u6599\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-6'),'\u5982\u4F55\u9012\u4EA4\u4E2A\u4EBA\u8EAB\u4EFD\u8EAB\u4EFD\u786E\u8BA4\u8D44\u6599\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-7'),'\u7533\u8BF7ISSUER\u662F\u5426\u53EF\u6839\u636E\u5C45\u4F4F\u6240\u5728\u56FD\u5BB6\u8FDB\u884C\u7533\u8BF7\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-8'),'\u7533\u8BF7ISSUER\u65F6\u9700\u8F93\u5165\u7684\u300C\u56E2\u4F53/\u516C\u53F8\u300D\u662F\u4EC0\u4E48\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-9'),'\u5982\u4F55\u66F4\u6539\u7533\u8BF7\u5DF2\u6CE8\u518C\u7684ISSUER\u8D44\u6599\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-h10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'H-10'),'\u6CA1\u6709\u63A5\u6536\u5230\u7533\u8BF7ISSUER\u7684\u53D7\u7406\u90AE\u4EF6')),'                                            ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J'),'\u521B\u5EFA\u30FB\u53D1\u884C \u4EE3\u5E01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-1'),'\u5982\u4F55\u521B\u5EFA\u4EE3\u5E01\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-2'),'\u521B\u5EFA\u4EE3\u5E01\u65F6\u663E\u793A\u7684\u300C\u5C5E\u6027\u300D\u662F\u4EC0\u4E48\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-3'),'\u521B\u5EFA\u4EE3\u5E01\u6216\u53D1\u884C\u4EE3\u5E01\u6536\u8D39\u5417\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-4'),'\u8BF7\u7528\u6613\u7406\u89E3\u7684\u65B9\u5F0F\u8BF4\u660E\u5982\u4F55\u4F7F\u7528RIA\u7684\u6BD4\u7387\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-5'),'\u4EE3\u5E01\u7533\u8BF7\u7684\u72B6\u6001\u663E\u793A\u201C\u5F85\u5B9A\u201D\u65E0\u6CD5\u521B\u5EFA\u4EE3\u5E01\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-6'),'\u5DF2\u521B\u5EFA\u7684\u4EE3\u5E01\u53EF\u4EE5\u5220\u9664\u5417\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-7'),'\u4EE3\u5E01\u7684\u6DFB\u52A0\u53D1\u884C\u5DF2\u65E0\u6548\u3002\u53EF\u4EE5\u6062\u590D\u5417\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-8'),'\u7535\u5B50\u94B1\u5305\u6709\u4F59\u989D\uFF0C\u5374\u4E00\u76F4\u663E\u793A\u300CNot enough funds in source account\u300D\u65E0\u6CD5\u53D1\u884C\u4EE3\u5E01\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-9'),'\u5F53\u63A5\u6536\u5230\u7528\u6237\u7684Trust\u7684\u7533\u8BF7\u65F6\uFF0C\u5982\u679C\u88AB\u62D2\u7EDD\u5C06\u663E\u793A\u4EC0\u4E48\u6837\u7684\u56FE\u6807\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-j10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'J-10'),'\u65E0\u6CD5\u4F7F\u7528\u6307\u5B9A\u7684\u4EE3\u5E01\u540D\u79F0\u521B\u5EFA\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K'),'\u5176\u5B83'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-1'),'\u5173\u4E8E\u63A8\u8350\u7684\u6D4F\u89C8\u5668')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-2'),'\u4EC0\u4E48\u662F\u4EE3\u5E01\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-3'),'\u5220\u9664\u591A\u4F59\u7684\u7535\u5B50\u94B1\u5305\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-4'),'\u53EF\u4EE5\u4FDD\u5B58\u4E00\u4E2A\u4F5C\u4E3A\u9891\u7E41\u53D1\u9001\u4EE3\u5E01\u7684\u5730\u5740\u5417\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-5'),'\u7535\u5B50\u94B1\u5305\u5408\u5E76\u662F\u4E00\u9879\u662F\u4EC0\u4E48\u6837\u7684\u529F\u80FD\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-6'),'\u4E2A\u4EBA\u8EAB\u4EFD\u786E\u8BA4\u7684\u56FE\u7247\u8D85\u8FC72MB\uFF0C\u65E0\u6CD5\u4E0A\u4F20\uFF0C\u5982\u4F55\u64CD\u4F5C\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-7'),'\u5173\u4E8E\u7535\u5B50\u94B1\u5305\u4EA4\u6613\u8BB0\u5F55\u67E5\u8BE2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-k8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'K-8'),' \u8BBE\u7F6E\u9875\u9762\u663E\u793A\u7684\u300C\u767B\u5F55\u65F6\u8BF7\u8F93\u5165\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u7801 \u300D\u8981\u6C42\uFF0C\u662F\u4EC0\u4E48\u610F\u601D\uFF1F')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'M'),'Multisig \u7535\u5B50\u94B1\u5305'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-m1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'M-1'),'\u4EC0\u4E48\u662FMultisig \u7535\u5B50\u94B1\u5305\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-m2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'M-2'),'\u521B\u5EFAMultisig \u7535\u5B50\u94B1\u5305\u6536\u8D39\u5417\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-m3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'M-3'),'\u521B\u5EFAMultisig \u7535\u5B50\u94B1\u5305\u6B65\u9AA4\u5982\u4F55\u64CD\u4F5C\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-m4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'M-4'),'Multisig \u7535\u5B50\u94B1\u5305\u53D1\u9001\u4EE3\u5E01\u7684\u6B65\u9AA4\u5982\u4F55\u64CD\u4F5C\uFF1F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-m5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'M-5'),'Multisig\u521B\u5EFA\u65F6\u4E0B\u8F7D\u7684\u5BC6\u94A5\u786E\u8BA4\u540E\uFF0C\u5BC6\u94A5\u663E\u793A\u4E3A6\u4E2A\uFF0C\u54EA\u4E2A\u624D\u662F\u5BC6\u94A5\uFF1F'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-role',id:'accordion',role:'main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-legend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u611F\u8C22\u60A8\u4F7F\u7528TRIAM Network'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5982\u679C\u60A8\u5728\u4F7F\u7528TRIAM\u65F6\u9047\u5230\u4E0D\u660E\u95EE\u9898\uFF0C\u8BF7\u53C2\u9605\u4EE5\u4E0BQ&A\u95EE\u9898\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TRIAM Network\u63D0\u4F9B\u5404\u79CD\u652F\u6301\uFF0C\u8BA9\u60A8\u66F4\u653E\u5FC3\u65B9\u4FBF\u7684\u4F7F\u7528\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-group',id:'accordion'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-a'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A'),'\u521B\u5EFA\u8D26\u6237')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a1',className:'panel-title expand custom-h3-font-size custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-1'),'\u5982\u4F55\u6CE8\u518C\u521B\u5EFA\u8D26\u6237\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6CE8\u518C\u521B\u5EFATRIAM Network\u8D26\u6237\uFF0C\u4EFB\u4F55\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u5747\u53EF\u8FDB\u884C\u6CE8\u518C\u8D26\u6237\u3002\u6CE8\u518C\u8D26\u6237\u53EA\u9700\u8981\u4E00\u4E2A\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u4E0E\u60A8\u8BBE\u5B9A\u7684\u767B\u5F55\u5BC6\u7801\u65E2\u53EF\u6CE8\u518C\u8D26\u6237\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1. \u8BF7\u524D\u5F80\u767B\u5F55\u9875\u9762\u3001\u70B9\u51FB\u6253\u5F00\u521B\u5EFA\u8D26\u6237\u3001\u8F93\u5165\u59D3\u540D\u3001\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u548C\u767B\u5F55\u5BC6\u7801\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2. \u53CC\u51FB\u300C\u4E0B\u4E00\u6B65\u300D\u6309\u94AE\u3001\u63A5\u6536\u81EA\u52A8\u56DE\u590D\u90AE\u4EF6\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3. \u8F93\u5165\u81EA\u52A8\u56DE\u590D\u90AE\u4EF6\u4E2D\u7684\u663E\u793A\u7684\u9A8C\u8BC1\u7801\u5373\u5B8C\u6210\u8D26\u6237\u521B\u5EFA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4. \u8BBE\u7F6E\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u548C\u4EA4\u6613\u5BC6\u7801\u540E\uFF0C\u5373\u53EF\u521B\u5EFA\u7535\u5B50\u94B1\u5305\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-2'),'\u6CE8\u518C\u521B\u5EFA\u8D26\u6237\u6536\u8D39\u5417\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6CE8\u518C\u521B\u5EFA\u8D26\u6237\u662F\u514D\u8D39\u7684\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-3'),'\u5728\u54EA\u91CC\u53EF\u4EE5\u67E5\u770B\u7535\u5B50\u90AE\u4EF6\u8BB0\u8F7D\u7684\u9A8C\u8BC1\u7801\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u521B\u5EFA\u8D26\u6237\u65F6\uFF0C\u60A8\u6CE8\u518C\u7684\u7535\u5B50\u90AE\u7BB1\u4F1A\u63A5\u6536\u5230\u7531TRIAM Network\u53D1\u51FA\u7684\u300C\u90AE\u4EF6\u9A8C\u8BC1\u4EE3\u7801\u300D\u6807\u9898\u7684\u90AE\u4EF6\uFF0C\u8BE5\u90AE\u4EF6\u4E2D\u8BB0\u8F7D\u7740\u9A8C\u8BC1\u4EE3\u7801\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6307\u5B9A\u9875\u9762\u4E2D\u8F93\u5165\u63A5\u6536\u5230\u7684\u9A8C\u8BC1\u4EE3\u7801\uFF0C\u521B\u5EFA\u8D26\u6237\u5373\u53EF\u8FDB\u884C\u4E0B\u4E00\u6B65\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-4'),'\u4E2A\u4EBA\u8EAB\u4EFD\u786E\u8BA4\u3001\u9700\u8981\u51C6\u5907\u4EC0\u4E48\u76F8\u5173\u8D44\u6599\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u521B\u5EFA\u8D26\u6237\uFF0C\u65E0\u9700\u63D0\u4EA4\u4E2A\u4EBA\u8EAB\u4EFD\u786E\u8BA4\u8D44\u6599\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7533\u8BF7Issuer\u65F6\u5FC5\u987B\u63D0\u4EA4\u4E2A\u4EBA\u8EAB\u4EFD\u76F8\u5173\u786E\u8BA4\u8D44\u6599')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-5'),'\u4EFB\u4F55\u56FD\u5BB6\u5747\u4E3A\u5408\u6CD5\u6CE8\u518C\u521B\u5EFA\u5E10\u6237\u5417\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6709\u5173\u6CE8\u518C\u8D26\u6237\u4EE5\u53CA\u8D27\u5E01\u4F7F\u7528\u8005\uFF0C\u8BF7\u5728\u6240\u5728\u56FD\u5BB6\u7684\u30FB\u5730\u533A\u6CD5\u5F8B\u30FB\u6CD5\u5219\u53CA\u6CD5\u89C4\u7684\u9075\u4ECE\u4E0B\u4F7F\u7528')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-6'),'\u90AE\u4EF6\u65E0\u6CD5\u6536\u53D6\uFF0C\u4E5F\u63A5\u6536\u4E0D\u5230\u9A8C\u8BC1\u4EE3\u7801\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672A\u80FD\u6536\u5230\u90AE\u4EF6\u7684\u7528\u6237\u3001\u53EF\u80FD\u5B58\u5728\u4EE5\u4E0B\u51E0\u79CD\u60C5\u51B5\u9020\u6210\u3001\u5F88\u62B1\u6B49\uFF0C\u8BF7\u60A8\u786E\u8BA4\u4EE5\u4E0B\u5185\u5BB9\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u25A0\u7535\u5B50\u90AE\u4EF6\u53EF\u80FD\u81EA\u52A8\u88AB\u5206\u7C7B\u4E8E\u5783\u573E\u90AE\u4EF6\u4E2D\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5783\u573E\u90AE\u4EF6\u7684\u9632\u62A4\u529F\u80FD\u6709\u53EF\u80FD\u5C06TRIAM Network\u7684\u90AE\u4EF6\u8BEF\u8BA4\u4E3A\u5783\u573E\u90AE\u4EF6\u7B49\u60C5\u51B5\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6709\u53EF\u80FD\u88AB\u81EA\u52A8\u5206\u7C7B\u4E8E\u5783\u573E\u6587\u4EF6\u5939\u4E2D\u6216\u5783\u573E\u7BB1\uFF0C\u8BF7\u60A8\u518D\u6B21\u786E\u8BA4\u90AE\u7BB1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u25A0\u4F7F\u7528\u79FB\u52A8\u7535\u8BDD\u30FB\u667A\u80FD\u624B\u673A\u7684\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u7684\u7528\u6237'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6709\u53EF\u80FD\u88AB\u9632\u6253\u6270\u90AE\u4EF6\u6EE4\u5668\u622A\u6B62'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5F00\u542F\u9632\u90AE\u4EF6\u6253\u6270\u529F\u80FD\u7684\u7528\u6237\uFF0C\u8BF7\u53D1\u9001\u90AE\u4EF6\u81F3 [no-reply@triazamnetwork.com]\u91CD\u65B0\u8BBE\u7F6E\u4E3A\u53EF\u63A5\u6536\u90AE\u4EF6\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u25A0\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u9519\u8BEF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4E5F\u6709\u53EF\u80FD\u6CE8\u518C\u586B\u5199\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u65F6\uFF0C\u5B57\u6BCD/\u6570\u5B57/\u6216\u4E0A\u4E0B\u6A2A\u7EBF\u7684\u6709\u9519\u8BEF\u7684\u53EF\u80FD\u6027\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u25A0\u8F93\u5165\u7684\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u9519\u8BEF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7528\u6237\u5728\u6CE8\u518C\u65F6 \u8F93\u5165\u4E86\u9519\u8BEF\u7684\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u7C7B\u4F3C\u7684\u9519\u8BEF\u4E8B\u4F8B\u5F88\u591A\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u25A0\u9632\u75C5\u6BD2\u8F6F\u4EF6\u3001\u5B89\u5168\u8F6F\u4EF6\u7684\u8BBE\u7F6E'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8BBE\u7F6E\u7684\u5B89\u5168\u8F6F\u4EF6\uFF0C\u5C06\u4F1A\u628A\u90AE\u4EF6\u5224\u65AD\u4E3A\u5783\u573E\u90AE\u4EF6\u800C\u88AB\u62D2\u7EDD\u63A5\u6536\u4E5F\u6709\u53EF\u80FD\u88AB\u5220\u9664\u7684\u53EF\u80FD\u6027\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u68C0\u67E5\u76EE\u524D\u4F7F\u7528\u4E2D\u8BBE\u7F6E\u7684\u5B89\u5168\u8F6F\u4EF6\uFF0C\u8BF7\u5C06\u8BBE\u7F6E\u5783\u573E\u90AE\u4EF6\u4E3A\u6392\u9664\u5916\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-7'),'\u672A\u6210\u5E74\u8005\u53EF\u4EE5\u6CE8\u518C\u521B\u5EFA\u8D26\u53F7\u5417?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6709\u5173\u672A\u6210\u5E74\u521B\u5EFA\u8D26\u6237\u4EE5\u53CA\u4EE3\u5E01\u4F7F\u7528\u8005\uFF0C\u4F7F\u7528\u8005\u5FC5\u987B\u9075\u4ECE\u3001\u9075\u5B88\u5F53\u5730\u7684\u6CD5\u5F8B\uFF0C\u6CD5\u89C4\u4E0B\u4F7F\u7528\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-8'),'\u4E00\u4EBA\u53EF\u4EE5\u6CE8\u518C\u591A\u4E2A\u8D26\u53F7\u5417\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6CE8\u518C\u8D26\u6237\u6570\u91CF\u65E0\u9650\u5236\u3002\u53EA\u8981\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u4E0D\u91CD\u590D\u53EF\u521B\u5EFA\u591A\u4E2A\u8D26\u6237\u3002\u4F46\u662F\uFF0C\u521B\u5EFA\u591A \u4E2A\u8D26\u6237\u7684\u7528\u6237\u8005\uFF0C\u8BF7\u52A1\u5FC5\u59A5\u5584\u7BA1\u7406')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a9',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-9'),'\u53EF\u4EE5\u6CE8\u518C\u521B\u5EFA\u516C\u53F8\u8D26\u53F7\u5417\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a9',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u76EE\u524D\u3001\u7535\u5B50\u94B1\u5305\u4E0D\u533A\u5206\u4E0E\u4E2A\u4EBA\u6216\u516C\u53F8\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-a10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-a10',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'A-10'),'\u663E\u793A\u65E0\u6548\u7684\u9A8C\u8BC1\u4EE3\u7801\uFF0C\u65E0\u6CD5\u6CE8\u518C'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-a10',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u81EA\u52A8\u56DE\u590D\u7684\u90AE\u4EF6\u4E2D\u8BB0\u8F7D\u7684\u9A8C\u8BC1\u4EE3\u7801\u6709\u65F6\u95F4\u9650\u5236\u7684\u3001\u63A5\u6536\u90AE\u4EF6\u540E30\u5206\u949F\u5185\u5219\u81EA\u52A8\u5931\u6548\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u91CD\u53D1\u4EE3\u7801\uFF0C\u5FC5\u987B\u5DF2\u63A5\u6536\u7684\u9A8C\u8BC1\u4EE3\u7801\u5931\u6548\u540E\uFF0C\u4E5F\u5C31\u662F30\u5206\u949F\u540E\u624D\u53EF\u4EE5\u91CD\u53D1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5982\u679C\u51FA\u73B0\u5931\u6548\u4EE3\u7801\u548C\u663E\u793A\u9519\u8BEF\uFF0C\u8BF7\u518D\u6B21\u8FD4\u56DE\u5230\u6CE8\u518C\u521B\u5EFA\u8D26\u53F7\u9875\u9762\uFF0C\u91CD\u65B0\u6CE8\u518C\u5E76\u91CD\u53D1\u9001\u9A8C\u8BC1\u7801\u3002'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-b'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B'),'\u5B89\u5168\u6027')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-1'),'\u5FD8\u8BB0\u767B\u5F55\u5BC6\u7801\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5982\u679C\u60A8\u5FD8\u8BB0\u4E86\u5BC6\u7801\uFF0C\u8BF7\u5230\u767B\u5F55\u9875\u9762\u4E2D\u70B9\u51FB\u3010\u5FD8\u8BB0\u5BC6\u7801\uFF0C\u8BF7\u70B9\u51FB\u6B64\u5904\u3011\u8FDB\u884C\u8BBE\u7F6E\u3002\u91CD\u7F6E\u5BC6\u7801\u65F6\u5FC5\u987B\u8F93\u5165\u60A8\u6CE8\u518C\u65F6\u586B\u5199\u7684\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2460 \u3000\u5FD8\u8BB0\u5BC6\u7801\uFF0C\u8BF7\u70B9\u51FB\u6B64\u5904'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2461 \u3000\u8BF7\u8F93\u5165\u6CE8\u518C\u65F6\u7684\u7535\u5B50\u90AE\u7BB1\u5730\u5740 '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2462 \u3000\u91CD\u7F6E\u9A8C\u8BC1\u7801\u5DF2\u53D1\u9001\u5230\u60A8\u7684\u90AE\u7BB1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2463 \u3000\u8BF7\u8F93\u5165\u60A8\u6536\u5230\u7684\u9A8C\u8BC1\u7801'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2464 \u3000\u8BF7\u8F93\u5165\u65B0\u5BC6\u7801'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'red',style:{color:'red'}},'*\u524A\u9664\u3057\u3066\u304F\u3060\u3055\u3044')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-2'),' \u5BC6\u7801\u8F93\u5165\u9519\u8BEF\uFF0C\u8D26\u6237\u88AB\u51BB\u7ED3\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8F93\u5165\u5BC6\u7801\u5728\u4E00\u5B9A\u6B21\u6570\u8303\u56F4\u5185\uFF0C\u8D26\u6237\u767B\u5F55\u65F6\u95F4\u4F1A\u88AB\u9650\u5236\u3002\u5982\u679C\u8FDE\u7EED\u8F93\u5165\u9519\u8BEF\u5BC6\u7801\u6B21 \u6570\u8FC7\u591A\uFF0C\u5B89\u5168\u8F6F\u4EF6\u5C06\u81EA\u52A8\u5F00\u542F\u4FDD\u62A4\uFF0C\u8D26\u53F7\u5C06\u81EA\u52A8\u88AB\u51BB\u7ED3\u3002\u5982\u679C\u8D26\u53F7\u88AB\u51BB\u7ED3\uFF0C\u8BF7\u60A8 \u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u53D1\u9001\u5230\u4EE5\u4E0B\u90AE\u7BB1\u5730\u5740\u4E0E\u6211\u4EEC\u8054\u7CFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TRIAM Support Team'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,'support@triamnetwork.com'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-3'),'\u5982\u4F55\u66F4\u6539\u767B\u5F55\u5BC6\u7801\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u767B\u5F55\u5BC6\u7801\u7684\u66F4\u6539 \u8BF7\u4ECE\u8BBE\u7F6E\u9875\u9762\u70B9\u51FB[\u66F4\u6539\u767B\u5F55\u5BC6\u7801]\u6216\u8005\u4ECE\u767B\u5F55\u9875\u9762\u4E2D\u70B9\u51FB\u3010\u5FD8\u8BB0\u5BC6\u7801\u3011\u540E\u8FDB\u884C\u91CD\u7F6E\u5BC6\u7801\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-4'),'\u8F93\u5165\u540E\u663E\u793A\u300C\u8BE5\u7528\u6237\u4E0D\u5B58\u5728\u300D\u3001\u300C\u5BC6\u7801\u9519\u8BEF\u300D\u65E0\u6CD5\u767B\u5F55\u8D26\u6237\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8F93\u5165\u767B\u5F55\u5BC6\u7801\u65F6\u4F1A\u81EA\u52A8\u533A\u5206\u5927\u5C0F\u5199\u6587\u5B57\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5982\u679C\u65E0\u6CD5\u767B\u5F55\u8D26\u53F7\u65F6\uFF0C\u8BF7\u786E\u8BA4\u5927\u5C0F\u5199\u952E\u76D8\u662F\u5426\u6709\u6253\u5F00\u3001\u786E\u8BA4\u60A8\u7684\u5BC6\u7801\u6587\u5B57\u5B57\u6BCD\u662F\u5426\u8F93\u5165\u6709\u8BEF\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-5'),'\u8BBE\u7F6E\u767B\u5F55\u5BC6\u7801\u5B57\u7B26\u4E3A\u51E0\u4F4D\u6570\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4E3A\u4E86\u60A8\u8D26\u6237\u7684\u5B89\u5168\uFF0CTRIAM Network\u7F51\u7EDC\u9700\u8981\u8BBE\u7F6E\u4E00\u4E2A\u5F3A\u5927\u7684\u5BC6\u7801\u3002\u5BC6\u7801\u8BBE\u7F6E\u5FC5 \u987B6\u4E2A\u6587\u5B57\u4EE5\u4E0A\u3001100\u4E2A\u6587\u5B57\u4EE5\u5185\u5B57\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-6'),'\u4EC0\u4E48\u662F\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u53CC\u91CD\u9A8C\u8BC1\u662F\u6307\uFF0C\u9664\u4E86TRIAM Network\u767B\u5F55\u5BC6\u7801\u4EE5\u5916\uFF0C\u52A0\u4E0A\u4EE3\u7801\u8FDB\u884C\u9A8C\u8BC1\uFF0C\u52A0\u5F3A\u8D26\u53F7\u7684\u5B89\u5168\u6027\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'TRIAM Network\u53EF\u4EE5\u5229\u7528Google\uFF08\u8C37\u6B4C\uFF09\u7684\u9A8C\u8BC1\u5E94\u7528\u7A0B\u5E8F\u8FDB\u884C\u53CC\u91CD\u9A8C\u8BC1\u7684\u8BBE\u7F6E')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-7'),'\u4EC0\u4E48\u662F\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u91CD\u7F6E\u4EE3\u7801\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u91CD\u7F6E\u4EE3\u7801\u662F\u6307\uFF0C\u8BBE\u7F6E\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u66F4\u6539\u624B\u673A\u7AEF\u672B\u7B49\u9700\u8981\u7684\u4EE3\u7801',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u624B\u673A\u4E22\u5931\uFF0C\u6545\u969C\u6216\u673A\u79CD\u66F4\u6362\u65F6\u7B49\u90FD\u5FC5\u987B\u4F7F\u7528\u5230\u53CC\u91CD\u8EAB\u4EFD\u91CD\u7F6E\u4EE3\u7801\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'red'},'\uFF01\uFF01\uFF01\u8BF7\u6CE8\u610F\uFF01\uFF01\uFF01',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u7531\u4E8E\u53CC\u91CD\u8EAB\u4EFD\u91CD\u7F6E\u4EE3\u7801\u5728\u8BBE\u7F6E\u65F6\u4EC5\u663E\u793A\u4E00\u6B21\uFF0C\u65E0\u6CD5\u518D\u6B21\u663E\u793A\u548C\u65E0\u6CD5\u518D\u53D1\u884C\u3002\u8BF7\u52A1\u5FC5\u4FDD\u5B58\u597D\u5207\u52FF\u4E22\u5931\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-8'),'\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u53EF\u4EE5\u89E3\u9664\u5417\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u767B\u5F55\u540E\uFF0C\u901A\u8FC7\u8BBE\u7F6E\u9875\u9762\u83DC\u5355\u53EF\u8FDB\u884C\u91CD\u7F6E\u548C\u66F4\u6539\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u91CD\u7F6E\u5FC5\u987B\u8BBE\u7F6E\u65F6\u53D1\u884C\u7684\u91CD\u7F6E\u4EE3\u7801\u3002\u4ECE\u5B89\u5168\u89D2\u5EA6\u51FA\u53D1\uFF0CTRIAM Network\u4E2D\uFF0C\u4F7F\u7528\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u670D\u52A1\u65F6\u5FC5\u5907\u9879\u76EE\u3002\u53EF\u8FDB\u884C\u66F4\u6539\u8BBE\u7F6E\uFF0C\u4F46\u5982\u679C\u4E00\u65E6\u89E3\u9664\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1TRIAM Network\u5185\u7684\u5404\u79CD\u529F\u80FD\u5C06\u4E0D\u80FD\u4F7F\u7528\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b9',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-9'),'\u5FD8\u8BB0\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u7684\u91CD\u7F6E\u4EE3\u7801\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b9',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u4EE3\u7801\u5728\u8BBE\u7F6E\u65F6\u4EC5\u663E\u793A\u4E00\u6B21\uFF0C\u4E00\u65E6\u4E22\u5931\uFF0C\u65E0\u6CD5\u518D\u663E\u793A\u4E5F\u65E0\u6CD5\u518D\u6B21\u53D1\u884C\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b10',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-10'),'\u6CA1\u6709\u667A\u80FD\u624B\u673A\uFF0C\u53EF\u4EE5\u8BBE\u7F6E\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u5417\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b10',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TRIAM Network\u7684\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u4F7F\u7528\u7531Google(\u8C37\u6B4C\uFF09\u63D0\u4F9B\u7684\u670D\u52A1\u3002\u6709WEB\u7248\u672C\uFF0CIOS\u7248\u672C\uFF0C\u5B89\u5353\u7248\u672C\u3002\u8BF7\u6839\u636E\u60A8\u7684\u8BBE\u5907\u8FDB\u884C\u9009\u62E9\u7248\u672C\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6709\u5173Google\uFF08\u8C37\u6B4C\uFF09\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u8BF7\u53C2\u9605\u4EE5\u4E0B\u94FE\u63A5',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://www.google.com/landing/2step/'},'https://www.google.com/landing/2step/'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b11',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-11'),'\u4EC0\u4E48\u662F\u4EA4\u6613\u5BC6\u7801\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b11',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4EA4\u6613\u5BC6\u7801\u662F\u53D1\u9001\u4EE3\u5E01\u7B49\u5404\u79CD\u5B9E\u65F6\u4EA4\u6613\u65F6\u8F93\u5165\u7684\u5BC6\u7801\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30FB\u5FC5\u987B\u542B1\u4E2A\u6570\u5B57\u4EE5\u4E0A \u30FB\u5FC5\u987B\u542B1\u4E2A\u7B26\u53F7\u4EE5\u4E0A \u30FB\u5FC5\u987B\u542B1\u4E2A\u5C0F\u5B57\u6BCD\u4EE5\u4E0A \u30FB\u5FC5\u987B\u542B1\u4E2A\u5927\u5B57\u6BCD\u4EE5\u4E0A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'red'},'\uFF01\uFF01\uFF01\u8BF7\u6CE8\u610F\uFF01\uFF01\uFF01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4EA4\u6613\u5BC6\u7801\u5FD8\u8BB0\u6216\u4E22\u5931\u867D\u7136\u53EF\u4EE5\u8FDB\u884C\u91CD\u7F6E\u5BC6\u7801\uFF0C\u5982\u679C\u4EA4\u6613\u5BC6\u7801\u4E00\u65E6\u91CD\u7F6E\u64CD\u4F5C\uFF0C\u5B89\u5168\u7CFB\u7EDF\u5C06\u81EA\u52A8\u5F00\u542F\uFF0C\u8D26\u6237\u5185\u7684\u6240\u6709\u7684\u7535\u5B50\u94B1\u5305\u5C06\u81EA\u52A8\u5C01\u9501\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u89E3\u9664\u7535\u5B50\u94B1\u5305\u5C01\u9501\uFF0C\u5FC5\u987B\u4F7F\u7528\u5404\u7535\u5B50\u94B1\u5305\u7684\u5BC6\u94A5\u624D\u80FD\u89E3\u9501\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5728\u91CD\u7F6E\u4EA4\u6613\u5BC6\u7801\u524D\uFF0C\u52A1\u5FC5\u68C0\u67E5\u662F\u5426\u6301\u6709\u5404\u7535\u5B50\u94B1\u5305\u7684\u5BC6\u94A5\u540E\u518D\u8FDB\u884C\u91CD\u7F6E\u4EA4\u6613\u5BC6\u7801\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5982\u679C\u6CA1\u6709\u5BC6\u94A5\uFF0C\u65E0\u6CD5\u89E3\u9501\u7684\u60C5\u51B5\uFF0C\u7535\u5B50\u94B1\u5305\u5C06\u6C38\u8FDC\u88AB\u51BB\u7ED3\uFF0C\u65E0\u6CD5\u4F7F\u7528\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://triamnetwork.com/faq#role-d12'},'\u89E3\u9501\u7535\u5B50\u94B1\u5305\u65B9\u6CD5\u8BF7\u70B9\u51FB\u2192'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b12',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-12'),'\u5982\u679C\u66F4\u6539\u4EA4\u6613\u5BC6\u7801\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b12',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4ECE\u8BBE\u7F6E\u9875\u9762\u70B9\u51FB [\u66F4\u6539\u4EA4\u6613\u5BC6\u7801] \u53EF\u8FDB\u884C\u66F4\u6539\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u9996\u5148\uFF0C\u8F93\u5165\u60A8\u5F53\u524D\u4F7F\u7528\u7684\u4EA4\u6613\u5BC6\u7801\uFF0C\u518D\u8F93\u5165\u60A8\u60F3\u66F4\u6539\u7684\u65B0\u5BC6\u7801\u540E\u70B9\u51FB\u66F4\u6539\u6309\u952E\u5373\u53EF\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u786E\u8BA4\u4EE5\u4E0B\u89C4\u5219\u540E\uFF0C\u4F7F\u75286\u4F4D\u6570\u4EE5\u4E0A\u7684\u82F1\u6587\u5927\u5C0F\u5199\u5B57\u6BCD\u548C\u7B26\u53F7\u8FDB\u884C\u8BBE\u7F6E\u4EA4\u6613\u5BC6\u7801 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u30FB\u5FC5\u987B\u542B1\u4E2A\u6570\u5B57\u4EE5\u4E0A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u5FC5\u987B\u542B1\u4E2A\u7B26\u53F7\u4EE5\u4E0A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u5FC5\u987B\u542B1\u4E2A\u5C0F\u5B57\u6BCD\u4EE5\u4E0A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u5FC5\u987B\u542B1\u4E2A\u5927\u5B57\u6BCD\u4EE5\u4E0A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b13',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-13'),'\u5FD8\u8BB0\u4EA4\u6613\u5BC6\u7801\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b13',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4EA4\u6613\u5BC6\u7801\u5FD8\u8BB0\u6216\u4E22\u5931\u867D\u7136\u53EF\u4EE5\u8FDB\u884C\u91CD\u7F6E\u5BC6\u7801\uFF0C\u5982\u679C\u4EA4\u6613\u5BC6\u7801\u4E00\u65E6\u91CD\u7F6E\u64CD\u4F5C\uFF0C\u5B89\u5168\u7CFB\u7EDF\u5C06\u81EA\u52A8\u5F00\u542F\uFF0C\u8D26\u6237\u5185\u7684\u6240\u6709\u7684\u7535\u5B50\u94B1\u5305\u5C06\u81EA\u52A8\u5C01\u9501\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u89E3\u9664\u7535\u5B50\u94B1\u5305\u5C01\u9501\uFF0C\u5FC5\u987B\u4F7F\u7528\u5404\u7535\u5B50\u94B1\u5305\u7684\u5BC6\u94A5\u624D\u80FD\u89E3\u9501\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5728\u91CD\u7F6E\u4EA4\u6613\u5BC6\u7801\u524D\uFF0C\u52A1\u5FC5\u68C0\u67E5\u662F\u5426\u6301\u6709\u5404\u7535\u5B50\u94B1\u5305\u7684\u5BC6\u94A5\u540E\u518D\u8FDB\u884C\u91CD\u7F6E\u4EA4\u6613\u5BC6\u7801\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5982\u679C\u6CA1\u6709\u5BC6\u94A5\uFF0C\u65E0\u6CD5\u89E3\u9501\u7684\u60C5\u51B5\uFF0C\u7535\u5B50\u94B1\u5305\u5C06\u6C38\u8FDC\u88AB\u51BB\u7ED3\uFF0C\u65E0\u6CD5\u4F7F\u7528\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4EA4\u6613\u5BC6\u7801\u91CD\u7F6E\u987A\u5E8F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u2460\u70B9\u51FB\u8BBE\u7F6E\u9875\u9762\u4E2D\u7684[\u91CD\u7F6E\u4EA4\u6613\u5BC6\u7801]\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u2461\u8F93\u5165\u66F4\u6539\u7684\u65B0\u5BC6\u7801\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u203B\u786E\u8BA4\u4EE5\u4E0B\u89C4\u5219\u540E\uFF0C\u4F7F\u75286\u4F4D\u6570\u4EE5\u4E0A\u7684\u82F1\u6587\u5927\u5C0F\u5199\u5B57\u6BCD\u548C\u7B26\u53F7\u8FDB\u884C\u8BBE\u7F6E\u4EA4\u6613\u5BC6\u7801\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u5FC5\u987B\u542B1\u4E2A\u6570\u5B57\u4EE5\u4E0A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u5FC5\u987B\u542B1\u4E2A\u7B26\u53F7\u4EE5\u4E0A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u5FC5\u987B\u542B1\u4E2A\u5C0F\u5B57\u6BCD\u4EE5\u4E0A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u5FC5\u987B\u542B1\u4E2A\u5927\u5B57\u6BCD\u4EE5\u4E0A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2462\u4E0B\u4E00\u6B65\uFF0C\u8BF7\u9009\u62E9\u8D26\u6237\u4E2D\u5176\u4E2D\u4E00\u4E2A\u7535\u5B50\u94B1\u5305\uFF0C\u8F93\u5165\u7535\u5B50\u94B1\u5305\u7684\u5BC6\u7801\u540E\u70B9\u51FB[\u91CD\u7F6E\u4EA4\u6613\u5BC6\u7801] \u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u2463\u4EA4\u6613\u5BC6\u7801\u4E00\u65E6\u91CD\u7F6E\uFF0C\u5C06\u5C01\u9501\u60A8\u8D26\u6237\u4E2D\u6240\u6709\u7684\u7535\u5B50\u94B1\u5305\uFF0C\u60A8\u53EF\u4EE5\u5728\u6700\u540E\u4E00\u6B65\u4E2D\u89E3\u9664\u5404\u7535\u5B50\u94B1\u5305\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8BF7\u9009\u62E9\u987B\u89E3\u9664\u7684\u7535\u5B50\u94B1\u5305\u540E\u8F93\u5165\u7535\u5B50\u94B1\u5305\u5BC6\u94A5\u540E\u70B9\u51FB [\u89E3\u9664] \u6309\u952E\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6700\u540E\u70B9\u51FB[\u5B8C\u6210] \u6309\u952E\u7ED3\u675F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u203B\u89E3\u9664\u7535\u5B50\u94B1\u5305\u6700\u540E\u6216\u8FC7\u540E\u4E5F\u53EF\u8FDB\u884C\u89E3\u9664\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://triamnetwork.com/faq#role-d12'},'\u89E3\u9664\u7535\u5B50\u94B1\u5305\u5C01\u9501\u8BF7\u70B9\u51FB\u2192'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-b14'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-b14',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'B-14'),'\u8BBE\u7F6E\u4EA4\u6613\u5BC6\u7801\u5B57\u7B26\u4E3A\u51E0\u4F4D\u6570\u4EE5\u4E0A\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-b14',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u203B\u786E\u8BA4\u4EE5\u4E0B\u89C4\u5219\u540E\uFF0C\u4F7F\u75286\u4F4D\u6570\u4EE5\u4E0A\u7684\u82F1\u6587\u5927\u5C0F\u5199\u5B57\u6BCD\u548C\u7B26\u53F7\u8FDB\u884C\u8BBE\u7F6E\u4EA4\u6613\u5BC6\u7801\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u5FC5\u987B\u542B1\u4E2A\u6570\u5B57\u4EE5\u4E0A ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u5FC5\u987B\u542B1\u4E2A\u7B26\u53F7\u4EE5\u4E0A ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u5FC5\u987B\u542B1\u4E2A\u5C0F\u5B57\u6BCD\u4EE5\u4E0A ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u5FC5\u987B\u542B1\u4E2A\u5927\u5B57\u6BCD\u4EE5\u4E0A'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-c'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'C'),'\u66F4\u6539\u6CE8\u518C\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-c1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-c1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'C-1'),'\u5982\u4F55\u66F4\u6539\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-c1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7531\u4E8E\u60A8\u6CE8\u518CTRIAM Network\u65F6\u7535\u5B50\u90AE\u7BB1\u4F5C\u4E3A\u767B\u5F55ID\u4F7F\u7528\uFF0C\u56E0\u6B64\u65E0\u6CD5\u66F4\u6539\u3002\u5982\u679C\u60A8 \u6CE8\u518C\u7684\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u65E0\u6CD5\u4F7F\u7528\uFF0C\u8BF7\u60A8\u8054\u7CFB\u6211\u4EEC\u7684\u5BA2\u670D\u5E2E\u52A9\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,'support@triamnetwork.com'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-c2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-c2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'C-2'),'\u66F4\u6539\u5DF2\u6CE8\u518C\u540D\u79F0\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-c2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5E0C\u671B\u66F4\u6539\u6CE8\u518C\u4FE1\u606F\u7684\u7528\u6237\u8BF7\u53D1\u90AE\u4EF6\u4E0E\u6211\u4EEC\u7684\u5BA2\u670D\u5E2E\u52A9\u8054\u7CFB\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-c3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-c3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'C-3'),'\u5982\u4F55\u67E5\u770B\u81EA\u5DF1\u7684\u6CE8\u518C\u4FE1\u606F\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-c3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5F88\u62B1\u6B49\u7ED9\u60A8\u5E26\u6765\u4E0D\u4FBF\uFF0C\u8BF7\u53D1\u9001\u90AE\u4EF6\u81F3\u5BA2\u6237\u5E2E\u52A9\u8054\u7CFB\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-c4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-c4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'C-4'),'C-4 \u5982\u4F55\u7F6E\u6362\u56FD\u5BB6\u8BED\u8A00\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-c4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u60A8\u53EF\u4EE5\u901A\u8FC7\u5C4F\u5E55\u4E0A\u53F3\u4E0A\u89D2\u663E\u793A\u7684\u56FD\u65D7\u6807\u5FD7\u8FDB\u884C\u66F4\u6539\u56FD\u5BB6\u8BED\u8A00\u3002'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-d'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D'),'\u521B\u5EFA\u7535\u5B50\u94B1\u5305')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-1'),'\u5982\u4F55\u521B\u5EFA\u65B0\u7684\u7535\u5B50\u94B1\u5305\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4ECE\u6211\u7684\u7535\u5B50\u94B1\u5305\u9875\u9762\u70B9\u51FB\u300C\u521B\u5EFA\u65B0\u94B1\u5305\u300D\u8FDB\u884C\u64CD\u4F5C\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u7535\u5B50\u94B1\u5305\u540D\u79F0\u53EF\u968F\u610F\u8BBE\u7F6E\u548C\u66F4\u6539\u3002\u8FD9\u4E2A\u65F6\u5019\u4F1A\u663E\u793A\u5BC6\u94A5\uFF0C\u8BF7\u52A1\u5FC5\u59A5\u5584\u4FDD\u7BA1\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u521B\u5EFA\u7535\u5B50\u94B1\u5305\uFF0C\u9700\u8981\u4ECE\u5176\u5B83\u7684\u7535\u5B50\u94B1\u5305\u63D0\u4F9B\u5FC5\u8981\u7684\u8D44\u91D1\u3002\u8BF7\u5728\u300C\u53D1\u9001RIA\u5E01\u300D \u524D\u9762\u2714\uFF0C\u540C\u65F6\u8BF7\u6307\u5B9A\u63D0\u4F9B\u521D\u671F\u8D44\u91D1\u7684\u7535\u5B50\u94B1\u5305\u3002\u63A5\u7740\u8BF7\u8F93\u5165\u521D\u671F\u8D44\u91D1\u7684\u6570\u91CF\uFF0C \u521D\u671F\u8D44\u91D1\u5FC5\u987B20RIA\u5E01\u4EE5\u4E0A\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6240\u6709\u9879\u76EE\u8F93\u5165\u540E\u8BF7\u70B9\u51FB\u300C\u521B\u5EFA\u300D\u540E\uFF0C\u7CFB\u7EDF\u5C06\u63D0\u9192\u8981\u6C42\u8F93\u5165\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u4EE3\u7801\uFF0C\u8BF7 \u60A8\u8F93\u5165Google\uFF08\u8C37\u6B4C\uFF09\u751F\u6210\u7684\u52A8\u6001\u9A8C\u8BC1\u4EE3\u7801\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u25A0\u521D\u6B21\u521B\u5EFA\u7535\u5B50\u94B1\u5305\u7684\u987A\u5E8F',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u8D26\u6237\u5185\u7B2C\u4E00\u6B21\u521B\u5EFA\u7535\u5B50\u94B1\u5305\u7684\uFF0C\u5FC5\u987B\u4ECE\u5176\u5B83\u7684\u7535\u5B50\u94B1\u5305\u63D0\u4F9B\u521D\u671F\u8D44\u91D1\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'1) \u70B9\u51FB\u6211\u7684\u7535\u5B50\u94B1\u5305\u9875\u9762\u4E2D\u7684\u300C\u521B\u5EFA\u7535\u5B50\u94B1\u5305\u300D',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'2) \u968F\u610F\u8F93\u5165\u7535\u5B50\u94B1\u5305\u540D\u79F0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'3) \u4FDD\u5B58\u5BC6\u94A5',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4) \u70B9\u51FB\u300C\u4FDD\u5B58\u300D',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u7535\u5B50\u94B1\u5305\u4FDD\u5B58\u540E\uFF0C\u8BF7\u6C42\u63D0\u4F9B\u521D\u671F\u8D44\u91D1\u7684\u7528\u6237\u8005\u5BF9\u7535\u5B50\u94B1\u5305\u8FDB\u884C\u6FC0\u6D3B\u64CD\u4F5C\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u64CD\u4F5C\u6FC0\u6D3B\u7684\u7528\u6237\uFF0C\u4ECE\u81EA\u5DF1\u8D26\u6237\u4E2D\u3001\u6211\u7684\u7535\u5B50\u94B1\u5305\u9875\u9762\u70B9\u51FB\u300C\u6FC0\u6D3B\u7535\u5B50\u94B1\u5305\u300D\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u8F93\u5165\u9700\u8981\u6FC0\u6D3B\u7684\u7535\u5B50\u94B1\u5305\u5730\u5740\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6B64\u65F6\uFF0C\u4E0D\u7528\u9009\u4E2D\u6253\u52FE\u300C\u6FC0\u6D3B\u7535\u5B50\u94B1\u5305\u300D\u590D\u9009\u6846\u7EE7\u7EED\u6267\u884C\u64CD\u4F5C\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u9009\u62E9\u63D0\u4F9B\u521D\u671F\u8D44\u91D1\u7684\u7535\u5B50\u94B1\u5305\uFF0C\u8F93\u5165\u7531Google\uFF08\u8C37\u6B4C\uFF09\u663E\u793A\u7684\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u4EE3\u7801\u5373\u5B8C\u6210\uFF01',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'red'},'!!! \u8BF7\u6CE8\u610F !!!',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u521B\u5EFA\u7535\u5B50\u94B1\u5305\u65F6\u6240\u663E\u793A\u7684\u5BC6\u94A5\u5341\u5206\u91CD\u8981\uFF0C\u5728\u66F4\u6539\u5BC6\u7801\u6216\u6062\u590D\u8D26\u6237\u65F6\u5FC5\u987B\u7528\u5230\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5BC6\u94A5\u4EC5\u5728\u521B\u5EFA\u7535\u5B50\u94B1\u5305\u65F6\u663E\u793A\u4E00\u6B21\uFF0C\u8BF7\u52A1\u5FC5\u4E66\u5199\u6216\u5370\u5237\u6216\u62CD\u7167\u7684\u65B9\u5F0F\u6216\u5F53\u524D\u79BB\u7EBF\u72B6\u6001\u4FDD\u5B58\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6BCF\u4E2A\u7535\u5B50\u94B1\u5305\u53D1\u884C\u7684\u5BC6\u94A5\u5404\u4E0D\u76F8\u540C\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5982\u679C\u5BC6\u94A5\u4E00\u65E6\u88AB\u6CC4\u9732\u7B2C\u4E09\u8005\uFF0C\u7535\u5B50\u94B1\u5305\u5B58\u5728\u88AB\u76D7\u53D6\u7684\u53EF\u80FD\uFF0C\u8BF7\u52A1\u5FC5\u4FDD\u5B58\u597D\u5BC6\u94A5\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-2'),'\u4EC0\u4E48\u662F\u7535\u5B50\u94B1\u5305\u5730\u5740\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7535\u5B50\u94B1\u5305\u5730\u5740\u6307\u7684\u662F\uFF0C\u5728TRIAM Network\u4E2D\u4F7F\u7528\u7684\u8D27\u5E01\u6216\u4EE3\u5E01\u53D1\u9001\u63A5\u6536\u9700\u7528\u5230\uFF0C \u7C7B\u4F3C\u4E8E\u94F6\u884C\u7684\u8D26\u53F7\u4E00\u6837\u7684\u3002\u7535\u5B50\u94B1\u5305\u5730\u5740\u662F\u753127\uFF5E34\u4E2A\u82F1\u6587\u5B57\u6BCD\uFF0C\u6570\u5B57\u7EC4\u7EC7\u800C \u6210\u7684\u3002\u6BCF\u521B\u5EFA\u4E00\u4E2A\u7535\u5B50\u94B1\u5305\u4EC5\u53D1\u884C\u4E00\u4E2A\u7535\u5B50\u94B1\u5305\u5730\u5740\u3002\u5F53\u60A8\u9700\u8981\u63A5\u6536\u8D27\u5E01\u6216\u4EE3\u5E01 \uFF0C\u53D1\u9001\u8D27\u5E01\u6216\u4EE3\u5E01\uFF0C\u6216\u8005\u53D1\u884C\u4EE3\u5E01\u65F6\u5C31\u5FC5\u987B\u7528\u5230\u7535\u5B50\u94B1\u5305\u5730\u5740\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u7535\u5B50\u94B1\u5305\u5730\u5740\u7528\u4E8E\u901A\u77E5\u4ED6\u4EBA\u53D1\u9001\u8D27\u5E01\u6216\u4EE3\u5E01\u7684\u5730\u5740\uFF0C\u7B2C\u4E09\u65B9\u77E5\u6653\u4E5F\u4E0D\u4F1A\u6CC4\u9732\u4E2A\u4EBA\u4FE1\u606F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5DF2\u521B\u5EFA\u7684\u7535\u5B50\u94B1\u5305\u5730\u5740\u65E0\u6CD5\u66F4\u6539\u3002\u5DF2\u521B\u5EFA\u7684\u7535\u5B50\u94B1\u5305\u5730\u5740\u53EF\u4ECE\u300C\u6211\u7684\u7535\u5B50\u94B1\u5305\u300D\u9875\u9762\u8FDB\u884C\u786E\u8BA4\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-3'),'\u4EC0\u4E48\u662F\u5BC6\u94A5\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5BC6\u94A5\u662F\u6BCF\u4E2A\u521B\u5EFA\u7684\u94B1\u5305\u53D1\u884C\u7684\u4EE3\u7801\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5BC6\u94A5\u662F\u7535\u5B50\u94B1\u5305\u8FDB\u884C\u89E3\u9501\uFF0C\u4FEE\u590D\u548C\u5BFC\u5165\u7528\u7684\u91CD\u8981\u4EE3\u7801\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6CC4\u9732\u5BC6\u94A5\u5C31\u7B49\u4E8E\u6CC4\u9732\u94F6\u884C\u5361\u7684\u5BC6\u7801\u4E00\u6837\u3002\u4E00\u65E6\u4E22\u5931\u6216\u6CC4\u9732\u5BC6\u94A5\uFF0C\u5219\u65E0\u6CD5\u518D\u8FDB\u884C\u6062 \u590D\u7535\u5B50\u94B1\u5305\u64CD\u4F5C\uFF0C\u6709\u95EE\u9898\u4E5F\u65E0\u6CD5\u5904\u7406\u7684\u98CE\u9669\u3002\u8BF7\u52A1\u5FC5\u4FDD\u5B58\u597D\u5BC6\u94A5\uFF0C\u5BC6\u94A5\u53EF\u4EE4\u51FA\u73B0 \u95EE\u9898\u7684\u7535\u5B50\u94B1\u5305\u8FDB\u884C\u4FEE\u590D\u548C\u5904\u7406\u7535\u5B50\u94B1\u5305\u7684\u5404\u79CD\u95EE\u9898\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5BC6\u94A5\u4EC5\u5728\u521B\u5EFA\u7535\u5B50\u94B1\u5305\u65F6\u663E\u793A\u4E00\u6B21\uFF0C\u7531\u4E8E\u65E0\u6CD5\u518D\u6B21\u663E\u793A\u548C\u518D\u53D1\u884C\uFF0C\u8BF7\u60A8\u52A1\u5FC5\u8981\u4FDD\u5B58\u597D\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-4'),'\u4EC0\u4E48\u662FGoogle\uFF08\u8C37\u6B4C\uFF09\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u662F\u6307\u9664\u4E86\u9700\u8981\u8F93\u5165\u767B\u5F55\u5BC6\u7801\u5916\uFF0C\u8FD8\u987B\u8F93\u5165Google\u624B\u673A\u7AEF\u672B\u663E\u793A\u7684\u4EE3\u7801\u7684\u4E00\u79CD\u5B89\u5168\u6D41\u7A0B\u3002\u4E3A\u4E86\u767B\u5F55\u548C\u6267\u884C\u4EA4\u6613\u589E\u52A0\u6709\u5FC5\u8981\u7684\u4FE1\u606F\uFF0C\u5373\u4F7F\u906D\u5230\u7F51\u7EDC\u66B4\u529B\u653B\u51FB\u800C\u88AB\u76D7\u53D6\u5BC6\u7801\u4E5F\u65E0\u6CD5\u76F4\u63A5\u767B\u5F55\u6216\u76F4\u63A5\u4EA4\u6613\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://www.google.co.jp/intl/ja/landing/2step/'},'https://www.google.co.jp/intl/ja/landing/2step/'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-5'),'\u5982\u4F55\u66F4\u6539\u7535\u5B50\u94B1\u5305\u5730\u5740\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5DF2\u521B\u5EFA\u7684\u7535\u5B50\u94B1\u5305\u5730\u5740\u65E0\u6CD5\u8FDB\u884C\u66F4\u6539\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-6'),'\u5982\u4F55\u66F4\u6539\u7535\u5B50\u94B1\u5305\u540D\u79F0\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4ECE\u300C\u6211\u7684\u7535\u5B50\u94B1\u5305\u300D\u9875\u9762\uFF0C\u9009\u62E9\u9700\u8981\u66F4\u6539\u7684\u540D\u79F0\u7684\u7535\u5B50\u94B1\u5305\uFF0C\u7535\u5B50\u94B1\u5305\u66F4\u6539\u6B21\u6570 \u65E0\u9650\u5236\uFF0C\u8BF7\u70B9\u51FB\u7535\u5B50\u94B1\u5305\u540D\u79F0\u53F3\u8FB9\u663E\u793A\u7684\u94C5\u7B14\u7B26\u53F7\u8FDB\u884C\u66F4\u6539\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6B64\u5916\uFF0C\u7535\u5B50\u94B1\u5305\u540D\u79F0\u529F\u80FD\u4E3A\u4E86\u81EA\u5DF1\u66F4\u65B9\u4FBF\u7BA1\u7406\uFF0C\u53D1\u9001\u6216\u63A5\u6536\u7684\u4E1A\u52A1\u65E0\u9700\u544A\u77E5\u5BF9\u65B9 \u7535\u5B50\u94B1\u5305\u540D\u79F0\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-7'),'\u521B\u5EFA\u7535\u5B50\u94B1\u5305\u9700\u8981\u8D39\u7528\u5417\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u521B\u5EFA\u7535\u5B50\u94B1\u5305\u81EA\u8EAB\u662F\u514D\u8D39\u7684\u3001\u4F7F\u7528\u7535\u5B50\u94B1\u5305\u8FDB\u884C\uFF08\u4FDD\u5B58RIA\u5E01\uFF0C\u53D1\u9001/\u63A5\u6536\u4EE3\u5E01\u3001\u8D27\u5E01\uFF09\u7B49\u670D\u52A1\u3002\u5FC5\u987B\u6FC0\u6D3B\u7535\u5B50\u94B1\u5305\uFF0C\u6FC0\u6D3B\u7535\u5B50\u94B1 \u5305\u5FC5\u987B\u6301\u670920RIA\u4EE5\u4E0A\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u8BF7\u6CE8\u610F\u7528\u4E8E\u6FC0\u6D3B\u7535\u5B50\u94B1\u5305\u768420RIA\u5E01\u4E3A\u7535\u5B50\u94B1\u5305\u6700\u4F4E\u6570\u91CF\uFF0C\u65E0\u6CD5\u632A\u52A8\u4E5F\u65E0\u6CD5\u4F7F\u7528\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-8'),'\u53EF\u4EE5\u521B\u5EFA\u591A\u4E2A\u7535\u5B50\u94B1\u5305\u5417\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u521B\u5EFA\u7535\u5B50\u94B1\u5305\u6570\u91CF\u65E0\u9650\u5236\uFF0C\u4F46\u6BCF\u4E2A\u7535\u5B50\u94B1\u5305\u5FC5\u987B\u6301\u670920RIA\u5E01\u4EE5\u4E0A\u624D\u80FD\u4F7F\u7528\u7535\u5B50 \u94B1\u5305\u529F\u80FD\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d9',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-9'),'\u4E00\u4E2A\u7535\u5B50\u94B1\u5305\u53EF\u6301\u6709\u591A\u5C11\u79CD\u4EE3\u5E01\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d9',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4F7F\u7528\u4EE3\u5E01\u64CD\u4F5C\u524D\u5FC5\u987B\u5148TRUST\u4EE3\u5E01\u3002\u7535\u5B50\u94B1\u5305\u5BF9\u4FDD\u5B58\u8D27\u5E01\u3001\u4EE3\u5E01\u7684\u79CD\u7C7B\u548C\u8D27\u5E01\u3001\u4EE3\u5E01\u7684\u6570\u91CF\u5747\u65E0\u9650\u5236\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d10',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-10'),'\u7535\u5B50\u94B1\u5305\u7684\u9875\u9762\u663E\u793A\u300C\uFF0B\u300D\u7B26\u53F7\u662F\u4EC0\u4E48\u610F\u601D\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d10',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u70B9\u51FB\u300C+\u300D\u7B26\u53F7\uFF0C\u60A8\u53EF\u4EE5\u8FDB\u884CTRUST\u4EE3\u5E01\uFF0C\u4E5F\u53EF\u4EE5\u901A\u8FC7\u641C\u7D22\u8FDB\u884CTRUST\u5176\u5B83\u4EE3\u5E01\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d11',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-11'),'\u300C\u7535\u5B50\u94B1\u5305\u663E\u793A\u88AB\u5C01\u9501\u300D\u5982\u4F55\u64CD\u4F5C\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d11',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5BC6\u7801\u4E00\u65E6\u66F4\u6539\u3002\u5404\u7535\u5B50\u94B1\u5305\u5B89\u5168\u529F\u80FD\u5C06\u81EA\u52A8\u5F00\u542F\uFF0C\u5C01\u9501\u6240\u6709\u7535\u5B50\u94B1\u5305\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u89E3\u9664\u7535\u5B50\u94B1\u5305\u5C01\u9501\uFF0C\u9700\u8981\u4F7F\u7528\u5404\u7535\u5B50\u94B1\u5305\u7684\u5BC6\u94A5\u8FDB\u884C\u89E3\u9501\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4ECE\u300C\u6211\u7684\u7535\u5B50\u94B1\u5305\u300D\u9875\u9762\uFF0C\u70B9\u51FB\u7535\u5B50\u94B1\u5305\u5DE6\u8FB9\u663E\u793A\u7684\u300C\u5C0F\u9501\u5934\u300D\u7B26\u53F7',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u8BF7\u5728\u6240\u663E\u793A\u9875\u9762\u8F93\u5165\u6B63\u786E\u7684\u5BC6\u94A5\uFF0C\u7535\u5B50\u94B1\u5305\u5C06\u81EA\u52A8\u89E3\u9501\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6BCF\u4E2A\u7535\u5B50\u94B1\u5305\u6301\u6709\u7684\u5BC6\u94A5\u5404\u4E0D\u76F8\u540C\uFF0C\u5FC5\u987B\u8F93\u5165\u76F8\u5BF9\u5E94\u7684\u5BC6\u94A5\u8FDB\u884C\u89E3\u9501\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d12',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-12'),'\u521B\u5EFA\u7535\u5B50\u94B1\u5305\u65F6\u5DF2\u6309\u300C\u4FDD\u5B58\u300D\uFF0C\u5982\u4F55\u8BA9\u7535\u5B50\u94B1\u5305\u751F\u6548\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d12',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7535\u5B50\u94B1\u5305\u521B\u5EFA\u540E\u76F4\u63A5\u4FDD\u5B58\uFF0C\u8BE5\u7535\u5B50\u94B1\u5305\u4E3A\u672A\u6FC0\u6D3B\u72B6\u6001\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u9700\u8981\u4F7F\u7528\u5DF2\u6FC0\u6D3B\u7684\u7535\u5B50\u94B1\u5305\u53D1\u900120RIA\u5E01\u4EE5\u4E0A\u8FDB\u884C\u6FC0\u6D3B\u5F85\u6FC0\u6D3B\u7684\u7535\u5B50\u94B1\u5305\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4ECE\u6211\u7684\u7535\u5B50\u94B1\u5305\u9875\u9762\u4E2D\u3001\u70B9\u51FB\u7535\u5B50\u94B1\u5305\u5DE6\u8FB9\u663E\u793A\u7684\u300C\uFF01\u300D\u7B26\u53F7\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u9009\u62E9\u63D0\u4F9B\u521D\u671F\u7535\u5B50\u94B1\u5305\u3001\u6FC0\u6D3B\u7535\u5B50\u94B1\u5305\u9700\u898120RIA\u5E01\u4EE5\u4E0A\u3001\u8F93\u5165\u521D\u671F\u6570\u91CF\u3002\u6700\u540E\u8F93\u5165Google\u663E\u793A\u7684\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u4EE3\u7801\uFF0C\u7535\u5B50\u94B1\u5305\u5C06\u6FC0\u6D3B\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4ECE\u5176\u5B83\u7684\u8D26\u6237\u7535\u5B50\u94B1\u5305\u4E2D\u63D0\u4F9B\u521D\u671F\u8D44\u91D1\u7684\u7528\u6237\uFF0C\u8BF7\u63D0\u4F9B\u521D\u671F\u8D44\u91D1\u7684\u8D26\u6237\u6301\u6709\u8005\u8FDB\u884C\u6FC0\u6D3B\u7535\u5B50\u94B1\u5305 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6211\u7684\u7535\u5B50\u94B1\u5305\u9875\u9762\u70B9\u51FB\u300C\u6FC0\u6D3B\u7535\u5B50\u94B1\u5305\u300D',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u8F93\u5165\u60F3\u8981\u6FC0\u6D3B\u7684\u7535\u5B50\u94B1\u5305\u5730\u5740\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u8FD9\u4E2A\u65F6\u5019\uFF0C\u300C\u6FC0\u6D3B\u7535\u5B50\u94B1\u5305\u300D\u65C1\u8FB9\u7684\u65B9\u6846\u65E0\u9700\u6253\u52FE\u76F4\u63A5\u7EE7\u7EED\u64CD\u4F5C\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u9009\u62E9\u63D0\u4F9B\u521D\u671F\u8D44\u91D1\u7684\u7535\u5B50\u94B1\u5305\u3001\u8F93\u5165Google\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u4EE3\u7801\u540E\u5B8C\u6210\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-d13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-d13',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'D-13'),'\u521B\u5EFA\u65B0\u7535\u5B50\u94B1\u5305\u65F6\uFF0C\u4E3A\u4F55\u5FC5\u987B20RIA\u5E01\u4EE5\u4E0A\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-d13',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7531\u4E8E\u7A7A\u7535\u5B50\u94B1\u5305\u4F1A\u81EA\u52A8\u88AB\u8BC6\u522B\u4E3A\u65E0\u6548\u7535\u5B50\u94B1\u5305\uFF0C\u56E0\u6B64\u521B\u5EFA\u65B0\u7535\u5B50\u94B1\u5305\u65F6\u5FC5\u987B\u6301\u6709RIA\u5E01\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'TRIAM\u7535\u5B50\u94B1\u5305\uFF0C\u6700\u4F4E\u5FC5\u987B20RIA\u5E01\u624D\u80FD\u6709\u6548\u6FC0\u6D3B\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6700\u4F4E\u7684\u4F59\u91CF\u6709\u52A9\u4E8E\u7F51\u7EDC\u4FDD\u62A4\u548C\u9632\u6B62\u521B\u5EFA\u5783\u573E\u90AE\u7BB1\u3002'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-f'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'F'),'TRUST')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-f1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-f1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'F-1'),'\u4EC0\u4E48\u662FTRUST?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-f1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TRUST\u7B80\u5355\u7684\u8BF4\u660E\u300C\u4FE1\u8D56\u8D27\u5E01\u6216\u4FE1\u8D56\u4EE3\u5E01\u300D\u7684\u610F\u601D\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5728\u8BF8\u591A\u4EE3\u5E01\u4E2D\uFF0C\u5B83\u662F\u4E00\u79CD\u4EC5\u542F\u7528\u60A8\u7ECF\u8FC7\u5224\u65AD\u548C\u53EF\u4FE1\u8D56\u7684\u4EE3\u5E01\u8FDB\u884CTRUST\u7684\u529F\u80FD\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4F7F\u7528\u53D1\u9001\u4EE3\u5E01\xB7\u63A5\u6536\u4EE3\u5E01\u524D\uFF0C\u5FC5\u987B\u5148TRUST\u4EE3\u5E01\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-f2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-f2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'F-2'),'\u5982\u4F55TRUST\u522B\u7684 \u8D27\u5E01\xB7\u4EE3\u5E01\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-f2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4ECE\u6211\u7684\u7535\u5B50\u94B1\u5305\u9875\u9762\uFF0C\u70B9\u51FB\u300C+\u300D\u53F7\u4F1A\u663E\u793A\u53EFTRUST\u7684\u4EE3\u5E01\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u60F3TRUST\u7684\u4EE3\u5E01\u4E0D\u663E\u793A\u53EF\u8FDB\u884C\u624B\u52A8\u8F93\u5165\u8FDB\u884C\u641C\u7D22\u3002\u70B9\u51FB\u60F3TRUST\u7684\u4EE3\u5E01\u540E\u518D\u70B9 \u51FBTRUST\u952E\u5373\u6DFB\u52A0\u6210\u529F\u3002 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'TRUST\u4EE3\u5E01\u5206\u4E3A\u4E24\u79CD\uFF0C\u76F4\u63A5\u7533\u8BF7\u5373\u6279\u51C6\u548C\u5FC5\u987B\u901A\u8FC7ISSUER\u8005\u6279\u51C6\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u7535\u5B50\u94B1\u5305\u9875\u9762\u5DF2\u6DFB\u52A0\u7684\u4EE3\u5E01\u53F3\u4E0B\u89D2\u663E\u793A\u6253\u52FE\u7B26\u53F7\u5373\u8868\u793A\u5DF2\u7ECF\u6DFB\u52A0\u5B8C\u6210\u72B6\u6001\u3002\u5982\u679C\u7535\u5B50\u94B1\u5305\u9875\u9762\u5DF2\u6DFB\u52A0\u7684\u4EE3\u5E01\u7684\u53F3\u4E0B\u89D2\u663E\u793A\u65F6\u949F\u7684\u7B26\u53F7\u5373\u8868\u793AISSUER \u8005\u672A\u6279\u51C6\u72B6\u6001\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5982\u679CTRUST\u5904\u4E8E\u672A\u6279\u51C6\u72B6\u6001\uFF0C\u8BE5\u4EE3\u5E01\u5219\u65E0\u6CD5\u4F7F\u7528\u4E0E\u53D1\u9001\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-f3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-f3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'F-3'),' \u5982\u4F55\u89E3\u9664\u5DF2TRUST\u7684 \u8D27\u5E01\xB7\u4EE3\u5E01\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-f3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u60F3\u89E3\u9664\u5DF2TRUST\u7684\u4EE3\u5E01\uFF0C\u5FC5\u987B\u6301\u6709\u7684\u4EE3\u5E01\u6570\u91CF\u4E3A0\u624D\u53EF\u89E3\u9664\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u70B9\u51FB\u7535\u5B50\u94B1\u5305\u5185\u60F3\u89E3\u9664TRUST\u7684\u4EE3\u5E01\uFF0C\u63A5\u7740\u70B9\u51FB\u300C\u89E3\u9664TRUST\u300D\u7EE7\u7EED\u64CD\u4F5C\u3002'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-x'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'X'),'\u624B\u7EED\u8D39')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-x1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-x1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'X-1'),'\u4EC0\u4E48\u662F\u4EA4\u6613\u8D39'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-x1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5904\u7406\u533A\u5757\u94FE\u4FE1\u606F\u65F6\u4EA7\u751F\u7684\u624B\u7EED\u8D39\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u53E6\u5916\uFF0C\u5373\u4F7F\u4EA4\u6613\u5931\u8D25\u4E5F\u4EA7\u751F\u624B\u7EED\u8D39\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-x2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-x2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'X-2'),'\u4EA4\u6613\u624B\u7EED\u8D39\u5982\u4F55\u6536\u53D6\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-x2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'RIA\u5E01\u4E00\u6B21\u4EA4\u6613\u624B\u7EED\u8D39\u4E3A0.001RIA\u5E01\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'TRIAM\u5E73\u53F0\u4E0A\u521B\u5EFA\u7684\u4EE3\u5E01\u9700\u8981\u53D1\u9001\u65F6\uFF0C\u5C06\u4EA7\u751FRIA\u5E01\u4EA4\u6613\u624B\u7EED\u8D39\u548C\u4EE3\u5E01\u4EA4\u6613 \u624B\u7EED\u8D39\u4EE5\u4E0A\u4E24\u7B14\u624B\u7EED\u8D39\u3002\u4EE3\u5E01\u7684\u4EA4\u6613\u624B\u7EED\u8D39\u56E0\u4EE3\u5E01\u79CD\u7C7B\u800C\u5F02\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-x3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-x3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'X-3'),'\u53D1\u9001\u663E\u793A\u9519\u8BEF\uFF0C\u4EE3\u5E01\u53D1\u9001\u672A\u6210\u529F\uFF0C\u4E3A\u4F55\u6263\u9664\u624B\u7EED\u8D39\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-x3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7531\u4E8E\u533A\u5757\u94FE\u4E0A\u4FE1\u606F\u9700\u8981\u505A\u5904\u7406\uFF0C\u5373\u4F7F\u53D1\u9001\u8D27\u5E01\u6216\u4EE3\u5E01\u65F6\u53D1\u751F\u9519\u8BEF\u6216\u5931\u8D25\uFF0C\u4E5F\u4F1A\u4EA7 \u751F\u4E00\u5B9A\u4EA4\u6613\u8D39\u3002'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-g'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G'),'\u53D1\u9001 \u8D27\u5E01\xB7\u4EE3\u5E01\uFF0C\u63A5\u6536 \u8D27\u5E01\xB7\u4EE3\u5E01')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-1'),' \u5982\u4F55\u5411\u597D\u53CB\u53D1\u9001RIA\u5E01\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4ECE\u6211\u7684\u7535\u5B50\u94B1\u5305\u9875\u9762\u5F00\u59CB\uFF0C\u9009\u62E9\u9700\u8981\u8FDB\u884C\u53D1\u9001\u8D27\u5E01\xB7\u4EE3\u5E01\u7684\u7535\u5B50\u94B1\u5305.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u63A5\u7740\u9009\u62E9\u60A8\u9700\u8981\u53D1\u9001\u7684\u8D27\u5E01\xB7\u4EE3\u5E01\u3002\u8BF7\u70B9\u51FBRIA\u5E01\xB7',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u70B9\u51FB\u4EA4\u6613\u9875\u9762\u4E2D\u663E\u793A\u7684\u300C\u53D1\u9001\u8D27\u5E01\xB7\u4EE3\u5E01\u300D\xB7',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u8F93\u5165\u63A5\u6536\u65B9\u7684\u7535\u5B50\u94B1\u5305\u5730\u5740\u548C\u6570\u91CF\xB7',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6700\u540E\u8F93\u5165Google\uFF08\u8C37\u6B4C\uFF09\u663E\u793A\u7684\u53CC\u91CD\u9A8C\u8BC1\u4EE3\u7801\u540E\u5B8C\u6210\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-2'),'\u53D1\u9001 \u8D27\u5E01\u30FB\u4EE3\u5E01\u7684\u6570\u91CF\u6709\u9650\u5236\u5417\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8D27\u5E01\xB7\u4EE3\u5E01\u7684\u53D1\u9001\u6570\u91CF\u65E0\u9650\u5236\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u53D1\u9001\u65F6\u8BF7\u6CE8\u610F\uFF0C\u53D1\u9001\u540E\u7684\u7535\u5B50\u94B1\u5305\u6700\u4F4E\u7684\u4F59\u91CF\u5FC5\u987B\u65F620RIA\u4EE5\u4E0A\xB7 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5982\u679C\u53D1\u9001\u7684\u4F59\u91CF\u4E0D\u8DB320RIA,\u6D4B\u4F1A\u51FA\u73B0\u4EA4\u6613\u9519\u8BEF\u7684\u663E\u793A\xB7',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4F8B\u5982\uFF1A\u7535\u5B50\u94B1\u5305\u5185\u6301\u6709\u603B\u6570\u91CF\u4E3A50RIA\u5E01\xB7',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u51CF\u53BB\u6FC0\u6D3B\u4F7F\u7528\u768420RIA\u5E01\u548C\u4EA4\u6613\u8D39\u76840.001RIA\uFF0C\u5269\u4F59\u53EF\u53D1\u9001\u7684\u6570\u91CF\u4E3A29.999RIA \u5E01\xB7\u53D1\u9001\u524D\u8BF7\u68C0\u67E5\u7535\u5B50\u94B1\u5305\u4F59\u91CF\u662F\u5426\u8DB3\u591F',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-3'),'\u8D27\u5E01\u30FB\u4EE3\u5E01\u53D1\u9001\u540E\u591A\u957F\u65F6\u95F4\u624D\u663E\u793A\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TRIAM Network\u4E0A\u7535\u5B50\u94B1\u5305\u4E4B\u95F4\u7684\u4F20\u9001\u53EA\u970011\u79D2\uFF5E2\u79D2\u5C06\u663E\u793A\u3002\u4EA4\u6613\u5904\u7406\u8F83\u4E3A\u7E41 \u5FD9\u65F6\u3001\u4E5F\u6709\u7A0D\u5FAE\u5EF6\u8FDF\u7684\u53EF\u80FD\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-4'),'\u53D1\u9001 \u8D27\u5E01\u30FB\u4EE3\u5E01\u65F6\uFF0C\u53D1\u751F\u9519\u8BEF\u3001\u663E\u793A\u300C\u6B64\u7535\u5B50\u94B1\u5305\u5730\u5740\u4E0D\u5B58\u5728\u300D\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6709\u53EF\u80FD\u63A5\u6536\u65B9\u7684\u7535\u5B50\u94B1\u5305\u5730\u5740\u8F93\u5165\u9519\u8BEF\uFF0C\u53C8\u6216\u8005\u5730\u5740\u94B1\u5305\u5730\u5740\u88AB\u5220\u9664\u7B49\u65E0\u6CD5\u5F97 \u5230\u786E\u8BA4\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5982\u679C\u663E\u793A\u300C\u7535\u5B50\u94B1\u5305\u5730\u5740\u4E0D\u5B58\u5728\u300D\u7684\u60C5\u51B5\uFF0C\u8BF7\u786E\u8BA4\u662F\u5426\u4EE5\u4E0B\u72B6\u51B5',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u518D\u6B21\u786E\u8BA4\u53D1\u9001\u65B9\u7684\u7535\u5B50\u94B1\u5305\u5730\u5740\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u6253\u5F00\u7535\u5B50\u94B1\u5305\u4EA4\u6613\u8BB0\u5F55\uFF0C\u67E5\u770B\u8F93\u5165\u63A5\u6536\u65B9\u7684\u7535\u5B50\u94B1\u5305\u5730\u5740\u662F\u5426\u6B63\u786E\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u4E0E\u63A5\u6536\u65B9\u786E\u8BA4\u63A5\u6536\u65B9\u7535\u5B50\u94B1\u5305\u662F\u5426\u88AB\u5C01\u9501\u72B6\u6001\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u4E0E\u63A5\u6536\u65B9\u786E\u8BA4\u7535\u5B50\u94B1\u5305\u662F\u5426\u5904\u4E8E\u672A\u6FC0\u6D3B\u72B6\u6001\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-5'),'\u53D1\u9001\u7684 \u8D27\u5E01\u30FB\u4EE3\u5E01\u5DF2\u663E\u793A\u6210\u529F\uFF0C\u63A5\u6536\u65B9\u6CA1\u6709\u63A5\u6536\u5230\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5982\u679C\u53D1\u9001\u7684\u8D27\u5E01\xB7\u4EE3\u5E01\u5DF2\u663E\u793A\u6210\u529F\uFF0C\u4F46\u63A5\u6536\u65B9\u5E76\u672A\u63A5\u6536\u5230\u7684\u60C5\u51B5\uFF0C\u8BF7\u53C2\u7167\u4EE5\u4E0B\u5E76 \u786E\u8BA4\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u518D\u6B21\u786E\u8BA4\u63A5\u6536\u65B9\u7684\u7535\u5B50\u94B1\u5305\u5730\u5740\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u6253\u5F00\u7535\u5B50\u94B1\u5305\u4EA4\u6613\u8BB0\u5F55\uFF0C\u67E5\u770B\u8F93\u5165\u7684\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u662F\u5426\u6B63\u786E\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-6'),'\u5C06 \u8D27\u5E01\u30FB\u4EE3\u5E01 \u8BEF\u53D1\u4E86\u9519\u8BEF\u7684\u7535\u5B50\u94B1\u5305\u5730\u5740\uFF0C\u8BE5\u5982\u4F55\u64CD\u4F5C\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5F88\u62B1\u6B49\uFF0C\u4E00\u65E6\u53D1\u9001\u6210\u529F\u5E76\u5904\u7406\u5B8C\u6BD5\u8D27\u5E01\xB7\u4EE3\u5E01\uFF0C\u65E0\u6CD5\u53D6\u6D88\u3002\u5373\u4F7F\u60A8\u8054\u7CFB\u5BA2\u670D\u652F\u6301\u4E5F \u65E0\u6CD5\u53D6\u6D88\u53D1\u9001\u6216\u6062\u590D\u7B49\u76F8\u5E94\u64CD\u4F5C\u3002\u53D1\u9001\u524D\u52A1\u5FC5\u786E\u8BA4\u662F\u5426\u6709\u8BEF\u518D\u8FDB\u884C\u53D1\u9001\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-7'),'\u5982\u4F55\u67E5\u770B\u8D27\u5E01\u30FB\u4EE3\u5E01\u662F\u5426\u53D1\u9001\u6210\u529F\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7535\u5B50\u94B1\u5305\u7684\u4EA4\u6613\u8BB0\u5F55\u4E2D\u53EF\u4EE5\u786E\u8BA4\u5404\u7535\u5B50\u94B1\u5305\u7684\u4EA4\u6613\u72B6\u51B5\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4E5F\u53EF\u4EE5\u5728\u4F7F\u7528\u626B\u63CF\u7684\u65B9\u5F0F\u5728TRIAM Blockscan\u8FDB\u884C\u786E\u8BA4\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-g8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-g8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G-8'),'\u65E0\u6CD5\u63A5\u6536\u5DF2TRUST\u7684\u4EE3\u5E01'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-g8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'TRUST\u4EE3\u5E01\u5206\u4E3A\u4E24\u79CD\uFF0C\u76F4\u63A5\u7533\u8BF7\u5373\u6279\u51C6\u548C\u5FC5\u987B\u901A\u8FC7ISSUER\u8005\u6279\u51C6\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u7535\u5B50\u94B1\u5305\u5185\u6DFB\u52A0\u7684\u4EE3\u5E01\u7684\u53F3\u4E0B\u89D2\u5982\u679C\u663E\u793A\u6253\u52FE\u7684\u7B26\u53F7\u5373\u8868\u793A\u5DF2 TRUST. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u7535\u5B50\u94B1\u5305\u4F60\u6DFB\u52A0\u7684\u4EE3\u5E01\u7684\u53F3\u4E0B\u89D2\u5982\u679C\u663E\u793A\u65F6\u949F\u7B26\u53F7\u5373\u5219\u8868\u793AISSUER\u8005\u5C1A\u672A\u6279\u51C6 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5982\u679CTRUST\u5C1A\u672A\u6279\u51C6\u72B6\u6001\uFF0C\u8BE5\u4EE3\u5E01\u65E0\u6CD5\u8FDB\u884C\u63A5\u6536\u6216\u53D1\u9001\u7684\u64CD\u4F5C\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-h'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H'),'ISSUER\u8005')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-1'),'\u4EC0\u4E48\u662FISSUER\u8005?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6210\u4E3AISSUER\u8005\u3001\u5C06\u6709\u6743\u72EC\u7ACB\u521B\u5EFA\u4EE3\u5E01\uFF0CISSUER\u4EE3\u5E01\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u72EC\u7ACB\u521B\u5EFA\u7684\u4EE3\u5E01\u53EF\u4EE5\u5E7F\u6CDB\u7684\u4F7F\u7528\u4E8E\u5404\u79CD\u5546\u52A1\u4E1A\u52A1\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-2'),'\u5982\u4F55\u6210\u4E3AISSUER\u8005?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u9700\u8981\u7533\u8BF7\u624D\u80FD\u6210\u4E3A\u53D1\u884C\u8005\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4ECE\u8BBE\u7F6E\u9875\u9762\u300C\u666E\u901A\u300D\u8FDB\u884C\u7533\u8BF7\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u8BF7\u8F93\u5165\u5FC5\u8981\u4E8B\u9879\u548C\u4E0A\u4F20\u6709\u6548\u8EAB\u4EFD\u75C7\u9644\u5E26\u5934\u50CF\u9875\u9762\u5148\u76F8\u7247\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u8EAB\u4EFD\u8BC1\u4EF6\u4EC5\u9650\u4E8E\u5404\u56FD\u673A\u5173\u53D1\u884C\u7684\u6709\u6548\u8BC1\u4EF6\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4F8B:\u673A\u52A8\u8F66\u9A7E\u9A76\u8BC1\uFF0C\u62A4\u7167',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4F7F\u7528\u673A\u52A8\u8F66\u9A7E\u9A76\u8BC1\u4E0A\u4F20:\u5FC5\u987B\u63D0\u4EA4\u8F66\u8BC1\u7684\u6B63\u9762\u53CD\u9762\u6E05\u6670\u7167\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4F7F\u7528\u62A4\u7167\u4E0A\u4F20\uFF1A\u5FC5\u987B\u63D0\u4EA4\u5E26\u5934\u50CF\uFF0C\u4F4F\u6240\u7B49\u8BB0\u8F7D\u9875\u9762\u6E05\u6670\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u8BF7\u6CE8\u610F\uFF0C\u5982\u76F8\u7247\u51FA\u73B0\u526A\u89D2\u3001\u6B8B\u7F3A\u6216\u6A21\u7CCA\u5219\u65E0\u6CD5\u63A5\u6536\u4E0E\u786E\u8BA4\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-3'),' ISSUER\u8005\u4ECE\u7533\u8BF7\u5230\u6279\u51C6\u9700\u8981\u51E0\u5929\u7684\u65F6\u95F4\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6309\u7167\u63D0\u4EA4\u7684\u987A\u5E8F\u5BF9\u7533\u8BF7\u8005\u7684\u8BC1\u4EF6\u8FDB\u884C\u5BA1\u6838\u4E0E\u9A8C\u8BC1\uFF0C\u8BF7\u63D0\u4EA4\u8005\u8010\u5FC3\u7684\u7B49\u5F85\u6211 \u4EEC\u7ED3\u679C\uFF0C ISSUER\u8005\u7684\u7533\u8BF7\u5BA1\u6838\u901A\u77E5\u5C06\u76F4\u63A5\u53D1\u9001\u81F3\u7533\u8BF7\u8005\u7684\u6CE8\u518C\u90AE\u7BB1\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-4'),'\u7533\u8BF7ISSUER\u9700\u8981\u6536\u8D39\u5417\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'ISSUER\u8005\u7684\u7533\u8BF7\u4EE5\u53CA\u6210\u4E3AISSUER\u8005\u90FD\u65E0\u9700\u8D39\u7528')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-5'),'ISSUER\u7684\u7533\u8BF7\uFF0C\u4E2A\u4EBA\u8EAB\u4EFD\u786E\u8BA4\u9700\u8981\u51C6\u5907\u4EC0\u4E48\u8D44\u6599\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'ISSUER\u8005\u7684\u7533\u8BF7\uFF0C\u987B\u63D0\u4EA4\u7684\u672C\u8BA4\u786E\u8BA4\u8D44\u6599\uFF0C\u4EC5\u9650\u4E8E\u5404\u56FD\u7531\u56FD\u5BB6\u53D1\u884C\u7684\u6709\u6548\u8BC1\u4EF6\u4E3A\u51C6\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5C45\u4F4F\u5728\u65E5\u672C\u56FD\u5185\u8EAB\u4EFD\u786E\u8BA4\u8D44\u6599\u4F8B\u5B50\uFF1A\uFF08\u65E5\u672C\u7C4D\u3001\u5916\u56FD\u7C4D\uFF09\u7684\u7528\u6237\u3001\u673A\u52A8\u9A7E\u9A76\u8BC1\u3001 \u62A4\u7167\u6216(\u65E5\u672C\u53D1\u884C\u62A4\u7167\uFF09\u3001\u4E2A\u4EBA\u53F7\u7801\u5361\u3001\u5728\u7559\u5361\u3001\u7279\u522B\u6C38\u9A7B\u8BC1\u660E\u4E66\u6216\u6C38\u9A7B\u5361\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u203B\u5982\u4E2A\u4EBA\u53F7\u7801\u5361\uFF08\u65E0\u7167\u7247\u7684\u901A\u77E5\u5361\uFF09\u4E0D\u7ED9\u4E88\u786E\u8BA4\u4E0E\u53D7\u7406\u3002 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u25A0\u673A\u52A8\u9A7E\u9A76\u8BC1',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u6B63\u9762\uFF0C\u80CC\u9762\u52A1\u5FC5\u63D0\u4EA4\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u786E\u8BA4\u4E0A\u4F20\u8D44\u6599\u662F\u5426\u6E05\u6670\u53EF\u89C1\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u786E\u8BA4\u5730\u5740\uFF0C\u59D3\u540D\uFF0C\u51FA\u751F\u5E74\u6708\u65E5\u662F\u5426\u6E05\u6670\u53EF\u89C1\u3002\u786E\u8BA4\u4E0A\u4F20\u7684\u76F8\u7247\u663E\u793A\u7684\u5730\u5740\uFF0C\u59D3\u540D\uFF0C\u51FA\u751F\u5E74\u6708\u65E5\u4E0E\u672C\u4EBA\u6CE8\u518C\u6240\u586B\u5199\u5185\u5BB9\u662F\u5426\u4E00\u81F4\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u786E\u8BA4\u8BC1\u4EF6\u662F\u5426\u4E3A\u6548\u671F\u5185\u3002\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u786E\u8BA4\u8BC1\u4EF6\u53F7\u7801\u662F\u5426\u6E05\u6670\u53EF\u89C1\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u786E\u8BA4\u516C\u5B89\u90E8\u95E8\u5370\u7AE0\u662F\u5426\u6E05\u6670\u53EF\u89C1\u3002\u82E5\u80CC\u9762\u4E5F\u6709\u5185\u5BB9\uFF0C\u786E\u8BA4\u80CC\u9762\u7684\u516C\u5B89\u90E8\u5370\u7AE0 \u662F\u5426\u6E05\u6670\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u786E\u62CD\u6444\u7684\u76F8\u7247\u3001\u8138\u90E8\u662F\u5426\u6E05\u6670\u53EF\u89C1\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u25A0\u62A4\u7167\u6216\uFF08\u65E5\u672C\u56FD\u5BB6\u53D1\u884C\u7684\u62A4\u7167\uFF09  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u63D0\u4EA4\u5E26\u5934\u50CF\u7684\u7167\u7247\u9875\u9762\u548C\u6301\u6709\u586B\u5199\u680F\u9875\u9762\uFF08\u8BB0\u8F7D\u5730\u5740\u9875\u9762\uFF09\u5171\u4E24\u9875\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u786E\u8BA4\u62CD\u6444\u7684\u8D44\u6599\u8BC1\u660E\u662F\u5426\u5168\u9762\u3001\u6E05\u6670\u53EF\u89C1\u3002 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u786E\u8BA4\u62A4\u7167\u53F7\u7801\u663E\u793A\u662F\u5426\u6E05\u6670\u53EF\u89C1\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u786E\u8BA4\u8BC1\u4EF6\u662F\u5426\u4E3A\u6548\u671F\u5185\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u786E\u8BA4\u5730\u5740\uFF0C\u59D3\u540D\uFF0C\u51FA\u751F\u5E74\u6708\u65E5\u662F\u5426\u6E05\u6670\u53EF\u89C1\u3002\u786E\u8BA4\u4E0A\u4F20\u7684\u76F8\u7247\u663E\u793A\u7684\u5730\u5740\u3001\u59D3\u540D\uFF0C\u51FA\u751F\u5E74\u6708\u65E5\u4E0E\u672C\u4EBA\u6CE8\u518C\u6240\u586B\u5199\u5185\u5BB9\u662F\u5426\u4E00\u81F4\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u25A0\u4E2A\u4EBA\u53F7\u7801\u5361 \u3001\u4E2A\u4EBA\u53F7\u7801\u901A\u77E5\u5361\uFF08\u65E0\u4E2A\u4EBA\u5934\u50CF\uFF09\u65E0\u6CD5\u4F5C\u4E3A\u4E2A\u4EBA\u786E\u8BA4\u8D44\u6599\u63D0\u4EA4 \u30FB\u63D0\u4EA4\u4E2A\u4EBA\u53F7\u7801\u5361/\u901A\u77E5\u5361\u4EC5\u9700\u8981\u63D0\u4EA4\u5361\u7684\u6B63\u9762\u3002\u80CC\u9762\u65E0\u9700\u63D0\u4EA4\u3002 \u30FB\u8BF7\u786E\u8BA4\u62CD\u6444\u7684\u8D44\u6599\u8BC1\u660E\u662F\u5426\u5168\u9762\u3001\u6E05\u6670\u53EF\u89C1\u3002 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u786E\u8BA4\u8BC1\u4EF6\u662F\u5426\u4E3A\u6548\u671F\u5185\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u786E\u8BA4\u5730\u5740\uFF0C\u59D3\u540D\uFF0C\u51FA\u751F\u5E74\u6708\u65E5\u662F\u5426\u6E05\u6670\u53EF\u89C1\u3002\u786E\u8BA4\u4E0A\u4F20\u7684\u76F8\u7247\u663E\u793A\u7684\u5730\u5740\uFF0C\u59D3\u540D\uFF0C\u51FA\u751F\u5E74\u6708\u65E5\u4E0E\u672C\u4EBA\u6CE8\u518C\u6240\u586B\u5199\u5185\u5BB9\u662F\u5426\u4E00\u81F4\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u25A0\u5728\u7559\u5361\u548C\u7279\u522B\u6C38\u9A7B\u8BC1\u660E\u4E66\u6216\u6C38\u9A7B\u5361',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u6B63\u9762\uFF0C\u80CC\u9762\u4E5F\u8BF7\u52A1\u5FC5\u63D0\u4EA4\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u786E\u8BA4\u62CD\u6444\u7684\u8D44\u6599\u8BC1\u660E\u662F\u5426\u5168\u9762\u3001\u6E05\u6670\u53EF\u89C1\u3002 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u786E\u8BA4\u5730\u5740\uFF0C\u59D3\u540D\uFF0C\u51FA\u751F\u5E74\u6708\u65E5\u662F\u5426\u6E05\u6670\u53EF\u89C1\u3002\u786E\u8BA4\u4E0A\u4F20\u7684\u76F8\u7247\u663E\u793A\u7684\u5730\u5740\u3001\u59D3\u540D\uFF0C\u51FA\u751F\u5E74\u6708\u65E5\u4E0E\u672C\u4EBA\u6CE8\u518C\u6240\u586B\u5199\u5185\u5BB9\u662F\u5426\u4E00\u81F4\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u786E\u8BA4\u5361\u53F7\u7801\u663E\u793A\u662F\u5426\u6E05\u6670\u53EF\u89C1\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u786E\u8BA4\u8BC1\u4EF6\u662F\u5426\u4E3A\u6548\u671F\u5185\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u8BF7\u786E\u8BA4\u5916\u7BA1\u5C40\u5370\u7AE0\u662F\u5426\u6E05\u6670\u53EF\u89C1\u3002\u82E5\u80CC\u9762\u4E5F\u6709\u5185\u5BB9\uFF0C\u786E\u8BA4\u80CC\u9762\u7684\u5370\u7AE0\u662F\u5426\u6E05\u6670\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-6'),' \u5982\u4F55\u9012\u4EA4\u4E2A\u4EBA\u8EAB\u4EFD\u8EAB\u4EFD\u786E\u8BA4\u8D44\u6599\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u53EF\u4EE5\u4ECE\u8D26\u6237\u8BBE\u7F6E\u9875\u9762\u663E\u793AISSUER\u8005\u7684\u7533\u8BF7\u548C\u540C\u65F6\u63D0\u4EA4\u4E2A\u4EBA\u8D44\u6599\u7684\u786E\u8BA4\u548C\u4FE1\u606F\u3002\u8BF7\u4E0A\u4F20\u8EAB\u4EFD\u786E\u8BA4\u4E66\u5E76\u63D0\u4EA4\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u76F8\u7247\u7684\u89C4\u683C\u6700\u5927\u4E3A2MB\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6709\u5173\u63D0\u4EA4\u76F8\u7247\u6CE8\u610F\u70B9\uFF0C\u8BF7\u53C2\u7167H-5\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-7'),'\u7533\u8BF7ISSUER\u8005\u662F\u5426\u53EF\u6839\u636E\u5C45\u4F4F\u6240\u5728\u56FD\u5BB6\u8FDB\u884C\u7533\u8BF7\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5C45\u4F4F\u56FD\u65E0\u9650\u5236\u3001\u5C45\u4F4F\u4E8E\u4EFB\u4F55\u56FD\u5BB6\u90FD\u53EF\u4EE5\u8FDB\u884C\u7533\u8BF7ISSUER\u8005',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4F46\u662F\u3001\u6709\u5173\u53D1\u884C\u8D27\u5E01\xB7\u4EE3\u5E01\u7684\u4F7F\u7528\u8005\uFF0C\u8BF7\u52A1\u5FC5\u9075\u5B88\u56FD\u5BB6\u53CA\u5730\u533A\u76F8\u5173\u7684\u6CD5\u5F8B\u6CD5\u89C4\u3002\u4ECA\u540E\u3001\u5982\u679C\u5168\u7403\u6216\u5C45\u4F4F\u56FD\u53D1\u751F\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u7684\u66F4\u6539\uFF0C\u5DF2\u88AB\u9A8C\u8BC1\u7684ISSUER\u8005\u6388\u6743\u6709\u53EF\u80FD\u968F\u7740\u6CD5\u5F8B\u6CD5\u89C4\u66F4\u6539\u800C\u65E0\u6548\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u8BF7\u6CE8\u610F\uFF0C\u5982\u679C\u53D1\u751F\u4EE5\u4E0A\u60C5\u51B5\uFF0C\u6709\u5173\u5DF2\u53D1\u884C\u7684\u8D27\u5E01\xB7\u4EE3\u5E01 \u4E00\u65E6\u4EA7\u751F\u4E86\u635F\u5BB3\u6216\u635F\u5931\u7B49\uFF0C\u6211\u4EEC\u4E0D\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u53CA\u4E0D\u8FDB\u884C\u4EFB\u4F55\u8D54\u635F\u548C\u8D54\u507F\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-8'),'\u7533\u8BF7ISSUER\u8005\u65F6\u9700\u8981\u8F93\u5165\u7684\u300C\u56E2\u4F53/\u516C\u53F8\u300D\u662F\u4EC0\u4E48\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5982\u679CISSUER\u8005\u7531\u56E2\u4F53\xB7\u516C\u53F8\u6267\u884C\uFF0C\u8BF7\u8F93\u5165\u6CE8\u660E\u3002ISSUER\u8005\u4FE1\u606F\u53EF\u9009\u62E9\u516C\u5F00\u6216\u4E0D\u516C\u5F00\u3002\u4E3A\u4E86UER\u7684\u4EE3\u5E01\u66F4\u5BB9\u6613\u5F97\u5230\u4FE1\u8D56\uFF0C\u6211\u4EEC\u5EFA\u8BAE\u60A8\u8BBE\u7F6E\u4E3A\u516C\u5F00\u6A21\u5F0F\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h9',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-9'),'\u6211\u60F3\u66F4\u6539\u53D1\u884C\u8005\u7533\u8BF7\u65F6\u6CE8\u518C\u65F6\u7684\u4FE1\u606F\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h9',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5982\u4F55\u66F4\u6539\u7533\u8BF7\u5DF2\u6CE8\u518C\u7684ISSUER\u8005\u4FE1\u606F\uFF1F \u4ECE\u201C\u8BBE\u7F6E\u201D\u9875\u9762\u21D2\u70B9\u51FB\u201C\u666E\u901A\u201D\u9875\u9762\u4E2D\u53F3\u4E0B\u89D2\u663E\u793A\u7684\u7F16\u8F91\u53D1\u884C\u8005\u7684\u4FE1\u606F\u540E\u8FDB\u884C\u7533\u8BF7\u3002\u91CD\u65B0\u7F16\u8F91\u65B0\u4FE1\u606F\u4E4B\u524D\uFF0C\u73B0\u6709\u7684\u4FE1\u606F\u6301\u7EED\u6709\u6548\u3002 \u8F93\u5165\u65B0\u4FE1\u606F\u5E76\u83B7\u5F97\u6279\u51C6\u540E\uFF0C\u73B0\u6709\u7684\u4FE1\u606F\u5C06\u65E0\u6548\u5E76\u81EA\u52A8\u88AB\u5220\u9664\u540E\uFF0C\u663E\u793A\u4E3A\u6700\u65B0\u7533\u8BF7\u4FE1\u606F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-h10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-h10',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H-10'),'\u6CA1\u6709\u63A5\u6536\u5230\u7533\u8BF7ISSUER\u7684\u53D7\u7406\u90AE\u4EF6'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-h10',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#role-a6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BF7\u53C2\u7167A-6'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-j'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J'),'\u521B\u5EFA\u4EE3\u5E01\u30FB\u53D1\u884C')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-1'),' \u5982\u4F55\u521B\u5EFA\u4EE3\u5E01\u30FB\u53D1\u884C\u4EE3\u5E01\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u521B\u5EFA\u4EE3\u5E01\u548C\u53D1\u9001\u4EE3\u5E01\uFF0C\u9700\u8981\u5148\u7533\u8BF7\u53D1\u884C\u8005\u4E14\u901A\u8FC7\u6279\u51C6\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4F5C\u4E3A\u53D1\u884C\u8005\u4E14\u5DF2\u901A\u8FC7\u6279\u51C6\u7684\u7528\u6237\u3001\u4ECE\u300C\u53D1\u884C\u8005\u6A21\u5F0F\u300D\u9875\u9762\u4E2D\uFF0C\u53EF\u8FDB\u884C\u521B\u5EFA\uFF0C\u53D1\u884C\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u9996\u5148\u4ECE\u300C\u521B\u5EFA\u4EE3\u5E01\u300D\u4E2D\u8FDB\u884C\u521B\u5EFA\u4EE3\u5E01\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u9009\u62E9\u521B\u5EFA\u4EE3\u5E01\u7684\u7535\u5B50\u94B1\u5305\u3002\u7531\u4E8E\u521B\u5EFA\u4EE3\u5E01\u987B\u4F7F\u7528RIA\u5E01\uFF0C\u6211\u4EEC\u63A8\u8350\u60A8\u9009\u62E9\u6301\u6709\u8DB3\u591FRIA\u5E01\u7684\u7535\u5B50\u94B1\u5305\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4E0B\u4E00\u6B65\uFF0C\u9009\u62E9\u4EE3\u5E01\u7684\u5C5E\u6027\u5E76\u8BBE\u7F6E\u4EE3\u5E01\u7684\u56FE\u6807\u76F8\u56FE\u7247\u3002\u56FE\u6807\u56FE\u7247\u4E5F\u53EF\u4EE5\u7A0D\u540E\u518D\u8BBE\u5B9A\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u8BF7\u8F93\u5165\u4EE3\u5E01\u540D\u79F0\uFF0C\u4EE3\u5E01\u7684\u5C0F\u6570\u70B9\u4F4D\u6570\uFF0C\u4EA4\u6613\u624B\u7EED\u8D39\uFF0CRIA\u5E01\u7684\u6BD4\u7387\u3001\u6700\u540E\uFF0C\u8BF7\u9009\u62E9\u6B64\u4EE3\u5E01\u88AB\u4F7F\u7528\u540E\u4EA7\u751F\u7684\u624B\u7EED\u8D39\u63A5\u6536\u7684\u7535\u5B50\u94B1\u5305\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4EE5\u4E0A\u5B8C\u6210\u521B\u5EFA\u4EE3\u5E01\u3002\u4E0B\u4E00\u6B65\uFF0C\u8BF7\u7EE7\u7EED\u4EE3\u5E01\u7684\u5206\u53D1\uFF0C\u4EE3\u5E01\u7684\u5B9E\u9645\u4F7F\u7528\u7684\u64CD\u4F5C\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-2'),'\u521B\u5EFA\u4EE3\u5E01\u65F6\u7684\u5C5E\u6027\u662F\u4EC0\u4E48\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6839\u636E\u5C5E\u6027\u7684\u8BBE\u7F6E\uFF0C\u60A8\u53EF\u4EE5\u5BF9\u5176\u5B83\u7528\u6237\u5982\u4F55\u4F7F\u7528\u60A8\u53D1\u884C\u7684\u4EE3\u5E01\u8BBE\u7F6E\u67D0\u4E9B\u9650\u5236\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u8BBE\u7F6E\u5C5E\u6027\u4EC5\u9650\u4E00\u6B21\uFF0C\u65E0\u6CD5\u66F4\u6539\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5C5E\u60271\uFF0C\u53EF\u4EE5\u5BF9\u5176\u5B83\u7528\u6237\u7684TRUST\u7533\u8BF7\u505A\u51FA\u5141\u8BB8\u6216\u62D2\u7EDD\u7684\u6388\u6743\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5C5E\u60272\uFF0C\u65E0\u6CD5\u6388\u6743\uFF0C\u7528\u6237\u5BF9\u60A8\u53D1\u884C\u7684\u4EE3\u5E01\u53EF\u4EE5\u81EA\u7531\u7684\u8FDB\u884CTRUST\u548C\u81EA\u7531\u7684\u4F7F\u7528\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-3'),'\u521B\u5EFA\u4EE3\u5E01\uFF0C\u53D1\u884C\u4EE3\u5E01\u9700\u8981\u6536\u8D39\u5417\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u521B\u5EFA\u4EE3\u5E01\u65E0\u9700\u4EFB\u4F55\u8D39\u7528\uFF0C\u6309\u53D1\u5E03\u5DF2\u521B\u5EFA\u4EE3\u5E01\u65F6\u53EF\u80FD\u9700\u8981RIA\u5E01\uFF0C\u5177\u4F53\u53D6\u51B3\u4E8E\u8BE5\u4EE3\u5E01\u8BBE\u7F6E\u7684RIA\u5E01\u7684\u6BD4\u7387\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u518D\u8005\uFF0C\u521B\u5EFA\u4EE3\u5E01\uFF0C\u53D1\u884C\u4EE3\u5E01\uFF0C\u5FC5\u987B\u6301\u6709\u4E24\u4E2A\u5DF2\u6FC0\u6D3B\u5E76\u4E14\u5404\u6301\u670921RIA\u5E01\u4EE5\u4E0A\u7684\u7535\u5B50\u94B1\u5305\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-4'),'\u4E0ERIA\u7684\u6BD4\u7387\u6307\u7684\u662F\u4EC0\u4E48\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u521B\u5EFA\u4EE3\u5E01\u65F6\uFF0C\u53EF\u4EE5\u8FDB\u884C\u8BBE\u7F6E\u4EE3\u5E01\u548CRIA\u7684\u6BD4\u7387\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'RIA\u7684\u6BD4\u7387\u4E3A\uFF0C\uFF3B\u65E0\u6BD4\u7387\uFF3D\uFF3B1/1\uFF3D\uFF3B1/10\uFF3D\uFF3B1/100\uFF3D\uFF3B1/1000\uFF3D\u53EF5\u79CD\u9009\u62E9\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4F8B\u5982\u9009\u62E9\uFF3B1/1\uFF3D\u53D1\u884C\u300C\uFF11\u4EE3\u5E01\u300D\u9700\u8981\u300C1RIA\u5E01\u300D\u3002\u9009\u62E9\uFF3B1/1000\uFF3D\u53D1\u884C\u300C\uFF11\u4EE3\u5E01\u300D\u9700\u8981\u300C0.001RIA\u300D\u5E01')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-5'),'\u7533\u8BF7\u4EE3\u5E01\u7684\u8BB0\u5F55\u72B6\u6001\u4E00\u76F4\u663E\u793A\u300CPending\u300D\uFF0C\u65E0\u6CD5\u521B\u5EFA\u4EE3\u5E01\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7533\u8BF7\u53D1\u884C\u8005\u6216\u7533\u8BF7\u53D1\u884C\u4EE3\u5E01\u7684\u6279\u51C6\u5904\u4E8E\u4FDD\u7559\u4E2D\u72B6\u6001\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u7533\u8BF7\u53D1\u884C\u4EE3\u5E01\u6240\u63D0\u4EA4\u7684\u672C\u4EBA\u786E\u8BA4\u8D44\u6599\u6309\u63D0\u4EA4\u7684\u987A\u5E8F\u8FDB\u884C\u5BA1\u6838\u548C\u6279\u51C6\uFF0C\u7533\u8BF7\u540E\u8BF7\u8010\u5FC3\u7684\u7B49\u5F85\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u53D1\u884C\u8005\u7684\u7533\u8BF7\u9A8C\u8BC1\u5B8C\u6BD5\u540E\u3002\u5BA1\u67E5\u9A8C\u8BC1\u7ED3\u679C\u901A\u77E5\u5C06\u53D1\u9001\u81F3\u60A8\u6CE8\u518C\u7684\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-6'),'\u4EE5\u521B\u5EFA\u7684\u4EE3\u5E01\u53EF\u4EE5\u5220\u9664\u5417\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5DF2\u521B\u5EFA\u7684\u4EE3\u5E01\uFF0C\u4EE5\u53CA\u53D1\u884C\u7684\u4EE3\u5E01\u65E0\u6CD5\u5220\u9664\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-7'),'\u4EE3\u5E01\u7684\u6DFB\u52A0\u53D1\u884C\u8BBE\u7F6E\u4E3A\u7981\u7528\uFF0C\u53EF\u4EE5\u518D\u6062\u590D\u5417\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5982\u679C\u4EE3\u5E01\u7684\u6DFB\u52A0\u53D1\u884C\u8BBE\u7F6E\u4E3A\u7981\u7528\uFF0C\u65E0\u6CD5\u91CD\u65B0\u64CD\u4F5C\uFF0C\u4E5F\u65E0\u6CD5\u89E3\u9664\u6DFB\u52A0\u53D1\u884C\u7981\u7528\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5982\u679C\u4EE3\u5E01\u7684\u6DFB\u52A0\u53D1\u884C\u8BBE\u7F6E\u4E3A\u7981\u7528\uFF0C\u521B\u5EFA\u8BE5\u4EE3\u5E01\u7684\u7535\u5B50\u94B1\u5305\u6240\u6709\u7684\u529F\u80FD\u5C06\u88AB\u51BB\u7ED3\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u66F4\u6539\u7535\u5B50\u94B1\u5305\u8BBE\u7F6E\uFF0CRIA\u5E01/\u4EE3\u5E01\u7684\u53D1\u9001\u548C\u63A5\u6536\uFF0C\u4EE3\u5E01\u7684\u6DFB\u52A0\u53D1\u884C\u30FBTRUST\u30FB\u89E3\u9664RUST\u7684\u529F\u80FD\u5C06\u65E0\u6CD5\u4F7F\u7528\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u552F\u4E00\u53EF\u4EE5\u4F7F\u7528\u529F\u80FD\u662F\u4EE3\u5E01\u7684TRUST\u5141\u8BB8\u6743\u9650\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-8'),'\u663E\u793A\u300CNot enough funds in source account\u300D\u4EE3\u5E01\u65E0\u6CD5\u53D1\u9001\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8BF7\u786E\u8BA4\u521B\u5EFA\u4EE3\u5E01\u7684\u7535\u5B50\u94B1\u5305\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6839\u636E\u521B\u5EFA\u4EE3\u5E01\u65F6\u8BBE\u7F6E\u7684RIA\u6BD4\u7387\u7684\u57FA\u51C6\uFF0C\u5FC5\u987B\u6301\u6709\u53D1\u884C\u4EE3\u5E01\u9700\u8981\u7684RIAB\u5E01\u548C\u4EA4\u6613\u624B\u7EED\u8D39\u7684RIA\u5E01\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j9',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-9'),'\u5BF9\u4E8E\u63A5\u6536\u5230\u7533\u8BF7TRUST\u7684\u7528\u6237\u505A\u51FA\u62D2\u7EDD\u7533\u8BF7\uFF0C\u5BF9\u65B9\u4F1A\u663E\u793A\u4EC0\u4E48\u6837\u72B6\u6001\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j9',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u62D2\u7EDD\u5BF9\u65B9\u7533\u8BF7TRUST\u7684\u7528\u6237\uFF0C\u5BF9\u65B9\u7684\u72B6\u6001\u4E00\u76F4\u5904\u4E8E\u672A\u6279\u51C6\u72B6\u6001\uFF0C\u5BF9\u65B9\u4E0D\u4F1A\u77E5\u9053\u7684\u529F\u80FD\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-j10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-j10',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'J-10'),'\u53EF\u4EE5\u4F7F\u7528\u81EA\u5DF1\u5E0C\u671B\u7684\u4EE3\u5E01\u540D\u79F0\u521B\u5EFA\u4EE3\u5E01\u5417\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-j10',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8981\u521B\u5EFA\u7684\u4EE3\u5E01\u540D\u79F0\uFF0C\u4E0D\u80FD\u4E0E\u5DF2\u53D1\u884C\u4EE3\u5E01\u7684\u540D\u79F0\u91CD\u590D',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5E0C\u671B\u7684\u4EE3\u5E01\u540D\u79F0\u5B58\u5728\u88AB\u5176\u5B83\u7528\u6237\u4F7F\u7528\u7684\u53EF\u80FD\u6027\uFF0C\u521B\u5EFA\u4EE3\u5E01\u524D\uFF0C\u5EFA\u8BAE\u63D0\u524D\u60F3\u597D\u4EE3\u5E01\u540D\u79F0\u7684\u5019\u8865\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-k'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K'),'\u5176\u5B83')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-1'),'\u5173\u4E8E\u63A8\u8350\u7684\u6D4F\u89C8\u5668'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4E3A\u4E86\u5B89\u5168\u8212\u9002\u5730\u4F7F\u7528TRIAM Network\uFF0C\u6211\u4EEC\u5EFA\u8BAE\u4F7F\u7528\u4EE5\u4E0B\u7248\u672C\u7684\u6D4F\u89C8\u5668\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBGoogle\uFF08\u8C37\u6B4C\uFF09\u6700\u65B0\u7248\u672C ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u706B\u72D0\u6D4F\u89C8\u5668 \u6700\u65B0\u7248\u672C ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u203B\u6211\u4EEC\u4E0D\u5EFA\u8BAE\u4F7F\u7528IE\u6D4F\u89C8\u5668')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-2'),'\u4EC0\u4E48\u662F\u4EE3\u5E01\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8FD9\u662FTRIAM\u5E73\u53F0\u4E0A\u521B\u5EFA\u72EC\u7684\u52A0\u5BC6\u5E01\u3002\u6301\u6709TRIAM\u8D26\u6237\u7684\u7528\u6237\u53EF\u8FDB\u884C\u53D1\u884C\u7533\u8BF7ISSUER\u8005\u3001\u53EA\u9700\u83B7\u5F97\u6279\u51C6\uFF0C\u5747\u53EF\u53D1\u884C\u4EE3\u5E01\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'ISSUER\u8005\u7684\u7533\u8BF7\u65E0\u9700\u8D39\u7528\u3002\u53D1\u884C\u72EC\u521B\u7684\u4EE3\u5E01\u9700\u8981RIA\u5E01\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-3'),'\u5220\u9664\u591A\u4F59\u7684\u7535\u5B50\u94B1\u5305\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5DF2\u521B\u5EFA\u7684\u7535\u5B50\u94B1\u5305\u65E0\u6CD5\u5220\u9664\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u4F46\u662F\uFF0C\u591A\u4F59\u7684\u7535\u5B50\u94B1\u5305\u53EF\u4EE5\u901A\u8FC7\u7535\u5B50\u94B1\u5305\u5408\u5E76\u7684\u529F\u80FD\u8FDB\u884C\u8D26\u6237\u5185\u7684\u94B1\u5305\u8FDB\u884C\u7BA1\u7406\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u7535\u5B50\u94B1\u5305\u5408\u5E76\u529F\u80FD\u53EF\u4F7F\u4E24\u4E2A\u7535\u5B50\u94B1\u5305\u5408\u5E76\u96C6\u6210\u4E00\u4E2A\u7535\u5B50\u94B1\u5305\u3002\u7535\u5B50\u94B1\u5305\u4E00\u65E6\u5408\u5E76\uFF0C\u88AB\u5438\u6536\u7684\u7535\u5B50\u94B1\u5305\u4F59\u91CF\u81EA\u52A8\u6E05\u96F6\u5E76\u5220\u9664\u3002\u7535\u5B50\u94B1\u5305\u5438\u6536\u53E6\u5916\u4E00\u4E2A\u7535\u5B50\u94B1\u5305\u96C6\u6210\u5408\u5E76\u64CD\u4F5C\u5FC5\u987B\u6EE1\u8DB3\u4E00\u6B21\u554A\u6761\u4EF6',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u4E0D\u662F\u4F5C\u4E3A\u53D1\u884C\u4EE3\u5E01\u7528\u7684\u7535\u5B50\u94B1\u5305',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u4E0D\u662F\u4F5C\u4E3A\u4EE3\u7406\u5E97\u7ED3\u7B97\u7684\u7535\u5B50\u94B1\u5305',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u4E0D\u662F\u4F5C\u4E3A\u4EA4\u6613\u4E2D\u7684\u7535\u5B50\u94B1\u5305 \u5305\u62EC \uFF08i\u63A5\u6536/\u53D1\u9001 \u8D27\u5E01\xB7\u4EE3\u5E01\uFF09',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u4E3ATRUST\u8FC7RIA\u5E01\u4EE5\u5916\u7684\u8D27\u5E01\xB7\u4EE3\u5E01',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FBRIA\u5E01\u4F59\u91CF\u5FC5\u987B20.001\u4EE5\u4E0A\u7684\u7535\u5B50\u94B1\u5305',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u7535\u5B50\u94B1\u5305\u7684\u5408\u5E76\uFF0C\u4ECE\u6211\u7684\u7535\u5B50\u94B1\u5305\u9875\u9762\u4E2D\u70B9\u51FB\u300C\u5408\u5E76\u7535\u5B50\u94B1\u5305\u300D\u8FDB\u884C\u64CD\u4F5C\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-4'),'\u9891\u7E41\u53D1\u9001\u8D27\u5E01\u7684\u7535\u5B50\u94B1\u5305\u7684\u5730\u5740\u53EF\u4EE5\u4FDD\u5B58\u5417\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u53EF\u4EE5\u7684\u3002\u4ECE\u6211\u7684\u7535\u5B50\u94B1\u5305\u9875\u9762\u70B9\u51FB\u300C\u7535\u5B50\u94B1\u5305\u63A5\u6536\u65B9\u7BA1\u7406\u300D\u8FDB\u884C\u4FDD\u5B58\u7535\u5B50\u94B1\u5305\u5730\u5740\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-5'),'\u7535\u5B50\u94B1\u5305\u5408\u5E76\u662F\u4E00\u9879\u662F\u4EC0\u4E48\u6837\u7684\u529F\u80FD\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u53EF\u5C06\u540C\u4E2A\u8D26\u6237\u5185\u7684\u4E24\u4E2A\u7535\u5B50\u94B1\u5305\u5408\u5E76\u6210\u4E00\u4E2A\u7535\u5B50\u94B1\u5305\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u7535\u5B50\u94B1\u5305\u5408\u5E76\u529F\u80FD\u53EF\u4F7F\u4E24\u4E2A\u7535\u5B50\u94B1\u5305\u5408\u5E76\u96C6\u6210\u4E00\u4E2A\u7535\u5B50\u94B1\u5305\u3002\u7535\u5B50\u94B1\u5305\u4E00\u65E6\u5408\u5E76\uFF0C\u88AB\u5438\u6536\u7684\u7535\u5B50\u94B1\u5305\u4F59\u91CF\u81EA\u52A8\u6E05\u96F6\u5E76\u5220\u9664\u3002\u7535\u5B50\u94B1\u5305\u5438\u6536\u53E6\u5916\u4E00\u4E2A\u7535\u5B50\u94B1\u5305\u96C6\u6210\u5408\u5E76\u64CD\u4F5C\u5FC5\u987B\u6EE1\u8DB3\u4E00\u6B21\u554A\u6761\u4EF6 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u30FB\u4E0D\u662F\u4F5C\u4E3A\u53D1\u884C\u4EE3\u5E01\u7528\u7684\u7535\u5B50\u94B1\u5305 \u30FB\u4E0D\u662F\u4F5C\u4E3A\u4EE3\u7406\u5E97\u7ED3\u7B97\u7684\u7535\u5B50\u94B1\u5305 \u30FB\u4E0D\u662F\u4F5C\u4E3A\u4EA4\u6613\u4E2D\u7684\u7535\u5B50\u94B1\u5305 \u5305\u62EC \uFF08i\u63A5\u6536/\u53D1\u9001 \u8D27\u5E01\xB7\u4EE3\u5E01\uFF09 \u30FB\u4E3ATRUST\u8FC7RIA\u5E01\u4EE5\u5916\u7684\u8D27\u5E01\xB7\u4EE3\u5E01 \u30FBRIA\u5E01\u4F59\u91CF\u5FC5\u987B20.001\u4EE5\u4E0A\u7684\u7535\u5B50\u94B1\u5305')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k6',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-6'),'\u4E2A\u4EBA\u8EAB\u4EFD\u786E\u8BA4\u7684\u76F8\u7247\u8D85\u8FC72MB\u65E0\u6CD5\u4E0A\u4F20\u3002\u5E94\u8BE5\u600E\u4E48\u64CD\u4F5C\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k6',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5F88\u62B1\u6B49\uFF0C\u9EBB\u70E6\u4F7F\u7528\u76F8\u7247\u7F16\u8F91\u8F6F\u4EF6\u6216\u5E94\u7528\uFF0C\u8FDB\u884C\u76F8\u7247\u8C03\u6574\u81F32MB\u4EE5\u5185\u518D\u8FDB\u884C\u4E0A\u4F20\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k7',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-7'),'\u5173\u4E8E\u7535\u5B50\u94B1\u5305\u4EA4\u6613\u8BB0\u5F55\u67E5\u8BE2'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k7',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5404\u7535\u5B50\u94B1\u5305\u7684\u4EA4\u6613\u8BB0\u5F55\u53EF\u4ECE\u7535\u5B50\u94B1\u5305\u4EA4\u6613\u8BB0\u5F55\u4E2D\u67E5\u8BE2\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-k8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-k8',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K-8'),'\u8BBE\u7F6E\u9875\u9762\u663E\u793A\u7684\u300C\u767B\u5F55\u65F6\u8BF7\u8F93\u5165\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u7801 \u300D\u8981\u6C42\uFF0C\u662F\u4EC0\u4E48\u610F\u601D\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-k8',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6211\u4EEC\u5F3A\u70C8\u63A8\u8350\u60A8\u6253\u5F00\u8BBE\u7F6E\u5E76\u70B9\u51FB\u9009\u62E9\u680F\u76EE\u7684\uFF08\u5B89\u5168\uFF09\u9009\u9879\u3002\u300C\u8981\u6C42\u767B\u5F55\u65F6\u8F93\u5165\u53CC\u91CD\u9A8C\u8BC1\u300D\u524D\u9762\u6253\u52FE\u9009\u62E9\u6765\u63D0\u9AD8\u8B66\u60D5\u6027\u3002'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item',id:'role-m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'M'),'Multisign \u7535\u5B50\u94B1\u5305')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-m1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-m1',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'M-1'),'\u4EC0\u4E48\u662FMultisig \u7535\u5B50\u94B1\u5305\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-m1',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Multisig \u7535\u5B50\u94B1\u5305\u4E0E\u666E\u901A\u7684\u7535\u5B50\u94B1\u5305\u4E0D\u540C\uFF0C\u9700\u8981\u591A\u4E2A\u5BC6\u94A5\u4F7F\u7528\uFF0C\u8FDB\u884C\u4EA4\u6613\u65F6',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Multisig\u7535\u5B50\u94B1\u5305\u9700\u8981\u591A\u4E2A\u5BC6\u94A5\u8FDB\u884C\u9A8C\u8BC1\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u666E\u901A\u7535\u5B50\u94B1\u5305\u7684\u5BC6\u94A5\u53EA\u6709\u4E00\u4E2A\u5BC6\u94A5\u3002\u4E07\u4E00\u7535\u8111\u6216\u624B\u673A\u906D\u5230\u75C5\u6BD2\u5165\u4FB5\u6216\u5728\u7EBF\u4FDD\u5B58\u7684\u5BC6',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u7801\u6216\u5BC6\u94A5\u906D\u9ED1\u5BA2\u88AB\u76D7\uFF0C\u4F1A\u9020\u6210\u8D27\u5E01\u635F\u5931\u7684\u98CE\u9669\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'TRIAM\u7684Multisig \u7535\u5B50\u94B1\u5305,\u4E00\u4E2A\u7535\u5B50\u94B1\u5305\u5BF9\u5E943\u5BC6\u94A5\u3001\u5373\u4F7F\u88AB\u6CC4\u9732\u4E00\u4E2A\u5BC6\u7801\u4E5F\u53EF\u8D77\u5230',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u9632\u76D7\u6548\u679C\u3002\u591A\u4E2A\u5BC6\u94A5\u88AB\u8BA4\u4E3A\u53EF\u500D\u6570\u589E\u52A0\u5B89\u5168\u6027\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5982\u679C\u4F7F\u7528Multisig\u7535\u5B50\u94B1\u5305\u8FDB\u884C\u4F7F\u7528 \u53D1\u9001 \u8D27\u5E01\xB7\u4EE3\u5E01 \u6BCF\u53D1\u9001\u4E00\u6B21\u5FC5\u987B\u8F93\u51653\u4E2A\u5BC6\u94A5\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'red'},'\uFF01\uFF01\uFF01\u8BF7\u6CE8\u610F\uFF01\uFF01\uFF01',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\xB7\u666E\u901A\u7535\u5B50\u94B1\u5305\u4E00\u65E6\u8BBE\u4E3AMultisig \u7535\u5B50\u94B1\u5305,\u5219\u65E0\u6CD5\u53D6\u6D88\u4E5F\u65E0\u6CD5\u518D\u8FD4\u56DE\u666E\u901A\u7535\u5B50\u94B1\u5305\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\xB7\u666E\u901A\u94B1\u5305\u4E00\u65E6\u521B\u5EFA\u4E3AMultisig \u7535\u5B50\u94B1\u5305\uFF0C\u8BE5\u7535\u5B50\u94B1\u5305\u5C06\u65E0\u6CD5\u518D\u521B\u5EFA\u4E3AShared \u7535\u5B50\u94B1',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u5305\u548C\u8BBE\u7F6EMaster key\u3002\u4E00\u65E6\u8BBE\u7F6E\u4E86Master key\u7684Shared \u7535\u5B50\u94B1\u5305\u540C\u6837\u65E0\u6CD5\u518D\u521B\u5EFA\u4E3AMultisig\u7535\u5B50\u94B1\u5305\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\xB7TRIAM\u7684Multisig \u7535\u5B50\u94B1\u5305\u8FDB\u884C\u53D1\u9001\u8D27\u5E01\u6216TRUST\u4EE3\u5E01\u65F6\u6BCF\u6B21\u5FC5\u987B\u8F93\u51653\u4E2A\u5BC6\u94A5\u7684\u64CD \u4F5C\u3002\u5982\u679C3\u4E2A\u5BC6\u94A5\u7684\u5176\u4E2D\u4E00\u4E2A\u5BC6\u94A5\u9057\u5931\uFF0C\u8BE5Multisig \u7535\u5B50\u94B1\u5305\u5C06\u6C38\u4E45\u88AB\u51BB\u7ED3\u65E0\u6CD5\u4F7F\u7528\u3002 3\u4E2A\u5BC6\u94A5\u5728\u521B\u5EFAMultisig \u7535\u5B50\u94B1\u5305\u65F6\u4EC5\u663E\u793A1\u6B21\uFF0C\u65E0\u6CD5\u518D\u6B21\u663E\u793A\u4E5F\u65E0\u6CD5\u518D\u53D1\u884C\uFF0C\u8BF7\u52A1\u5FC5 \u59A5\u5584\u4FDD\u7BA1\u597D\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u521B\u5EFAMultisig \u7535\u5B50\u94B1\u5305\u524D\uFF0C\u8BF7\u7EC6\u8BFB\u4EE5\u4E0A\u5185\u5BB9\u4E0E\u8003\u8651\u5404\u79CD\u8981\u7D20\u540E\u518D\u8FDB\u884C\u64CD\u4F5C\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-m2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-m2',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'M-2'),'\u521B\u5EFAMultisig \u7535\u5B50\u94B1\u5305\u6536\u8D39\u5417\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-m2',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u521B\u5EFAMultisig \u7535\u5B50\u94B1\u5305\u65F6\uFF0C\u5C06\u6536\u53D60.003RIA\u5E01\u4F5C\u4E3A\u8D39\u7528')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-m3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-m3',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'M-3'),'\u8BF7\u6559\u6211Multisig \u7535\u5B50\u94B1\u5305\u521B\u5EFA\u7684\u6B65\u9AA4'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-m3',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u521B\u5EFAMultisig \u7535\u5B50\u94B1\u5305\u7684\u8BBE\u7F6E\u6B65\u9AA4\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\uFF081\uFF09\u767B\u5F55\u8D26\u6237\uFF0C\u70B9\u51FB\u6211\u7684\u7535\u5B50\u94B1\u5305\u4E2D\u7684\u300CMultisig \u300D\u5F00\u59CB\u8BBE\u7F6E\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\uFF082\uFF09\u70B9\u51FB\u300C\u521B\u5EFAMultisig\u7535\u5B50\u94B1\u5305\u300D\u9009\u62E9\u60F3\u521B\u5EFA\u6210Multisig\u7684\u7535\u5B50\u94B1\u5305\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\uFF083\uFF09\u4E0B\u4E00\u9875\u9762\u5C06\u751F\u62103\u4E2A\u76F8\u5BF9\u5E94Multisig\u7535\u5B50\u94B1\u5305\u7684\u5BC6\u94A5\uFF0C\u70B9\u51FB\u300C\u751F\u6210KEY PAIRS\u300D\u5C06\u81EA\u52A8\u751F\u6210KEY PAIRS\u5E76\u81EA\u52A8\u4E0B\u8F7D\u81F3\u7EC8\u7AEF\u3002(\u56E0\u624B\u673A\u7EC8\u7AEF\u800C\u5F02\uFF0C\u4E5F\u6709\u53EF\u80FD\u5B58\u5728\u65E0\u6CD5\u4E0B\u8F7D\u7684\u60C5\u51B5\u3002\u8BF7\u52A1\u5FC5\u68C0\u67E5\u7EC8\u7AEF\u662F\u5426\u5DF2\u4E0B\u8F7DKEY PAIRS\uFF09 \u5305\u62EC\u6B64\u65F6\u5DF2\u751F\u6210\u76843\u4E2AKEY PAIRS\uFF0C\u5728\u4ECA\u540E\u4F7F\u7528Multisig \u7535\u5B50\u94B1\u5305\u8FDB\u884C\u53D1\u9001\u8D27\u5E01\u6216\u4EE3\u5E01\u65F6\uFF0C\u5FC5\u987B\u4F7F\u7528\u91CD\u8981\u5BC6\u94A5\u5BF9\u3002\u8BF7\u52A1\u5FC5\u786E\u8BA4\u5185\u5BB9\u540E\u5BF9\u5BC6\u94A5\u8FDB\u884C\u59A5\u5584\u4FDD\u7BA1\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'(4)\u8BF7\u5728\u663E\u793A3\u4E2AKEY PAIRS\u9875\u9762\u7684\u4E0B\u65B9\u663E\u793A\u300CKey pairs\u4E00\u65E6\u4E22\u5931\uFF0C\u7535\u5B50\u94B1\u5305\u5185\u7684\u8D27\u5E01/\u4EE3\u5E01\u5219\u65E0\u6CD5\u8F6C\u79FB\u3002\u8BF7\u77E5\u6089\u5E76\u7406\u89E3\u3002\u300D\u7684\u590D\u9009\u6846\u4E2D\u6253\u52FE\u540E\u70B9\u51FB\u300C\u4E0B\u4E00\u6B65\u300D\u5B8C\u6210Multisig \u7535\u5B50\u94B1\u5305\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u203B\u8BBE\u7F6EMultisig \u7535\u5B50\u94B1\u5305\u7684\u6CE8\u610F\u70B9',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u8BF7\u6CE8\u610F\uFF01\u8BBE\u7F6E\u4E3AMultisig \u7684\u7535\u5B50\u94B1\u5305\u4EC5\u9650\u4E8E\u901A\u5E38\u7684\u7535\u5B50\u94B1\u5305\u3002Shared \u7535\u5B50\u94B1\u5305\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Master key wallet\u6216Signer walle\uFF0C\u6216\u8005\u5DF2\u521B\u5EFA\u4EE3\u5E01\u7684\u7684\u7535\u5B50\u94B1\u5305\u90FD\u65E0\u6CD5\u8BBE\u7F6E\u4E3AMultisig \u7535\u5B50\u94B1\u5305\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-m4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-m4',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'M-4'),'\u4F7F\u7528 Multisig \u7535\u5B50\u94B1\u5305\u53D1\u9001\u4EE3\u5E01\u7684\u6B65\u9AA4\u5982\u4F55\u64CD\u4F5C\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-m4',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4F7F\u7528 Multisig \u7535\u5B50\u94B1\u5305\u53D1\u9001\u4EE3\u5E01\u7684\u6B65\u9AA4',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\uFF081\uFF09\u8BF7\u6253\u5F00\u9996\u9875\u83DC\u5355\u4E2D\u7684\u300CMultisig wallet\u300D\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\uFF082\uFF09\u9009\u62E9\u7535\u5B50\u94B1\u5305\uFF0C\u70B9\u51FB\u7535\u5B50\u94B1\u5305\u5185\u60F3\u8FDB\u884C\u53D1\u9001\u7684\u4EE3\u5E01\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\uFF083\uFF09\u70B9\u51FB\u300C\u53D1\u9001\u8D27\u5E01\xB7\u4EE3\u5E01\u300D\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\uFF084\uFF09\u8F93\u5165\u63A5\u6536\u65B9\u7684\u7535\u5B50\u94B1\u5305\u5730\u5740\u548C\u53D1\u9001\u7684\u6570\u91CF\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\uFF085\uFF09\u70B9\u51FB\u300C\u53D1\u9001\u300D\u6309\u94AE\uFF0C\u5C06\u5F39\u51FA\u5BC6\u94A5\u9A8C\u8BC1\u8F93\u5165\u6587\u5B57\u6846\uFF0C\u5E76\u5206\u522B\u8F93\u5165\u6240\u5C5EMultisig\u7535\u5B50\u94B1\u5305\u76843\u989D\u5BC6\u94A5\u540E\u70B9\u51FB\u300C\u786E\u8BA4\u300D\u6309\u952E\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\uFF086\uFF09\u6700\u540E\u8F93\u5165\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u4EE3\u7801\u540E\u5219\u5B8C\u6210\u53D1\u9001\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'red'},'\uFF01\uFF01\uFF01\u8BF7\u6CE8\u610F\uFF01\uFF01\uFF01',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'TRIAM\u7684Multisig \u7535\u5B50\u94B1\u5305\u6BCF\u4E00\u6B21\u7684\u4EE3\u5E01\u53D1\u9001\u90FD\u5FC5\u987B\u8F93\u51653\u4E2A\u5BC6\u94A5\u3002\u5982\u679C3\u4E2A\u5BC6\u94A5\u5176\u4E2D\u4EFB\u4F551\u4E2A\u5BC6\u94A5\u88AB\u4E22\u5931\uFF0C\u8BE5Multisig \u7535\u5B50\u94B1\u5305\u5C06\u6C38\u4E45\u65E0\u6CD5\u4F7F\u7528\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u7531\u4E8E\u6240\u5C5E\u76843\u4E2A\u5BC6\u94A5\u5728\u8BBE\u7F6E\u4E3AMultisig \u7535\u5B50\u94B1\u5305\u65F6\u4EC5\u663E\u793A1\u6B21\uFF0C\u65E0\u6CD5\u663E\u793A\u7B2C2\u6B21\u4E5F\u65E0\u6CD5\u518D\u6B21\u53D1\u884C\u3002\u8BF7\u52A1\u5FC5\u8BF7\u52A1\u5FC5\u5BF9\u5BC6\u94A5\u8FDB\u884C\u59A5\u5584\u4FDD\u7BA1\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-item-child',id:'role-m5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{'data-toggle':'collapse','data-parent':'#accordion',href:'#c_role-m5',className:'panel-title expand custom-h3-font-size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-arrow pull-right show-content'},'+'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'M-5'),'\u5B89\u88C5Multisig\u7535\u5B50\u94B1\u5305\u65F6\u4E0B\u8F7D\u7684\u5BC6\u94A5\u786E\u8BA4\u540E\uFF0C\u5BC6\u94A5\u663E\u793A\u4E3A6\u4E2A\uFF0C\u54EA\u4E2A\u624D\u662F\u5BC6\u94A5\uFF1F'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'c_role-m5',className:'panel-collapse collapse '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-role-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Multisig\u7535\u5B50\u94B1\u5305\u76843\u4E2A\u5BC6\u94A5\uFF0C\u5728\u751F\u6210KEY PAIRS\u4E0B\u8F7D\u540E\u6587\u4EF6\u4E2D\u663E\u793A\u53F3\u8FB9\u7684\u4E3A\u5BC6\u94A5\u3002\u4E3A\u4E86\u65B9\u4FBF\u7CFB\u7EDF\uFF0C\u5DE6\u8FB9\u7684\u300CPUBLIC KEY\u300D\u548C\u53F3\u8FB9\u663E\u793A\u662F\u4E3A\u4E00\u5BF9\u7684\u3002\u8BF7\u6CE8\u610F\uFF0C\u5982\u679C\u53D1\u9001\u4EE3\u5E01\u7B49\u6216\u8FDB\u884C\u4EA4\u6613\u65F6\u5982\u679C\u8F93\u5165\u300CPUBLIC KEY\u300D\u5C06\u663E\u793A\u9519\u8BEF\u65E0\u6CD5\u6279\u51C6\u3002')))))))))));}}]);return FaqCh;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FaqCh);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageNotFound=function(_Component){_inherits(PageNotFound,_Component);function PageNotFound(){_classCallCheck(this,PageNotFound);return _possibleConstructorReturn(this,(PageNotFound.__proto__||Object.getPrototypeOf(PageNotFound)).apply(this,arguments));}_createClass(PageNotFound,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}]);return PageNotFound;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PageNotFound);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__privacyPolicyContent__ = __webpack_require__(136);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrivacyPolicy=function(_Component){_inherits(PrivacyPolicy,_Component);function PrivacyPolicy(){_classCallCheck(this,PrivacyPolicy);return _possibleConstructorReturn(this,(PrivacyPolicy.__proto__||Object.getPrototypeOf(PrivacyPolicy)).apply(this,arguments));}_createClass(PrivacyPolicy,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;setTimeout(function(){return _this2.node.scrollIntoView();},0);}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],{ns:'translations'},function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'wraper-other',ref:function ref(node){return _this3.node=node;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__menu__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'contact'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__privacyPolicyContent__["a" /* default */],{t:t}),';'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer__["a" /* default */],null));});}}]);return PrivacyPolicy;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PrivacyPolicy);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrivacyPolicyContent=function(_Component){_inherits(PrivacyPolicyContent,_Component);function PrivacyPolicyContent(){_classCallCheck(this,PrivacyPolicyContent);return _possibleConstructorReturn(this,(PrivacyPolicyContent.__proto__||Object.getPrototypeOf(PrivacyPolicyContent)).apply(this,arguments));}_createClass(PrivacyPolicyContent,[{key:"render",value:function render(){var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mgt-30 faq-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"common-title"},t('privacy_title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"common-title"},t('privacy_subtitle_1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),t('privacy_subtitle_2'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"faq-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"list-policy"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"list-policy-item row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"list-policy-sidenav col-12 col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,t('article_1'))),t('article_1_content')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,t('article_2'))),t('article_2_content')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,t('article_3'))),t('article_3_content')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,t('article_4'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,t('article_4_p_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,t('article_4_p_2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_4_p_2_li_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_4_p_2_li_2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_4_p_2_li_3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_4_p_2_li_4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_4_p_2_li_5')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_4_p_2_li_6')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_4_p_2_li_7')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_4_p_2_li_8')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_4_p_2_li_9')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_4_p_2_li_10')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,t('article_5'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,t('article_5_p_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,t('article_5_p_2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_5_p_2_li_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_5_p_2_li_2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_5_p_2_li_3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_5_p_2_li_4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_5_p_2_li_5')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_5_p_2_li_6')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_5_p_2_li_7')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_5_p_2_li_8'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,t('article_5_p_3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_5_p_3_li_1'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,t('article_5_p_4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_5_p_4_li_1')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,t('article_6'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,t('article_6_p_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_6_p_1_li_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_6_p_1_li_2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_6_p_1_li_3'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,t('article_6_p_2'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,t('article_7'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,t('article_7_p_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,t('article_7_p_2'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,t('article_8'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,t('article_8_p_1'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,t('article_9'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,t('article_9_p_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_9_p_1_li_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u30FB "),t('article_9_p_1_li_2')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,t('article_10'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,t('article_10_p_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,t('article_10_p_2'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,t('article_11'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,t('article_11_p_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,t('article_11_p_2'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,t('article_12'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,t('article_12_p_1'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,t('address_'),":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{paddingLeft:10}},"Room 705,7th Floor, Nam Wo Hong Building, 148 Wing Lok Street, Sheung Wan, Hong Kong")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,t('company_name'),":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{paddingLeft:10}},"EXCEL FINANCE LIMITED")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,t('email_address'),":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{paddingLeft:10}},"info@excelfinance-ltd.com")))))))))));}}]);return PrivacyPolicyContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PrivacyPolicyContent);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auto_transfer_ja__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auto_transfer_en__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auto_transfer_ch__ = __webpack_require__(140);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GuideAutoTransfer=function(_Component){_inherits(GuideAutoTransfer,_Component);function GuideAutoTransfer(){_classCallCheck(this,GuideAutoTransfer);return _possibleConstructorReturn(this,(GuideAutoTransfer.__proto__||Object.getPrototypeOf(GuideAutoTransfer)).apply(this,arguments));}_createClass(GuideAutoTransfer,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;setTimeout(function(){return _this2.node.scrollIntoView();},0);}},{key:'render',value:function render(){var _this3=this;var language=localStorage.getItem('i18nextLng');var atContent=void 0;switch(language){case'ja':atContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__auto_transfer_ja__["a" /* default */],null);break;case'ch':atContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__auto_transfer_ch__["a" /* default */],null);break;default:atContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__auto_transfer_en__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],{ns:'translations'},function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'wraper-other',ref:function ref(node){return _this3.node=node;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__menu__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'auto-transfer'},atContent),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer__["a" /* default */],null));});}}]);return GuideAutoTransfer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GuideAutoTransfer);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AutoTransferJa=function(_Component){_inherits(AutoTransferJa,_Component);function AutoTransferJa(){_classCallCheck(this,AutoTransferJa);return _possibleConstructorReturn(this,(AutoTransferJa.__proto__||Object.getPrototypeOf(AutoTransferJa)).apply(this,arguments));}_createClass(AutoTransferJa,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mgt-30 faq-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-center block-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"common-title"},"TRIAM Auto Transfer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"version: 1.0.1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"opening"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"intro"},"Auto Transfer\u6A5F\u80FD\u3068\u306F\u3001\u6307\u5B9A\u3057\u305F\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u306E\u6307\u5B9A\u3057\u305F\u30B3\u30A4\u30F3\u304C\u3001\u8A2D\u5B9A\u3057\u305F\u6570\u91CF\u3092\u8D85\u904E\u3057\u305F\u969B\u306B\u81EA\u52D5\u7684\u306B\u4ED6\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u8D85\u904E\u5206\u3092\u8EE2\u9001\u3059\u308B\u6A5F\u80FD\u3067\u3059\u3002 \u4F8B\u3048\u3070\u9867\u5BA2\u304B\u3089\u306E\u30B3\u30A4\u30F3\u652F\u6255\u3092\u53D7\u3051\u53D6\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u306A\u3069\u306B\u8A2D\u5B9A\u3059\u308B\u3053\u3068\u3067\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u6B8B\u9AD8\u306E\u904E\u5270\u3092\u9632\u304E\u3001\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u3092\u9AD8\u3081\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"example"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4F8B\uFF09"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2460\u300C\u9867\u5BA2\u304B\u3089\u306E\u30B3\u30A4\u30F3\u652F\u6255\u3092\u53D7\u3051\u53D6\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u300D\u306BAuto Transfer\u6A5F\u80FD\u3092\u8A2D\u5B9A\u3059\u308B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u6307\u5B9A\u30B3\u30A4\u30F3\uFF1ARIA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u6307\u5B9A\u30B3\u30A4\u30F3\u6570\u91CF\uFF1A500,000RIA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u8EE2\u9001\u5148\u30A6\u30A9\u30EC\u30C3\u30C8\uFF1A\u300C\u9867\u5BA2\u652F\u6255\u30B3\u30A4\u30F3\u7BA1\u7406\u30A6\u30A9\u30EC\u30C3\u30C8\u300D"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2461 \u9867\u5BA2\u304B\u3089\u300C\u9867\u5BA2\u304B\u3089\u306E\u30B3\u30A4\u30F3\u652F\u6255\u3092\u53D7\u3051\u53D6\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u300D\u3078\u30B3\u30A4\u30F3\u9001\u4FE1\u304C\u884C\u308F\u308C\u308B\u3002\u300C\u9867\u5BA2\u304B\u3089\u306E\u30B3\u30A4\u30F3\u652F\u6255\u3092\u53D7\u3051\u53D6\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u300D\u5185\u306E\u6B8B\u9AD8\u304C\u6307\u5B9A\u3057\u305F\u6570\u91CF\u3092\u8D85\u3048\u305F\u5834\u5408\u3001\u81EA\u52D5\u7684\u306B\u904E\u5270\u5206\u306E\u30B3\u30A4\u30F3\u304C\u300C\u9867\u5BA2\u652F\u6255\u30B3\u30A4\u30F3\u7BA1\u7406\u30A6\u30A9\u30EC\u30C3\u30C8\u300D\u3078\u8EE2\u9001\u3055\u308C\u308B\u3002")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/auto-transfer-des.png",alt:"Auto Transfer Des"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"guide"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Auto Transfer\u6A5F\u80FD\u306E\u8A2D\u5B9A\u624B\u9806")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"step-guide decimal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30ED\u30B0\u30A4\u30F3\u3057\u3001\u30E1\u30CB\u30E5\u30FC\u306E\u300CAuto Transfer\u300D\u30DA\u30FC\u30B8\u304B\u3089\u8A2D\u5B9A\u3057\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"[Setup Auto Transfer\uFF3D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s1.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Name"),"\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306B\u306F\u8A2D\u5B9A\u3059\u308BAuto Transfer\u306E\u8AAC\u660E\u3092\u5165\u529B\u3057\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Source Wallet"),"\u306B\u306FAuto Transfer\u6A5F\u80FD\u3092\u8A2D\u5B9A\u3057\u305F\u3044\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Amount"),"\u306FSource Wallet\u3067\u4FDD\u6709\u3059\u308B\u6B8B\u9AD8\u306E\u4E0A\u9650\u6570\u91CF\u3092\u5165\u529B\u3057\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u4F8B\uFF09Amount\u306B100,000\u3068\u8A2D\u5B9A\u3057\u305F\u5834\u5408\u3001\u305D\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u3067100,000\u3092\u8D85\u3048\u308B\u30B3\u30A4\u30F3\u3092\u4FDD\u6709\u3057\u305F\u5834\u5408\u306BAuto Transfer\u6A5F\u80FD\u304C\u4F5C\u52D5\u3057\u3001\u81EA\u52D5\u7684\u306B\u8D85\u904E\u5206\u304C\u6307\u5B9A\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u8EE2\u9001\u3055\u308C\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Asset"),"\u3067\u30B3\u30A4\u30F3\u306E\u7A2E\u985E\u3092\u9078\u629E\u3057\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uFF3BNEXT\uFF3D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s2.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u6B21\u306BAuto Transfer\u6A5F\u80FD\u304C\u4F5C\u52D5\u3057\u305F\u969B\u306E\u30B3\u30A4\u30F3\u306E\u8EE2\u9001\u5148\u30A6\u30A9\u30EC\u30C3\u30C8\uFF08Destination Wallet\uFF09\u3092\u8A2D\u5B9A\u3057\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u540C\u3058\u30A2\u30AB\u30A6\u30F3\u30C8\u5185\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u8A2D\u5B9A\u3059\u308B\u5834\u5408\u306F\u300CSelect destination from your wallets\u300D\u304B\u3089\u9078\u629E\u3057\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u5225\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u5185\u306B\u3042\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u8A2D\u5B9A\u3059\u308B\u5834\u5408\u306F\u300CEnter the destination\u300D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306B\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u3092\u76F4\u63A5\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u5165\u529B\u3057\u305F\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u3092\u78BA\u8A8D\u3057\u3066\uFF3BNEXT\uFF3D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s3.png",alt:"Auto Transfer S3"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text highlight"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u6CE8\u610F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Destination Wallet\u306B\u306F\u3001\u30B3\u30A4\u30F3\u53D7\u4FE1\u306E\u969B\u306BTag\u306E\u6307\u5B9A\u304C\u5FC5\u8981\u306E\u306A\u3044\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u4F8B\u3048\u3070Tag\u306E\u6307\u5B9A\u304C\u5FC5\u8981\u306A\u53D6\u5F15\u6240\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u7B49\u3092Destination Wallet\u306B\u8A2D\u5B9A\u3057\u305F\u5834\u5408\u3001Auto Transfer\u306E\u8EE2\u9001\u51E6\u7406\u81EA\u4F53\u306F\u5B9F\u884C\u3055\u308C\u307E\u3059\u304C\u3001\u53D7\u3051\u53D6\u308A\u5074\u3067\u4E0D\u660E\u306A\u7740\u91D1\u3068\u306A\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u306E\u3067\u304F\u308C\u3050\u308C\u3082\u3054\u6CE8\u610F\u304F\u3060\u3055\u3044\u3002"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u6B21\u306E\u753B\u9762\u3067\u306F\u8A2D\u5B9A\u3057\u305FAuto Transfer\u6A5F\u80FD\u306E\u6D41\u308C\u304C\u56F3\u3067\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u78BA\u8A8D\u3057\u3066\uFF3BNEXT\uFF3D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s4.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u6700\u7D42\u78BA\u8A8D\u753B\u9762\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u306E\u3067\u3001\u78BA\u8A8D\u3057\u3066\uFF3BCONFIRM\uFF3D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s5.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"OP\u30D1\u30B9\u30EF\u30FC\u30C9\u3068Google\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u3092\u5165\u529B\u3057\u3066\u5B8C\u4E86\u3067\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s6.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Auto Transfer\u306E\u8A2D\u5B9A\u60C5\u5831\u306F\u5404\u30A6\u30A9\u30EC\u30C3\u30C8\u3054\u3068\u306B\u78BA\u8A8D\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s7.png",alt:"Auto Transfer S1"})))))))));}}]);return AutoTransferJa;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AutoTransferJa);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AutoTransferEn=function(_Component){_inherits(AutoTransferEn,_Component);function AutoTransferEn(){_classCallCheck(this,AutoTransferEn);return _possibleConstructorReturn(this,(AutoTransferEn.__proto__||Object.getPrototypeOf(AutoTransferEn)).apply(this,arguments));}_createClass(AutoTransferEn,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mgt-30 faq-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-center block-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"common-title"},"TRIAM Auto Transfer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"version: 1.0.1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"opening"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"intro"},"The Auto Transfer function is a function which automatically transfers the exceed amount to another wallet when the specified coin in the specified wallet exceed the set quantity. For example, you can set up as a wallet receive coin paymens from customers to prevent excessive wallet balances and increase security."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"example"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Example:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2460 Set Auto Transfer function in the \u201Cwallet receiving coin payments from customer\u201D"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Specified coin\uFF1ARIA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Specified coin amount\uFF1A500,000RIA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Destination wallet: \u201CCustomer payment coin management wallet\u201D"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2461 Coins will be sent from the customer to the wallet \u201Cwallet receiving coin payments from customer\u201D. If the balance in \u201Cwallet receiving coin payment from customer\u201D exceeds the specified quantity, excess coins will be automatically transferred to \u201CCustomer payment coin management wallet\u201D.")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/auto-transfer-des-en.png",alt:"Auto Transfer Des"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"guide"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"How to set up the Auto Transfer function")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"step-guide decimal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Login to account and set from Menu\u2019s Auto Transfer page"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Click Setup Auto Transfer button")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s1.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"In the ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Name")," field, enter a description of the Auto Transfer you want to set"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"For ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Source Wallet"),", please select the wallet you want to set the Auto Transfer function"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"In ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Amount"),", enter the maximum amount of balance held by Soure Wallet"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Example: If Amount is set to 100,000, the Auto Transfer function will be actived if you hold more than 100,000 coins in that wallet, and the excess amount will be automatically transferred to the specified wallet."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Select the coin type in ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Asset")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Click NEXT button")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s2.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Next, set the destination wallet for coins when the Auto Transfer function is actived."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"If you want to set up a wallet in the same account, select from \u201CSelect destination from your wallets\u201D."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"If you want to set up a wallet in another account, please enter the wallet address directly in the \u201CEnter the destination\u201D field."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Check the wallet address you entered and click NEXT button.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s3.png",alt:"Auto Transfer S3"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text highlight"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Notices:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"For Destination wallet, please set a wallet that does not require Tag to be specified when receiving coins. For example, if you set the wallet address of the exchange that requires Tag specification to Destination Wallet, the transfer process itself of Auto Transfer will be performed but please be careful because it may become an unknown deposit on the receiving side. "))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"On the next screen, you can check the flow of the set Auto Transfer function in the diagram."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Check and click NEXT button ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s4.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"The final confirmation screen will be displayed. Confirm it and click CONFIRM button. ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s5.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Enter your OP password and Google TFA and complete. ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s6.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Auto Transfer setting information can be checked for each wallet.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s7.png",alt:"Auto Transfer S1"})))))))));}}]);return AutoTransferEn;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AutoTransferEn);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AutoTransferCh=function(_Component){_inherits(AutoTransferCh,_Component);function AutoTransferCh(){_classCallCheck(this,AutoTransferCh);return _possibleConstructorReturn(this,(AutoTransferCh.__proto__||Object.getPrototypeOf(AutoTransferCh)).apply(this,arguments));}_createClass(AutoTransferCh,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mgt-30 faq-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-center block-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"common-title"},"TRIAM Auto Transfer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"version: 1.0.1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"opening"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"intro"},"\u4EC0\u4E48\u662FAuto Transfer\u7684\u529F\u80FD\uFF1F\u5F53\u60A8\u7684\u7535\u5B50\u94B1\u5305\u8D85\u8FC7\u6240\u8BBE\u7F6E\u7684\u4EE3\u5E01\u6570\u91CF\u65F6\uFF0C\u591A\u4F59\u7684\u4EE3\u5E01\u5C06\u81EA\u52A8\u8F6C\u5165\u53E6\u4E00\u4E2A\u7535\u5B50\u94B1\u5305\u7684\u4E00\u79CD\u529F\u80FD\u3002 \u4F8B\u5982 \u5728\u63A5\u6536\u987E\u5BA2\u652F\u4ED8\u4EE3\u5E01\u7684\u7535\u5B50\u94B1\u5305\u4E2D\u8BBE\u7F6E\u6B64\u529F\u80FD\uFF0C\u65E2\u53EF\u4EE5\u9632\u6B62\u7535\u5B50\u94B1\u5305\u4E2D\u7684\u4F59\u989D\u8FC7\u591A\uFF0C\u5E76\u4E14\u53EF\u4EE5\u63D0\u9AD8\u7535\u5B50\u94B1\u5305\u7684\u9AD8\u5B89\u5168\u6027\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"example"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4F8B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2460 \u63A5\u6536\u987E\u5BA2\u652F\u4ED8\u4EE3\u5E01\u7684\u7535\u5B50\u94B1\u5305\u300D\u8FDB\u884CAuto Transfer\u7684\u529F\u80FD\u8BBE\u7F6E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u8BBE\u7F6E\u7684\u4EE3\u5E01\uFF1ARIA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u8BBE\u7F6E\u4EE3\u5E01\u7684\u6570\u91CF\uFF1A500,000 RIA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u8F6C\u9001\u7684\u7535\u5B50\u94B1\u5305\uFF1A\u300C\u987E\u5BA2\u652F\u4ED8\u7BA1\u7406\u7535\u5B50\u94B1\u5305\u300D"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2461 \u987E\u5BA2\u5BF9\u300C\u63A5\u6536\u987E\u5BA2\u652F\u4ED8\u4EE3\u5E01\u7684\u7535\u5B50\u94B1\u5305\u300D\u8FDB\u884C\u53D1\u9001\u4EE3\u5E01\u3002\u5F53\uFF08\u63A5\u6536\u987E\u5BA2\u652F\u4ED8\u4EE3\u5E01\u7684\u7535\u5B50\u94B1\u5305\uFF09\u5185\u7684\u4EE3\u5E01\u6570\u91CF\u8D85\u8FC7\u4E86\u60A8\u6240\u8BBE\u7F6E\u4EE3\u5E01\u6570\u91CF\u7684\u65F6\u5019 \u591A\u4F59\u7684\u4EE3\u5E01\u6570\u91CF\u5C06\u81EA\u52A8\u8F6C\u79FB\u81F3\uFF08\u987E\u5BA2\u652F\u4ED8\u7BA1\u7406\u7535\u5B50\u94B1\u5305\uFF09\u4E2D\u3002")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/auto-transfer-des-ch.png",alt:"Auto Transfer Des"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"guide"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Auto Transfer\u529F\u80FD\u7684\u8BBE\u7F6E\u987A\u5E8F")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"step-guide decimal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u767B\u5F55\u8D26\u53F7 \u4ECE\u83DC\u5355\u4E2D\u7684\u300CAuto Transfer\u300D\u9875\u9762\u5F00\u59CB\u8BBE\u7F6E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u70B9\u51FB\uFF3BSetup Auto Transfer\uFF3D\u6309\u94AE")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s1.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u5728\u540D\u79F0\u5B57\u6BB5\u4E2D\u8F93\u5165\u8BBE\u7F6EAuto Transfer\u7684\u5185\u5BB9\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u8BF7\u9009\u62E9\u9700\u8981\u8BBE\u7F6EAuto Transfer\u529F\u80FD\u7684Source Wallet\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u8BF7\u5728\u7535\u5B50\u94B1\u5305\u4E2D\u8F93\u5165Amount\u6301\u6709\u4F59\u989D\u7684\u6700\u5927\u91CF\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"(\u4F8B) \u5982\u679C\u5C06Amount\u8BBE\u7F6E\u4E3A100000\u65F6 \u8BE5\u7535\u5B50\u94B1\u5305\u8D85\u8FC7\u6301\u6709\u4EE3\u5E01100000\u65F6 Auto Transfer\u7684\u529F\u80FD\u5C06\u81EA\u52A8\u5F00\u542F \u81EA\u52A8\u7684\u5C06\u8D85\u51FA\u7684\u6570\u91CF\u8F6C\u9001\u81F3\u6240\u6307\u5B9A\u7684\u7535\u5B50\u94B1\u5305\u4E2D\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u8BF7\u5728Asset\u9009\u62E9\u4EE3\u5E01\u7684\u79CD\u7C7B\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u8BF7\u70B9\u51FB\uFF3BNEXT\uFF3D\u6309\u94AE\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s2.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u4E0B\u4E00\u6B65\u8BBE\u7F6E \u542F\u7528Auto Transfer\u524D\u5148\u8BBE\u7F6E\u8F6C\u9001\u4EE3\u5E01\u7528\u7684\uFF08Destination Wallet\uFF09\u7535\u5B50\u94B1\u5305\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u5982\u679C\u9700\u8981\u540C\u4E00\u4E2A\u8D26\u53F7\u8BBE\u7F6E\u7535\u5B50\u94B1\u5305\uFF0C\u8BF7\u5728\u300CSelect destination from your wallets\u300D\u4E2D\u9009\u62E9\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u5982\u679C\u5728\u4E0D\u540C\u8D26\u53F7\u5185\u8BBE\u7F6E\u7535\u5B50\u94B1\u5305\u7684 \u76F4\u63A5\u5728\u300CEnter the destination\u300D\u7684\u5B57\u6BB5\u4E2D\u76F4\u63A5\u8F93\u5165\u7535\u5B50\u94B1\u5305\u5730\u5740\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u8BF7\u786E\u8BA4\u8F93\u5165\u7684\u7535\u5B50\u94B1\u5305\u5730\u5740\u540E\u70B9\u51FB\uFF3BNEXT\uFF3D\u6309\u94AE\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s3.png",alt:"Auto Transfer S3"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text highlight"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u6CE8\u610F\uFF01"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Destination Wallet \u63A5\u6536\u4EE3\u5E01\u65F6\u8BF7\u8BBE\u7F6E\u4E00\u4E2A\u4E0D\u9700\u8981Tag\u7684\u7535\u5B50\u94B1\u5305\u3002\u4F8B\u5982 \u5982\u679C\u9700\u8981\u8F93\u5165Tag\u4EA4\u6613\u6240\u7684\u7535\u5B50\u94B1\u5305 \u867D\u7136Auto Transfer\u4E5F\u4F1A\u81EA\u52A8\u6267\u884C\u8F6C\u9001\uFF0C\u8BF7\u6CE8\u610F \u4F1A\u51FA\u73B0\u63A5\u6536\u65B9\u63A5\u6536\u65F6\u663E\u793A\u4E00\u7B14\u672A\u77E5\u5B58\u6B3E\u7684\u53EF\u80FD\u6027\u3002"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u5728\u4E0B\u4E00\u9875\u9762\u53EF\u4EE5\u786E\u8BA4\u6240\u8BBE\u7F6E\u7684Auto Transfer\u6D41\u7A0B\u56FE\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u8BF7\u6309\uFF3BNEXT\uFF3D\u6309\u94AE\u786E\u8BA4\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s4.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u5C06\u663E\u793A\u6700\u7EC8\u786E\u8BA4\u753B\u9762 \u8BF7\u786E\u8BA4\u5E76\u70B9\u51FB\uFF3BCONFIRM\uFF3D\u6309\u94AE\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s5.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u8BF7\u8F93\u5165OP\u5BC6\u7801\u548C\u8C37\u6B4C\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s6.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Auto Transfer\u7684\u8BBE\u7F6E\u8D44\u6599\u53EF\u5728\u5404\u7535\u5B50\u94B1\u5305\u4E2D\u786E\u8BA4\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/setup-auto-transfer-s7.png",alt:"Auto Transfer S1"})))))))));}}]);return AutoTransferCh;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AutoTransferCh);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auto_transfer_app_ja__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auto_transfer_app_en__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auto_transfer_app_ch__ = __webpack_require__(144);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GuideAutoTransferApp=function(_Component){_inherits(GuideAutoTransferApp,_Component);function GuideAutoTransferApp(){_classCallCheck(this,GuideAutoTransferApp);return _possibleConstructorReturn(this,(GuideAutoTransferApp.__proto__||Object.getPrototypeOf(GuideAutoTransferApp)).apply(this,arguments));}_createClass(GuideAutoTransferApp,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;setTimeout(function(){return _this2.node.scrollIntoView();},0);}},{key:'render',value:function render(){var _this3=this;var language=localStorage.getItem('i18nextLng');var atContent=void 0;switch(language){case'ja':atContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__auto_transfer_app_ja__["a" /* default */],null);break;case'ch':atContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__auto_transfer_app_ch__["a" /* default */],null);break;default:atContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__auto_transfer_app_en__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],{ns:'translations'},function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'wraper-other',ref:function ref(node){return _this3.node=node;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__menu__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'auto-transfer-app'},atContent),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer__["a" /* default */],null));});}}]);return GuideAutoTransferApp;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GuideAutoTransferApp);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AutoTransferAppJa=function(_Component){_inherits(AutoTransferAppJa,_Component);function AutoTransferAppJa(){_classCallCheck(this,AutoTransferAppJa);return _possibleConstructorReturn(this,(AutoTransferAppJa.__proto__||Object.getPrototypeOf(AutoTransferAppJa)).apply(this,arguments));}_createClass(AutoTransferAppJa,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mgt-30 faq-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-center block-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"common-title"},"TRIAM Auto Transfer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"version: 1.0.4.1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"opening"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"intro"},"Auto Transfer\u6A5F\u80FD\u3068\u306F\u3001\u6307\u5B9A\u3057\u305F\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u306E\u6307\u5B9A\u3057\u305F\u30B3\u30A4\u30F3\u304C\u3001\u8A2D\u5B9A\u3057\u305F\u6570\u91CF\u3092\u8D85\u904E\u3057\u305F \u969B\u306B\u81EA\u52D5\u7684\u306B\u4ED6\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u8D85\u904E\u5206\u3092\u8EE2\u9001\u3059\u308B\u6A5F\u80FD\u3067\u3059\u3002",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u4F8B\u3048\u3070\u9867\u5BA2\u304B\u3089\u306E\u30B3\u30A4\u30F3\u652F\u6255\u3092\u53D7\u3051\u53D6\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u306A\u3069\u306B\u8A2D\u5B9A\u3059\u308B\u3053\u3068\u3067\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u6B8B\u9AD8\u306E\u904E\u5270\u3092\u9632\u304E\u3001\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u3092\u9AD8\u3081\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"example"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4F8B\uFF09"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2460 \u9867\u5BA2\u304B\u3089\u306E\u30B3\u30A4\u30F3\u652F\u6255\u3092\u53D7\u3051\u53D6\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u300D\u306BAuto Transfer\u6A5F\u80FD\u3092\u8A2D\u5B9A\u3057\u307E\u3059"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{marginLeft:'25px'}},"\u6307\u5B9A\u30B3\u30A4\u30F3\uFF1ARIA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{marginLeft:'25px'}},"\u6307\u5B9A\u30B3\u30A4\u30F3\u6570\u91CF\uFF1A500,000RIA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{marginLeft:'25px'}},"\u8EE2\u9001\u5148\u30A6\u30A9\u30EC\u30C3\u30C8\uFF1A\u300C\u9867\u5BA2\u652F\u6255\u30B3\u30A4\u30F3\u7BA1\u7406\u30A6\u30A9\u30EC\u30C3\u30C8\u300D"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2461 \u9867\u5BA2\u304B\u3089\u300C\u9867\u5BA2\u304B\u3089\u306E\u30B3\u30A4\u30F3\u652F\u6255\u3092\u53D7\u3051\u53D6\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u300D\u3078\u30B3\u30A4\u30F3\u9001\u4FE1\u304C\u884C\u308F\u308C\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u300C\u9867\u5BA2\u304B\u3089\u306E\u30B3\u30A4\u30F3\u652F\u6255\u3092\u53D7\u3051\u53D6\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u300D\u5185\u306E\u6B8B\u9AD8\u304C\u6307\u5B9A\u3057\u305F\u6570\u91CF\u3092\u8D85\u3048\u305F\u5834\u5408\u3001\u81EA\u52D5\u7684\u306B\u904E\u5270\u5206\u306E\u30B3\u30A4\u30F3\u304C\u300C\u9867\u5BA2\u652F\u6255\u30B3\u30A4\u30F3\u7BA1\u7406\u30A6\u30A9\u30EC\u30C3\u30C8\u300D\u3078\u8EE2\u9001\u3055\u308C\u307E\u3059\u3002")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/auto-transfer-des.png",alt:"Auto Transfer Des"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"guide guide-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Auto Transfer\u6A5F\u80FD\u306E\u8A2D\u5B9A\u624B\u9806")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"step-guide decimal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2460 \u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30ED\u30B0\u30A4\u30F3\u3057\u3001\u30E1\u30CB\u30E5\u30FC\u753B\u9762\u306E\u53F3\u4E0B\u306E\u300CSettings\u300D\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s1.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2461 \u30B9\u30AF\u30ED\u30FC\u30EB\u3057\u3001\u300CAuto Transfer\u300D\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s2.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2462\u300CSetup Auto Transfer\u300D\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s3.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"1. Wallet & Asset")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2463 \u30BF\u30A4\u30C8\u30EB\u3084\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u9078\u629E\u306A\u3069\u3092\u8A2D\u5B9A\u3057\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Name"),"\u2026\u8A2D\u5B9A\u3059\u308BAuto Transfer\u306E\u8AAC\u660E\u3092\u5165\u529B\u3057\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u203B\u8A2D\u5B9A\u5F8C\u3001\u5185\u5BB9\u78BA\u8A8D\u3001\u5909\u66F4\u7B49\u3059\u308B\u969B\u306B\u76EE\u5370\u306B\u306A\u308A\u307E\u3059"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Source wallet"),"\u2026Auto Transfer\u6A5F\u80FD\u3092\u8A2D\u5B9A\u3057\u305F\u3044\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Min amount"),"\u2026Source wallet\u3067\u4FDD\u6709\u3059\u308B\u6B8B\u9AD8\u306E\u4E0A\u9650\u6570\u91CF\u3092\u5165\u529B \u3057\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Asset"),"\u2026\u30B3\u30A4\u30F3\u306E\u7A2E\u985E\u3092\u9078\u629E\u3057\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u5168\u3066\u306E\u5165\u529B\u304C\u5B8C\u4E86\u3057\u305F\u3089\u300CNext\u300D\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s4.png",alt:"Auto Transfer S3"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"2. Destination & Amount")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2464Auto Transfer\u6A5F\u80FD\u304C\u4F5C\u52D5\u3057\u305F\u969B\u306E\u30B3\u30A4\u30F3\u306E\u8EE2\u9001\u5148\u30A6\u30A9\u30EC\u30C3\u30C8(Destination Wallet)\u3092\u9078\u629E\u3057\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Select destination from your wallets")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u2192"),"\u540C\u3058\u30A2\u30AB\u30A6\u30F3\u30C8\u5185\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u5834\u5408\u306F\u3053\u3053\u304B\u3089\u9078\u629E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Enter the destination")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u2192"),"\u5225\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u5185\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u5834\u5408\u306F\u3053\u3061\u3089\u3092\u9078\u629E\u3002\u76F4\u63A5\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u5165\u529B\u5185\u5BB9\u3092\u518D\u5EA6\u78BA\u8A8D\u3057\u3066\u300CNext\u300D\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s5.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text highlight"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u203B\u6CE8\u610F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Destination Wallet\u306B\u306F\u3001\u30B3\u30A4\u30F3\u53D7\u4FE1\u306E\u969B\u306BTag\u306E\u6307\u5B9A\u304C\u5FC5\u8981\u306E\u306A\u3044\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u8A2D\u5B9A\u3057\u3066\u4E0B\u3055\u3044\u3002\u3082\u3057\u3001Tag\u306E\u6307\u5B9A\u304C\u5FC5\u8981\u306A\u53D6\u5F15\u6240\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u7B49\u3092Destination Wallet\u306B\u8A2D\u5B9A\u3057\u305F\u5834\u5408\u3001Auto Transfer\u306E\u8EE2\u9001\u51E6\u7406\u81EA\u4F53\u306F\u5B9F\u884C\u3055\u308C\u307E\u3059\u304C\u3001\u53D7\u53D6\u5074\u3067\u4E0D\u660E\u306A\u7740\u91D1\u3068\u306A\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u306E\u3067\u304F\u308C\u3050\u308C\u3082\u3054\u6CE8\u610F\u4E0B\u3055\u3044\u3002"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"3. Review")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2465 \u6B21\u306E\u753B\u9762\u3067\u306F\u8A2D\u5B9A\u3057\u305FAuto Transfer\u6A5F\u80FD\u306E\u6D41\u308C\u304C\u56F3\u3067\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u78BA\u8A8D\u3057\u3066\u300CNext\u300D\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s6.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"4. Confirm")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2466 \u6700\u7D42\u78BA\u8A8D\u753B\u9762\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u306E\u3067\u3001\u78BA\u8A8D\u3057\u3066\u300CConfirm\u300D\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s7.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2467 OP\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3001\u300CConfirm\u300D\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s8.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2468 Google\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u3092\u5165\u529B\u3057\u3001\u300CConfirm\u300D\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s9.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"5. Done")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2469 \u8A2D\u5B9A\u304C\u5B8C\u4E86\u3059\u308B\u3068\u5DE6\u56F3\u306B\u306A\u308A\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u30E1\u30CB\u30E5\u30FC\u753B\u9762\u3078\u306F\u300CDone\u300D\u3092\u30BF\u30C3\u30D7\u3057\u3066\u623B\u308A\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u3053\u308C\u3067\u8A2D\u5B9A\u306F\u5B8C\u4E86\u3067\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s10.png",alt:"Auto Transfer S1"})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"guide guide-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{style:{marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Auto Transfer\u6A5F\u80FD\u306E\u8A2D\u5B9A\u5185\u5BB9\u5909\u66F4\u53CA\u3073\u624B\u9806")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Auto Transfer\u6A5F\u80FD\u306E\u5404\u7A2E\u8A2D\u5B9A\u3092\u5909\u66F4\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"step-guide decimal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2460 \u30E1\u30CB\u30E5\u30FC\u753B\u9762\u53F3\u4E0B\u306E\u300CSettings\u300D\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s1.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2461 \u30B9\u30AF\u30ED\u30FC\u30EB\u3057\u3001\u300CAuto Transfer\u300D\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s2.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2462 \u5909\u66F4\u3057\u305F\u3044Auto Transfer\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u203BName\u3067\u8A2D\u5B9A\u3057\u305FAuto Transfer\u3092\u898B\u5206\u3051\u308B\u3053\u3068\u304C\u51FA\u6765\u307E\u3059")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s13.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2463 Auto Transfer\u306E\u8A73\u7D30\u753B\u9762\u306B\u306A\u308A\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2776 \u5C65\u6B74\u2192\u30B3\u30A4\u30F3\u306E\u8EE2\u9001\u5C65\u6B74\u3092\u898B\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2777 \u7DE8\u96C6\u2192Name\u3001\u4FDD\u6709\u30B3\u30A4\u30F3\u306E\u6B8B\u9AD8\u4E0A\u9650\u6570\u306E\u5909\u66F4\u3001\u8EE2\u9001\u5148\u30A6\u30A9\u30EC\u30C3\u30C8(Destination Wallet)\u306E\u5909\u66F4\u304C\u884C\u3048\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u8A2D\u5B9A\u5185\u5BB9\u3092\u5909\u66F4\u3059\u308B\u5834\u5408\u306F\u2777\u306E\u7DE8\u96C6\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s14.png",alt:"Auto Transfer S3"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2464 \u30BF\u30A4\u30C8\u30EB\u3084\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u5909\u66F4\u3092\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Name"),"\u2026\u8A2D\u5B9A\u3057\u305FAuto Transfer\u306E\u8AAC\u660E\u3092\u5909\u66F4\u3067\u304D\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Select destination from your wallets")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2192\u540C\u3058\u30A2\u30AB\u30A6\u30F3\u30C8\u5185\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u5834\u5408\u306F\u3053\u3053\u304B\u3089\u9078\u629E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Enter the destination")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2192\u5225\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u5185\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u5834\u5408\u306F\u3053\u3061\u3089\u306B\u76F4\u63A5\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u307E\u3059"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Amount"),"\u2026\u4FDD\u6709\u30B3\u30A4\u30F3\u306E\u6B8B\u9AD8\u4E0A\u9650\u6570\u306E\u5909\u66F4\u304C\u3067\u304D\u307E\u3059\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u5168\u3066\u306E\u5165\u529B\u304C\u5B8C\u4E86\u3057\u305F\u3089\u300CSave\u300D\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s15.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2465 OP\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3001\u300CConfirm\u300D\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s8.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2466 Google\u4E8C\u6BB5\u968E\u8A8D\u8A3C\u3092\u5165\u529B\u3057\u3001\u300CConfirm\u300D\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s9.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2467 \u5DE6\u56F3\u306E\u753B\u9762\u306B\u5207\u308A\u66FF\u308F\u308C\u3070\u5909\u66F4\u306F\u5B8C\u4E86\u3067\u3059\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s18.png",alt:"Auto Transfer S1"}))))))))));}}]);return AutoTransferAppJa;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AutoTransferAppJa);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AutoTransferAppEn=function(_Component){_inherits(AutoTransferAppEn,_Component);function AutoTransferAppEn(){_classCallCheck(this,AutoTransferAppEn);return _possibleConstructorReturn(this,(AutoTransferAppEn.__proto__||Object.getPrototypeOf(AutoTransferAppEn)).apply(this,arguments));}_createClass(AutoTransferAppEn,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mgt-30 faq-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-center block-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"common-title"},"TRIAM Auto Transfer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"version: 1.0.4.1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"opening"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"intro"},"The Auto Transfer function is a function which automatically transfers the exceed amount to another wallet when the specified coin in the specified wallet exceed the set quantity.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"For example, you can set up as a wallet receive coin paymens from customers to prevent excessive wallet balances and increase security."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"example"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Example:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2460 Set Auto Transfer function in the \u201CWallet receiving coin payments from customer\u201D"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{marginLeft:'25px'}},"Specified coin: RIA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{marginLeft:'25px'}},"Specified coin amount: 500,000RIA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{marginLeft:'25px'}},"Destination wallet: \u201CCustomer payment coin management wallet\u201D"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2461 Coins will be sent from the customer to the wallet \u201CWallet receiving coin payments from customer\u201D. If the balance in \u201CWallet receiving coin payment from customer\u201D exceeds the specified quantity, excess coins will be automatically transferred to \u201CCustomer payment coin management wallet\u201D.")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/auto-transfer-des-en.png",alt:"Auto Transfer Des"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"guide guide-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"How to set up the Auto Transfer function")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"step-guide decimal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2460 Log in to your account and tap \u201CSetting\u201D on the bottom right of the menu screen. ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s1.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2461 Scroll down and tap Auto Transfer.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s2.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2462 Tap \"Setup Auto Transfer\".")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s3.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"1. Wallet & Asset")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2463 Set the title, wallet selection, etc."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Name"),"\u2026 Enter a description of the Auto Transfer to be configured."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u203BIt will be used as a sign when checking or changing the settings after they have been configured."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Source wallet"),"\u2026 Select the wallet for which you want to set the Auto Transfer function."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Min amount"),"\u2026 Enter the maximum quantity of the balance you wish to hold in Source wallet."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Asset"),"\u2026 Select the coin type."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Tap \"Next\" when all the input are completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s4.png",alt:"Auto Transfer S3"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"2. Destination & Amount")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2464 Select the destination wallet for coins when the Auto Transfer function is activated."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Select destination from your wallets")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u2192"),"If the wallets are in the same account, select from here."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Enter the destination")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u2192"),"Select this option for a wallet in a different account. Enter the wallet address directly."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Check the information you entered again and tap \"Next\".")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s5.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text highlight"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u203BNotices:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"For Destination wallet, please set a wallet that does not require Tag to be specified when receiving coins. If you set the wallet address of the exchange that requires Tag specification to Destination Wallet, the transfer process itself of Auto Transfer will be performed but please be careful because it may become an unknown deposit on the receiving side."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"3. Review")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2465 On the next screen, you can check the flow of the set Auto Transfer function in the diagram."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Check and click NEXT button")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s6.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"4. Confirm")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2466 The final confirmation screen will be displayed. Confirm it and tap Confirm button.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s7.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2467 Enter your OP password and tap Confirm")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s8.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2468 Enter Google TFA and tap Confirm")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s9.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"5. Done")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2469 When the setting is completed, the screen on the left is displayed."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Tap Done to return to the menu screen."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"The set up is now completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s10.png",alt:"Auto Transfer S1"})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"guide guide-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{style:{marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Changing the settings and procedures for the Auto Transfer function")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"You can change various settings of the Auto Transfer function."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"step-guide decimal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2460 Tap \"Settings\" at the bottom right of the menu screen.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s1.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2461 Scroll down and tap Auto Transfer.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s2.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2462 Tap the Auto Transfer you want to change."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u203BYou will be able to identify the Auto Transfer set in Name.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s13.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2463 This is the Auto Transfer details screen."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2776 History\u2192You can view the coin transfer history."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2777 Edit\u2192You can change your name, the maximum number of coins you can hold, and the destination wallet."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"If you want to change the settings, tap the \u2777 Edit button ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s14.png",alt:"Auto Transfer S3"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2464 You can change the title and wallet."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Name"),"\u2026 If the wallets are in the same account, select from here."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Select destination from your wallets")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2192If the wallets are in the same account, select from here."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Enter the destination")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2192For a wallet in a different account, enter the wallet address directly here."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Amount"),"\u2026 You can change the maximum number of coins you have."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Tap \"Save\" when all the input are completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s15.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2465 Enter the OP password and tap Confirm")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s8.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2466 Enter the GoogleTFA and tap Confirm. ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s9.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2467 The change is completed when you switch to the screen shown on the left.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s18.png",alt:"Auto Transfer S1"}))))))))));}}]);return AutoTransferAppEn;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AutoTransferAppEn);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AutoTransferAppCh=function(_Component){_inherits(AutoTransferAppCh,_Component);function AutoTransferAppCh(){_classCallCheck(this,AutoTransferAppCh);return _possibleConstructorReturn(this,(AutoTransferAppCh.__proto__||Object.getPrototypeOf(AutoTransferAppCh)).apply(this,arguments));}_createClass(AutoTransferAppCh,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mgt-30 faq-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-center block-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"common-title"},"TRIAM Auto Transfer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"version: 1.0.4.1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"opening"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"intro"},"\u4EC0\u4E48\u662FAuto Transfer\u7684\u529F\u80FD\uFF1F\u5F53\u60A8\u7684\u7535\u5B50\u94B1\u5305\u8D85\u8FC7\u8BBE\u5B9A\u7684\u6570\u91CF\u65F6\uFF0C\u591A\u4F59\u7684\u6570\u91CF\u5C06\u81EA\u52A8\u8F6C\u5165\u53E6\u4E00\u4E2A\u7535\u5B50\u94B1\u5305\u7684\u4E00\u79CD\u529F\u80FD\u3002",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u4F8B\u5982 \u5728\u63A5\u6536\u987E\u5BA2\u652F\u4ED8\u4EE3\u5E01\u7684\u7535\u5B50\u7B49\u94B1\u5305\u4E2D\u8BBE\u7F6E\u6B64\u529F\u80FD\uFF0C\u65E2\u53EF\u4EE5\u9632\u6B62\u7535\u5B50\u94B1\u5305\u4E2D\u8FC7\u4F59\u989D\uFF0C\u5E76\u4E14\u63D0\u9AD8\u5B89\u5168\u6027\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"example"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4F8B\uFF09"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2460\u300C\u63A5\u6536\u987E\u5BA2\u652F\u4ED8\u4EE3\u5E01\u7684\u7535\u5B50\u94B1\u5305\u300D\u8FDB\u884CAuto Transfer\u7684\u529F\u80FD\u8BBE\u7F6E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{marginLeft:'25px'}},"\u8BBE\u7F6E\u7684\u4EE3\u5E01\uFF1ARIA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{marginLeft:'25px'}},"\u8BBE\u7F6E\u4EE3\u5E01\u7684\u6570\u91CF\uFF1A500,000RIA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{marginLeft:'25px'}},"\u8F6C\u9001\u7684\u7535\u5B50\u94B1\u5305\uFF1A\u300C\u987E\u5BA2\u652F\u4ED8\u7BA1\u7406\u7535\u5B50\u94B1\u5305\u300D"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2461 \u987E\u5BA2\u5BF9\u300C\u63A5\u6536\u987E\u5BA2\u652F\u4ED8\u4EE3\u5E01\u7684\u7535\u5B50\u94B1\u5305\u300D\u8FDB\u884C\u53D1\u9001\u4EE3\u5E01"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u5F53\uFF08\u63A5\u6536\u987E\u5BA2\u652F\u4ED8\u4EE3\u5E01\u7684\u7535\u5B50\u94B1\u5305\uFF09\u5185\u7684\u4F59\u989D\u8D85\u8FC7\u4E86\u60A8\u6240\u8BBE\u7F6E\u6570\u91CF\u7684\u65F6\u5019 \u591A\u4F59\u7684\u4EE3\u5E01\u6570\u91CF\u5C06\u81EA\u52A8\u8F6C\u79FB\u81F3\uFF08\u987E\u5BA2\u652F\u4ED8\u7BA1\u7406\u7535\u5B50\u94B1\u5305\uFF09\u4E2D\u3002")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"class":"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/auto-transfer-des-ch.png",alt:"Auto Transfer Des"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"guide guide-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Auto Transfer\u529F\u80FD\u7684\u8BBE\u7F6E\u987A\u5E8F")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"step-guide decimal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2460 \u8BF7\u767B\u5F55\u8D26\u53F7\u540E\u70B9\u51FB\u83DC\u5355\u753B\u9762\u53F3\u4E0B\u89D2\u663E\u793A\u7684 \u300CSettings\u300D\u952E\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s1.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2461 \u6EDA\u52A8\u70B9\u51FB\u300CAuto Transfer\u300D\u952E\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s2.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2462 \u70B9\u51FB\u300CSetup Auto Transfer\u300D\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s3.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"1. Wallet & Asset")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2463 \u8BBE\u7F6E\u6807\u9898 \u548C\u9009\u62E9\u7535\u5B50\u94B1\u5305\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Name"),"\u2026\u8BF7\u8F93\u5165\u4F60\u8981Auto Transfer\u7684\u8BF4\u660E\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u203B\u8BF7\u786E\u8BA4\u5185\u5BB9 \u66F4\u6539\u65F6\u4F1A\u6210\u4E3A\u6807\u8BB0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Source wallet"),"\u2026\u8BF7\u9009\u62E9\u8BBE\u7F6EAuto Transfer\u529F\u80FD\u7684\u7535\u5B50\u94B1\u5305\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Min amount"),"\u2026\u8BF7\u8F93\u5165Source wallet\u6301\u6709\u7684\u4F59\u989D\u6700\u5927\u7684\u6570\u91CF\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Asset"),"\u2026\u8BF7\u9009\u62E9\u4EE3\u5E01\u7684\u6570\u91CF\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u5168\u90E8\u8F93\u5165\u5B8C\u6BD5\u540E\u8BF7\u70B9\u51FB\u300CNext\u300D\u6309\u94AE\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s4.png",alt:"Auto Transfer S3"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"2. Destination & Amount")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2464 \u542F\u7528Auto Transfer\u529F\u80FD\u65F6\u8BF7\u5148\u9009\u62E9\u4EE3\u5E01\u8F6C\u53D1\u5BF9\u65B9\u7684\u7535\u5B50\u94B1\u5305\uFF08Destination Wallet\uFF09\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Select destination from your wallets")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u2192"),"\u5982\u679C\u540C\u4E00\u4E2A\u8D26\u53F7\u91CC\u7684\u7535\u5B50\u94B1\u5305\u8BF7\u4ECE\u8FD9\u91CC\u9009\u62E9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Enter the destination")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u2192"),"\u4E0D\u540C\u8D26\u53F7\u5185\u7684\u7535\u5B50\u94B1\u5305\u8BF7\u4ECE\u8FD9\u91CC\u9009\u62E9\u3002\u8BF7\u76F4\u63A5\u8F93\u5165\u7535\u5B50\u94B1\u5305\u8BF7\u518D\u6B21\u786E\u8BA4\u8F93\u5165\u7684\u5185\u5BB9\u540E\u70B9\u51FB\u300CNext\u300D\u6309\u94AE\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s5.png",alt:"Auto Transfer S1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text highlight"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u203B\u6CE8\u610F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u63A5\u6536\u4EE3\u5E01\u7684Destination Wallet\u8BF7\u8BBE\u7F6E\u65E0\u9700\u6307\u5B9ATag\u7684\u7535\u5B50\u94B1\u5305\u3002\u5982\u679CDestination Wallet\u5DF2\u7ECF\u8BBE\u7F6E\u4E86\u5FC5\u987B\u6307\u5B9ATag\u7684\u4EA4\u6613\u6240\u7684\u7535\u5B50\u94B1\u5305\u5730\u5740\u7684\u60C5\u51B5\u4E0B\uFF0CAuto Transfer\u867D\u7136\u4F1A\u81EA\u52A8\u6267\u884C\u8F6C\u9001\uFF0C\u4F46\u63A5\u6536\u8005\u6709\u53EF\u80FD\u4F1A\u6536\u5230\u4E00\u7B14\u672A\u77E5\u6216\u4E0D\u660E\u7684\u8D44\u91D1\u3002\u8BF7\u6CE8\u610F\u3002"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"3. Review")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2465 \u4E0B\u4E00\u9875\u4E3A\u5DF2\u7ECF\u8BBE\u7F6E\u7684Auto Transfer\u7684\u529F\u80FD\u7684\u987A\u5E8F\u753B\u9762\u53EF \u4EE5\u8FDB\u884C\u786E\u8BA4\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u786E\u8BA4\u540E\u8BF7\u70B9\u51FB\u300CNext\u300D\u6309\u94AE\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s6.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"4. Confirm")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2466 \u5C06\u4F1A\u663E\u793A\u6700\u7EC8\u786E\u8BA4\u753B\u9762\uFF0C\u8BF7\u786E\u8BA4\u540E\u70B9\u51FB\u300CConfirm\u300D\u952E\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s7.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2467 \u8BF7\u8F93\u5165OP\u5BC6\u7801\u540E \u70B9\u51FB\u300CConfirm\u300D\u952E\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s8.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2468 \u8BF7\u8F93\u5165Google\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u540E\u70B9\u51FB\u300CConfirm\u300D\u952E\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s9.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"5. Done")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2469 \u8BBE\u7F6E\u5B8C\u6210\u540E\u5C06\u5982\u5DE6\u56FE\u6240\u793A\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u70B9\u51FB\u83DC\u5355\u753B\u9762\u4E2D\u7684\u300CDone\u300D\u952E\u8FD4\u56DE\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Auto Transfe\u7684\u8BBE\u7F6E\u5DF2\u5B8C\u6210\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s10.png",alt:"Auto Transfer S1"})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"guide guide-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{style:{marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\u66F4\u6539Auto Transfer\u529F\u80FD\u7684\u8BBE\u7F6E\u53CA\u6B65\u9AA4\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u53EF\u4EE5\u66F4\u6539Auto Transfer\u7684\u5404\u79CD\u529F\u80FD\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"step-guide decimal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2460 \u70B9\u51FB\u83DC\u5355\u753B\u9762\u53F3\u4E0B\u89D2\u7684\u300CSettings\u300D\u952E\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s1.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2461 \u6EDA\u52A8\u70B9\u51FB\u300CAuto Transfer\u300D\u952E\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s12.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2462 \u8BF7\u70B9\u51FB\u60A8\u8981\u66F4\u6539\u7684Auto Transfer\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u203B\u53EF\u4EE5\u6309\u5DF2\u8BBE\u7F6E\u7684\u540D\u79F0\u533A\u5206Auto Transfer\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s13.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2463Auto Transfer\u7684\u8BE6\u7EC6\u753B\u9762\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2776 \u8BB0\u5F55\u2026\u53EF\u4EE5\u67E5\u770B\u4EE3\u5E01\u7684\u8F6C\u9001\u8BB0\u5F55"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2777 \u7F16\u8F91\u2026\u53EF\u4EE5\u8FDB\u884C\u66F4\u6539\u540D\u79F0\uFF0C\u4EE3\u5E01\u4F59\u989D\u6700\u5927\u91CF\u548C\u8F6C\u9001\u63A5\u6536\u65B9\u7684\u7535\u5B50\u94B1\u5305(Destination Wallet)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u5982\u679C\u8BBE\u7F6E\u5185\u5BB9\u8FDB\u884C\u66F4\u6539\u7684\u8BF7\u70B9\u51FB\u2777\u8FDB\u884C\u66F4\u6539\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s14.png",alt:"Auto Transfer S3"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2464 \u53EF\u4EE5\u8FDB\u884C\u66F4\u6539\u6807\u9898\u548C\u7535\u5B50\u94B1\u5305\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Name"),"\u2026\u53EF\u4EE5\u66F4\u6539\u5DF2\u7ECF\u8BBE\u7F6E\u7684Auto Transfer\u5185\u5BB9\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Select destination from your wallets")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2192\u5982\u679C\u540C\u4E00\u4E2A\u8D26\u53F7\u91CC\u7684\u7535\u5B50\u94B1\u5305\u8BF7\u4ECE\u8FD9\u91CC\u9009\u62E9\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Enter the destination")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2192\u5982\u679C\u4E0D\u540C\u8D26\u53F7\u5185\u7684\u7535\u5B50\u94B1\u5305\u8BF7\u76F4\u63A5\u8F93\u5165\u7535\u5B50\u94B1\u5305\u5730\u5740\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"\uFF65Amount"),"\u2026\u53EF\u4EE5\u66F4\u6539\u6301\u6709\u4EE3\u5E01\u4F59\u989D\u6700\u5927\u6570\u91CF\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u6240\u6709\u7684\u8F93\u5165\u5B8C\u6BD5\u540E\u8BF7\u70B9\u51FB\u300CSave\u300D\u952E\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s15.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2465 \u8BF7\u8F93\u5165OP\u5BC6\u7801\u540E \u70B9\u51FB\u300CConfirm\u300D\u952E\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s8.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2466 \u8BF7\u8F93\u5165Google\u7684\u53CC\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u540E\u70B9\u51FB\u300CConfirm\u300D\u952E\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s9.png",alt:"Auto Transfer S1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u2467 \u663E\u793A\u5DE6\u4FA7\u7684\u753B\u9762\uFF0C\u5373\u66F4\u6539\u5DF2\u5B8C\u6210\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/app/setup-auto-transfer-s18.png",alt:"Auto Transfer S1"}))))))))));}}]);return AutoTransferAppCh;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AutoTransferAppCh);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.4818f30c.js